webpackJsonp([1],Array(678).concat([
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _class2, _temp; /* global espn_ui espn twttr jQuery */
	
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(244);
	
	var _gamepackage = __webpack_require__(679);
	
	var _GameStrip = __webpack_require__(680);
	
	var _lite = __webpack_require__(847);
	
	var _lite2 = __webpack_require__(859);
	
	var _api = __webpack_require__(366);
	
	var _cricket = __webpack_require__(861);
	
	var _utils = __webpack_require__(669);
	
	var _common = __webpack_require__(686);
	
	var _common2 = __webpack_require__(423);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _redux = __webpack_require__(253);
	
	var _actions = __webpack_require__(411);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GamePackage = (_dec = (0, _reactRedux.connect)(function (state) {
	  return (0, _extends3.default)({}, state.gamePackage, state.utils, { edition: state.page.edition });
	}, function (dispatch) {
	  return { dispatch: dispatch, postCommentryFeedback: (0, _redux.bindActionCreators)(_utils.postCommentryFeedback, dispatch) };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  (0, _inherits3.default)(GamePackage, _React$Component);
	
	  function GamePackage() {
	    (0, _classCallCheck3.default)(this, GamePackage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (GamePackage.__proto__ || (0, _getPrototypeOf2.default)(GamePackage)).call(this));
	
	    _this.timer = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(GamePackage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          _props$fastCastMeta = _props.fastCastMeta,
	          fastCastMeta = _props$fastCastMeta === undefined ? {} : _props$fastCastMeta,
	          isFastcastAllowed = _props.isFastcastAllowed,
	          edition = _props.edition,
	          params = _props.params,
	          meta = _props.meta,
	          gameState = _props.gameState,
	          adblock = _props.adblock;
	      // Init webviews
	
	      this.initWebViews(this.props, 'init');
	      this.props.ads.updateKeyValue(edition, params, meta, gameState);
	      this.props.ads.init(adblock);
	      this.spliceShell();
	      this.props.ads.loadInViewAds();
	
	      /**
	       * Gamestrip times need to be updated when that game is in prestate
	       */
	      if (gameState === 'pregame') {
	        this.props.dispatch((0, _actions.updateGameStrip)(params.sport));
	      }
	
	      /**
	       * Initiate Fastcast connection (if fastcast is available for this sports) and Ajax polling
	       * if Fastcast connection is successfull Ajax polling will be disabled
	       */
	      if (fastCastMeta.enabled === true) {
	        //console.info('Setup fastcast since match is live')
	        _cricket.gamepackageFastCast.call(this, null);
	      }
	      // if Fastcast is not allowed initiat ajax polling
	      if (isFastcastAllowed !== true) {
	        //console.info('fastcast is not available')
	        _common2.poll.call(this, GamePackage.loadActions);
	      }
	      if ((0, _selectn2.default)('edition.isEspnCricinfo', this.props)) {
	        var duration = (0, _selectn2.default)('edition.isAsiaRegion', this.props) ? 90000 : 300000;
	        this.props.ads.refreshInPageAdSlots(duration);
	      }
	    }
	  }, {
	    key: 'initWebViews',
	    value: function initWebViews() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var action = arguments[1];
	
	      var platform = (0, _selectn2.default)('params.platform', props);
	      if (typeof platform !== 'undefined') {
	        var meta = (0, _selectn2.default)('meta', props);
	        var allVideos = ((0, _selectn2.default)('allVideos.videos', props) || []).slice(0) // clone in case other components are reading `allVideos.videos` node
	        .concat((0, _selectn2.default)('article.video', props) || []); // append any videos in preview/report
	        var sliderVideos = (0, _selectn2.default)('videoSlider.videos', props) || []; // this WAS hardcoded to read this.props, even in 'componentWillReceiveProps', @TODO change back if that was intentional, I'm assuming it was a mistake
	        var lecclips = (0, _selectn2.default)('lecclips', props) || [];
	        var rosterVideos = (0, _selectn2.default)('rosterVideos', props) || [];
	        this.props.webviews.init(platform, meta, allVideos, sliderVideos, lecclips, rosterVideos, action);
	      }
	    }
	
	    /*
	    * The statement below checks if its a page load or tab switch
	    * If there is a change in URL, will trigger a webview init with all latest videos
	    * Videos for webviews after geo filtering on props change will happen on props change
	    * "init" will update meta information as well
	    */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _nextProps$fastCastMe = nextProps.fastCastMeta,
	          fastCastMeta = _nextProps$fastCastMe === undefined ? {} : _nextProps$fastCastMe,
	          isFastcastAllowed = nextProps.isFastcastAllowed;
	
	      var currentUrl = (0, _selectn2.default)('meta.canonical', nextProps);
	      var previousUrl = (0, _selectn2.default)('meta.canonical', this.props);
	      // updates meta related info and videos on tab switch
	      this.initWebViews(nextProps, !previousUrl || previousUrl !== currentUrl ? 'init' : 'onstatechange');
	      //poll.call(this, GamePackage.loadActions)
	      /**
	       * Initiate Fastcast connection (if fastcast is available for this sports) and Ajax polling
	       * if Fastcast connection is successfull Ajax polling will be disabled
	       */
	      if (fastCastMeta.enabled === true) {
	        //console.info('Setup fastcast since match is live')
	        _cricket.gamepackageFastCast.call(this, null);
	      }
	      // if Fastcast is not allowed initiat ajax polling
	      if (isFastcastAllowed !== true) {
	        //console.info('fastcast is not available')
	        _common2.poll.call(this, GamePackage.loadActions);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _props2 = this.props,
	          location = _props2.location,
	          edition = _props2.edition,
	          params = _props2.params,
	          meta = _props2.meta,
	          gameState = _props2.gameState,
	          adblock = _props2.adblock;
	      // Refresh ads only if there is a change in route
	
	      if ((0, _common2.hasRouteChanged)(prevProps.location, location)) {
	        this.props.ads.inviewAdRevert();
	        this.props.ads.updateKeyValue(edition, params, meta, gameState);
	        this.props.ads.init(adblock);
	        this.props.ads.loadInViewAds(adblock);
	        try {
	          var activeVideoThumb = jQuery('.video.active');
	          espn.video.remove();
	
	          var $container = jQuery('.top-highlights .mediaList__list');
	          var nextVideo = $container.find('.mediaList__item--next');
	          var currentVideo = $container.find('.mediaList__item--active');
	
	          if (activeVideoThumb.length) {
	            activeVideoThumb.removeClass('active');
	            currentVideo.removeClass('mediaList__item--active').find('.mediaList__phase').remove();
	            nextVideo.find('.mediaList__phase').remove();
	          }
	        } catch (ReferenceError) {
	          // document is not defined
	        }
	      }
	      this.spliceShell();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.clearInterval(this.timer);
	      this.timer = null;
	      // disable event handlers
	      var platform = (0, _selectn2.default)('params.platform', this.props);
	      if (typeof platform !== 'undefined') {
	        this.props.webviews.disableInterceptor();
	      }
	      _cricket.disconnectGPG.call(this, null);
	    }
	  }, {
	    key: 'spliceShell',
	    value: function spliceShell() {
	      try {
	        // init Behaviors for articles
	        espn_ui.LoadBehavior(document.querySelectorAll('.main-content.react-content :not(.app_partial)'));
	        // update meta data
	        this.props.updateMeta(this.props.meta);
	        // set league prop (for video tracking in report?)
	        espn.gamepackage = espn.gamepackage || {};
	        espn.gamepackage.league = this.props.params.league;
	        // load twitter widgets
	        twttr.widgets.load();
	      } catch (e) {
	        if (e instanceof ReferenceError && e.message === 'twttr is not defined') {
	          console.log('Error loading twitter widget');
	        } else {
	          console.log(e);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          gameStateClass = _props3.gameStateClass,
	          summary = _props3.summary,
	          matchSummary = _props3.matchSummary,
	          params = _props3.params,
	          location = _props3.location,
	          gameStrip = _props3.gameStrip,
	          _props3$links = _props3.links,
	          links = _props3$links === undefined ? [] : _props3$links,
	          showGameDetailFooter = _props3.showGameDetailFooter,
	          leagueUid = _props3.leagueUid,
	          detailsHeaderClass = _props3.detailsHeaderClass,
	          loading = _props3.loading,
	          gameState = _props3.gameState,
	          _props3$appProps = _props3.appProps,
	          appProps = _props3$appProps === undefined ? {} : _props3$appProps,
	          matchShortName = _props3.matchShortName,
	          edition = _props3.edition,
	          trackingImg = _props3.trackingImg,
	          showBtmAdModule = _props3.showBtmAdModule,
	          siteType = _props3.siteType,
	          showGameHeader = _props3.showGameHeader,
	          adblock = _props3.adblock,
	          isSmallDevice = _props3.isSmallDevice;
	      var sport = params.sport,
	          pageType = params.pageType;
	
	      var isWebView = params.platform ? true : false;
	      var mainContainerClass = '' + (loading ? 'loading' : '');
	      var isMobile = (0, _selectn2.default)('device.mobile', appProps);
	      var isAppLite = appProps.isAppLite;
	      var isDataLite = siteType === 'data-lite' ? true : false;
	      // Compose the game package view
	
	      var appView = (0, _gamepackage.composeView)({
	        pageType: pageType,
	        state: (0, _extends3.default)({}, this.props, { isWebView: isWebView, isMobile: isMobile }),
	        params: params,
	        query: location.query,
	        isAppLite: isAppLite
	      });
	
	      var simplifiedAdLink = (0, _common2.getAdSimplifiedLink)(this.props.edition, params.pageType);
	      var excludeVal = ['s'];
	
	      if (isAppLite) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { maxHeight: '1px', position: 'absolute' } },
	            _react2.default.createElement('img', { id: 'omniture', src: trackingImg, alt: '', width: '1', height: '1' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { key: 'hd', className: 'cricinfo__header' },
	            !isWebView && _react2.default.createElement(
	              'div',
	              { className: 'cricinfo__header__logo' },
	              _react2.default.createElement(
	                'a',
	                { href: '/', className: 'cricinfo__header__logo__link' },
	                _react2.default.createElement('img', { src: 'http://a.espncdn.com/i/cricinfo/logo_cricinfo@2x.png', alt: 'ESPN Cricinfo', className: 'cricinfo__header__logo__img', height: '16', width: '126' })
	              )
	            ),
	            _react2.default.createElement(
	              'h1',
	              { className: 'cricinfo__header__title' },
	              matchShortName
	            ),
	            _react2.default.createElement(_lite.GlobalNavTertiary, { links: links, activeKey: pageType })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ad-banner-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { key: 'ad', className: 'ad-slot ad-slot-banner ad-wrapper', style: { 'textAlign': 'center' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ad' },
	                _react2.default.createElement(
	                  'a',
	                  { href: simplifiedAdLink.link },
	                  _react2.default.createElement('img', { src: simplifiedAdLink.src })
	                )
	              )
	            )
	          ),
	          appView,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'cricinfo__content__item' },
	              _react2.default.createElement(
	                'a',
	                { href: '#', className: 'cricinfo__type__link cricinfo__type__link--back-to-top ' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Back to top '
	                ),
	                _react2.default.createElement('div', { className: 'cricinfo__caret' })
	              )
	            )
	          ),
	          !isWebView && _react2.default.createElement(_lite2.FooterLite, { editionUserGeo: edition.userGeo })
	        );
	      }
	
	      if (isWebView) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { id: 'custom-nav' },
	            _react2.default.createElement(
	              'div',
	              { id: 'gamepackage-header-wrap', className: detailsHeaderClass, 'data-league-uid': leagueUid },
	              _react2.default.createElement(
	                'div',
	                { id: 'gamepackage-matchup-wrap' },
	                !showGameHeader && _react2.default.createElement(_GameStrip.GameStrip, (0, _extends3.default)({}, gameStrip, { sport: sport, className: gameStateClass })),
	                !showGameHeader && showGameDetailFooter && _react2.default.createElement(_GameStrip.GameDetailsFooter, { className: gameStateClass, sport: sport, summaryText: summary, summaryData: matchSummary, gameState: gameState })
	              ),
	              !showGameHeader && _react2.default.createElement(_gamepackage.GlobalNavTertiary, { links: links, activeKey: pageType })
	            )
	          ),
	          /* Adding both server and client side device check */
	          !isMobile && !isSmallDevice && _react2.default.createElement(
	            'div',
	            { className: 'ad-banner-wrapper' },
	            _react2.default.createElement(_common.Ad, { id: 'banner', className: 'react-ad ad-slot-banner ad-wrapper', slotType: 'banner', kvpos: 'top', isAdBlock: adblock, exclude: excludeVal })
	          ),
	          _react2.default.createElement(
	            'section',
	            { id: 'main-container', className: mainContainerClass },
	            _react2.default.createElement(
	              'div',
	              { className: 'main-content' },
	              appView
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'section',
	        { id: 'gamepackage-wrapper' },
	        isDataLite && trackingImg && _react2.default.createElement(
	          'div',
	          { style: { maxHeight: '1px', position: 'absolute' } },
	          _react2.default.createElement('img', { id: 'omniture', src: trackingImg, alt: '', width: '1', height: '1' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'custom-nav' },
	          !showGameHeader && _react2.default.createElement(_GameStrip.GameStrip, (0, _extends3.default)({}, gameStrip, { sport: sport, className: gameStateClass })),
	          !showGameHeader && showGameDetailFooter && _react2.default.createElement(_GameStrip.GameDetailsFooter, { className: gameStateClass, sport: sport, summaryText: summary, summaryData: matchSummary, gameState: gameState }),
	          !showGameHeader && _react2.default.createElement(_gamepackage.GlobalNavTertiary, { links: links, activeKey: pageType })
	        ),
	        /* Adding both server and client side device check */
	        !isMobile && !isSmallDevice && _react2.default.createElement(
	          'div',
	          { className: 'ad-banner-wrapper' },
	          _react2.default.createElement(_common.Ad, { id: 'banner', className: 'react-ad ad-slot-banner ad-wrapper', slotType: 'banner', kvpos: 'top', isAdBlock: adblock, exclude: excludeVal })
	        ),
	        _react2.default.createElement(
	          'section',
	          { id: 'main-container', className: mainContainerClass },
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content' },
	            !isMobile && _react2.default.createElement(_common.LongStripAd, { edition: edition, type: 'game' }),
	            appView,
	            showBtmAdModule && edition.isAsiaRegion && _react2.default.createElement(_common.Ad, { id: 'banner', className: 'react-ad ad-banner-mobile ad-wrapper', slotType: 'banner', include: ['s'], kvpos: 'bottom' }),
	            showBtmAdModule && isMobile && _react2.default.createElement(_common.Ad, { id: 'mpu', className: 'ad-slot-inview ad-slot-mobile-incontent ad-wrapper', kvpos: 'bottom', slotType: 'incontent2' })
	          )
	        )
	      );
	    }
	  }]);
	  return GamePackage;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  ads: _react.PropTypes.object.isRequired
	}, _class2.loadActions = [_api.getGamePackage], _temp)) || _class);
	exports.default = GamePackage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.composeView = exports.VideoGrid = exports.HeadToHead = exports.PlayerDetails = exports.PlayersToWatch = exports.GlobalNavTertiary = exports.GameHeader = exports.GameStrip = undefined;
	
	var _GameStrip = __webpack_require__(680);
	
	var _GameStrip2 = _interopRequireDefault(_GameStrip);
	
	var _GameHeader = __webpack_require__(684);
	
	var _GameHeader2 = _interopRequireDefault(_GameHeader);
	
	var _GlobalNavTertiary = __webpack_require__(685);
	
	var _GlobalNavTertiary2 = _interopRequireDefault(_GlobalNavTertiary);
	
	var _PlayersToWatch = __webpack_require__(804);
	
	var _PlayersToWatch2 = _interopRequireDefault(_PlayersToWatch);
	
	var _PlayerDetails = __webpack_require__(805);
	
	var _PlayerDetails2 = _interopRequireDefault(_PlayerDetails);
	
	var _HeadToHead = __webpack_require__(806);
	
	var _HeadToHead2 = _interopRequireDefault(_HeadToHead);
	
	var _VideoGrid = __webpack_require__(807);
	
	var _VideoGrid2 = _interopRequireDefault(_VideoGrid);
	
	var _composeView = __webpack_require__(808);
	
	var _composeView2 = _interopRequireDefault(_composeView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.GameStrip = _GameStrip2.default;
	exports.GameHeader = _GameHeader2.default;
	exports.GlobalNavTertiary = _GlobalNavTertiary2.default;
	exports.PlayersToWatch = _PlayersToWatch2.default;
	exports.PlayerDetails = _PlayerDetails2.default;
	exports.HeadToHead = _HeadToHead2.default;
	exports.VideoGrid = _VideoGrid2.default;
	exports.composeView = _composeView2.default;
	exports.default = {
	  GameStrip: _GameStrip2.default,
	  GameHeader: _GameHeader2.default,
	  GlobalNavTertiary: _GlobalNavTertiary2.default,
	  PlayersToWatch: _PlayersToWatch2.default,
	  PlayerDetails: _PlayerDetails2.default,
	  HeadToHead: _HeadToHead2.default,
	  VideoGrid: _VideoGrid2.default,
	  composeView: _composeView2.default
	};

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScoreCellHeader = exports.ScoreCellCompetitor = exports.GameStrip = exports.GameDetailsFooter = exports.Competitor = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _EventSummary = __webpack_require__(681);
	
	var _EventSummary2 = _interopRequireDefault(_EventSummary);
	
	var _AnchorLink = __webpack_require__(682);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	var _BannerPicture = __webpack_require__(683);
	
	var _BannerPicture2 = _interopRequireDefault(_BannerPicture);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Competitor = exports.Competitor = function Competitor(_ref) {
	  var _ref$id = _ref.id,
	      id = _ref$id === undefined ? '' : _ref$id,
	      _ref$name = _ref.name,
	      name = _ref$name === undefined ? '' : _ref$name,
	      _ref$shortName = _ref.shortName,
	      shortName = _ref$shortName === undefined ? '' : _ref$shortName,
	      _ref$abbrev = _ref.abbrev,
	      abbrev = _ref$abbrev === undefined ? '' : _ref$abbrev,
	      _ref$logo = _ref.logo,
	      logo = _ref$logo === undefined ? '' : _ref$logo,
	      _ref$bannerLogo = _ref.bannerLogo,
	      bannerLogo = _ref$bannerLogo === undefined ? '' : _ref$bannerLogo,
	      _ref$scoreMarkup = _ref.scoreMarkup,
	      scoreMarkup = _ref$scoreMarkup === undefined ? '' : _ref$scoreMarkup,
	      _ref$team = _ref.team,
	      team = _ref$team === undefined ? 'home' : _ref$team,
	      _ref$trackingName = _ref.trackingName,
	      trackingName = _ref$trackingName === undefined ? '' : _ref$trackingName,
	      rank = _ref.rank,
	      record = _ref.record,
	      possession = _ref.possession,
	      _ref$href = _ref.href,
	      href = _ref$href === undefined ? '' : _ref$href,
	      uid = _ref.uid,
	      sport = _ref.sport,
	      isTeamLinkActive = _ref.isTeamLinkActive,
	      isWebView = _ref.isWebView;
	
	
	  var isHome = team === 'home';
	
	  var picture = '\n    <picture>\n      <!--[if IE 9]><video style="display: none;"><![endif]-->\n      <source srcset="' + logo + '">\n      <!--[if IE 9]></video><![endif]--><img data-default-src="' + logo + '" class="team-logo lazyload" data-src="' + logo + '" />\n    </picture>\n  ';
	
	  var teamBanner = _react2.default.createElement(
	    'div',
	    { key: 'tb', className: 'team__banner' },
	    _react2.default.createElement(
	      'div',
	      { className: 'team__banner__wrapper' },
	      _react2.default.createElement(_BannerPicture2.default, { bannerLogo: bannerLogo, teamId: id })
	    )
	  );
	
	  var teamName = [_react2.default.createElement(
	    'span',
	    { className: 'long-name', key: 'ln' },
	    name
	  ), _react2.default.createElement(
	    'span',
	    { className: 'short-name', key: 'sn' },
	    sport === 'cricket' ? shortName : name
	  ), _react2.default.createElement(
	    'span',
	    { className: 'abbrev', key: 'ab' },
	    abbrev
	  )];
	
	  var teamLogo = _react2.default.createElement('div', { key: 'nc', className: 'logo', dangerouslySetInnerHTML: { __html: logo && picture || '' } });
	  var logoWrapper = _react2.default.createElement(
	    'div',
	    { key: 'l', className: 'team-info-logo' },
	    teamLogo
	  );
	  var linkTeamName = _react2.default.createElement(
	    'div',
	    { className: 'team-name' },
	    teamName
	  );
	  var linkProps = { 'name': trackingName, 'isRouterLink': false, 'data-uid': uid, 'classes': 'app_partial team-info-logo', 'data-linktype': 'clubhouse' };
	  var linkPropsTeamName = (0, _extends3.default)({}, linkProps, { 'classes': 'team-name app_partial' });
	
	  if (!isWebView) {
	    linkProps.to = href;
	    linkPropsTeamName.to = href;
	  }
	
	  if (href != '') {
	    logoWrapper = _react2.default.createElement(_AnchorLink2.default, (0, _extends3.default)({ key: 'l', children: teamLogo }, linkProps));
	    linkTeamName = _react2.default.createElement(_AnchorLink2.default, (0, _extends3.default)({ key: 'ltn', children: teamName }, linkPropsTeamName));
	  }
	
	  var teamInfo = _react2.default.createElement(
	    'div',
	    { key: 'ti', className: 'team-info' },
	    _react2.default.createElement(
	      'div',
	      { className: 'team-info-wrapper' },
	      _react2.default.createElement(
	        'span',
	        { className: 'rank' },
	        rank
	      ),
	      isTeamLinkActive && linkTeamName
	    ),
	    record && _react2.default.createElement(
	      'span',
	      { className: 'record' },
	      record
	    )
	  );
	
	  var teamContainer = _react2.default.createElement(
	    'div',
	    { key: 'tc', className: 'team-container' },
	    isHome ? [teamInfo, logoWrapper] : [logoWrapper, teamInfo]
	  );
	
	  var scoreContainer = _react2.default.createElement(
	    'div',
	    { key: 'sc', className: 'score-container' },
	    _react2.default.createElement('div', { className: (0, _classnames2.default)('score', isHome ? 'icon-font-after' : 'icon-font-before'), dangerouslySetInnerHTML: { __html: scoreMarkup } })
	  );
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('team', isHome ? 'team-a' : 'team-b', { possession: possession }) },
	    _react2.default.createElement(
	      'div',
	      { className: 'team__content' },
	      isHome ? [teamBanner, teamContainer, scoreContainer] : [teamBanner, scoreContainer, teamContainer]
	    )
	  );
	};
	
	var GameDetailsFooter = exports.GameDetailsFooter = function GameDetailsFooter(_ref2) {
	  var _ref2$summaryData = _ref2.summaryData,
	      summaryData = _ref2$summaryData === undefined ? {} : _ref2$summaryData,
	      _ref2$summaryText = _ref2.summaryText,
	      summaryText = _ref2$summaryText === undefined ? '' : _ref2$summaryText,
	      _ref2$mobileText = _ref2.mobileText,
	      mobileText = _ref2$mobileText === undefined ? '' : _ref2$mobileText,
	      _ref2$className = _ref2.className,
	      className = _ref2$className === undefined ? '' : _ref2$className,
	      _ref2$sport = _ref2.sport,
	      sport = _ref2$sport === undefined ? '' : _ref2$sport,
	      _ref2$gameState = _ref2.gameState,
	      gameState = _ref2$gameState === undefined ? 'pregame' : _ref2$gameState;
	
	
	  var details = [];
	  var sportClass = sport;
	  if ((sport === 'rugby' || sport === 'rugby-league') && gameState !== 'pregame') {
	    //sportClass = 'rugby'
	    details.push(_react2.default.createElement(_EventSummary2.default, { key: 'summary', summary: summaryData }));
	  }
	
	  if (summaryText) {
	    details.push(_react2.default.createElement(
	      'div',
	      { key: 'status', className: 'game-status' },
	      summaryText
	    ));
	  }
	
	  if (mobileText || summaryText) {
	    details.push(_react2.default.createElement(
	      'div',
	      { key: 'mob-status', className: 'game-status mobile' },
	      mobileText || summaryText
	    ));
	  }
	
	  if (details.length == 0) {
	    return _react2.default.createElement('script', null);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('game-details footer', className, sportClass) },
	    _react2.default.createElement(
	      'div',
	      { className: 'wrap' },
	      details
	    )
	  );
	};
	
	var GameStrip = exports.GameStrip = function GameStrip(_ref3) {
	  var _ref3$header = _ref3.header,
	      header = _ref3$header === undefined ? '' : _ref3$header,
	      _ref3$network = _ref3.network,
	      network = _ref3$network === undefined ? '' : _ref3$network,
	      _ref3$time = _ref3.time,
	      time = _ref3$time === undefined ? '' : _ref3$time,
	      _ref3$date = _ref3.date,
	      date = _ref3$date === undefined ? '' : _ref3$date,
	      _ref3$target = _ref3.target,
	      target = _ref3$target === undefined ? '' : _ref3$target,
	      _ref3$teams = _ref3.teams,
	      teams = _ref3$teams === undefined ? {} : _ref3$teams,
	      _ref3$sport = _ref3.sport,
	      sport = _ref3$sport === undefined ? '' : _ref3$sport,
	      _ref3$className = _ref3.className,
	      className = _ref3$className === undefined ? '' : _ref3$className,
	      _ref3$winnerClass = _ref3.winnerClass,
	      winnerClass = _ref3$winnerClass === undefined ? '' : _ref3$winnerClass,
	      _ref3$homeTeamBattedF = _ref3.homeTeamBattedFirst,
	      homeTeamBattedFirst = _ref3$homeTeamBattedF === undefined ? true : _ref3$homeTeamBattedF,
	      _ref3$isTeamLinkActiv = _ref3.isTeamLinkActive,
	      isTeamLinkActive = _ref3$isTeamLinkActiv === undefined ? true : _ref3$isTeamLinkActiv,
	      isWebView = _ref3.isWebView;
	
	
	  // Swap team 1 and team 2 in case home team did not bat first
	  var team1 = homeTeamBattedFirst ? teams.home : teams.away;
	  var team2 = homeTeamBattedFirst ? teams.away : teams.home;
	
	  var sportClass = sport;
	  if (sport === 'rugby-league') {
	    sportClass = 'rugby';
	  }
	
	  /* TODO: REMOVE THIS INLINE STYLE ONCE IT IS ADDED IN THE SCORE REPO */
	  var hotFixStyle = '\n    <style type="text/css">\n      @media screen and (min-width: 768px) {\n        body.webview.cricket.gamepackage .game-strip {\n          display: block !important;\n        }\n      }\n    </style>\n  ';
	
	  return _react2.default.createElement(
	    'header',
	    { className: (0, _classnames2.default)('game-strip game-package', sportClass, className, winnerClass) },
	    _react2.default.createElement('span', { style: { 'display': 'none' }, dangerouslySetInnerHTML: { __html: hotFixStyle } }),
	    _react2.default.createElement(
	      'div',
	      { className: 'game-details header' },
	      header
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'competitors' },
	      _react2.default.createElement(Competitor, (0, _extends3.default)({ team: 'home' }, team1, { sport: sport, isTeamLinkActive: isTeamLinkActive, isWebView: isWebView })),
	      _react2.default.createElement(
	        'div',
	        { className: 'game-status' },
	        network && _react2.default.createElement(
	          'span',
	          { className: 'network' },
	          network
	        ),
	        date && _react2.default.createElement(
	          'span',
	          { className: 'game-date' },
	          date
	        ),
	        time && _react2.default.createElement(
	          'span',
	          { className: 'game-time' },
	          time
	        ),
	        target && _react2.default.createElement(
	          'span',
	          { className: 'game-play' },
	          target
	        )
	      ),
	      _react2.default.createElement(Competitor, (0, _extends3.default)({ team: 'away' }, team2, { sport: sport, isTeamLinkActive: isTeamLinkActive, isWebView: isWebView }))
	    )
	  );
	};
	
	var ScoreCellCompetitor = exports.ScoreCellCompetitor = function ScoreCellCompetitor(_ref4) {
	  var _ref4$name = _ref4.name,
	      name = _ref4$name === undefined ? '' : _ref4$name,
	      _ref4$abbrev = _ref4.abbrev,
	      abbrev = _ref4$abbrev === undefined ? '' : _ref4$abbrev,
	      _ref4$logo = _ref4.logo,
	      logo = _ref4$logo === undefined ? '' : _ref4$logo,
	      _ref4$scoreMarkupMobi = _ref4.scoreMarkupMobile,
	      scoreMarkupMobile = _ref4$scoreMarkupMobi === undefined ? '' : _ref4$scoreMarkupMobi,
	      _ref4$team = _ref4.team,
	      team = _ref4$team === undefined ? 'home' : _ref4$team,
	      rank = _ref4.rank,
	      href = _ref4.href,
	      uid = _ref4.uid,
	      _ref4$trackingName = _ref4.trackingName,
	      trackingName = _ref4$trackingName === undefined ? '' : _ref4$trackingName,
	      isWebView = _ref4.isWebView;
	
	
	  var picture = '\n    <picture>\n      <!--[if IE 9]><video style="display: none;"><![endif]-->\n      <source srcset="' + logo + '">\n      <!--[if IE 9]></video><![endif]--><img data-default-src="' + logo + '" class="cscore_image lazyload" data-src="' + logo + '" />\n    </picture>\n  ';
	  var defaultLinkLogo = [];
	  var defaultLinkAbbr = [];
	
	  var defaultLinkProps = { 'name': trackingName, 'data-uid': uid, 'className': 'app_partial cscore_logo', 'data-linktype': 'clubhouse' };
	  var defaultLinkAbbrProps = (0, _extends3.default)({}, defaultLinkProps, { 'className': 'app_partial' });
	
	  if (!isWebView) {
	    defaultLinkProps.href = href;
	    defaultLinkAbbrProps.href = href;
	  }
	
	  var teamname = [_react2.default.createElement(
	    'span',
	    { key: 'l', className: 'cscore_name cscore_name--long' },
	    name
	  ), _react2.default.createElement(
	    'span',
	    { key: 's', className: 'cscore_name cscore_name--short' },
	    name
	  ), _react2.default.createElement(
	    'span',
	    { key: 'a', className: 'cscore_name cscore_name--abbrev' },
	    abbrev
	  )];
	
	  var spanAbbrTag = _react2.default.createElement(
	    'span',
	    { className: 'cscore_truncate' },
	    teamname
	  );
	  var divLogoTag = _react2.default.createElement('div', { className: 'cscore_logo', dangerouslySetInnerHTML: { __html: logo && picture || '' } });
	
	  if (href != '' && href != '#') {
	    defaultLinkLogo.push(_react2.default.createElement('a', (0, _extends3.default)({ key: 'l2', dangerouslySetInnerHTML: { __html: logo && picture || '' } }, defaultLinkProps)));
	    defaultLinkAbbr.push(_react2.default.createElement(
	      'a',
	      (0, _extends3.default)({ key: 'l2a' }, defaultLinkAbbrProps),
	      teamname
	    ));
	  } else {
	    defaultLinkLogo.push(divLogoTag);
	    defaultLinkAbbr.push(spanAbbrTag);
	  }
	  return _react2.default.createElement(
	    'li',
	    { key: team, className: 'cscore_item cscore_item--' + team },
	    defaultLinkLogo,
	    rank && _react2.default.createElement(
	      'div',
	      { 'class': 'cscore_rank' },
	      rank
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cscore_team icon-font-after' },
	      _react2.default.createElement(
	        'div',
	        { className: 'cscore_truncate' },
	        defaultLinkAbbr
	      ),
	      _react2.default.createElement('div', { className: 'cscore_score ', dangerouslySetInnerHTML: { __html: scoreMarkupMobile } })
	    )
	  );
	};
	
	var ScoreCellHeader = exports.ScoreCellHeader = function ScoreCellHeader(_ref5) {
	  var _ref5$header = _ref5.header,
	      header = _ref5$header === undefined ? '' : _ref5$header,
	      _ref5$network = _ref5.network,
	      network = _ref5$network === undefined ? '' : _ref5$network,
	      _ref5$time = _ref5.time,
	      time = _ref5$time === undefined ? '' : _ref5$time,
	      _ref5$date = _ref5.date,
	      date = _ref5$date === undefined ? '' : _ref5$date,
	      _ref5$teams = _ref5.teams,
	      teams = _ref5$teams === undefined ? {} : _ref5$teams,
	      _ref5$sport = _ref5.sport,
	      sport = _ref5$sport === undefined ? '' : _ref5$sport,
	      _ref5$className = _ref5.className,
	      className = _ref5$className === undefined ? '' : _ref5$className,
	      _ref5$summaryText = _ref5.summaryText,
	      summaryText = _ref5$summaryText === undefined ? '' : _ref5$summaryText,
	      _ref5$winnerClassMobi = _ref5.winnerClassMobile,
	      winnerClassMobile = _ref5$winnerClassMobi === undefined ? '' : _ref5$winnerClassMobi,
	      _ref5$homeTeamBattedF = _ref5.homeTeamBattedFirst,
	      homeTeamBattedFirst = _ref5$homeTeamBattedF === undefined ? true : _ref5$homeTeamBattedF,
	      showGameDetailFooter = _ref5.showGameDetailFooter,
	      _ref5$isWebView = _ref5.isWebView,
	      isWebView = _ref5$isWebView === undefined ? false : _ref5$isWebView,
	      _ref5$isUpdatesOnly = _ref5.isUpdatesOnly,
	      isUpdatesOnly = _ref5$isUpdatesOnly === undefined ? false : _ref5$isUpdatesOnly,
	      _ref5$gameState = _ref5.gameState,
	      gameState = _ref5$gameState === undefined ? '' : _ref5$gameState;
	
	  var team1 = homeTeamBattedFirst ? teams.home : teams.away;
	  var team2 = homeTeamBattedFirst ? teams.away : teams.home;
	
	  var sportClass = sport;
	  if (sport === 'rugby-league') {
	    sportClass = 'rugby';
	  }
	  var matchStatusDesc = time && '' + time + (isUpdatesOnly && gameState === 'live' ? ' - Updates only' : '') || '';
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('cscore', className, sportClass, winnerClassMobile) },
	    _react2.default.createElement(
	      'div',
	      { className: 'cscore_link cscore_link--button' },
	      _react2.default.createElement(
	        'div',
	        { className: 'cscore_overview' },
	        (date || time) && _react2.default.createElement(
	          'div',
	          { className: 'cscore_date-time' },
	          date && _react2.default.createElement(
	            'span',
	            { className: 'cscore_date' },
	            date
	          ),
	          matchStatusDesc && _react2.default.createElement(
	            'span',
	            { className: 'cscore_time' },
	            matchStatusDesc
	          )
	        ),
	        header && _react2.default.createElement(
	          'div',
	          { className: 'cscore_info-overview' },
	          header
	        ),
	        network && _react2.default.createElement(
	          'div',
	          { className: 'cscore_network cscore_network--watch' },
	          _react2.default.createElement(
	            'div',
	            { className: 'cscore_channels icon-font-before icon-watch-outline-before' },
	            _react2.default.createElement(
	              'span',
	              null,
	              network
	            )
	          )
	        ) || null
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'cscore_details' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'cscore_competitors ' },
	          _react2.default.createElement(ScoreCellCompetitor, (0, _extends3.default)({ team: 'home' }, team1, { sport: sport, isWebView: isWebView })),
	          _react2.default.createElement(ScoreCellCompetitor, (0, _extends3.default)({ team: 'away' }, team2, { sport: sport, isWebView: isWebView }))
	        )
	      )
	    ),
	    summaryText && showGameDetailFooter && _react2.default.createElement(
	      'div',
	      { className: 'cscore_commentary cscore_commentary--footer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'cscore_notes' },
	        _react2.default.createElement(
	          'span',
	          { className: 'cscore_notes_game' },
	          summaryText
	        )
	      )
	    ) || null
	  );
	};
	
	exports.default = GameStrip;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EventSummary = exports.TeamSummary = exports.SummaryStat = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AnchorLink = __webpack_require__(682);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SummaryStat = exports.SummaryStat = function SummaryStat(_ref) {
	  var _ref$stats = _ref.stats,
	      stats = _ref$stats === undefined ? [] : _ref$stats,
	      _ref$statname = _ref.statname,
	      statname = _ref$statname === undefined ? '' : _ref$statname;
	
	
	  var statsMap = {
	    'tries': 'goal icon-font-before icon-rugby-solid-before icon-rugby-solid',
	    'conversiongoals': 'goal icon-font-before icon-rugby-conversion-solid-before icon-rugby-conversion-solid',
	    'penalties': 'goal icon-font-before icon-rugby-penalty-solid-before icon-rugby-penalty-solid',
	    'yellowcards': 'icon-font-before icon-soccer-card02-solid-before icon-yellowcard',
	    'redcards': 'icon-font-before icon-soccer-card02-solid-before icon-redcard',
	    'dropgoalsconverted': 'goal icon-font-before icon-rugby-drop-goal-solid-before icon-rugby-drop-goal-solid'
	  };
	
	  if (stats.length === 0 || statsMap.hasOwnProperty(statname) === false) {
	    return _react2.default.createElement('script', null);
	  }
	
	  var statNodesMarkup = [];
	
	  for (var playerId in stats) {
	    var playerStat = stats[playerId];
	    var times = '(' + playerStat.times.join(', ') + ')';
	    statNodesMarkup.push(_react2.default.createElement(
	      'li',
	      { key: playerId },
	      playerStat.link && _react2.default.createElement(
	        _AnchorLink2.default,
	        { target: '_blank', to: playerStat.link },
	        playerStat.name
	      ) || _react2.default.createElement(
	        'span',
	        { style: { fontWeight: 600 } },
	        playerStat.name
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        times
	      )
	    ));
	  }
	
	  return _react2.default.createElement(
	    'ul',
	    { className: statsMap[statname] },
	    statNodesMarkup
	  );
	};
	
	var TeamSummary = exports.TeamSummary = function TeamSummary(_ref2) {
	  var _ref2$team = _ref2.team,
	      team = _ref2$team === undefined ? {} : _ref2$team,
	      _ref2$how = _ref2.how,
	      how = _ref2$how === undefined ? 'home' : _ref2$how;
	
	
	  var summaryStats = [];
	  for (var stat in team) {
	    summaryStats.push(_react2.default.createElement(SummaryStat, { key: stat, stats: team[stat], statname: stat }));
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'team ' + how },
	    _react2.default.createElement(
	      'div',
	      { className: 'team-info players' },
	      summaryStats
	    )
	  );
	};
	
	var EventSummary = exports.EventSummary = function EventSummary(_ref3) {
	  var _ref3$summary = _ref3.summary,
	      summary = _ref3$summary === undefined ? {} : _ref3$summary;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'competitors' },
	    _react2.default.createElement(TeamSummary, { team: summary.home, how: 'away' }),
	    _react2.default.createElement(TeamSummary, { team: summary.away, how: 'home' })
	  );
	};
	
	exports.default = EventSummary;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(177);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A wrapper component for react-router links
	 * @param   {Object}                  props   link properties
	 * @return  {React.PropTypes.element} React   router Link
	 */
	var AnchorLink = function AnchorLink(props) {
	  var text = props.text,
	      trackingName = props.trackingName,
	      dataRoute = props.dataRoute,
	      classes = props.classes,
	      _props$isRouterLink = props.isRouterLink,
	      isRouterLink = _props$isRouterLink === undefined ? true : _props$isRouterLink,
	      href = props.to,
	      children = props.children;
	  /**
	   * isRouterLink specifies if this link is react router link / external link
	   *
	   * react-router-link class signifies that this link is handled by reduxion app
	   * Add any other classes as well. classNames module will strip off falsy
	   * values by default.
	   *
	   */
	
	  var allClasses = (0, _classnames2.default)(classes, { 'react-router-link': isRouterLink });
	
	  if (isRouterLink) {
	    return _react2.default.createElement(
	      _reactRouter.Link,
	      (0, _extends3.default)({ name: trackingName, className: allClasses, 'data-route': dataRoute || false }, props),
	      children || text
	    );
	  } else {
	    return _react2.default.createElement(
	      'a',
	      (0, _extends3.default)({ name: trackingName, className: allClasses, 'data-route': dataRoute || false, href: href }, props),
	      children || text
	    );
	  }
	};
	
	exports.default = AnchorLink;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
		* React banner logos for gamheaders
		*
		* @param  	{String} options.teamId  	Unique key to force lazyload plugin to update <img/>.src
		* @param  	{Array} options.bannerLogo  Logo URLs for teams
		* @return 	{React.PropTypes.element} 	BannerPicture element
	*/
	
	var BannerPicture = function BannerPicture(_ref) {
		var teamId = _ref.teamId,
		    _ref$bannerLogo = _ref.bannerLogo,
		    bannerLogo = _ref$bannerLogo === undefined ? '' : _ref$bannerLogo;
	
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'picture',
				null,
				_react2.default.createElement(
					'video',
					{ style: { display: 'none' } },
					_react2.default.createElement('source', { srcSet: bannerLogo })
				),
				_react2.default.createElement('img', { key: teamId, 'data-default-src': bannerLogo, className: 'team-logo lazyload', 'data-src': bannerLogo })
			),
			_react2.default.createElement(
				'svg',
				{ className: 'team__svg team__svg--primary', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', viewBox: '0 0 176 80' },
				_react2.default.createElement(
					'defs',
					null,
					_react2.default.createElement(
						'linearGradient',
						{ id: 'linear-gradient', x1: '108.61', y1: '752.49', x2: '90.78', y2: '770.32', gradientTransform: 'translate(-5 -710)', gradientUnits: 'userSpaceOnUse' },
						_react2.default.createElement('stop', { offset: '0', stopOpacity: '0' }),
						_react2.default.createElement('stop', { offset: '1' })
					)
				),
				_react2.default.createElement('polygon', { className: 'team__stroke', points: '81 80 80 80 0 0 1 0 81 80' }),
				_react2.default.createElement('polygon', { className: 'team__gradient', points: '170.1 80 122.1 80 42.1 0 90.1 0 170.1 80' })
			),
			_react2.default.createElement(
				'svg',
				{ className: 'team__svg team__svg--left', 'data-name': 'Layer 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 176 80' },
				_react2.default.createElement('polygon', { className: 'team__left', points: '0 80 80 80 0 0 0 80' })
			),
			_react2.default.createElement(
				'svg',
				{ className: 'team__svg team__svg--right', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', viewBox: '0 0 176 80' },
				_react2.default.createElement('polygon', { className: 'team__right', points: '176 0 96 0 176 80 176 0' })
			)
		);
	};
	
	module.exports = BannerPicture;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GameHeader = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GlobalNavTertiary = __webpack_require__(685);
	
	var _GlobalNavTertiary2 = _interopRequireDefault(_GlobalNavTertiary);
	
	var _GameStrip = __webpack_require__(680);
	
	var _GameHeaderLiveData = __webpack_require__(802);
	
	var _GameHeaderLiveData2 = _interopRequireDefault(_GameHeaderLiveData);
	
	var _PlayerOfTheMatch = __webpack_require__(803);
	
	var _PlayerOfTheMatch2 = _interopRequireDefault(_PlayerOfTheMatch);
	
	var _common = __webpack_require__(686);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GameHeader = exports.GameHeader = function GameHeader(_ref) {
	  var _ref$gameStrip = _ref.gameStrip,
	      gameStrip = _ref$gameStrip === undefined ? {} : _ref$gameStrip,
	      _ref$sport = _ref.sport,
	      sport = _ref$sport === undefined ? '' : _ref$sport,
	      _ref$links = _ref.links,
	      links = _ref$links === undefined ? [] : _ref$links,
	      _ref$pageType = _ref.pageType,
	      pageType = _ref$pageType === undefined ? '' : _ref$pageType,
	      _ref$innings = _ref.innings,
	      innings = _ref$innings === undefined ? {} : _ref$innings,
	      _ref$gameState = _ref.gameState,
	      gameState = _ref$gameState === undefined ? '' : _ref$gameState,
	      _ref$matchFlags = _ref.matchFlags,
	      matchFlags = _ref$matchFlags === undefined ? {} : _ref$matchFlags,
	      _ref$playerOfTheMatch = _ref.playerOfTheMatch,
	      playerOfTheMatch = _ref$playerOfTheMatch === undefined ? [] : _ref$playerOfTheMatch,
	      _ref$gameStateClassMo = _ref.gameStateClassMobile,
	      gameStateClassMobile = _ref$gameStateClassMo === undefined ? '' : _ref$gameStateClassMo,
	      summaryText = _ref.summaryText,
	      showGameDetailFooter = _ref.showGameDetailFooter,
	      _ref$watchESPNLink = _ref.watchESPNLink,
	      watchESPNLink = _ref$watchESPNLink === undefined ? {} : _ref$watchESPNLink,
	      _ref$fullWidth = _ref.fullWidth,
	      fullWidth = _ref$fullWidth === undefined ? false : _ref$fullWidth,
	      _ref$isWebView = _ref.isWebView,
	      isWebView = _ref$isWebView === undefined ? false : _ref$isWebView,
	      _ref$device = _ref.device,
	      device = _ref$device === undefined ? {} : _ref$device;
	
	
	  // show player of the match module if total player received the award upto 2
	  var showPlayerOfTheMatch = false;
	  if (playerOfTheMatch.length > 0 && playerOfTheMatch.length < 3) {
	    showPlayerOfTheMatch = true;
	  }
	
	  //minimum one data require to set as true
	  var showGameHeaderLiveData = false;
	  if (innings.crr || innings.rrr || innings.minRemainingOvers || innings.lastNForInnings) {
	    showGameHeaderLiveData = true;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('sub-module gameHeader', { 'gameHeader--fullWidth': fullWidth }) },
	    _react2.default.createElement(
	      'div',
	      { className: 'gp__cricket__gameHeader' },
	      _react2.default.createElement(_GameStrip.ScoreCellHeader, (0, _extends3.default)({}, gameStrip, {
	        sport: sport,
	        className: gameStateClassMobile,
	        summaryText: summaryText,
	        showGameDetailFooter: showGameDetailFooter,
	        isUpdatesOnly: matchFlags.updatesOnly,
	        gameState: gameState,
	        isWebView: isWebView })),
	
	      //aditional data such as crr,rrr,min ov rem, last n overs data when match is live state
	      //do not show if showPlayerOfTheMatch is true ie player of the match is announced
	      gameState === 'live' && !showPlayerOfTheMatch && showGameHeaderLiveData && _react2.default.createElement(_GameHeaderLiveData2.default, { key: 'ld', crr: innings.crr, rrr: innings.rrr, minRemainingOvers: innings.minRemainingOvers, lastNForInnings: innings.lastNForInnings, isLimitedOvers: matchFlags.limitedOvers }) || null,
	
	      //show player of the match when avaialble
	      showPlayerOfTheMatch && _react2.default.createElement(_PlayerOfTheMatch2.default, { key: 'pm', pom: playerOfTheMatch }) || null
	    ),
	
	    //show Watch ESPN link if available. if available also check if device type is desktop
	    gameState === 'live' && watchESPNLink && watchESPNLink.href && device.desktop === true && [_react2.default.createElement(
	      'ul',
	      { className: 'mobile-button-group' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _common.AnchorLink,
	          { to: watchESPNLink.href, classes: 'button-alt med stand-alone watch-live', isRouterLink: false },
	          'Watch'
	        )
	      )
	    ), _react2.default.createElement(
	      'ul',
	      { id: 'watch-listen-desktop', className: 'desktop-button-group desktop-tablet-only' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _common.AnchorLink,
	          { to: watchESPNLink.href, classes: 'icon-font-before icon-watch-outline-before', isRouterLink: false },
	          'Watch'
	        )
	      )
	    )] || null,
	    _react2.default.createElement(_GlobalNavTertiary2.default, { links: links, activeKey: pageType, spacerId: 'watch-listen-desktop' })
	  );
	};
	
	exports.default = GameHeader;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GlobalNavTertiary = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /* global jQuery */
	
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _common = __webpack_require__(686);
	
	var _common2 = __webpack_require__(423);
	
	var utils = _interopRequireWildcard(_common2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GlobalNavTertiary = exports.GlobalNavTertiary = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(GlobalNavTertiary, _React$Component);
	
	  function GlobalNavTertiary(props) {
	    (0, _classCallCheck3.default)(this, GlobalNavTertiary);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (GlobalNavTertiary.__proto__ || (0, _getPrototypeOf2.default)(GlobalNavTertiary)).call(this, props));
	
	    _this._initNav = _this._initNav.bind(_this);
	    _this._toggleMoreLinks = _this._toggleMoreLinks.bind(_this);
	    _this._hideMoreLinks = _this._hideMoreLinks.bind(_this);
	    _this._setSubContentHeight = _this._setSubContentHeight.bind(_this);
	
	    // by default more links are hidden
	    _this.state = {
	      showMoreLinks: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(GlobalNavTertiary, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // keep the ref of throttled Fn
	      this._handleResize = utils.throttle(this._initNav, 150).bind(this);
	
	      try {
	        jQuery(window).on('resize orientationchange', this._handleResize);
	        this._initNav();
	      } catch (err) {
	        console.error(err);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      jQuery(window).off('resize orientationchange', this._handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      var linksCount = this.props.links.length;
	
	      // reset the state of visibleCount & linksCount
	      this.setState({
	        visibleCount: linksCount,
	        linksCount: linksCount,
	        isReset: true
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      try {
	        jQuery('.sub a[data-linktype=' + this.props.activeKey + ']').parent().addClass('active');
	      } catch (err) {
	        console.error(err);
	      }
	
	      // re-init only if previous props and current props are diff
	      if (prevProps !== this.props) {
	        this._initNav();
	      }
	    }
	
	    /**
	     * init Navigation
	     * @return {undefined}
	     */
	
	  }, {
	    key: '_initNav',
	    value: function _initNav() {
	      var navContainer = this.refs.navContainer;
	
	      // no init if the nav is hidden
	
	      if (jQuery(navContainer).is(':hidden')) {
	        return;
	      }
	
	      var visibleCount = void 0;
	      var linksCount = this.state.linksCount;
	
	      var deviceType = utils.deviceType();
	
	      this._resetNav();
	
	      // scrollable nav if device is mobile with touch
	      if (deviceType.isMobile && deviceType.isTouch) {
	        visibleCount = linksCount;
	      }
	      /*
	       * display more-button if device is not mobile
	       * or no touch
	       */
	      else {
	          visibleCount = this._getVisibleCount();
	
	          // hide the more links on resize if all links visible
	          if (visibleCount === linksCount) {
	            this._hideMoreLinks();
	          }
	        }
	
	      this.setState({
	        visibleCount: visibleCount,
	        isReset: false
	      });
	    }
	
	    /**
	     * reset the naviagation and
	     * make all the links and more button visible
	     * @return {undefined}
	     */
	
	  }, {
	    key: '_resetNav',
	    value: function _resetNav() {
	      var linksCount = this.state.linksCount;
	
	
	      this.setState({
	        visibleCount: linksCount,
	        isReset: true
	      });
	    }
	
	    /**
	     * Event Handler
	     * hide more links and remove scroll-lock
	     * @return {undefined}
	     */
	
	  }, {
	    key: '_hideMoreLinks',
	    value: function _hideMoreLinks() {
	      this.setState({
	        showMoreLinks: false
	      });
	
	      this._scrollLock(false);
	    }
	
	    /**
	     * Event Handler
	     * toggle the more links show/hide
	     * @return {undefined} [description]
	     */
	
	  }, {
	    key: '_toggleMoreLinks',
	    value: function _toggleMoreLinks() {
	      var showMoreLinks = this.state.showMoreLinks;
	
	
	      showMoreLinks = !showMoreLinks;
	
	      this.setState({
	        showMoreLinks: showMoreLinks
	      });
	
	      this._scrollLock(showMoreLinks);
	
	      return false;
	    }
	
	    /**
	     * lock scroll bar
	     * @param  {Boolean} shouldLock - on/off flag
	     * @return {undefined}
	     */
	
	  }, {
	    key: '_scrollLock',
	    value: function _scrollLock() {
	      var shouldLock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (typeof utils.scrollLock === 'function') {
	        utils.scrollLock(shouldLock);
	      }
	    }
	
	    /**
	     * set the height of sub-content
	     * @return {undefined}
	     */
	
	  }, {
	    key: '_setSubContentHeight',
	    value: function _setSubContentHeight() {
	      var _refs = this.refs,
	          subContent = _refs.subContent,
	          navWrap = _refs.navWrap;
	
	      var deviceType = utils.deviceType();
	      var height = void 0;
	
	      if (typeof subContent === 'undefined' || typeof navWrap === 'undefined') {
	        return;
	      }
	
	      if (deviceType.isTablet || deviceType.isMobile && !deviceType.isTouch) {
	        var windowHeight = jQuery(window).outerHeight();
	        var navWrap$ = jQuery(navWrap);
	        var navWrapHeight = navWrap$.outerHeight();
	        var navWrapOffsetY = navWrap$.offset().top;
	
	        height = windowHeight - navWrapOffsetY - navWrapHeight + 'px';
	      } else {
	        height = '0px';
	      }
	
	      subContent.style.minHeight = height;
	    }
	
	    /**
	     * calculate the visible links
	     * @return {Number}   - count of visible links
	     */
	
	  }, {
	    key: '_getVisibleCount',
	    value: function _getVisibleCount() {
	      var _refs2 = this.refs,
	          firstGroup = _refs2.firstGroup,
	          navContainer = _refs2.navContainer;
	      var _props$spacerId = this.props.spacerId,
	          spacerId = _props$spacerId === undefined ? '' : _props$spacerId;
	
	      var spacerWidth = jQuery('#' + spacerId).width();
	      var firstGroup$ = jQuery(firstGroup);
	      var lis = firstGroup$.find('li.sub');
	      var containerWidth = jQuery(navContainer).width() - spacerWidth;
	
	      // total width of 'more' button (including margin)
	      var moreButtonWidth = firstGroup$.find('.has-sub').outerWidth(true);
	
	      // intial to '0'
	      var maxVisibleLinks = 0;
	
	      // init with 'more' button width + 50px gutter space
	      var totalWidth = moreButtonWidth + 50;
	
	      for (var i = 0, len = lis.length; i < len; i++) {
	        var outerWidth = jQuery(lis[i]).outerWidth(true);
	        if (totalWidth + outerWidth > containerWidth) {
	          break;
	        } else {
	          maxVisibleLinks++;
	          totalWidth += outerWidth;
	        }
	      }
	
	      return maxVisibleLinks;
	    }
	
	    /**
	     * build nav links
	     * @param  {Array} options.links      links
	     * @param  {String} options.activeKey activeKey
	     * @param  {String} options.keyProp   key prop to check active link
	     * @return {Array}                    Array of React elements of links
	     */
	
	  }, {
	    key: '_buildLinks',
	    value: function _buildLinks(_ref) {
	      var _this2 = this;
	
	      var links = _ref.links,
	          activeKey = _ref.activeKey,
	          _ref$keyProp = _ref.keyProp,
	          keyProp = _ref$keyProp === undefined ? 'pageType' : _ref$keyProp;
	      var showMoreLinks = this.state.showMoreLinks;
	
	
	      return links.map(function (link, i) {
	        // mark active if more links is hidden and match the pageType
	        var liClass = (0, _classnames2.default)('sub', { active: !showMoreLinks && activeKey == link[keyProp] });
	        var anchorClass = (0, _classnames2.default)(link.pageType, link.external);
	        /**
	         * By default, all links on tertiary nav are handled by react router
	         * If link is external, set to false. Anchor component will not add class
	         * which specifies that this is react router link.
	         */
	        var isRouterLink = typeof link.isRouterLink === 'boolean' ? link.isRouterLink : true;
	        // external links need to open in new window
	        var linkTarget = {};
	        if (link.external) {
	          isRouterLink = false;
	          linkTarget.target = '_blank';
	        }
	        var text = [_react2.default.createElement(
	          'span',
	          { key: 't', className: 'link-text' },
	          link.text
	        ), _react2.default.createElement(
	          'span',
	          { key: 'st', className: 'link-text-short' },
	          link.text
	        )];
	        return _react2.default.createElement(
	          'li',
	          { key: i, className: liClass },
	          _react2.default.createElement(_common.AnchorLink, (0, _extends3.default)({ trackingName: link.trackingName }, linkTarget, { 'data-linktype': link.pageType || '', classes: anchorClass, text: text, to: link.href, onClick: _this2._hideMoreLinks, isRouterLink: isRouterLink }))
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var deviceType = utils.deviceType();
	      var _props = this.props,
	          _props$links = _props.links,
	          links = _props$links === undefined ? [] : _props$links,
	          _props$activeKey = _props.activeKey,
	          activeKey = _props$activeKey === undefined ? '' : _props$activeKey;
	      var _state = this.state,
	          visibleCount = _state.visibleCount,
	          linksCount = _state.linksCount,
	          showMoreLinks = _state.showMoreLinks,
	          isReset = _state.isReset;
	
	      var overlayClass = (0, _classnames2.default)('more-overlay-primary', { 'active': showMoreLinks && (deviceType.isTablet || deviceType.isMobile && !deviceType.isTouch) });
	      var moreLiClass = (0, _classnames2.default)('has-sub', { 'show hover': showMoreLinks });
	
	      var visibleLinks = this._buildLinks({ links: links, activeKey: activeKey });
	      var moreLinks = [];
	
	      if (visibleCount !== linksCount) {
	        moreLinks = visibleLinks.slice(visibleCount);
	        visibleLinks = visibleLinks.slice(0, visibleCount);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'gamepackage-links-wrap', ref: 'navWrap' },
	        _react2.default.createElement('div', { className: overlayClass }),
	        _react2.default.createElement(
	          'nav',
	          { id: 'global-nav-tertiary', className: 'game-package-nav', style: { display: 'block' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'tertiary-nav-container', style: { 'overflow': 'visible' }, ref: 'navContainer' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'first-group', ref: 'firstGroup', style: { 'overflow': showMoreLinks ? 'visible' : '' } },
	              visibleLinks,
	              !(isReset || moreLinks.length) ? '' : _react2.default.createElement(
	                'li',
	                { className: moreLiClass, onClick: this._toggleMoreLinks, onMouseEnter: this._setSubContentHeight },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'more-link', 'data-route': 'false' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'link-text' },
	                    'More'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'link-text-short' },
	                    'More'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sub-content', style: { 'top': '100%' }, ref: 'subContent' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'split' },
	                    moreLinks
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return GlobalNavTertiary;
	}(_react2.default.Component), _class.propTypes = {
	  links: _react.PropTypes.array.isRequired,
	  activeKey: _react.PropTypes.string.isRequired
	}, _temp);
	exports.default = GlobalNavTertiary;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LongStripAd = exports.Search = exports.DesktopScoreboardModule = exports.TopHighlights = exports.BowlerLite = exports.BatsmanLite = exports.PlayerStats = exports.Recaptcha = exports.Textarea = exports.Button = exports.Input = exports.LoaderIcon = exports.Picture = exports.BackToTop = exports.Lazyload = exports.TopStories = exports.ContentSummary = exports.VideoSlider = exports.Bet365 = exports.Video = exports.FixturesAndResultsModule = exports.TopScorersModule = exports.TeamRankingsModule = exports.StandingsModule = exports.Outbrain = exports.NewsModule = exports.Glossary = exports.DropdownSelect = exports.DropdownList = exports.Dropdown = exports.DatePickerV2 = exports.DatePicker = exports.DateSliderV2 = exports.DateSlider = exports.ContentWrapper = exports.AnchorLink = exports.Ad = undefined;
	
	var _Ad = __webpack_require__(687);
	
	var _Ad2 = _interopRequireDefault(_Ad);
	
	var _AnchorLink = __webpack_require__(682);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	var _ContentWrapper = __webpack_require__(688);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _DateSlider = __webpack_require__(689);
	
	var _DateSlider2 = _interopRequireDefault(_DateSlider);
	
	var _DateSliderV = __webpack_require__(692);
	
	var _DateSliderV2 = _interopRequireDefault(_DateSliderV);
	
	var _DatePicker = __webpack_require__(690);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _DatePickerV = __webpack_require__(693);
	
	var _DatePickerV2 = _interopRequireDefault(_DatePickerV);
	
	var _Dropdown = __webpack_require__(694);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _DropdownList = __webpack_require__(695);
	
	var _DropdownList2 = _interopRequireDefault(_DropdownList);
	
	var _DropdownSelect = __webpack_require__(696);
	
	var _DropdownSelect2 = _interopRequireDefault(_DropdownSelect);
	
	var _Glossary = __webpack_require__(697);
	
	var _Glossary2 = _interopRequireDefault(_Glossary);
	
	var _News = __webpack_require__(698);
	
	var _News2 = _interopRequireDefault(_News);
	
	var _Outbrain = __webpack_require__(590);
	
	var _Outbrain2 = _interopRequireDefault(_Outbrain);
	
	var _Standings = __webpack_require__(700);
	
	var _Standings2 = _interopRequireDefault(_Standings);
	
	var _TeamRankings = __webpack_require__(701);
	
	var _TeamRankings2 = _interopRequireDefault(_TeamRankings);
	
	var _TopScorers = __webpack_require__(704);
	
	var _TopScorers2 = _interopRequireDefault(_TopScorers);
	
	var _FixturesAndResults = __webpack_require__(706);
	
	var _FixturesAndResults2 = _interopRequireDefault(_FixturesAndResults);
	
	var _Video = __webpack_require__(708);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _Bet = __webpack_require__(709);
	
	var _Bet2 = _interopRequireDefault(_Bet);
	
	var _VideoSlider = __webpack_require__(710);
	
	var _VideoSlider2 = _interopRequireDefault(_VideoSlider);
	
	var _ContentSummary = __webpack_require__(711);
	
	var _ContentSummary2 = _interopRequireDefault(_ContentSummary);
	
	var _TopStories = __webpack_require__(712);
	
	var _TopStories2 = _interopRequireDefault(_TopStories);
	
	var _Lazyload = __webpack_require__(713);
	
	var _Lazyload2 = _interopRequireDefault(_Lazyload);
	
	var _BackToTop = __webpack_require__(721);
	
	var _BackToTop2 = _interopRequireDefault(_BackToTop);
	
	var _Picture = __webpack_require__(699);
	
	var _Picture2 = _interopRequireDefault(_Picture);
	
	var _LoaderIcon = __webpack_require__(722);
	
	var _LoaderIcon2 = _interopRequireDefault(_LoaderIcon);
	
	var _Input = __webpack_require__(723);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(724);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Textarea = __webpack_require__(725);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _Recaptcha = __webpack_require__(726);
	
	var _Recaptcha2 = _interopRequireDefault(_Recaptcha);
	
	var _PlayerStats = __webpack_require__(795);
	
	var _PlayerStats2 = _interopRequireDefault(_PlayerStats);
	
	var _BatsmanLite = __webpack_require__(796);
	
	var _BatsmanLite2 = _interopRequireDefault(_BatsmanLite);
	
	var _BowlerLite = __webpack_require__(797);
	
	var _BowlerLite2 = _interopRequireDefault(_BowlerLite);
	
	var _TopHighlights = __webpack_require__(798);
	
	var _TopHighlights2 = _interopRequireDefault(_TopHighlights);
	
	var _DesktopScoreboard = __webpack_require__(799);
	
	var _DesktopScoreboard2 = _interopRequireDefault(_DesktopScoreboard);
	
	var _Search = __webpack_require__(800);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _LongStripAd = __webpack_require__(801);
	
	var _LongStripAd2 = _interopRequireDefault(_LongStripAd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Ad = _Ad2.default;
	exports.AnchorLink = _AnchorLink2.default;
	exports.ContentWrapper = _ContentWrapper2.default;
	exports.DateSlider = _DateSlider2.default;
	exports.DateSliderV2 = _DateSliderV2.default;
	exports.DatePicker = _DatePicker2.default;
	exports.DatePickerV2 = _DatePickerV2.default;
	exports.Dropdown = _Dropdown2.default;
	exports.DropdownList = _DropdownList2.default;
	exports.DropdownSelect = _DropdownSelect2.default;
	exports.Glossary = _Glossary2.default;
	exports.NewsModule = _News2.default;
	exports.Outbrain = _Outbrain2.default;
	exports.StandingsModule = _Standings2.default;
	exports.TeamRankingsModule = _TeamRankings2.default;
	exports.TopScorersModule = _TopScorers2.default;
	exports.FixturesAndResultsModule = _FixturesAndResults2.default;
	exports.Video = _Video2.default;
	exports.Bet365 = _Bet2.default;
	exports.VideoSlider = _VideoSlider2.default;
	exports.ContentSummary = _ContentSummary2.default;
	exports.TopStories = _TopStories2.default;
	exports.Lazyload = _Lazyload2.default;
	exports.BackToTop = _BackToTop2.default;
	exports.Picture = _Picture2.default;
	exports.LoaderIcon = _LoaderIcon2.default;
	exports.Input = _Input2.default;
	exports.Button = _Button2.default;
	exports.Textarea = _Textarea2.default;
	exports.Recaptcha = _Recaptcha2.default;
	exports.PlayerStats = _PlayerStats2.default;
	exports.BatsmanLite = _BatsmanLite2.default;
	exports.BowlerLite = _BowlerLite2.default;
	exports.TopHighlights = _TopHighlights2.default;
	exports.DesktopScoreboardModule = _DesktopScoreboard2.default;
	exports.Search = _Search2.default;
	exports.LongStripAd = _LongStripAd2.default;
	exports.default = {
	  Ad: _Ad2.default,
	  AnchorLink: _AnchorLink2.default,
	  ContentWrapper: _ContentWrapper2.default,
	  DateSlider: _DateSlider2.default,
	  DateSliderV2: _DateSliderV2.default,
	  DatePicker: _DatePicker2.default,
	  DatePickerV2: _DatePickerV2.default,
	  Dropdown: _Dropdown2.default,
	  DropdownList: _DropdownList2.default,
	  DropdownSelect: _DropdownSelect2.default,
	  Glossary: _Glossary2.default,
	  NewsModule: _News2.default,
	  Outbrain: _Outbrain2.default,
	  StandingsModule: _Standings2.default,
	  TeamRankingsModule: _TeamRankings2.default,
	  TopScorersModule: _TopScorers2.default,
	  FixturesAndResultsModule: _FixturesAndResults2.default,
	  Video: _Video2.default,
	  Bet365: _Bet2.default,
	  VideoSlider: _VideoSlider2.default,
	  ContentSummary: _ContentSummary2.default,
	  TopStories: _TopStories2.default,
	  Lazyload: _Lazyload2.default,
	  BackToTop: _BackToTop2.default,
	  Picture: _Picture2.default,
	  LoaderIcon: _LoaderIcon2.default,
	  Input: _Input2.default,
	  Button: _Button2.default,
	  Textarea: _Textarea2.default,
	  Recaptcha: _Recaptcha2.default,
	  PlayerStats: _PlayerStats2.default,
	  BatsmanLite: _BatsmanLite2.default,
	  BowlerLite: _BowlerLite2.default,
	  TopHighlights: _TopHighlights2.default,
	  DesktopScoreboardModule: _DesktopScoreboard2.default,
	  Search: _Search2.default,
	  LongStripAd: _LongStripAd2.default
	};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ad = function (_React$Component) {
	  (0, _inherits3.default)(Ad, _React$Component);
	
	  function Ad() {
	    (0, _classCallCheck3.default)(this, Ad);
	    return (0, _possibleConstructorReturn3.default)(this, (Ad.__proto__ || (0, _getPrototypeOf2.default)(Ad)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Ad, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          collapseBeforeLoad = _props.collapseBeforeLoad,
	          refreshIfVisible = _props.refreshIfVisible,
	          isOutOfPage = _props.isOutOfPage,
	          _props$slotType = _props.slotType,
	          slotType = _props$slotType === undefined ? null : _props$slotType,
	          _props$include = _props.include,
	          include = _props$include === undefined ? [] : _props$include,
	          _props$exclude = _props.exclude,
	          exclude = _props$exclude === undefined ? [] : _props$exclude,
	          _props$kvps = _props.kvps,
	          kvps = _props$kvps === undefined ? {} : _props$kvps,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          _props$kvpos = _props.kvpos,
	          kvpos = _props$kvpos === undefined ? '' : _props$kvpos,
	          _props$inView = _props.inView,
	          inView = _props$inView === undefined ? false : _props$inView,
	          _props$isAdBlock = _props.isAdBlock,
	          isAdBlock = _props$isAdBlock === undefined ? false : _props$isAdBlock;
	
	
	      var slotKvps = [];
	      var adProps = { id: id, key: id
	
	        /* no type no ad */
	      };if (slotType === null || isAdBlock === true) {
	        return null;
	      }
	
	      /* default if pos not specified */
	      if (typeof kvps.pos === 'undefined') {
	        kvps.pos = slotType;
	      }
	
	      /* build key value pair string */
	      for (var k in kvps) {
	        if (k !== null && kvps.k !== null) {
	          slotKvps.push(k + '=' + kvps[k]);
	        }
	      }
	
	      /* build up the div properties */
	      adProps.className = (0, _classnames2.default)('react-ad', className, {
	        'ad-slot': !inView ? true : false
	      });
	
	      adProps['data-slot-type'] = slotType;
	      adProps['data-kvpos'] = kvpos;
	
	      if (isOutOfPage) {
	        adProps['data-out-of-page'] = 'true';
	      }
	
	      if (refreshIfVisible) {
	        adProps['data-refresh-if-visible'] = 'true';
	      }
	
	      if (collapseBeforeLoad) {
	        adProps['data-collapse-before-load'] = 'true';
	      }
	
	      if (include.length > 0) {
	        var includeStr = include.join(',');
	        adProps['data-include-bp'] = includeStr;
	      }
	
	      if (exclude.length > 0) {
	        var excludeStr = exclude.join(',');
	        adProps['data-exclude-bp'] = excludeStr;
	      }
	
	      if (slotKvps.length > 0) {
	        var kvpsStr = slotKvps.join(',');
	        adProps['data-slot-kvps'] = kvpsStr;
	      }
	
	      return _react2.default.createElement('div', adProps);
	    }
	  }]);
	  return Ad;
	}(_react2.default.Component);
	
	exports.default = Ad;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentWrapper = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Ad = __webpack_require__(687);
	
	var _Ad2 = _interopRequireDefault(_Ad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentWrapper = exports.ContentWrapper = function ContentWrapper(_ref) {
	  var content = _ref.content,
	      pageType = _ref.pageType,
	      isAdBlock = _ref.isAdBlock;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('div', { id: 'custom-nav', 'data-id': pageType }),
	    _react2.default.createElement(
	      'div',
	      { className: 'ad-banner-wrapper' },
	      _react2.default.createElement(_Ad2.default, { id: 'banner', className: 'react-ad ad-slot-banner ad-wrapper', slotType: 'banner', 'data-slot-type': 'banner', 'data-slot-kvps': 'pos=banner', isAdBlock: isAdBlock })
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'main-container' },
	      content
	    )
	  );
	};
	
	exports.default = ContentWrapper;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(308);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DatePicker = __webpack_require__(690);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _dateformat = __webpack_require__(437);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _createReactClass = __webpack_require__(691);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	    Action:     Output dynamic date selector
	    Original:   ---
	                https://github.com/akiran/react-slick cut down version of this slider functionality
	    Orginator:  ben.hobden@espn.com
	    Returns:    The JavaScript date iobject in the callback function
	*/
	
	var DateSlider = (0, _createReactClass2.default)({
	
	  displayName: 'DateSelect',
	
	  mixins: [_dateformat2.default],
	
	  getInitialState: function getInitialState() {
	    var iDayRange = 7;
	    var iItemWidth = 36;
	    var maxWidthMedium = 768;
	
	    /*
	      Below condition checks for screen size and initialize iDayRange and iItemWidth
	      based on that. For mobile < 768 iItemWidth is fixed to 40px
	    */
	    if (process.browser && screen && 'width' in screen && screen.width < maxWidthMedium) {
	      iDayRange = 5;
	      iItemWidth = 40;
	    }
	
	    var iStartPos = 0 - iDayRange * iItemWidth;
	    return {
	      activeDate: null,
	      displayDate: null,
	      oneDay: 86400000, // 1 day in milliseconds
	      dayRange: iDayRange,
	      itemWidth: iItemWidth,
	      touchObject: {
	        startX: null,
	        startY: null,
	        curX: null,
	        curY: null,
	        swipeLength: null
	      },
	      didSwipe: false,
	      dragging: false,
	      animate: false,
	      currentPos: iStartPos,
	      touchSliderMove: iStartPos
	    };
	  },
	
	  /**
	  * Intial load so add the date to the state for use and manipulation
	  * @returns {undefined} undefined
	  **/
	  componentWillMount: function componentWillMount() {
	    var date = this.props.date;
	    if (!date) {
	      date = new Date();
	      date = date.toISOString();
	    }
	    var oDate = this.dateToObject(date) || new Date();
	    var iDate = oDate.setHours(0, 0, 0, 0);
	    this.setState({
	      activeDate: iDate,
	      displayDate: iDate
	    });
	  },
	
	  /**
	  * Reset state if date has changed
	  *
	  * @param {Object} nextProps Props
	  * @returns {undefined} undefined
	  **/
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var oDate = this.dateToObject(nextProps.date) || new Date();
	    var iDate = oDate.setHours(0, 0, 0, 0);
	    if (nextProps.date !== this.props.date) {
	      this.animateToDate(iDate);
	      this.setState({
	        activeDate: iDate,
	        didSwipe: false
	      });
	    }
	  },
	
	  /**
	  * Captures the date of the node clicked and sets the state to that. If
	  * a swipe was tracked the click is ignored and the swipe tracker reset
	  *
	  * @param {Number} iDate date
	  * @param {Number} iItemPos position index
	  * @param {Object} e Event
	  * @returns {undefined} undefined
	  **/
	  selectDate: function selectDate(iDate, iItemPos, e) {
	    if (e && e.stopPropagation) {
	      e.stopPropagation();
	    }
	    if (e && e.preventDefault) {
	      e.preventDefault();
	    }
	    iDate = (typeof iDate === 'undefined' ? 'undefined' : (0, _typeof3.default)(iDate)) === 'object' ? iDate.setHours(0, 0, 0, 0) : iDate;
	    if (typeof this.state.touchObject.swipeLength !== 'number') {
	      this.setState({
	        activeDate: iDate
	      });
	      this.animateToDate(iDate);
	      this.dateSelected(iDate);
	    }
	  },
	
	  /**
	  * Subtracts 7 days from the current date and then forces a redraw
	  * @returns {undefined} undefined
	  **/
	  previous: function previous() {
	    var iNewDate = this.state.displayDate - this.state.oneDay * this.state.dayRange;
	    this.animateToDate(iNewDate);
	  },
	
	  /**
	  * Adds 7 days to the current date and then forces a redraw
	  * @returns {undefined} undefined
	  **/
	  next: function next() {
	    var iNewDate = this.state.displayDate + this.state.oneDay * this.state.dayRange;
	    this.animateToDate(iNewDate);
	  },
	
	  /**
	  * Redraws the page to last know good state
	  * @returns {undefined} undefined
	  **/
	  reset: function reset() {
	    this.setState({});
	  },
	
	  /**
	  * Capture the start position of the mouse/touch so that we can
	  * determine the direction and size of the interaction later.
	  *
	  * @param {Object} e event object
	  * @returns {undefined} undefined
	  **/
	  swipeStart: function swipeStart(e) {
	
	    var posX, posY;
	
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	
	    // e.preventDefault()
	  },
	
	  /**
	  * Captures the current mouse/finger movement and stores the value to
	  * allow the position of the slider to be updated.
	  *
	  * @param {Object} e event object
	  * @returns {undefined} undefined
	  **/
	  swipeMove: function swipeMove(e) {
	
	    if (!this.state.dragging) {
	      return;
	    }
	
	    var touchObject = this.state.touchObject;
	
	    var iCurrX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = touchObject.curX - touchObject.startX;
	    var iMoved = iCurrX - this.state.touchObject.curX;
	    touchObject.curX = iCurrX;
	    var dayRange = this.state.dayRange;
	    var touchSlider = {
	      touchObject: touchObject
	    };
	    if (dayRange == 5) {
	      var swipeMoved = null;
	      var swipeDirection = this.swipeDirection(touchObject);
	      if (swipeDirection === 'left') {
	        swipeMoved = this.state.currentPos + iCurrX;
	      } else if (swipeDirection === 'right') {
	        swipeMoved = this.state.currentPos - iCurrX;
	      }
	      touchSlider.touchSliderMove = swipeMoved;
	    } else {
	      touchSlider.touchSliderMove = this.state.currentPos + iMoved;
	    }
	    this.setState(touchSlider);
	    e.preventDefault();
	  },
	
	  /**
	  * Capture end event and then calculate the action desired by the user
	  *
	  * @param {Object} e event object
	  * @returns {undefined} undefined
	  **/
	  swipeEnd: function swipeEnd() {
	
	    // e.preventDefault()
	
	    if (!this.state.dragging) {
	      return;
	    }
	
	    var touchObject = this.state.touchObject;
	    // var minSwipe        = this.state.listWidth/this.props.touchThreshold
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      touchObject: {},
	      swipeLength: 0,
	      touchSliderMove: this.state.currentPos
	    });
	
	    if (swipeDirection === 'left' && Math.abs(touchObject.swipeLength) > 5) {
	      this.setState({ didSwipe: true });
	      this.previous();
	    } else if (swipeDirection === 'right' && Math.abs(touchObject.swipeLength) > 5) {
	      this.setState({ didSwipe: true });
	      this.next();
	    } else if (Math.abs(touchObject.swipeLength) > 1) {
	      // micro swipe, not really a click.
	      this.reset();
	    } else {
	      this.reset();
	    }
	  },
	
	  /**
	  * Determines whether the swipe was within a certain angle range and
	  * therefore a horizontal swipe rather than a verticle one.
	  *
	  * @param {Object} touchObject touchObject
	  * @returns {String} left/right/vertical
	  **/
	  swipeDirection: function swipeDirection(touchObject) {
	
	    var xDist = touchObject.startX - touchObject.curX;
	    var yDist = touchObject.startY - touchObject.curY;
	    var r = Math.atan2(yDist, xDist);
	    var swipeAngle = Math.round(r * 180 / Math.PI);
	
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	
	    return 'vertical';
	  },
	
	  /**
	  * for performance reasons provide a facility to throttle the updates
	  * triggered by mousemove
	  *
	  * @param {Number} delay time to delay
	  * @param {Function} callback function reference which needs to be throttled
	  * @returns {Function} Anonymous Function
	  **/
	  _throttle: function _throttle(delay, callback) {
	    var previousCall = new Date().getTime();
	    return function () {
	      var time = new Date().getTime();
	      if (time - previousCall >= delay) {
	        previousCall = time;
	        callback.apply(null, arguments);
	      }
	    };
	  },
	
	  render: function render() {
	    var oActiveDates = this.props.activeDates || {};
	    var iDisplayDate = this.state.displayDate;
	    var iActiveDate = this.state.activeDate;
	    var iOneDay = this.state.oneDay;
	    var iDayRange = this.state.dayRange;
	    var iItemWidth = this.state.itemWidth;
	    // var iSwipeLen       = this.state.touchObject.swipeLength || 0
	    var aDayNames = this.dateDayNamesMedium();
	    var iStartDate = iDisplayDate - iOneDay * iDayRange;
	    var iEndDate = iDisplayDate + (iDayRange - 1) * iOneDay;
	    var aOptNodes = [];
	    var showWeek = this.props.showWeek;
	    var allDaysActive = this.props.allDaysActive;
	    /**
	    * Build the date list for the carousel, take the date and build
	    * an item for each day X days either side
	    **/
	    for (var i = 0; i < iDayRange * 3; i++) {
	
	      var iOptDate = iStartDate + iOneDay * i;
	      var iItemPos = iItemWidth * i;
	      var sActiveClass = '';
	
	      var props = {
	        'data-id': this.dateToKey(iOptDate),
	        className: 'day slick-slide', //slick-active
	        index: i,
	        style: { width: iItemWidth + 'px' },
	        key: i
	
	        // If allDaysActive is true, all dates get marked as active
	      };if (!allDaysActive && !oActiveDates[iOptDate]) {
	        sActiveClass = 'inactive';
	      }
	
	      if (iActiveDate === iOptDate) {
	        sActiveClass = 'active';
	      }
	
	      /* react will add a span round the first value and the css dosn't want that */
	      var oOptDate = this.dateToObject(iOptDate);
	      var sDisplayValue = aDayNames[oOptDate.getDay()] + ' <span>' + oOptDate.getDate() + '</span>';
	
	      aOptNodes.push(_react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, props, { onClick: this.selectDate.bind(this, iOptDate, iItemPos) }),
	        _react2.default.createElement('a', { key: 'item' + this.dateToKey(iOptDate), className: sActiveClass, dangerouslySetInnerHTML: { __html: sDisplayValue } })
	      ));
	    }
	
	    var oSliderprops = {
	      onMouseDown: this.swipeStart,
	      onMouseMove: this.state.dragging ? this._throttle(50, this.swipeMove) : null,
	      onMouseUp: this.swipeEnd,
	      onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	      onTouchStart: this.swipeStart,
	      onTouchMove: this.state.dragging ? this._throttle(50, this.swipeMove) : null,
	      onTouchEnd: this.swipeEnd,
	      onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	      className: 'slick-list draggable',
	      tabIndex: 0
	    };
	
	    var deviceSlider = this.state.dayRange === 5 ? this.state.currentPos : this.state.touchSliderMove;
	    var oSliderStyle = {
	      width: iItemWidth * (iDayRange * 3) + 'px',
	      left: deviceSlider + (this.props.centered ? iItemWidth * Math.floor(iDayRange / 2) : 0) + 'px'
	    };
	
	    var dateStringLarge = _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'span',
	        { key: 'firstDay', className: 'firstDay' },
	        this.dateFormat(iDisplayDate - iOneDay * Math.floor(iDayRange / 2), 'date13'),
	        ' - '
	      ),
	      _react2.default.createElement(
	        'span',
	        { key: 'lastDay', className: 'lastDay' },
	        this.dateFormat(iEndDate - iOneDay * Math.floor(iDayRange / 2), 'date13')
	      )
	    );
	
	    if (!this.props.centered) {
	      dateStringLarge = _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'span',
	          { key: 'firstDay', className: 'firstDay' },
	          this.dateFormat(iDisplayDate, 'date13'),
	          ' - '
	        ),
	        _react2.default.createElement(
	          'span',
	          { key: 'lastDay', className: 'lastDay' },
	          this.dateFormat(iEndDate, 'date13')
	        )
	      );
	    }
	
	    var dateStringSmall = _react2.default.createElement(
	      'span',
	      { key: 'selectedDay', className: 'firstDay' },
	      this.dateFormat(iDisplayDate, 'date13')
	    );
	
	    if (this.state.animate) {
	      oSliderStyle.transition = 'left 0.5s'; //'all 1s ease-in-out'
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'carousel-wrap' },
	      _react2.default.createElement(
	        'div',
	        { className: 'carousel-week' },
	        showWeek ? dateStringLarge : dateStringSmall
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'date-picker-carousel slick-initialized slick-slider' },
	        _react2.default.createElement(
	          'div',
	          oSliderprops,
	          _react2.default.createElement(
	            'div',
	            { className: 'slick-track', style: oSliderStyle },
	            aOptNodes
	          )
	        ),
	        _react2.default.createElement('button', { type: 'button', 'data-role': 'none', className: 'slick-prev slice-arrow', style: { display: 'block' }, onClick: this.previous }),
	        _react2.default.createElement('button', { type: 'button', 'data-role': 'none', className: 'slick-next slice-arrow', style: { display: 'block' }, onClick: this.next })
	      ),
	      _react2.default.createElement(_DatePicker2.default, { date: iDisplayDate, callback: this.selectDate }),
	      _react2.default.createElement(
	        'div',
	        { className: 'carousel-day' },
	        _react2.default.createElement('span', { id: 'sbpDate', className: 'date' })
	      )
	    );
	  },
	
	  /**
	  * Calculates the position of the original display date within the
	  * new range of dates so it can create the animation effect
	  *
	  * @param {Number} iNewDate date
	  * @returns {undefined} undefined
	  **/
	  animateToDate: function animateToDate(iNewDate) {
	
	    // get the visible range of dates.
	    var iDisplayDate = this.state.displayDate;
	    var iOneDay = this.state.oneDay;
	    var iDayRange = this.state.dayRange;
	    var iMinDate = iNewDate - iOneDay * iDayRange;
	    var iMaxDate = iMinDate + iDayRange * 3 * iOneDay;
	    var iItemWidth = this.state.itemWidth;
	    var iMoveTo = 0;
	
	    if (iDisplayDate >= iMinDate && iDisplayDate <= iMaxDate) {
	      // is the original date within the visible range?
	      var iDiff = iDisplayDate - iMinDate;
	      iMoveTo = 0 - iDiff / iOneDay * iItemWidth;
	    } else if (iDisplayDate > iMaxDate) {
	      // is it bigger then set moveto to last
	      iMoveTo = 0 - iItemWidth * (iDayRange * 3);
	    } else if (iDisplayDate < iMinDate) {
	      // is it smaller then set moveto to first
	      iMoveTo = 0;
	    }
	
	    this.setState({
	      displayDate: iNewDate,
	      currentPos: iMoveTo,
	      touchSliderMove: iMoveTo,
	      animate: false
	    });
	  },
	
	  /**
	  * Call once we have selected a date
	  *
	  * @param {Number} iDate date
	  * @returns {undefined} undefined
	  **/
	  dateSelected: function dateSelected(iDate) {
	    if (typeof this.props.callback !== 'undefined') {
	      var selectedDate = this.dateFormat(iDate, 'date12');
	      this.props.callback(this.dateToObject(iDate), selectedDate);
	    }
	  },
	
	  /**
	  * After the component has drawn reset the position of the slider
	  * this will cause the css animation to trigger. The timeout is to
	  * force react to re-render else it trys to group the changes into 1
	  * update and you won't see the animation
	  *
	  * @returns {undefined} undefined
	  **/
	  componentDidUpdate: function componentDidUpdate() {
	
	    var iDayRange = this.state.dayRange;
	    var iItemWidth = this.state.itemWidth;
	    var iNewPos = 0 - iDayRange * iItemWidth;
	
	    if (iNewPos !== this.state.currentPos) {
	      setTimeout(function () {
	        this.setState({
	          currentPos: iNewPos,
	          touchSliderMove: iNewPos,
	          animate: true
	        });
	      }.bind(this), 1);
	    }
	  }
	
	});
	
	module.exports = DateSlider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dateformat = __webpack_require__(437);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _createReactClass = __webpack_require__(691);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	    Action:     Mimic the jquery UI date picker
	    Original:   ---
	    Orginator:  ben.hobden@espn.com
	    Returns:    The JavaScript date iobject in the callback function
	*/
	
	var DatePicker = (0, _createReactClass2.default)({
	
	  displayName: 'DatePicker',
	
	  mixins: [_dateformat2.default],
	
	  getInitialState: function getInitialState() {
	
	    return {
	      date: null,
	      today: null,
	      month: null,
	      open: false,
	      monthOpen: false,
	      yearOpen: false,
	      oneDay: 86400000 // 1 day in milliseconds
	    };
	  },
	
	  /**
	  * Intial load so add the date to the state for use and manipulation
	  *
	  * @returns {undefined} undefined
	  **/
	  componentWillMount: function componentWillMount() {
	    this.updateState(this.props);
	  },
	
	  /**
	  * Parent may have changed date propertyso lets compare and set state
	  * if required
	  *
	  * @param {Object} nextProps new props
	  * @returns {undefined} undefined
	  **/
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    // var oDate       = this.dateToObject(nextProps.date) || new Date()
	    // var iDate       = oDate.setHours(0,0,0,0)
	    if (this.props.date !== nextProps.date) {
	      this.updateState(nextProps);
	    }
	  },
	
	  /**
	  * Checks the prop for a date, if none found it sets it to today, also
	  * sets the current month and year. Makes sure all dates are set to
	  * midnight
	  *
	  * @param {Object} oProps props
	  * @returns {undefined} undefined
	  **/
	  updateState: function updateState(oProps) {
	    var oDate = this.dateToObject(oProps.date) || new Date();
	    var iDate = oDate.setHours(0, 0, 0, 0);
	    var iMonth = new Date(iDate).setDate(1);
	    var iToday = new Date().setHours(0, 0, 0, 0);
	
	    this.setState({
	      date: iDate,
	      today: iToday,
	      month: iMonth
	    });
	  },
	
	  /**
	  * Toggles the state to show or hide the calendar dropdown.
	  *
	  * @returns {undefined} undefined
	  **/
	  showCalendar: function showCalendar() {
	    if (this.state.open) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  },
	
	  show: function show() {
	    document.addEventListener('click', this.hide);
	    this.setState({
	      open: true,
	      monthOpen: false,
	      yearOpen: false
	    });
	  },
	
	  hide: function hide() {
	    document.removeEventListener('click', this.hide);
	    this.setState({
	      open: false,
	      monthOpen: false,
	      yearOpen: false
	    });
	  },
	
	  /**
	  * Moves the current view month forward by 1
	  *
	  * @param {Object} e event object
	  * @returns {undefined} undefined
	  **/
	  nextMonth: function nextMonth(e) {
	
	    e.stopPropagation();
	    e.nativeEvent.stopImmediatePropagation();
	
	    var oMonth = this.dateToObject(this.state.month);
	    var iMonth = oMonth.getMonth() + 1;
	    var iYear = oMonth.getFullYear();
	    if (iMonth > 11) {
	      iMonth = 0;
	      iYear++;
	    }
	    oMonth = new Date(iYear, iMonth, 1);
	    this.setState({
	      month: oMonth.getTime()
	    });
	  },
	
	  /**
	  * Moves the current view month back by 1
	  *
	  * @param {Object} e event object
	  * @returns {undefined} undefined
	  **/
	  prevMonth: function prevMonth(e) {
	
	    e.stopPropagation();
	    e.nativeEvent.stopImmediatePropagation();
	
	    var oMonth = this.dateToObject(this.state.month);
	    var iMonth = oMonth.getMonth() - 1;
	    var iYear = oMonth.getFullYear();
	    if (iMonth < 0) {
	      iMonth = 11;
	      iYear--;
	    }
	    oMonth = new Date(iYear, iMonth, 1);
	    this.setState({
	      month: oMonth.getTime()
	    });
	  },
	
	  selectDate: function selectDate(iDate) {
	    if (typeof this.props.callback !== 'undefined') {
	      this.props.callback(this.dateToObject(iDate));
	    }
	  },
	
	  /**
	  * Helper function to build all the dates for the calendar
	  *
	  * @returns {Array} dates for the calendar
	  **/
	  buildDates: function buildDates() {
	
	    var iDate = this.state.date;
	    var iToday = this.state.today;
	    var iMonth = this.state.month;
	    var oActiveDates = this.props.activeDates || {};
	
	    /* Calculate first date */
	    var iStartDay = iMonth - this.dateToObject(iMonth).getDay() * this.state.oneDay;
	
	    var aRows = [];
	    for (var iWeeks = 0; iWeeks < 6; iWeeks++) {
	      var aDays = [];
	      //today old new active
	      for (var iDays = 0; iDays < 7; iDays++) {
	
	        var aDayClass = ['day'];
	        var props = {
	          key: iDays,
	          onClick: this.selectDate.bind(this, iStartDay)
	        };
	
	        if (iToday === iStartDay) {
	          aDayClass.push('today');
	        }
	
	        if (iDate === iStartDay) {
	          aDayClass.push('active');
	        }
	
	        // TODO: Highlight active game dates when available in the future
	        if (!oActiveDates[iStartDay]) {
	          // aDayClass.push('inactive');
	        }
	
	        if (this.dateToObject(iMonth).getMonth() !== this.dateToObject(iStartDay).getMonth()) {
	          aDayClass.push('old');
	        }
	
	        props.className = (0, _classnames2.default)(aDayClass);
	        aDays.push(_react2.default.createElement(
	          'td',
	          props,
	          this.dateToObject(iStartDay).getDate()
	        ));
	
	        iStartDay = iStartDay + this.state.oneDay;
	      }
	      aRows.push(_react2.default.createElement(
	        'tr',
	        { key: iWeeks },
	        aDays
	      ));
	    }
	
	    return aRows;
	  },
	
	  onClickToday: function onClickToday() {
	    this.selectDate(this.state.today);
	  },
	
	  render: function render() {
	
	    var oMonth = this.state.month;
	
	    var propsPicker = {
	      className: 'datepicker datepicker-dropdown datepicker-orient-left datepicker-orient-top',
	      style: { top: '36px', left: '0px', display: 'none' },
	      autoFocus: true,
	      tabIndex: '-1'
	    };
	
	    if (this.state.open) {
	      propsPicker.style.display = 'block';
	    }
	
	    var aDates = this.buildDates();
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'calendar-container', 'data-thisdate': '20150710', 'data-startdate': '2002-10-10', ref: 'calendarContainer' },
	      _react2.default.createElement('span', { className: 'datepicker date icon', onClick: this.showCalendar }),
	      _react2.default.createElement(
	        'div',
	        propsPicker,
	        _react2.default.createElement(
	          'div',
	          { className: 'datepicker-days', style: { display: 'block' } },
	          _react2.default.createElement(
	            'table',
	            { className: 'table-condensed' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                { className: 'top-nav' },
	                _react2.default.createElement('th', { className: 'prev', style: { visibility: 'visible' }, onClick: this.prevMonth }),
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: '5', className: 'datepicker-switch' },
	                  this.dateFormat(oMonth, 'date11')
	                ),
	                _react2.default.createElement('th', { className: 'next', style: { visibility: 'visible' }, onClick: this.nextMonth })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { className: 'dow' },
	                  'Su'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'dow' },
	                  'Mo'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'dow' },
	                  'Tu'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'dow' },
	                  'We'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'dow' },
	                  'Th'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'dow' },
	                  'Fr'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'dow' },
	                  'Sa'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              aDates
	            ),
	            _react2.default.createElement(
	              'tfoot',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: '7', className: 'today', onClick: this.onClickToday, style: { display: 'table-cell' } },
	                  'View Today'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'datepicker-months', style: { display: 'none' } },
	          _react2.default.createElement(
	            'table',
	            { className: 'table-condensed' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                { className: 'top-nav' },
	                _react2.default.createElement('th', { className: 'prev', style: { visibility: 'visible' } }),
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: '5', className: 'datepicker-switch' },
	                  '2015'
	                ),
	                _react2.default.createElement('th', { className: 'next', style: { visibility: 'visible' } })
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { colSpan: '7' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'month' },
	                    'Jan'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'month' },
	                    'Feb'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'month' },
	                    'Mar'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'month' },
	                    'Apr'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'month' },
	                    'May'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'month' },
	                    'Jun'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'month' },
	                    'Jul'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'month' },
	                    'Aug'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'month' },
	                    'Sep'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'month' },
	                    'Oct'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'month' },
	                    'Nov'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'month' },
	                    'Dec'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tfoot',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: '7', className: 'today', onClick: this.onClickToday, style: { display: 'table-cell' } },
	                  'View Today'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: '7', className: 'clear', style: { display: 'none' } },
	                  'Clear'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'datepicker-years', style: { display: 'none' } },
	          _react2.default.createElement(
	            'table',
	            { className: 'table-condensed' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                { className: 'top-nav' },
	                _react2.default.createElement('th', { className: 'prev', style: { visibility: 'visible' } }),
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: '5', className: 'datepicker-switch' },
	                  '2009-2020'
	                ),
	                _react2.default.createElement('th', { className: 'next', style: { visibility: 'visible' } })
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { colSpan: '7' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'year old' },
	                    '2009'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'year' },
	                    '2010'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'year' },
	                    '2011'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'year' },
	                    '2012'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'year' },
	                    '2013'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'year' },
	                    '2014'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'year' },
	                    '2015'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'year' },
	                    '2016'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'year disabled' },
	                    '2017'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'year disabled' },
	                    '2018'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'year disabled' },
	                    '2019'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'year new disabled' },
	                    '2020'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tfoot',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: '7', className: 'today', onClick: this.onClickToday, style: { display: 'table-cell' } },
	                  'View Today'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: '7', className: 'clear', style: { display: 'none' } },
	                  'Clear'
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	
	});
	
	module.exports = DatePicker;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(9);
	var factory = __webpack_require__(37);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(308);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateformat = __webpack_require__(437);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _debounce = __webpack_require__(676);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _DatePickerV = __webpack_require__(693);
	
	var _DatePickerV2 = _interopRequireDefault(_DatePickerV);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var xLarge = 1280; /* global jQuery */
	
	var large = 1024;
	var medium = 768;
	var small = 412;
	
	var SliderItem = function (_Component) {
	  (0, _inherits3.default)(SliderItem, _Component);
	
	  function SliderItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SliderItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SliderItem.__proto__ || (0, _getPrototypeOf2.default)(SliderItem)).call.apply(_ref, [this].concat(args))), _this), _this.onItemSelected = function () {
	      if ((0, _typeof3.default)(_this.props.onPressCallback) !== undefined) {
	        _this.props.onPressCallback(_this.props.iDate);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SliderItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$dateNo = _props.dateNo,
	          dateNo = _props$dateNo === undefined ? '' : _props$dateNo,
	          _props$dayName = _props.dayName,
	          dayName = _props$dayName === undefined ? '' : _props$dayName,
	          _props$month = _props.month,
	          month = _props$month === undefined ? '' : _props$month,
	          _props$year = _props.year,
	          year = _props$year === undefined ? '' : _props$year,
	          _props$isActive = _props.isActive,
	          isActive = _props$isActive === undefined ? false : _props$isActive,
	          _props$isNow = _props.isNow,
	          isNow = _props$isNow === undefined ? false : _props$isNow,
	          _props$type = _props.type,
	          type = _props$type === undefined ? 'day' : _props$type;
	
	
	      var liClass = ['DateCarousel__list__item'];
	      isActive ? liClass.push('is-active') : liClass.push('has-event');
	      var liProps = {
	        onClick: this.onItemSelected,
	        className: (0, _classnames2.default)(liClass)
	      };
	
	      return _react2.default.createElement(
	        'li',
	        liProps,
	        type !== 'day' ? _react2.default.createElement(
	          'div',
	          { className: 'DateCarousel__day', style: { fontSize: 'inherit' } },
	          _react2.default.createElement(
	            'span',
	            { className: 'DateCarousel__dayNum' },
	            _react2.default.createElement(
	              'span',
	              null,
	              month
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'DateCarousel__dayName', style: { color: 'inherit' } },
	            year
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'DateCarousel__day', style: { fontSize: 'inherit' } },
	          _react2.default.createElement(
	            'span',
	            { className: 'DateCarousel__dayNum' },
	            _react2.default.createElement(
	              'span',
	              null,
	              isNow ? 'Now' : month + ' ' + dateNo
	            )
	          ),
	          !isNow ? _react2.default.createElement(
	            'span',
	            { className: 'DateCarousel__dayName', style: { color: 'inherit' } },
	            dayName
	          ) : null
	        )
	      );
	    }
	  }]);
	  return SliderItem;
	}(_react.Component);
	
	var DateSliderV2 = function (_Component2) {
	  (0, _inherits3.default)(DateSliderV2, _Component2);
	
	  function DateSliderV2(props) {
	    (0, _classCallCheck3.default)(this, DateSliderV2);
	
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, (DateSliderV2.__proto__ || (0, _getPrototypeOf2.default)(DateSliderV2)).call(this, props));
	
	    var _props$device = props.device,
	        device = _props$device === undefined ? {} : _props$device;
	
	    var screenWidth = 0;
	    var itemWidth = 80;
	    var dayRange = _this2.getSliderRange(screenWidth, device);
	    var startPos = 0 - itemWidth * dayRange;
	    _this2.state = {
	      activeDate: null,
	      displayDate: null,
	      oneDay: 86400000, // 1 day in milliseconds
	      dayRange: dayRange,
	      itemWidth: itemWidth,
	      touchObject: {
	        startX: null,
	        startY: null,
	        curX: null,
	        curY: null,
	        swipeLength: null
	      },
	      didSwipe: false,
	      dragging: false,
	      animate: false,
	      currentPos: startPos,
	      touchSliderMove: startPos,
	      device: device,
	      screenWidth: screenWidth
	      //method bindings
	    };_this2.selectDate = _this2.selectDate.bind(_this2);
	    _this2.previous = _this2.previous.bind(_this2);
	    _this2.next = _this2.next.bind(_this2);
	    _this2.swipeStart = _this2.swipeStart.bind(_this2);
	    _this2.swipeMove = _this2.swipeMove.bind(_this2);
	    _this2.swipeEnd = _this2.swipeEnd.bind(_this2);
	    _this2._throttle = _this2._throttle.bind(_this2);
	    _this2.handleResize = _this2.handleResize.bind(_this2);
	    return _this2;
	  }
	
	  /**
	  * Intial load so add the date to the state for use and manipulation
	  * @returns {undefined} undefined
	  **/
	
	
	  (0, _createClass3.default)(DateSliderV2, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var date = this.props.date;
	      var type = this.props.type;
	      if (!date) {
	        date = new Date();
	        date = date.toISOString();
	      }
	      var oDate = _dateformat2.default.dateToObject(date) || new Date();
	      var iDate = oDate.setHours(0, 0, 0, 0);
	      if (type == 'month') {
	        iDate = _dateformat2.default.dateToObject(iDate).setDate(1);
	      }
	      this.setState({
	        activeDate: iDate,
	        displayDate: iDate
	      });
	    }
	
	    /**
	    * Reset state if date has changed
	    *
	    * @param {Object} nextProps Props
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var oDate = _dateformat2.default.dateToObject(nextProps.date) || new Date();
	      var iDate = oDate.setHours(0, 0, 0, 0);
	      var type = this.props.type;
	      var currDate = this.props.date || new Date();
	      var iCurrDate = _dateformat2.default.dateToObject(currDate).setHours(0, 0, 0, 0);
	      if (type == 'month') {
	        iDate = _dateformat2.default.dateToObject(iDate).setDate(1);
	        iCurrDate = _dateformat2.default.dateToObject(iCurrDate).setDate(1);
	      }
	      if (iDate !== iCurrDate) {
	        this.animateToDate(iDate);
	        this.setState({
	          activeDate: iDate,
	          didSwipe: false
	        });
	      }
	    }
	
	    /**
	    * After the component has drawn reset the position of the slider
	    * this will cause the css animation to trigger. The timeout is to
	    * force react to re-render else it trys to group the changes into 1
	    * update and you won't see the animation
	    *
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var iDayRange = this.state.dayRange;
	      var iItemWidth = this.state.itemWidth;
	      var iNewPos = 0 - iDayRange * iItemWidth;
	
	      if (iNewPos !== this.state.currentPos) {
	        setTimeout(function () {
	          this.setState({
	            currentPos: iNewPos,
	            touchSliderMove: iNewPos,
	            animate: true
	          });
	        }.bind(this), 1);
	      }
	    }
	
	    /**
	     * After Component is mounted bind jquery resize event handlers to adjust slider based on screen size
	     * This helps to handle touch devices orientation changes
	     * @returns {undefined}
	     */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initResizeEvent();
	    }
	
	    /**
	     * triggers resize handlers after a debounce of 500ms
	     * @returns {undefined}
	     */
	
	  }, {
	    key: 'initResizeEvent',
	    value: function initResizeEvent() {
	      try {
	        jQuery(window).resize((0, _debounce2.default)(this.handleResize, 500));
	        this.handleResize();
	      } catch (e) {
	        /* Intentionally ignored error */
	      }
	    }
	    /**
	     * window resize handler, checks if current width and resized \
	     * width is differe t and initialize the state accordingly
	     * @return {undefined}
	     */
	
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      var currentWidth = jQuery(window).outerWidth();
	      var screenWidth = this.state.screenWidth;
	      var device = this.state.device;
	      if (screenWidth !== currentWidth) {
	        this.setState({
	          screenWidth: currentWidth,
	          dayRange: this.getSliderRange(currentWidth, device)
	        });
	      }
	    }
	
	    /**
	    * Captures the date of the node clicked and sets the state to that. If
	    * a swipe was tracked the click is ignored and the swipe tracker reset
	    *
	    * @param {Number} iDate date
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'selectDate',
	    value: function selectDate(iDate) {
	      iDate = (typeof iDate === 'undefined' ? 'undefined' : (0, _typeof3.default)(iDate)) === 'object' ? iDate.setHours(0, 0, 0, 0) : iDate;
	      if (typeof this.state.touchObject.swipeLength !== 'number' && this.props.enabled) {
	        this.setState({
	          activeDate: iDate
	        });
	
	        this.dateSelected(iDate);
	        this.animateToDate(iDate);
	      }
	    }
	
	    /**
	    * Call once we have selected a date
	    *
	    * @param {Number} iDate date
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'dateSelected',
	    value: function dateSelected(iDate) {
	      var type = this.props.type || 'day';
	      if (typeof this.props.callback == 'function') {
	        var selectedDate = _dateformat2.default.dateFormat(iDate, type == 'month' ? 'date19' : 'date12');
	        this.props.callback(_dateformat2.default.dateToObject(iDate), selectedDate);
	      }
	    }
	
	    /**
	    * Subtracts #(dayRange-1) days from the display date and then forces a redraw
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'previous',
	    value: function previous() {
	      var iNewDate = void 0;
	      var iDisplayDate = this.state.displayDate;
	      var dayRange = this.state.dayRange;
	      if (this.props.type == 'month') {
	        iNewDate = _dateformat2.default.subtractMonths(iDisplayDate, dayRange - 1).setHours(0, 0, 0, 0);
	      } else {
	        iNewDate = iDisplayDate - this.state.oneDay * (dayRange - 1);
	      }
	      this.animateToDate(iNewDate);
	    }
	
	    /**
	    * Adds #(dayRange) days from the display date and then forces a redraw
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'next',
	    value: function next() {
	      var iNewDate = void 0;
	      var iDisplayDate = this.state.displayDate;
	      var dayRange = this.state.dayRange;
	      if (this.props.type == 'month') {
	        iNewDate = _dateformat2.default.addMonths(iDisplayDate, dayRange - 1).setHours(0, 0, 0, 0);
	      } else {
	        iNewDate = iDisplayDate + this.state.oneDay * (dayRange - 1);
	      }
	      this.animateToDate(iNewDate);
	    }
	
	    /**
	    * Redraws the page to last know good state
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.setState({});
	    }
	  }, {
	    key: 'animateToDate',
	    value: function animateToDate(newDate) {
	      var displayDate = this.state.displayDate;
	      var type = this.props.type;
	      var dayRange = this.state.dayRange;
	      var minDate = void 0;
	      var maxDate = void 0;
	      var itemWidth = this.state.itemWidth;
	      var diff = 0;
	      var moveTo = 0;
	      var oneDay = this.state.oneDay;
	      if (type == 'month') {
	        minDate = _dateformat2.default.subtractMonths(newDate, dayRange).setHours(0, 0, 0, 0);
	        maxDate = _dateformat2.default.addMonths(newDate, dayRange * 3).setHours(0, 0, 0, 0);
	      } else {
	        minDate = newDate - oneDay * dayRange;
	        maxDate = minDate + dayRange * 3 * oneDay;
	      }
	      if (displayDate >= minDate && displayDate <= maxDate) {
	        // is the original date within the visible range?
	        if (type == 'month') {
	          diff = _dateformat2.default.dateDiff(minDate, displayDate, 'months');
	        } else {
	          diff = (displayDate - minDate) / oneDay;
	        }
	        moveTo = 0 - diff * itemWidth;
	      } else if (displayDate > maxDate) {
	        // is it bigger then set moveto to last
	        moveTo = 0 - itemWidth * (dayRange * 3);
	      } else if (displayDate < minDate) {
	        // is it smaller then set moveto to first
	        moveTo = 0;
	      }
	
	      this.setState({
	        displayDate: newDate,
	        currentPos: moveTo,
	        touchSliderMove: moveTo,
	        animate: false
	      });
	    }
	  }, {
	    key: 'getSliderRange',
	    value: function getSliderRange() {
	      var screenWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var device = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var dayRange = 9;
	      var wi = screenWidth;
	      if (screenWidth > 0) {
	        dayRange = wi >= xLarge ? 9 : wi >= large ? 7 : wi >= medium ? 7 : wi >= small ? 5 : 3;
	      } else {
	        dayRange = device.desktop ? 9 : device.tablet ? 9 : device.mobile ? 5 : 3;
	      }
	      return dayRange;
	    }
	    /**
	    * Capture the start position of the mouse/touch so that we can
	    * determine the direction and size of the interaction later.
	    *
	    * @param {Object} e event object
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'swipeStart',
	    value: function swipeStart(e) {
	      var posX = void 0,
	          posY = void 0;
	      posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	      posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	      this.setState({
	        dragging: true,
	        touchObject: {
	          startX: posX,
	          startY: posY,
	          curX: posX,
	          curY: posY
	        }
	      });
	    }
	
	    /**
	    * Captures the current mouse/finger movement and stores the value to
	    * allow the position of the slider to be updated.
	    *
	    * @param {Object} e event object
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'swipeMove',
	    value: function swipeMove(e) {
	      if (!this.state.dragging) {
	        return;
	      }
	
	      var touchObject = this.state.touchObject;
	      var iCurrX = e.touches ? e.touches[0].pageX : e.clientX;
	      touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	      touchObject.swipeLength = touchObject.curX - touchObject.startX;
	      touchObject.curX = iCurrX;
	      var touchSlider = {
	        touchObject: touchObject
	      };
	      var swipeMoved = null;
	      var swipeDirection = this.swipeDirection(touchObject);
	      if (swipeDirection === 'left') {
	        swipeMoved = this.state.currentPos + iCurrX;
	      } else if (swipeDirection === 'right') {
	        swipeMoved = this.state.currentPos - iCurrX;
	      }
	      touchSlider.touchSliderMove = swipeMoved;
	      this.setState(touchSlider);
	    }
	
	    /**
	      * Capture end event and then calculate the action desired by the user
	      *
	      * @param {Object} e event object
	      * @returns {undefined} undefined
	      **/
	
	  }, {
	    key: 'swipeEnd',
	    value: function swipeEnd() {
	      if (!this.state.dragging) {
	        return;
	      }
	
	      var touchObject = this.state.touchObject;
	      var swipeDirection = this.swipeDirection(touchObject);
	      // reset the state of touch related state letiables.
	      this.setState({
	        dragging: false,
	        touchObject: {},
	        swipeLength: 0,
	        touchSliderMove: this.state.currentPos
	      });
	
	      if (swipeDirection === 'left' && Math.abs(touchObject.swipeLength) > 5) {
	        this.setState({ didSwipe: true });
	        this.previous();
	      } else if (swipeDirection === 'right' && Math.abs(touchObject.swipeLength) > 5) {
	        this.setState({ didSwipe: true });
	        this.next();
	      } else if (Math.abs(touchObject.swipeLength) > 1) {
	        // micro swipe, not really a click.
	        this.reset();
	      } else {
	        this.reset();
	      }
	    }
	
	    /**
	    * Determines whether the swipe was within a certain angle range and
	    * therefore a horizontal swipe rather than a verticle one.
	    *
	    * @param {Object} touchObject touchObject
	    * @returns {String} left/right/vertical
	    **/
	
	  }, {
	    key: 'swipeDirection',
	    value: function swipeDirection(touchObject) {
	
	      var xDist = touchObject.startX - touchObject.curX;
	      var yDist = touchObject.startY - touchObject.curY;
	      var r = Math.atan2(yDist, xDist);
	      var swipeAngle = Math.round(r * 180 / Math.PI);
	
	      if (swipeAngle < 0) {
	        swipeAngle = 360 - Math.abs(swipeAngle);
	      }
	      if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	        return this.props.rtl === false ? 'left' : 'right';
	      }
	      if (swipeAngle >= 135 && swipeAngle <= 225) {
	        return this.props.rtl === false ? 'right' : 'left';
	      }
	
	      return 'vertical';
	    }
	
	    /**
	    * for performance reasons provide a facility to throttle the updates
	    * triggered by mousemove
	    *
	    * @param {Number} delay time to delay
	    * @param {Function} callback function reference which needs to be throttled
	    * @returns {Function} Anonymous Function
	    **/
	
	  }, {
	    key: '_throttle',
	    value: function _throttle(delay, callback) {
	      var previousCall = new Date().getTime();
	      return function () {
	        var time = new Date().getTime();
	        if (time - previousCall >= delay) {
	          previousCall = time;
	          callback.apply(null, arguments);
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      //let activeDates    = this.props.activeDates || {}
	      var displayDate = this.state.displayDate;
	      var activeDate = this.state.activeDate;
	      var oneDay = this.state.oneDay;
	      var dayRange = this.state.dayRange;
	      var itemWidth = this.state.itemWidth;
	      var dayNames = _dateformat2.default.dateDayNamesMedium();
	      var monthNames = _dateformat2.default.monthNamesShort();
	      var dateNodes = [];
	      var startDate = displayDate - oneDay * dayRange;
	      var type = this.props.type;
	      var now = new Date();
	      var oActiveDate = _dateformat2.default.dateToObject(activeDate);
	      if (type == 'month') {
	        startDate = _dateformat2.default.subtractMonths(displayDate, dayRange).setHours(0, 0, 0, 0);
	      }
	      // construct dayRange*3 no. of nodes for smooth scroll effect
	      for (var i = 0; i < dayRange * 3; i++) {
	        var iCurrDate = void 0;
	        var oCurrDate = void 0;
	        var isNow = false;
	        var isActive = false;
	        var currMonth = void 0;
	        var currYear = void 0;
	        if (type == 'month') {
	          oCurrDate = _dateformat2.default.addMonths(startDate, i);
	          iCurrDate = oCurrDate.setHours(0, 0, 0, 0);
	          currMonth = oCurrDate.getMonth();
	          currYear = oCurrDate.getFullYear();
	          isNow = now.getMonth() == currMonth && now.getFullYear() == currYear;
	          isActive = oActiveDate.getMonth() == currMonth && oActiveDate.getFullYear() == currYear;
	        } else {
	          iCurrDate = startDate + oneDay * i;
	          oCurrDate = _dateformat2.default.dateToObject(iCurrDate);
	          currMonth = oCurrDate.getMonth();
	          currYear = oCurrDate.getFullYear();
	          isActive = activeDate == iCurrDate;
	          isNow = now.setHours(0, 0, 0, 0) == iCurrDate;
	        }
	        var dateItemProps = {
	          dateNo: oCurrDate.getDate(),
	          dayName: dayNames[oCurrDate.getDay()],
	          month: monthNames[currMonth],
	          year: currYear,
	          isActive: isActive,
	          isNow: isNow,
	          iDate: iCurrDate
	        };
	        dateNodes.push(_react2.default.createElement(SliderItem, (0, _extends3.default)({}, dateItemProps, {
	          onPressCallback: this.selectDate,
	          key: iCurrDate,
	          type: type
	        })));
	      }
	
	      var sliderProps = {
	        onMouseDown: this.swipeStart,
	        onMouseMove: this.state.dragging ? this._throttle(50, this.swipeMove) : null,
	        onMouseUp: this.swipeEnd,
	        onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	        onTouchStart: this.swipeStart,
	        onTouchMove: this.state.dragging ? this._throttle(50, this.swipeMove) : null,
	        onTouchEnd: this.swipeEnd,
	        onTouchCancel: this.state.dragging ? this.swipeEnd : null
	      };
	      var sliderStyle = {
	        width: itemWidth * dayRange * 3 + 'px',
	        left: -40 + this.state.touchSliderMove + itemWidth * dayRange / 2 + 'px',
	        overflowY: 'initial'
	      };
	      if (this.state.animate) {
	        sliderStyle.transition = 'left 1s'; //'all 1s ease-in-out'
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'DatePicker DatePicker--cricket' },
	        _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({ className: 'DateCarousel' }, sliderProps, { style: { overflow: 'hidden', msOverflowStyle: 'none' } }),
	          _react2.default.createElement('button', { className: 'carousel__arrow carousel__arrow--left', onClick: this.previous }),
	          _react2.default.createElement(
	            'ul',
	            { className: 'DateCarousel__list', style: sliderStyle },
	            dateNodes
	          ),
	          _react2.default.createElement('button', { className: 'carousel__arrow carousel__arrow--right', onClick: this.next })
	        ),
	        _react2.default.createElement(_DatePickerV2.default, { date: displayDate, activeDate: activeDate, callback: this.selectDate, type: type })
	      );
	    }
	  }]);
	  return DateSliderV2;
	}(_react.Component);
	
	exports.default = DateSliderV2;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateformat = __webpack_require__(437);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerV2 = function (_Component) {
	  (0, _inherits3.default)(DatePickerV2, _Component);
	
	  function DatePickerV2(props) {
	    (0, _classCallCheck3.default)(this, DatePickerV2);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DatePickerV2.__proto__ || (0, _getPrototypeOf2.default)(DatePickerV2)).call(this, props));
	
	    _this.state = {
	      date: null,
	      activeDate: null,
	      today: null,
	      month: null,
	      year: null,
	      open: false,
	      oneDay: 86400000
	    };
	
	    _this.showCalendar = _this.showCalendar.bind(_this);
	    _this.hide = _this.hide.bind(_this);
	    _this.show = _this.show.bind(_this);
	    _this.selectDate = _this.selectDate.bind(_this);
	    _this.onClickToday = _this.onClickToday.bind(_this);
	    _this.buildDayNodes = _this.buildDayNodes.bind(_this);
	    return _this;
	  }
	
	  /**
	  * Intial load so add the date to the state for use and manipulation
	  *
	  * @returns {undefined} undefined
	  **/
	
	
	  (0, _createClass3.default)(DatePickerV2, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateState(this.props);
	    }
	
	    /**
	    * Parent may have changed date property so lets compare and set state
	    * if required
	    *
	    * @param {Object} nextProps new props
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var oDate = _dateformat2.default.dateToObject(nextProps.date) || new Date();
	      var iDate = oDate.setHours(0, 0, 0, 0);
	      var currDate = this.props.date || new Date();
	      var iCurrDate = _dateformat2.default.dateToObject(currDate).setHours(0, 0, 0, 0);
	      //check if dates are changed and update accordingly
	      if (iDate != iCurrDate) {
	        this.updateState(nextProps);
	      }
	    }
	
	    /**
	    * Checks the prop for a date, if none found it sets it to today, also
	    * sets the current month and year. Makes sure all dates are set to
	    * midnight
	    *
	    * @param {Object} oProps props
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'updateState',
	    value: function updateState(oProps) {
	      var oDate = _dateformat2.default.dateToObject(oProps.date) || new Date();
	      var iDate = oDate.setHours(0, 0, 0, 0);
	      var iMonth = new Date(iDate).setDate(1);
	      var iToday = new Date().setHours(0, 0, 0, 0);
	      var iYear = new Date(iDate).getFullYear();
	      var iActiveDate = _dateformat2.default.dateToObject(oProps.activeDate || new Date()).setHours(0, 0, 0, 0);
	      this.setState({
	        date: iDate,
	        activeDate: iActiveDate,
	        today: iToday,
	        month: iMonth,
	        year: iYear
	      });
	    }
	    /**
	    * Moves the current view month forward by 1
	    * @param {string} type type of event
	    * @param {Object} e event object
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'next',
	    value: function next(type, e) {
	      e.stopPropagation();
	      e.nativeEvent.stopImmediatePropagation();
	      var oMonth = _dateformat2.default.dateToObject(this.state.month);
	      var iMonth = oMonth.getMonth();
	      var iYear = oMonth.getFullYear();
	      if (type == 'year') {
	        iYear += 1;
	      }
	      if (type == 'month') {
	        if (iMonth > 10) {
	          iMonth = 0;
	          iYear++;
	        } else {
	          iMonth += 1;
	        }
	      }
	
	      oMonth = new Date(iYear, iMonth, 1);
	      this.setState({
	        month: oMonth.getTime()
	      });
	    }
	
	    /**
	    * Moves the current view month back by 1
	    * @param {String} type type of action whether month/year
	    * @param {Object} e event object
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'prev',
	    value: function prev(type, e) {
	
	      e.stopPropagation();
	      e.nativeEvent.stopImmediatePropagation();
	      var oMonth = _dateformat2.default.dateToObject(this.state.month);
	      var iMonth = oMonth.getMonth();
	      var iYear = oMonth.getFullYear();
	      if (type == 'year') {
	        iYear -= 1;
	      }
	      if (type == 'month') {
	        if (iMonth < 0) {
	          iMonth = 0;
	          iYear--;
	        } else {
	          iMonth -= 1;
	        }
	      }
	      oMonth = new Date(iYear, iMonth, 1);
	      this.setState({
	        month: oMonth.getTime()
	      });
	    }
	    /**
	    * Toggles the state to show or hide the calendar dropdown.
	    *
	    * @returns {undefined} undefined
	    **/
	
	  }, {
	    key: 'showCalendar',
	    value: function showCalendar() {
	      if (this.state.open) {
	        this.hide();
	      } else {
	        this.show();
	      }
	    }
	
	    // show calender and attach a listener to document to hide if clicked anywhere else
	
	  }, {
	    key: 'show',
	    value: function show() {
	      document.addEventListener('click', this.hide);
	      this.updateState(this.props);
	      this.setState({
	        open: true
	      });
	    }
	
	    //hide calender and remove listener
	
	  }, {
	    key: 'hide',
	    value: function hide() {
	      document.removeEventListener('click', this.hide);
	      this.setState({
	        open: false
	      });
	    }
	    /**
	     * selects a date and triggers a callback
	     * @param {date} iDate date
	     * @return {undefined} undefined 
	     */
	
	  }, {
	    key: 'selectDate',
	    value: function selectDate(iDate) {
	      var type = this.props.type;
	      var selectedDate = void 0;
	      if (typeof this.props.callback == 'function') {
	        selectedDate = _dateformat2.default.dateFormat(iDate, type == 'month' ? 'date19' : 'date12');
	        this.props.callback(_dateformat2.default.dateToObject(iDate), selectedDate);
	      }
	    }
	
	    // handler for today's click
	
	  }, {
	    key: 'onClickToday',
	    value: function onClickToday() {
	      this.selectDate(this.state.today);
	    }
	  }, {
	    key: 'buildMonthNodes',
	    value: function buildMonthNodes() {
	      var iActiveDate = this.state.activeDate;
	      var iMonth = this.state.month;
	      var oDate = _dateformat2.default.dateToObject(iMonth);
	      //let month = oDate.getMonth()
	      var year = oDate.getFullYear();
	      var monthNames = _dateformat2.default.monthNamesLong();
	      var monthRows = [];
	      var oActiveDate = _dateformat2.default.dateToObject(iActiveDate);
	
	      for (var i = 0; i < 12; i++) {
	        var oCurrMonth = _dateformat2.default.dateToObject(year + '-' + (i > 8 ? i + 1 : '0' + (i + 1)) + '-01T00:00:00');
	        var iCurrMonth = oCurrMonth.setHours(0, 0, 0, 0);
	        var props = {
	          key: iCurrMonth,
	          onClick: this.selectDate.bind(this, iCurrMonth)
	        };
	        var liClass = ['DateCarousel__list__item'];
	        if (oActiveDate.getMonth() == i && oActiveDate.getFullYear() == year) {
	          liClass.push('is-active');
	          props.style = { maxWidth: 'none' };
	        } else {
	          liClass.push('has-event');
	        }
	        monthRows.push(_react2.default.createElement(
	          'li',
	          (0, _extends3.default)({}, props, { className: (0, _classnames2.default)(liClass) }),
	          _react2.default.createElement(
	            'div',
	            { className: 'DateCarousel__day', style: { fontSize: 'inherit' } },
	            _react2.default.createElement(
	              'span',
	              { className: 'DateCarousel__dayNum' },
	              monthNames[i]
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'DateCarousel__dayName', style: { color: 'inherit' } },
	              year
	            )
	          )
	        ));
	      }
	      return _react2.default.createElement(
	        'ul',
	        { className: 'MonthContainer__weekList' },
	        monthRows
	      );
	    }
	    // frame markup for date nodes
	
	  }, {
	    key: 'buildDayNodes',
	    value: function buildDayNodes() {
	      var iDate = this.state.activeDate;
	      var iToday = this.state.today;
	      var iMonth = this.state.month;
	      //let oActiveDates    = this.props.activeDates || {}
	
	      /* Calculate first date */
	      var iStartDay = iMonth - _dateformat2.default.dateToObject(iMonth).getDay() * this.state.oneDay;
	
	      var aRows = [];
	      for (var iWeeks = 0; iWeeks < 6; iWeeks++) {
	        var aDays = [];
	        //today old new active
	        for (var iDays = 0; iDays < 7; iDays++) {
	
	          var aDayClass = ['MonthContainer__day'];
	          var props = {
	            key: iDays,
	            onClick: this.selectDate.bind(this, iStartDay)
	          };
	
	          if (iToday === iStartDay && iToday !== iDate) {
	            aDayClass.push('MonthContainer__day--today');
	          }
	
	          if (iDate === iStartDay) {
	            aDayClass.push('MonthContainer__day--selected');
	          }
	
	          // TODO: Highlight active game dates when available in the future(as of now all dates are active)
	          /*if(!oActiveDates[iStartDay]) {
	            aDayClass.push('MonthContainer__day--noEvent')
	          }*/
	
	          if (_dateformat2.default.dateToObject(iMonth).getMonth() !== _dateformat2.default.dateToObject(iStartDay).getMonth()) {
	            aDayClass.push('MonthContainer__day--out');
	          }
	
	          props.className = (0, _classnames2.default)(aDayClass);
	          aDays.push(_react2.default.createElement(
	            'li',
	            props,
	            _dateformat2.default.dateToObject(iStartDay).getDate()
	          ));
	
	          iStartDay = iStartDay + this.state.oneDay;
	        }
	        aRows.push(_react2.default.createElement(
	          'ul',
	          { className: 'MonthContainer__week', key: iWeeks },
	          aDays
	        ));
	      }
	
	      return aRows;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var open = this.state.open;
	      var iMonth = this.state.month;
	      var pickerClass = 'DatePicker__MonthContainer';
	      var today = this.state.today;
	      var date = this.state.date;
	      var type = this.props.type;
	      var dayNodes = '';
	      var monthNodes = '';
	      var dayNames = [];
	      var dayNamesMrkp = void 0;
	      var heading = '';
	      var nowButtonText = void 0;
	      var nowButtonClass = ['button', 'MonthContainer__button'];
	      var isTodayActive = void 0;
	      if (type == 'day') {
	        dayNames = _dateformat2.default.dateDayNamesXShort();
	        dayNamesMrkp = dayNames.map(function (day, i) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'MonthContainer__dayNames', key: 'w' + i },
	            day
	          );
	        });
	        dayNodes = this.buildDayNodes();
	        heading = _dateformat2.default.dateFormat(iMonth, 'date11');
	        nowButtonText = 'NOW';
	        isTodayActive = date == today;
	      } else {
	        heading = _dateformat2.default.dateToObject(iMonth).getFullYear();
	        monthNodes = this.buildMonthNodes();
	        nowButtonText = 'THIS MONTH';
	        isTodayActive = _dateformat2.default.dateFormat(today, 'date19') == _dateformat2.default.dateFormat(date, 'date19');
	      }
	      if (open) {
	        pickerClass += ' is-active';
	      }
	      if (isTodayActive) {
	        nowButtonClass.push('disabled');
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('button', { className: 'DateCarousel__MonthTrigger', onClick: this.showCalendar }),
	        _react2.default.createElement(
	          'div',
	          { className: pickerClass },
	          _react2.default.createElement(
	            'div',
	            { className: 'MonthContainer__header' },
	            _react2.default.createElement('button', { className: 'carousel__arrow carousel__arrow--year carousel__arrow--left',
	              onClick: this.prev.bind(this, 'year') }),
	            type == 'day' ? _react2.default.createElement('button', { className: 'carousel__arrow carousel__arrow--month carousel__arrow--left',
	              onClick: this.prev.bind(this, 'month') }) : null,
	            _react2.default.createElement(
	              'div',
	              { className: 'MonthContainer__monthYear' },
	              heading
	            ),
	            type == 'day' ? _react2.default.createElement('button', { className: 'carousel__arrow carousel__arrow--month carousel__arrow--right',
	              onClick: this.next.bind(this, 'month') }) : null,
	            _react2.default.createElement('button', { className: 'carousel__arrow carousel__arrow--year carousel__arrow--right',
	              onClick: this.next.bind(this, 'year') })
	          ),
	          type == 'day' ? _react2.default.createElement(
	            'div',
	            { className: 'MonthContainer__week MonthContainer__week__dayNames' },
	            dayNamesMrkp
	          ) : null,
	          type == 'day' ? dayNodes : monthNodes,
	          _react2.default.createElement(
	            'div',
	            { className: 'MonthContainer__buttonContainer' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: (0, _classnames2.default)(nowButtonClass),
	                onClick: this.onClickToday,
	                disabled: isTodayActive,
	                style: { borderWidth: '0px' } },
	              nowButtonText
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'button MonthContainer__button', onClick: this.showCalendar },
	              'Cancel'
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return DatePickerV2;
	}(_react.Component);
	
	exports.default = DatePickerV2;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dropdown = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownList = __webpack_require__(695);
	
	var _DropdownList2 = _interopRequireDefault(_DropdownList);
	
	var _DropdownSelect = __webpack_require__(696);
	
	var _DropdownSelect2 = _interopRequireDefault(_DropdownSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dropdown = exports.Dropdown = function Dropdown(props) {
	  return _react2.default.createElement(
	    'div',
	    { style: { 'display': 'inline-block' } },
	    _react2.default.createElement(_DropdownList2.default, props),
	    _react2.default.createElement(_DropdownSelect2.default, props)
	  );
	};
	
	exports.default = Dropdown;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AnchorLink = __webpack_require__(682);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import classNames   from 'classnames'
	
	/* This should be modified to utalise reacts control not the espn_ui */
	
	/* global espn_ui */
	var DropdownList = function (_React$Component) {
	  (0, _inherits3.default)(DropdownList, _React$Component);
	
	  function DropdownList() {
	    (0, _classCallCheck3.default)(this, DropdownList);
	    return (0, _possibleConstructorReturn3.default)(this, (DropdownList.__proto__ || (0, _getPrototypeOf2.default)(DropdownList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DropdownList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      try {
	        var _refs$dropdownDOM = this.refs.dropdownDOM,
	            dropdownDOM = _refs$dropdownDOM === undefined ? '' : _refs$dropdownDOM;
	
	        espn_ui.loadBehaviorNamed('button_dropdown', dropdownDOM);
	      } catch (err) {
	        console.error(err);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$items = _props.items,
	          items = _props$items === undefined ? [] : _props$items,
	          _props$selected = _props.selected,
	          selected = _props$selected === undefined ? '' : _props$selected,
	          formatUrl = _props.formatUrl,
	          classnames = _props.classnames,
	          _props$dropLeft = _props.dropLeft,
	          dropLeft = _props$dropLeft === undefined ? false : _props$dropLeft,
	          _props$isSmallDevice = _props.isSmallDevice,
	          isSmallDevice = _props$isSmallDevice === undefined ? false : _props$isSmallDevice;
	
	
	      var ulClass = 'dropdown-menu med';
	      if (dropLeft) {
	        ulClass += ' drop-left';
	      }
	
	      var ddClass = 'dropdown-wrapper';
	      if (!isSmallDevice) {
	        ddClass += ' hoverable';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dropdown-wrapper display-desktop hoverable', 'data-behavior': 'button_dropdown', ref: 'dropdownDOM' },
	        _react2.default.createElement(
	          'button',
	          { className: 'button-filter med dropdown-toggle', type: 'button' },
	          selected ? selected : '-- select --'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: ulClass },
	          items.map(function (item, i) {
	
	            var href = item.href || '#';
	
	            if (typeof formatUrl === 'function') {
	              href = formatUrl(item);
	            }
	
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(_AnchorLink2.default, { classes: classnames, to: href, name: item.trackingName, text: item.text })
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return DropdownList;
	}(_react2.default.Component);
	
	exports.default = DropdownList;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DropdownSelect = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleChange = function handleChange(routerPush) {
	  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var _ref = e.target || {},
	      selectedIndex = _ref.selectedIndex,
	      options = _ref.options;
	
	  var selectedOption = options[selectedIndex];
	  var path = selectedOption.getAttribute('data-url');
	
	  if (path) {
	    routerPush(path);
	  }
	};
	
	var DropdownSelect = exports.DropdownSelect = function DropdownSelect(props) {
	  var showDefaultValue = false;
	  var _props$items = props.items,
	      items = _props$items === undefined ? [] : _props$items,
	      _props$selected = props.selected,
	      selected = _props$selected === undefined ? '' : _props$selected,
	      formatUrl = props.formatUrl,
	      routerPush = props.routerPush;
	
	
	  var options = items.map(function (item, i) {
	
	    var href = item.href || '#';
	
	    if (typeof formatUrl === 'function') {
	      href = formatUrl(item);
	    }
	
	    if (!showDefaultValue && selected === item.text) {
	      showDefaultValue = true;
	    }
	
	    return _react2.default.createElement(
	      'option',
	      { key: i, 'data-url': href, name: item.trackingName, value: item.text },
	      item.text
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'dropdown-wrapper' },
	    _react2.default.createElement(
	      'div',
	      { className: 'mobile-dropdown' },
	      _react2.default.createElement('span', { className: 'mobile-arrow' }),
	      _react2.default.createElement(
	        'select',
	        { onChange: handleChange.bind(null, routerPush), value: selected },
	        !showDefaultValue && _react2.default.createElement(
	          'option',
	          { key: '0', value: selected },
	          selected
	        ) || null,
	        options
	      )
	    )
	  );
	};
	
	exports.default = DropdownSelect;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Glossary = function Glossary(_ref) {
	  var _ref$glossaries = _ref.glossaries,
	      glossaries = _ref$glossaries === undefined ? [] : _ref$glossaries,
	      _ref$notes = _ref.notes,
	      notes = _ref$notes === undefined ? [] : _ref$notes;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'glossary' },
	    notes.map(function (item, i) {
	      return _react2.default.createElement('p', { key: i, dangerouslySetInnerHTML: { __html: item } });
	    }),
	    glossaries.length && _react2.default.createElement(
	      'h3',
	      null,
	      'Glossary'
	    ) || '',
	    _react2.default.createElement(
	      'ul',
	      null,
	      glossaries.map(function (item, i) {
	        return _react2.default.createElement('li', { key: i, dangerouslySetInnerHTML: { __html: '<span>' + item.title + ':</span> ' + item.description } });
	      })
	    )
	  );
	};
	
	exports.default = Glossary;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Picture = __webpack_require__(699);
	
	var _Picture2 = _interopRequireDefault(_Picture);
	
	var _AnchorLink = __webpack_require__(682);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * React News element
	 * @param {String} title - Specify the title <h2> of the module
	 * @param {String} href - link to full news page
	 * @param {Array} items - Array of Objects representing news items
	 */
	
	var News = function News(_ref) {
	  var _ref$title = _ref.title,
	      title = _ref$title === undefined ? '' : _ref$title,
	      _ref$href = _ref.href,
	      href = _ref$href === undefined ? '' : _ref$href,
	      _ref$linkText = _ref.linkText,
	      linkText = _ref$linkText === undefined ? '' : _ref$linkText,
	      _ref$trackingName = _ref.trackingName,
	      trackingName = _ref$trackingName === undefined ? '' : _ref$trackingName,
	      _ref$items = _ref.items,
	      items = _ref$items === undefined ? [] : _ref$items;
	
	  var headerContent = void 0;
	  // Settings for all sources of the video thumbnail images
	  var allSources = [{
	    config: [{
	      combinerOptions: {
	        w: 120,
	        h: 120
	      }
	    }]
	  }];
	
	  if (href) {
	    headerContent = [_react2.default.createElement(
	      'h1',
	      { key: 'h' },
	      title
	    ), _react2.default.createElement(_AnchorLink2.default, {
	      key: 'a',
	      to: href,
	      text: linkText,
	      className: 'header-link icon-font-after icon-caret-sm-right-after',
	      name: trackingName
	    })];
	  } else {
	    headerContent = _react2.default.createElement(
	      'h1',
	      null,
	      title
	    );
	  }
	
	  var newsModule = _react2.default.createElement(
	    'article',
	    { className: 'sub-module sub-module-news' },
	    _react2.default.createElement(
	      'header',
	      { className: (0, _classnames2.default)({ 'has-link': href }) },
	      headerContent
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'content' },
	      items.map(function (news, i) {
	        var text = [_react2.default.createElement(
	          'h2',
	          { key: 'h' },
	          _react2.default.createElement(
	            'a',
	            { href: news.href, name: news.trackingName },
	            news.headline
	          )
	        ), _react2.default.createElement(
	          'p',
	          { key: 'p' },
	          news.description
	        )];
	
	        var _news$image = news.image,
	            image = _news$image === undefined ? {} : _news$image,
	            _news$video = news.video,
	            video = _news$video === undefined ? {} : _news$video;
	
	        var thumbnailUrl = video.thumbnail || image.url;
	
	        return _react2.default.createElement(
	          'li',
	          { className: (0, _classnames2.default)('text-container', { 'no-thumb': image.url }), key: i },
	          !thumbnailUrl ? text : [_react2.default.createElement(
	            'figure',
	            { key: 'f', className: 'feed-item-figure' },
	            _react2.default.createElement(
	              'a',
	              { href: news.href, className: 'img-wrap', name: news.trackingName },
	              _react2.default.createElement(_Picture2.default, {
	                thumbnail: thumbnailUrl,
	                imgClasses: { lazyload: true },
	                allSources: allSources
	              })
	            )
	          ), _react2.default.createElement(
	            'div',
	            { key: 'd', className: 'text-container' },
	            text
	          )]
	        );
	      })
	    )
	  );
	
	  return items.length ? newsModule : _react2.default.createElement('aside', { className: 'sub-module sub-module-news' });
	};
	
	exports.default = News;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _queryString = __webpack_require__(204);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * React Picture element
	 * @param  {String} options.thumbnail    thumnail URL of the image
	 * @param  {Array}  options.imgClasses   classes
	 * @param  {Array}  options.imgDataAttrs data attributes which need to be set on
	 *                                       img element
	 * @param  {Array}  options.sources      list of objects for sources
	 * @return {React.PropTypes.element}     Picture element
	 */
	var Picture = function Picture(_ref) {
	  var _ref$thumbnail = _ref.thumbnail,
	      thumbnail = _ref$thumbnail === undefined ? '' : _ref$thumbnail,
	      _ref$imgClasses = _ref.imgClasses,
	      imgClasses = _ref$imgClasses === undefined ? {} : _ref$imgClasses,
	      _ref$imgContainer = _ref.imgContainer,
	      imgContainer = _ref$imgContainer === undefined ? '' : _ref$imgContainer,
	      _ref$allSources = _ref.allSources,
	      allSources = _ref$allSources === undefined ? [] : _ref$allSources;
	
	
	  // Iterate over all sources and get the actual image URLs
	  for (var i = 0; i < allSources.length; i++) {
	    var source = allSources[i];
	    // Set default URL for this source to thumbnail
	    source.urlString = thumbnail;
	    // If thumbnail image url is not on ESPN CDN exit the loop. Keep url as is.
	    var notEspnCdn = thumbnail.match(/a(?:\d|ssets)?\.(?:espncdn|espn\.go)\.com\//i) || [];
	    if (notEspnCdn.length <= 0) {
	      break;
	    }
	    // Contnue to next data source if config object is not found
	    if (source.hasOwnProperty('config') === false) {
	      continue;
	    }
	    // Get list of configs. i.e. there can be multiple sources per image
	    var config = source.config || [];
	    var urls = [];
	    var urlString = '';
	    // Loop over the sources and construct the combiner URL
	    for (var j = 0; j < config.length; j++) {
	      var url = '';
	      var params = [];
	      var paramString = '';
	      // Get current options object
	      var current = config[j];
	      //console.info('current', current)
	
	      // Get combiner options - convert to query string
	      var combinerOptions = current.combinerOptions;
	      // Get any other options - that might be needed in query string format
	      var mqOptions = current.mqOptions;
	      /**
	       * other options are to be used for image sizes like 2x/3x - add them
	       * after query string with space
	       */
	      var others = current.others || '';
	      // Append options to params array
	      if (typeof combinerOptions !== 'undefined') {
	        params.push(_queryString2.default.stringify(combinerOptions));
	      }
	      if (typeof mqOptions !== 'undefined') {
	        params.push(_queryString2.default.stringify(mqOptions));
	      }
	      // Create params string only if params array is not empty
	      if (params.length > 0) {
	        paramString = params.join('&');
	      }
	      // Set URL if paramString exists
	      if (paramString !== '') {
	        url = thumbnail + '?' + paramString;
	      }
	      if (url !== '' && others !== '') {
	        url = url + ' ' + others;
	      }
	      // Append urls only if it's not an empty string
	      if (url !== '') {
	        urls.push(url);
	      }
	    }
	    /**
	     * If more than 1 src url is available, join on ,
	     * Update urlString property on source with new URL
	     */
	    if (urls.length > 0) {
	      urlString = urls.join(',');
	      source.urlString = urlString;
	    }
	    //console.info('==urlString==', urlString)
	  }
	
	  // Convert sources to string and set as __html
	  // In case of 404, this prevents image nodes
	  // from getting removed from the DOM
	  var sourcesString = '';
	  var lazyLoad = (imgClasses || {}).lazyload === true;
	
	  allSources.map(function (source) {
	    sourcesString += '<source ' + (lazyLoad ? 'data-srcset="' + source.urlString + '"' : 'srcset="' + source.urlString + '"') + ' media="' + (source.mediaQuery || '') + '" />';
	  });
	
	  sourcesString += '<img class="' + (0, _classnames2.default)(imgClasses) + '" data-image-container="' + imgContainer + '" />';
	
	  return _react2.default.createElement('picture', { dangerouslySetInnerHTML: { __html: sourcesString } });
	}; /**
	    * @fileOverview Picture element with provision for <source> element
	    * to handle multiple media resources.
	    *
	    * @example
	    * allSources should be an array of objects in this format:
	    * [{
	       config: [ {
	         combinerOptions: {
	           w: 943,
	           h: 530
	         },
	         others: '2x'
	       } ],
	       mediaQuery: '(min-width: 376px)'
	     }]
	    */
	
	module.exports = Picture;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AnchorLink = __webpack_require__(682);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Standings = function Standings(_ref) {
	  var _ref$title = _ref.title,
	      title = _ref$title === undefined ? 'Table' : _ref$title,
	      _ref$teams = _ref.teams,
	      teams = _ref$teams === undefined ? [] : _ref$teams,
	      _ref$link = _ref.link,
	      link = _ref$link === undefined ? {
	    title: '',
	    href: '#',
	    external: false
	  } : _ref$link,
	      _ref$displayKey = _ref.displayKey,
	      displayKey = _ref$displayKey === undefined ? 'abbrev' : _ref$displayKey,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params,
	      _ref$isTeamLinkActive = _ref.isTeamLinkActive,
	      isTeamLinkActive = _ref$isTeamLinkActive === undefined ? true : _ref$isTeamLinkActive;
	
	  var aGroups = teams || []; /* these are groups not teams passed */
	  var target = link.external ? { target: '_blank' } : {};
	  var iGroupLen = aGroups.length || 0;
	  var aTables = [];
	
	  if (!iGroupLen) {
	    /* check here to save work */
	    return _react2.default.createElement('article', { className: 'sub-module' });
	  }
	
	  for (var i = 0; i < iGroupLen; i++) {
	    var groupTeams = aGroups[i].teams || [];
	    var groupKeys = aGroups[i].keys || [];
	    var iTeamLen = groupTeams.length || 0;
	    var iKeyLen = groupKeys.length || 0;
	    var aRows = [];
	
	    for (var a = 0; a < iTeamLen; a++) {
	      var team = groupTeams[a];
	      var stats = groupTeams[a].stats || [];
	      var highlightCell = false;
	      if (params.pageType == 'team' && params.team == team.id) {
	        highlightCell = true;
	      }
	      var aCells = [];
	
	      for (var b = 0; b < iKeyLen; b++) {
	        if (groupKeys[b].type === 'team') {
	          if (isTeamLinkActive) {
	            aCells.push(_react2.default.createElement(
	              'td',
	              { key: b },
	              _react2.default.createElement(
	                'a',
	                { title: team.displayName, name: team.trackingName, href: team.href },
	                team[displayKey]
	              )
	            ));
	          } else {
	            aCells.push(_react2.default.createElement(
	              'td',
	              { key: b },
	              team[displayKey]
	            ));
	          }
	        } else if (b === 0) {
	          aCells.push(_react2.default.createElement(
	            'td',
	            { key: b },
	            stats[b] || '-'
	          ));
	        } else {
	          aCells.push(_react2.default.createElement(
	            'td',
	            { key: b, className: 'right' },
	            stats[b] || '-'
	          ));
	        }
	      }
	      aRows.push(_react2.default.createElement(
	        'tr',
	        { key: a, className: highlightCell ? 'highlight' : '' },
	        aCells
	      ));
	    }
	
	    aRows.length > 0 ? aTables.push(_react2.default.createElement(TableHead, { key: 'th.' + i, keys: aGroups[i].keys, className: i > 0 ? 'bordered' : '', abbreviation: aGroups[i].abbreviation }), _react2.default.createElement(
	      'tbody',
	      { key: 'tb.' + i },
	      aRows
	    )) : aTables.push(_react2.default.createElement('tbody', { key: 'empty-tbody' + i }));
	  }
	
	  return _react2.default.createElement(
	    'article',
	    { className: 'sub-module' },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'table',
	        { className: 'mod-data' },
	        aTables
	      )
	    ),
	    link.href && link.title && _react2.default.createElement(
	      'footer',
	      null,
	      _react2.default.createElement(_AnchorLink2.default, (0, _extends3.default)({ trackingName: link.trackingName, to: link.href, text: link.title }, target))
	    )
	  );
	};
	
	var TableHead = function TableHead(_ref2) {
	  var _ref2$keys = _ref2.keys,
	      keys = _ref2$keys === undefined ? [] : _ref2$keys,
	      _ref2$className = _ref2.className,
	      className = _ref2$className === undefined ? '' : _ref2$className,
	      _ref2$abbreviation = _ref2.abbreviation,
	      abbreviation = _ref2$abbreviation === undefined ? '' : _ref2$abbreviation;
	
	  var iLen = keys.length || 0;
	  var aCols = [];
	
	  for (var i = 0; i < iLen; i++) {
	    aCols.push(_react2.default.createElement(
	      'th',
	      { key: i, className: i === 0 || keys[i].type === 'team' ? 'left' : 'right', title: keys[i].tooltip },
	      keys[i].text
	    ));
	  }
	
	  return _react2.default.createElement(
	    'thead',
	    { className: className },
	    abbreviation && _react2.default.createElement(
	      'tr',
	      { className: 'column-group' },
	      _react2.default.createElement(
	        'th',
	        { colSpan: iLen },
	        abbreviation
	      )
	    ) || null,
	    _react2.default.createElement(
	      'tr',
	      null,
	      aCols
	    )
	  );
	};
	
	exports.default = Standings;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AnchorLink = __webpack_require__(682);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	var _Curve = __webpack_require__(702);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Line = __webpack_require__(703);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRankings = function TeamRankings(_ref) {
	  var _ref$title = _ref.title,
	      title = _ref$title === undefined ? 'Team Rankings' : _ref$title,
	      _ref$subtitle = _ref.subtitle,
	      subtitle = _ref$subtitle === undefined ? '' : _ref$subtitle,
	      _ref$isAllTop = _ref.isAllTop,
	      isAllTop = _ref$isAllTop === undefined ? false : _ref$isAllTop,
	      _ref$charts = _ref.charts,
	      charts = _ref$charts === undefined ? [] : _ref$charts,
	      _ref$link = _ref.link,
	      link = _ref$link === undefined ? {
	    title: 'Full Statistics',
	    href: '#',
	    external: true
	  } : _ref$link,
	      _ref$teamColor = _ref.teamColor,
	      teamColor = _ref$teamColor === undefined ? '' : _ref$teamColor;
	
	  var target = link.external ? { target: '_blank' } : {};
	  var Header = title + '<span>' + subtitle + ' </span>';
	  var TeamRankingsModule = !charts.length ? _react2.default.createElement('article', { className: 'sub-module' }) : _react2.default.createElement(
	    'article',
	    { className: 'sub-module rankings alt' },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement('h1', { dangerouslySetInnerHTML: { __html: Header } })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        charts.map(function (c, i) {
	          return _react2.default.createElement(Chart, (0, _extends3.default)({}, c, { key: i, isAllTop: isAllTop, teamColor: teamColor }));
	        })
	      )
	    ),
	    link.href && link.title && _react2.default.createElement(
	      'footer',
	      null,
	      _react2.default.createElement(_AnchorLink2.default, (0, _extends3.default)({ trackingName: link.trackingName, to: link.href, text: link.title }, target))
	    )
	  );
	  return TeamRankingsModule;
	};
	
	var Chart = function Chart(_ref2) {
	  var _ref2$heading = _ref2.heading,
	      heading = _ref2$heading === undefined ? '' : _ref2$heading,
	      _ref2$subHeading = _ref2.subHeading,
	      subHeading = _ref2$subHeading === undefined ? '' : _ref2$subHeading,
	      chartType = _ref2.chartType,
	      _ref2$isOnlyMax = _ref2.isOnlyMax,
	      isOnlyMax = _ref2$isOnlyMax === undefined ? false : _ref2$isOnlyMax,
	      _ref2$isTied = _ref2.isTied,
	      isTied = _ref2$isTied === undefined ? false : _ref2$isTied,
	      _ref2$isAllTop = _ref2.isAllTop,
	      isAllTop = _ref2$isAllTop === undefined ? false : _ref2$isAllTop,
	      _ref2$homeTeam = _ref2.homeTeam,
	      homeTeam = _ref2$homeTeam === undefined ? {} : _ref2$homeTeam,
	      _ref2$awayTeam = _ref2.awayTeam,
	      awayTeam = _ref2$awayTeam === undefined ? {} : _ref2$awayTeam,
	      _ref2$statName = _ref2.statName,
	      statName = _ref2$statName === undefined ? '' : _ref2$statName,
	      _ref2$teamColor = _ref2.teamColor,
	      teamColor = _ref2$teamColor === undefined ? '' : _ref2$teamColor;
	
	  var props = {
	    heading: heading,
	    subHeading: subHeading,
	    chartType: chartType,
	    isOnlyMax: isOnlyMax,
	    isTied: isTied,
	    homeTeam: homeTeam,
	    awayTeam: awayTeam,
	    teamColor: teamColor
	  };
	  var logo = '';
	  var rank = '1<sup>st</sup> <span>' + (homeTeam.stats || awayTeam.stats) + ' ' + statName + '</span>';
	  rank = statName == 'points' && isAllTop ? '= ' + rank : rank;
	  var isChartRequired = true;
	  if (isOnlyMax) {
	    logo = homeTeam.teamLogo || '';
	    isChartRequired = false;
	  } else if (isTied) {
	    logo = awayTeam.teamLogo || '';
	    isChartRequired = false;
	  }
	  if (isChartRequired) {
	    return _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(ChartHeading, props),
	      chartType == 'curve' ? _react2.default.createElement(CurveChart, props) : _react2.default.createElement(LineChart, props)
	    );
	  } else {
	    return _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(ChartHeading, props),
	      _react2.default.createElement('img', { 'data-default-src': logo, className: 'team-logo lazyload', 'data-src': logo }),
	      _react2.default.createElement('div', { className: 'rank', dangerouslySetInnerHTML: { __html: rank } })
	    );
	  }
	};
	
	var ChartHeading = function ChartHeading(_ref3) {
	  var _ref3$homeTeam = _ref3.homeTeam,
	      homeTeam = _ref3$homeTeam === undefined ? {} : _ref3$homeTeam,
	      _ref3$awayTeam = _ref3.awayTeam,
	      awayTeam = _ref3$awayTeam === undefined ? {} : _ref3$awayTeam,
	      _ref3$heading = _ref3.heading,
	      heading = _ref3$heading === undefined ? '' : _ref3$heading,
	      _ref3$subHeading = _ref3.subHeading,
	      subHeading = _ref3$subHeading === undefined ? '' : _ref3$subHeading,
	      _ref3$isOnlyMax = _ref3.isOnlyMax,
	      isOnlyMax = _ref3$isOnlyMax === undefined ? false : _ref3$isOnlyMax,
	      _ref3$teamColor = _ref3.teamColor,
	      teamColor = _ref3$teamColor === undefined ? '' : _ref3$teamColor;
	
	  var subHeadingMarkup = subHeading ? '<span>' + subHeading + '</span>' : '';
	  var headingMarkup = [heading || '', subHeadingMarkup].join(' ');
	  var titleMarkup = _react2.default.createElement('div', { className: 'title', dangerouslySetInnerHTML: { __html: headingMarkup } });
	  if (isOnlyMax) {
	    return titleMarkup;
	  } else {
	    return _react2.default.createElement(
	      'div',
	      { className: 'chart-header' },
	      _react2.default.createElement(Team, { className: 'team-a', abbrev: homeTeam.abbreviation, rankMarkup: homeTeam.rankMarkup, isHomeTeam: true, key: 'teama', teamColor: teamColor }),
	      titleMarkup,
	      _react2.default.createElement(Team, { className: 'team-b', abbrev: awayTeam.abbreviation, rankMarkup: awayTeam.rankMarkup, isHomeTeam: false, key: 'teamb' })
	    );
	  }
	};
	
	var Team = function Team(_ref4) {
	  var _ref4$className = _ref4.className,
	      className = _ref4$className === undefined ? '' : _ref4$className,
	      _ref4$abbrev = _ref4.abbrev,
	      abbrev = _ref4$abbrev === undefined ? '' : _ref4$abbrev,
	      _ref4$rankMarkup = _ref4.rankMarkup,
	      rankMarkup = _ref4$rankMarkup === undefined ? '' : _ref4$rankMarkup,
	      _ref4$isHomeTeam = _ref4.isHomeTeam,
	      isHomeTeam = _ref4$isHomeTeam === undefined ? false : _ref4$isHomeTeam,
	      _ref4$teamColor = _ref4.teamColor,
	      teamColor = _ref4$teamColor === undefined ? '' : _ref4$teamColor;
	
	  var color = {
	    background: isHomeTeam ? teamColor : '#dddddd'
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement('span', { className: 'bar', style: color }),
	    _react2.default.createElement(
	      'span',
	      { className: 'short-name' },
	      abbrev
	    ),
	    _react2.default.createElement('span', { className: 'rank', dangerouslySetInnerHTML: { __html: rankMarkup } })
	  );
	};
	
	var CurveChart = function CurveChart(_ref5) {
	  var _ref5$homeTeam = _ref5.homeTeam,
	      homeTeam = _ref5$homeTeam === undefined ? {} : _ref5$homeTeam,
	      _ref5$awayTeam = _ref5.awayTeam,
	      awayTeam = _ref5$awayTeam === undefined ? {} : _ref5$awayTeam,
	      _ref5$teamColor = _ref5.teamColor,
	      teamColor = _ref5$teamColor === undefined ? '' : _ref5$teamColor;
	
	  var homeTeamWidth = Math.abs(Math.ceil(homeTeam.stats / awayTeam.stats * 100)) || 2;
	  var homeColor = { color: teamColor };
	  var awayColor = { color: '#dddddd' };
	  return _react2.default.createElement(
	    'div',
	    { className: 'half-chart' },
	    _react2.default.createElement(_Curve2.default, { className: 'team-a', arcWidth: homeTeamWidth, color: homeColor, value: homeTeam.stats }),
	    _react2.default.createElement(_Curve2.default, { className: 'team-b', arcWidth: awayTeam.stats > 0 ? 100 : 2, color: awayColor, value: awayTeam.stats })
	  );
	};
	var LineChart = function LineChart(_ref6) {
	  var _ref6$homeTeam = _ref6.homeTeam,
	      homeTeam = _ref6$homeTeam === undefined ? {} : _ref6$homeTeam,
	      _ref6$awayTeam = _ref6.awayTeam,
	      awayTeam = _ref6$awayTeam === undefined ? {} : _ref6$awayTeam,
	      _ref6$teamColor = _ref6.teamColor,
	      teamColor = _ref6$teamColor === undefined ? '' : _ref6$teamColor;
	
	  var absHomeVal = Math.abs(homeTeam.stats);
	  var absAwayVal = Math.abs(awayTeam.stats);
	  var maxVal = Math.max(absHomeVal, absAwayVal);
	  var homeBarStyle = { background: teamColor, width: Math.ceil(absHomeVal * 50 / maxVal) || 3 };
	  var awayBarStyle = { background: '#dddddd', width: Math.ceil(absAwayVal * 50 / maxVal) || 3 };
	  return _react2.default.createElement(
	    'div',
	    { className: 'bar-chart' },
	    _react2.default.createElement(_Line2.default, { className: 'team team-a', value: homeTeam.stats, style: homeBarStyle }),
	    _react2.default.createElement(_Line2.default, { className: 'team team-b', value: awayTeam.stats, style: awayBarStyle })
	  );
	};
	exports.default = TeamRankings;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Curve = function Curve(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$arcWidth = _ref.arcWidth,
	      arcWidth = _ref$arcWidth === undefined ? 2 : _ref$arcWidth,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? {} : _ref$color,
	      _ref$value = _ref.value,
	      value = _ref$value === undefined ? 0 : _ref$value;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      { className: 'chart-wrapper' },
	      _react2.default.createElement('div', { className: 'arc', 'data-value': arcWidth, style: color })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'score', style: color },
	      value
	    )
	  );
	};
	
	exports.default = Curve;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Line = function Line(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      value = _ref.value,
	      style = _ref.style;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      { className: 'score' },
	      value
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'bar ' + (value >= 0 ? 'positive' : 'negative') },
	      _react2.default.createElement('span', { className: 'fill', style: style })
	    )
	  );
	};
	
	exports.default = Line;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TopScorers = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(308);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(686);
	
	var _Graphics = __webpack_require__(705);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TopScorers = exports.TopScorers = function (_React$Component) {
	  (0, _inherits3.default)(TopScorers, _React$Component);
	
	  function TopScorers() {
	    (0, _classCallCheck3.default)(this, TopScorers);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TopScorers.__proto__ || (0, _getPrototypeOf2.default)(TopScorers)).call(this));
	
	    _this.state = {
	      activeTab: ''
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TopScorers, [{
	    key: 'clicked',
	    value: function clicked(e, t) {
	      if (e && e.preventDefault) {
	        e.preventDefault();
	      }
	      this.setState({ activeTab: t });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$link = _props.link,
	          link = _props$link === undefined ? {} : _props$link,
	          _props$players = _props.players,
	          players = _props$players === undefined ? {} : _props$players,
	          _props$season = _props.season,
	          season = _props$season === undefined ? '' : _props$season,
	          _props$title = _props.title,
	          title = _props$title === undefined ? '' : _props$title,
	          _props$subtitle = _props.subtitle,
	          subtitle = _props$subtitle === undefined ? '' : _props$subtitle,
	          _props$trackingName = _props.trackingName,
	          trackingName = _props$trackingName === undefined ? '' : _props$trackingName;
	
	      if (typeof players === 'undefined' || !players.length) {
	        return _react2.default.createElement('span', null);
	      }
	      var heading = season + ' ' + title + '<span class=\'league\'>' + subtitle + '</span>';
	      var target = link.external === true ? { target: '_blank' } : {};
	      var performers = [];
	      var tabs = [];
	      var playerTrackingName = trackingName;
	      var playersLen = players.length || 0;
	
	      var _loop = function _loop(e) {
	        var topPlayers = (0, _selectn2.default)('leaders', players[e]) || [];
	        var topPlayLen = topPlayers.length || 0;
	        var performersList = [];
	        var categoryTab = players[e] || [];
	        _this2.state.activeTab = _this2.state.activeTab === '' ? categoryTab.displayCat : _this2.state.activeTab;
	        var activeTab = '' + (_this2.state.activeTab === categoryTab.displayCat ? ' active' : '');
	        for (var i = 0; i < topPlayLen; i++) {
	          var topPlayer = topPlayers[i];
	          if (!topPlayLen || topPlayer.name === '' || topPlayer.href === '') {
	            return {
	              v: _react2.default.createElement('li', null)
	            };
	          }
	          var athleteHeadshots = void 0;
	          if (topPlayer.img == '') {
	            athleteHeadshots = _react2.default.createElement(
	              'div',
	              { className: 'headshot-jersey-md fl hs-push-right' },
	              _react2.default.createElement(_Graphics.AthleteJersey, {
	                trackingName: playerTrackingName,
	                href: topPlayer.href,
	                jerseyColor: link.teamColor })
	            );
	          } else {
	            athleteHeadshots = _react2.default.createElement(
	              'div',
	              { className: 'img-container player' },
	              _react2.default.createElement(
	                'a',
	                { name: playerTrackingName, href: topPlayer.href },
	                _react2.default.createElement('img', { className: 'focus-image headshot lazyload', 'data-behavior': 'fix_broken_images', 'data-src': topPlayer.img })
	              )
	            );
	          }
	          performersList.push(_react2.default.createElement(
	            'li',
	            { key: i },
	            _react2.default.createElement(
	              'div',
	              { className: 'content-wrapper' },
	              athleteHeadshots,
	              _react2.default.createElement(
	                'div',
	                { className: 'content-meta' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { name: playerTrackingName,
	                      href: topPlayer.href },
	                    ' ',
	                    topPlayer.name,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    topPlayer.position
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'number' },
	                  topPlayer.stats
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overall-stats' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      topPlayer.matches
	                    )
	                  )
	                )
	              )
	            )
	          ));
	        }
	        performers.push(_react2.default.createElement(
	          'div',
	          { key: e, className: 'tab-pane' + activeTab },
	          _react2.default.createElement(
	            'ul',
	            { className: 'module-list performers' },
	            performersList
	          )
	        ));
	        tabs.push(_react2.default.createElement(
	          'li',
	          { key: e, className: activeTab },
	          _react2.default.createElement(
	            'span',
	            { onClick: function onClick(e) {
	                _this2.clicked(e, categoryTab.displayCat);
	              } },
	            categoryTab.displayName
	          )
	        ));
	      };
	
	      for (var e = 0; e < playersLen; e++) {
	        var _ret = _loop(e);
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	      }
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'sub-module performers', 'data-module': 'performers' },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement('h1', { dangerouslySetInnerHTML: { __html: heading } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tab-container' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'tabs', 'data-behavior': 'tabs_transform' },
	            tabs
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tab-content' },
	          performers
	        ),
	        _react2.default.createElement(
	          'footer',
	          null,
	          _react2.default.createElement(_common.AnchorLink, (0, _extends3.default)({ trackingName: link.trackingName, to: link.href, text: link.title }, target))
	        )
	      );
	    }
	  }]);
	  return TopScorers;
	}(_react2.default.Component);
	
	exports.default = TopScorers;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompareLineGraph = exports.AthleteJersey = exports.PieChart = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PieChart = exports.PieChart = function PieChart(_ref) {
	  var _ref$values = _ref.values,
	      values = _ref$values === undefined ? [0, 0, 0, 0, 0, 0, 0, 0] : _ref$values,
	      className = _ref.className;
	
	
	  var max = 0;
	  // Find the max out of all the slice values
	  for (var i = 0; i < values.length; i++) {
	    var value = Number(values[i]);
	    if (value > max) {
	      max = value;
	    }
	  }
	  // return true if the slice value is equal to max value:
	  var isSelected = function isSelected(index) {
	    return max > 0 && values[index] == max;
	  };
	
	  var pieSVG = '\n    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 133.02 133.02" id="cricket-pie-chart">\n      <g>\n        <circle class="pie-chart-border" cx="66.51" cy="66.51" r="64.52"></circle>\n\n        <path class="slice ' + (isSelected(5) ? 'slice--selected' : '') + '" d="M20.56,111.87,65.49,67.1H2A63.09,63.09,0,0,0,20.56,111.87Z"></path>\n        <path class="pie-chart-border" d="M65.28,130.38h0Z"></path>\n\n        <path class="slice ' + (isSelected(4) ? 'slice--selected' : '') + '" d="M65.95,131l.11-63.44-44.9,44.9A63.09,63.09,0,0,0,65.95,131Z"></path>\n        <path class="pie-chart-border" d="M110.65,112.49l.15-.16-.3.3Z"></path>\n\n        <path class="slice ' + (isSelected(2) ? 'slice--selected' : '') + '" d="M112.43,111.87,67.49,67.1H131A63.09,63.09,0,0,1,112.43,111.87Z"></path>\n\n        <path class="slice ' + (isSelected(3) ? 'slice--selected' : '') + '" d="M67,131l-.11-63.44,44.9,44.9A63.09,63.09,0,0,1,67,131Z"></path>\n        <path class="pie-chart-border" d="M22.33,112.49l-.15-.16.3.3Z"></path>\n\n        <path class="slice ' + (isSelected(6) ? 'slice--selected' : '') + '" d="M20.56,21.44,65.49,66.22H2A63.09,63.09,0,0,1,20.56,21.44Z"></path>\n        <path class="pie-chart-border" d="M65.28,2.94h0Z"></path>\n\n        <path class="slice ' + (isSelected(7) ? 'slice--selected' : '') + '" d="M65.95,2.29l.11,63.44-44.9-44.9A63.09,63.09,0,0,1,65.95,2.29Z"></path>\n        <path class="pie-chart-border" d="M110.65,20.83l.15.16-.3-.3Z"></path>\n\n        <path class="slice ' + (isSelected(1) ? 'slice--selected' : '') + '" d="M112.43,21.44,67.49,66.22H131A63.09,63.09,0,0,0,112.43,21.44Z"></path>\n        <path class="pie-chart-border" d="M67.71,2.94h0Z"></path>\n\n        <path class="slice ' + (isSelected(0) ? 'slice--selected' : '') + '" d="M67,2.29l-.11,63.44,44.9-44.9A63.09,63.09,0,0,0,67,2.29Z"></path>\n        <path class="pie-chart-border" d="M22.33,20.83l-.15.16.3-.3Z"></path>\n\n        <text class="slice-text ' + (isSelected(7) ? 'slice-text--selected' : '') + '" transform="translate(36.32 31.22)">' + (values[7] || 0) + '</text>\n        <text class="slice-text ' + (isSelected(0) ? 'slice-text--selected' : '') + '" transform="translate(72.32 31.22)">' + (values[0] || 0) + '</text>\n        <text class="slice-text ' + (isSelected(1) ? 'slice-text--selected' : '') + '" transform="translate(94.65 55.84)">' + (values[1] || 0) + '</text>\n        <text class="slice-text ' + (isSelected(6) ? 'slice-text--selected' : '') + '" transform="translate(13.44 55.84)">' + (values[6] || 0) + '</text>\n        <text class="slice-text ' + (isSelected(5) ? 'slice-text--selected' : '') + '" transform="translate(13.44 89.59)">' + (values[5] || 0) + '</text>\n        <text class="slice-text ' + (isSelected(4) ? 'slice-text--selected' : '') + '" transform="translate(36.32 115.93)">' + (values[4] || 0) + '</text>\n        <text class="slice-text ' + (isSelected(3) ? 'slice-text--selected' : '') + '" transform="translate(72.32 116.16)">' + (values[3] || 0) + '</text>\n        <text class="slice-text ' + (isSelected(2) ? 'slice-text--selected' : '') + ' " transform="translate(94.65 88.16)">' + (values[2] || 0) + '</text>\n        <circle class="pie-chart-outline" cx="66.51" cy="66.51" r="64.52"></circle>\n      </g>\n    </svg>\n  ';
	
	  return _react2.default.createElement('div', { className: (0, _classnames2.default)('data-vis-col', className), dangerouslySetInnerHTML: { __html: pieSVG } });
	};
	
	var AthleteJersey = exports.AthleteJersey = function AthleteJersey(_ref2) {
	  var _ref2$href = _ref2.href,
	      href = _ref2$href === undefined ? '#' : _ref2$href,
	      _ref2$className = _ref2.className,
	      className = _ref2$className === undefined ? '' : _ref2$className,
	      _ref2$styles = _ref2.styles,
	      styles = _ref2$styles === undefined ? '' : _ref2$styles,
	      _ref2$isMedium = _ref2.isMedium,
	      isMedium = _ref2$isMedium === undefined ? false : _ref2$isMedium,
	      _ref2$jerseyColor = _ref2.jerseyColor,
	      jerseyColor = _ref2$jerseyColor === undefined ? '' : _ref2$jerseyColor,
	      _ref2$trackingName = _ref2.trackingName,
	      trackingName = _ref2$trackingName === undefined ? '' : _ref2$trackingName;
	
	  var jerseySize = isMedium ? 'md' : 'sm';
	  var jerseyFillColor = jerseyColor != '' ? jerseyColor : '#FFF';
	  var jerseySVG = '\n    <svg style="' + styles + '" class="jerseySVG ' + className + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.6 91.7"><path  d="M55.8 5.3c-.5 0-1.4-.7-2.2-.8-1.6-.3-3 .2-4.5.2-1.7 0-2.5.2-2.7.3-.2.1-.5.2-.9.2-.8 0-2.1-.3-3.1-.6-.6-.2-1.2-.3-1.5-.3-.7-.1-2.3.4-3.3.6-.6.2-1 .3-1.2.3h-.1c-.8 0-1.3-.8-1.4-1l-.3-.2 1.2-2.5.1-.1C38 .2 42.9 0 45.7 0h.6c1.7 0 7.4.1 9.8 1.4l.1.1 1.1 2.4c.1.1.2.4 0 .8-.3.5-1 .6-1.5.6z"></path><path fill="' + jerseyFillColor + '" d="M76.3 12.4c-2.5-4.5-6.5-5-10.2-5.5-3.8-.5-11.5-2.6-12-2.8-3.1-1-5.6.2-8.2.2-2.7 0-5.2-1.2-8.2-.2-.5.2-8.3 2.2-12 2.8-3.8.5-7.7 1-10.2 5.5-2.7 4.5-14.4 24.4-14.4 24.4l15.5 7.8 6.1-8.5s1.6 13.7 1.6 20.7-1.9 24.3-.8 30.7c0 0 1.1 3.1 21.3 3.1H47c20.2 0 21.2-3.1 21.2-3.1 1.1-6.4-.6-23.5-.6-30.6s1.5-20.8 1.5-20.8l6 8.4 15.4-7.8c0 .1-11.7-19.8-14.2-24.3z"></path><path fill="#FFF" d="M47 85.4h-2.2c-19.6 0-21.6-2.9-21.8-3.4l1-.4c.1.1 1.9 2.8 20.8 2.8H47c18.8 0 20.6-2.6 20.7-2.7l1 .4c-.2.4-2.1 3.3-21.7 3.3z" opacity=".4"></path><path opacity=".5" fill="none" stroke="#FFF" stroke-width="1.578" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M68.8 36.2s1.7-16.5 4-18.8M23 36.1s-1.7-16.5-4-18.8"></path><path fill="none" stroke="#000" stroke-width="2.158" stroke-linejoin="round" stroke-miterlimit="10" d="M76.3 12.4c-2.5-4.5-6.5-5-10.2-5.5-3.8-.5-11.5-2.6-12-2.8-3.1-1-5.6.2-8.2.2-2.7 0-5.2-1.2-8.2-.2-.5.2-8.3 2.2-12 2.8-3.8.5-7.7 1-10.2 5.5-2.7 4.5-14.4 24.4-14.4 24.4l15.5 7.8 6.1-8.5s1.6 13.7 1.6 20.7-1.9 24.3-.8 30.7c0 0 1.1 3.1 21.3 3.1H47c20.2 0 21.2-3.1 21.2-3.1 1.1-6.4-.6-23.5-.6-30.6s1.5-20.8 1.5-20.8l6 8.4 15.4-7.8c0 .1-11.7-19.8-14.2-24.3z"></path></svg>\n  ';
	  return _react2.default.createElement('a', { name: trackingName, href: href, className: 'headshot-jersey-' + jerseySize + ' athlete', dangerouslySetInnerHTML: { __html: jerseySVG } });
	};
	
	var CompareLineGraph = exports.CompareLineGraph = function CompareLineGraph(_ref3) {
	  var _ref3$text = _ref3.text,
	      text = _ref3$text === undefined ? '' : _ref3$text,
	      _ref3$value = _ref3.value,
	      value = _ref3$value === undefined ? '' : _ref3$value,
	      _ref3$color = _ref3.color1,
	      color1 = _ref3$color === undefined ? '#f2f2f2' : _ref3$color,
	      _ref3$color2 = _ref3.color2,
	      color2 = _ref3$color2 === undefined ? '#81B859' : _ref3$color2;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'compareLineGraph' },
	    _react2.default.createElement(
	      'span',
	      { className: 'chartLabel clear' },
	      text
	    ),
	    _react2.default.createElement(
	      'span',
	      { style: { backgroundColor: color1 }, className: 'bar-total' },
	      _react2.default.createElement('span', { style: { backgroundColor: color2, width: value + '%' }, className: 'bar-percentage' })
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'chartValue' },
	      value,
	      '%'
	    )
	  );
	};

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FixturesAndResults = exports.FixturesAndResultsMobile = exports.TabsHeading = exports.ScheduleDiv = exports.TeamInfoTag = exports.GamestatusTag = exports.GameLeagueInfoTag = exports.ScheduleWrapTag = exports.Schedule = undefined;
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp, _class2, _temp2;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tabs = __webpack_require__(707);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * [Individual schedule component]
	 * @return {[type]} [component]
	 */
	var Schedule = exports.Schedule = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Schedule, _React$Component);
	
	  function Schedule(props) {
	    (0, _classCallCheck3.default)(this, Schedule);
	    return (0, _possibleConstructorReturn3.default)(this, (Schedule.__proto__ || (0, _getPrototypeOf2.default)(Schedule)).call(this, props));
	  }
	
	  (0, _createClass3.default)(Schedule, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$data = _props.data,
	          data = _props$data === undefined ? {} : _props$data,
	          _props$team = _props.team,
	          team = _props$team === undefined ? {} : _props$team,
	          datakey = _props.datakey,
	          isMobile = _props.isMobile;
	
	
	      if (typeof data === 'undefined' || typeof team === 'undefined') {
	        return _react2.default.createElement('span', null);
	      }
	      var gameStatusProps = {
	        broadcast: data.broadcast,
	        aggregate: data.score,
	        dateFormatted: data.dateFormatted,
	        gameTime: data.gameTime,
	        status: data.status,
	        htGameDetail: data.htGameDetail,
	        isHTScoreAvailable: data.isHTScoreAvailable
	      };
	      var teamA = data.teamA;
	      var teamB = data.teamB;
	      //console.info('======>data modified',data)
	      //console.info('======>homeTeam',homeTeam)
	      var gameStripArr = [_react2.default.createElement(TeamInfoTag, { key: 'tia-' + datakey, teamProps: teamA }), _react2.default.createElement(GamestatusTag, { key: 'gs-' + datakey, gameStatusProps: gameStatusProps }), _react2.default.createElement(TeamInfoTag, { key: 'tih-' + datakey, teamProps: teamB })];
	      var AnchorTag = data.href ? _react2.default.createElement(
	        _common.AnchorLink,
	        { trackingName: data.trackingName, key: 'ac-' + datakey, to: data.href, classes: 'competitors', isRouterLink: false },
	        gameStripArr
	      ) : _react2.default.createElement(
	        'a',
	        { name: data.trackingName, className: 'competitors' },
	        gameStripArr
	      );
	      var broadcastTag = data.broadcast ? _react2.default.createElement(
	        'a',
	        { href: '#', className: 'bt-sport-link external' },
	        data.broadcast
	      ) : '';
	
	      var scheduleTag = [_react2.default.createElement(
	        'header',
	        { key: 'hd-' + datakey, className: data.gameStripClassname },
	        _react2.default.createElement('div', { className: 'game-details header' }),
	        AnchorTag,
	        broadcastTag
	      ), _react2.default.createElement(
	        'div',
	        { key: 'gidiv-' + datakey, className: data.gameDetailsClassname },
	        _react2.default.createElement(GameLeagueInfoTag, { key: 'gli' + datakey, leagueName: data.leagueName, leagueAbbreviation: data.leagueAbbreviation, isMobile: isMobile })
	      )];
	
	      return _react2.default.createElement(ScheduleWrapTag, { key: datakey, datakey: datakey, data: scheduleTag, scrollToLiveClass: data.scrollToLiveClass, isMobile: this.props.isMobile });
	    }
	  }]);
	  return Schedule;
	}(_react2.default.Component), _class.propTypes = {
	  children: _react.PropTypes.object
	}, _temp);
	var ScheduleWrapTag = exports.ScheduleWrapTag = function ScheduleWrapTag(_ref) {
	  var data = _ref.data,
	      datakey = _ref.datakey,
	      isMobile = _ref.isMobile,
	      scrollToLiveClass = _ref.scrollToLiveClass;
	
	  if (isMobile) {
	    return _react2.default.createElement(
	      'li',
	      { key: 'li-' + datakey, className: scrollToLiveClass },
	      data
	    );
	  } else {
	    return _react2.default.createElement(
	      'article',
	      { key: 'art-' + datakey },
	      data
	    );
	  }
	};
	var GameLeagueInfoTag = exports.GameLeagueInfoTag = function GameLeagueInfoTag(_ref2) {
	  var leagueName = _ref2.leagueName,
	      leagueAbbreviation = _ref2.leagueAbbreviation,
	      isMobile = _ref2.isMobile;
	
	  if (typeof leagueName === 'undefined' || typeof leagueAbbreviation === 'undefined') {
	    return _react2.default.createElement('span', null);
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'wrap' },
	    isMobile === true ? _react2.default.createElement(
	      'div',
	      { className: 'game-status mobile' },
	      leagueAbbreviation
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'game-status' },
	      leagueName
	    )
	  );
	};
	var GamestatusTag = exports.GamestatusTag = function GamestatusTag(_ref3) {
	  var gameStatusProps = _ref3.gameStatusProps;
	  var broadcast = gameStatusProps.broadcast,
	      dateFormatted = gameStatusProps.dateFormatted,
	      gameTime = gameStatusProps.gameTime,
	      status = gameStatusProps.status,
	      htGameDetail = gameStatusProps.htGameDetail,
	      isHTScoreAvailable = gameStatusProps.isHTScoreAvailable;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'game-status' },
	    dateFormatted && status === 'pre' ? _react2.default.createElement(
	      'span',
	      { className: 'game-date' },
	      dateFormatted
	    ) : null,
	    gameTime ? _react2.default.createElement(
	      'span',
	      { className: 'game-time' },
	      gameTime
	    ) : null,
	    _react2.default.createElement('span', { className: 'game-play' }),
	    isHTScoreAvailable === true ? _react2.default.createElement(
	      'span',
	      { className: 'aggregate' },
	      htGameDetail
	    ) : _react2.default.createElement('span', null),
	    broadcast ? _react2.default.createElement(
	      'span',
	      { className: 'network' },
	      _react2.default.createElement(
	        'span',
	        { href: '#' },
	        broadcast
	      )
	    ) : null
	  );
	};
	
	var TeamInfoTag = exports.TeamInfoTag = function TeamInfoTag(_ref4) {
	  var teamProps = _ref4.teamProps;
	  var logo = teamProps.logo,
	      name = teamProps.name,
	      abbreviation = teamProps.abbreviation,
	      record = teamProps.record,
	      score = teamProps.score,
	      className = teamProps.className;
	
	
	  var teamContComp = _react2.default.createElement(
	    'div',
	    { className: 'team-container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'team-info-logo' },
	      _react2.default.createElement(
	        'picture',
	        null,
	        _react2.default.createElement('img', { 'data-default-src': logo, className: 'team-logo lazyload', 'data-src': logo })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'team-info' },
	      _react2.default.createElement('span', { className: 'rank' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'team-name' },
	        _react2.default.createElement(
	          'span',
	          { className: 'long-name' },
	          name
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'short-name' },
	          name
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'abbrev' },
	          abbreviation
	        )
	      ),
	      record ? _react2.default.createElement(
	        'span',
	        { className: 'record' },
	        record
	      ) : null
	    )
	  );
	
	  var contentElem = _react2.default.createElement('span', null);
	  {
	    score && className === 'team-a' ? contentElem = _react2.default.createElement(
	      'div',
	      { className: 'team team-a possession' },
	      _react2.default.createElement(
	        'div',
	        { className: 'team__content' },
	        teamContComp,
	        _react2.default.createElement(
	          'div',
	          { className: 'score-container' },
	          _react2.default.createElement(
	            'span',
	            { className: 'score icon-font-after' },
	            score
	          )
	        )
	      )
	    ) : null;
	  }
	  {
	    score && className === 'team-b' ? contentElem = _react2.default.createElement(
	      'div',
	      { className: 'team team-b possession' },
	      _react2.default.createElement(
	        'div',
	        { className: 'team__content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'score-container' },
	          _react2.default.createElement(
	            'span',
	            { className: 'score icon-font-before' },
	            score
	          )
	        ),
	        teamContComp
	      )
	    ) : null;
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    contentElem
	  );
	};
	
	var ScheduleDiv = exports.ScheduleDiv = function ScheduleDiv(_ref5) {
	  var data = _ref5.data,
	      team = _ref5.team,
	      sport = _ref5.sport,
	      contentName = _ref5.contentName,
	      isMobile = _ref5.isMobile;
	
	  if (typeof data === 'undefined') {
	    return _react2.default.createElement('span', null);
	  }
	  if (data.length === 0 && !isMobile) {
	    return _react2.default.createElement(
	      'p',
	      { style: { fontSize: '11px', padding: '10px' } },
	      'No ',
	      contentName,
	      ' available'
	    );
	  }
	  var cont = [];
	  var dataLen = data.length > 0 ? data.length : 0;
	  for (var i = 0; i < dataLen; i++) {
	    cont.push(_react2.default.createElement(Schedule, { key: 'schd-' + i, datakey: 'schd-' + i, data: data[i], team: team, sport: sport, isMobile: isMobile }));
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    cont
	  );
	};
	
	var TabsHeading = exports.TabsHeading = function TabsHeading(_ref6) {
	  var heading = _ref6.heading;
	
	  if (typeof heading === 'undefined') {
	    return _react2.default.createElement('span', null);
	  }
	  return _react2.default.createElement(
	    'h1',
	    { key: 'hds' },
	    _react2.default.createElement(
	      'div',
	      null,
	      heading.text
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      heading.timeZone
	    )
	  );
	};
	
	var FixturesAndResultsMobile = exports.FixturesAndResultsMobile = function FixturesAndResultsMobile(_ref7) {
	  var mobileData = _ref7.mobileData;
	  var heading = mobileData.heading,
	      schedule = mobileData.schedule,
	      team = mobileData.team,
	      sport = mobileData.sport,
	      isMobile = mobileData.isMobile,
	      notes = mobileData.notes,
	      fixturesLinkText = mobileData.fixturesLinkText,
	      fixturesLink = mobileData.fixturesLink,
	      resultsLinkText = mobileData.resultsLinkText,
	      resultsLink = mobileData.resultsLink;
	
	  var contentsArr = [];
	  var dataLen = schedule.length > 0 ? schedule.length : 0;
	  if (dataLen <= 0) {
	    return _react2.default.createElement('span', null);
	  }
	  if (resultsLink) {
	    contentsArr.push(_react2.default.createElement(
	      'li',
	      { key: 'reslnkli', className: 'full-schedule' },
	      _react2.default.createElement(_common.AnchorLink, { key: 'reslnk', to: resultsLink, text: resultsLinkText, classes: 'icon-font-before icon-calendar-outline-before' })
	    ));
	  }
	  for (var i = 0; i < dataLen; i++) {
	    contentsArr.push(_react2.default.createElement(Schedule, { key: 'schd-mob-' + i, datakey: 'schd-mob-' + i, data: schedule[i], team: team, sport: sport, isMobile: isMobile }));
	  }
	  if (fixturesLink) {
	    contentsArr.push(_react2.default.createElement(
	      'li',
	      { key: 'fixlnkli', className: 'full-schedule' },
	      _react2.default.createElement(_common.AnchorLink, { key: 'fixlnk', to: fixturesLink, text: fixturesLinkText, classes: 'icon-font-before icon-calendar-outline-before' })
	    ));
	  }
	  return _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      'section',
	      { className: 'club-mobile-schedule scroll', 'data-behavior': 'scroll_to_live_game', 'data-module': 'module' },
	      _react2.default.createElement(
	        'header',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'date' },
	          heading.text
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'notes' },
	          notes
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        { key: 'ulmob', className: 'has-game-strips' },
	        contentsArr
	      )
	    )
	  );
	};
	
	/**
	 * Component for schedule(fixtures and results)
	 * @return {[type]} [component]
	 */
	var FixturesAndResults = exports.FixturesAndResults = (_temp2 = _class2 = function (_React$Component2) {
	  (0, _inherits3.default)(FixturesAndResults, _React$Component2);
	
	  function FixturesAndResults(props) {
	    (0, _classCallCheck3.default)(this, FixturesAndResults);
	    return (0, _possibleConstructorReturn3.default)(this, (FixturesAndResults.__proto__ || (0, _getPrototypeOf2.default)(FixturesAndResults)).call(this, props));
	  }
	
	  (0, _createClass3.default)(FixturesAndResults, [{
	    key: 'render',
	    value: function render() {
	      if (typeof (0, _selectn2.default)('schedule', this.props) === 'undefined') {
	        return _react2.default.createElement('span', null);
	      }
	
	      var _props2 = this.props,
	          _props2$isMobile = _props2.isMobile,
	          isMobile = _props2$isMobile === undefined ? '' : _props2$isMobile,
	          _props2$schedule = _props2.schedule,
	          schedule = _props2$schedule === undefined ? {} : _props2$schedule,
	          _props2$sport = _props2.sport,
	          sport = _props2$sport === undefined ? '' : _props2$sport,
	          _props2$team = _props2.team,
	          team = _props2$team === undefined ? '' : _props2$team;
	      var _schedule$heading = schedule.heading,
	          heading = _schedule$heading === undefined ? {} : _schedule$heading,
	          _schedule$mobile = schedule.mobile,
	          mobile = _schedule$mobile === undefined ? [] : _schedule$mobile,
	          _schedule$notes = schedule.notes,
	          notes = _schedule$notes === undefined ? '' : _schedule$notes,
	          _schedule$fixturesLin = schedule.fixturesLinkText,
	          fixturesLinkText = _schedule$fixturesLin === undefined ? '' : _schedule$fixturesLin,
	          _schedule$resultsLink = schedule.resultsLinkText,
	          resultsLinkText = _schedule$resultsLink === undefined ? '' : _schedule$resultsLink;
	
	
	      if (isMobile) {
	        var mobileData = {
	          heading: heading,
	          isMobile: isMobile,
	          schedule: mobile,
	          team: team,
	          sport: sport,
	          notes: notes,
	          fixturesLinkText: fixturesLinkText,
	          fixturesLink: (0, _selectn2.default)('fixtures.link', schedule),
	          resultsLinkText: resultsLinkText,
	          resultsLink: (0, _selectn2.default)('results.link', schedule)
	        };
	        return _react2.default.createElement(FixturesAndResultsMobile, { key: 'mob-sch-mod', mobileData: mobileData });
	      }
	
	      var tabAData = (0, _selectn2.default)('fixtures.items', schedule);
	      var tabAContentName = (0, _selectn2.default)('fixtures.name', schedule);
	      var tabAContentText = (0, _selectn2.default)('fixtures.text', schedule);
	      var tabBData = (0, _selectn2.default)('results.items', schedule);
	      var tabBContentName = (0, _selectn2.default)('results.name', schedule);
	      var tabBContentText = (0, _selectn2.default)('results.text', schedule);
	
	      var tabHeadingChildren = _react2.default.createElement(TabsHeading, { key: 'sch-hdr', heading: heading });
	      var tabAContChildren = _react2.default.createElement(ScheduleDiv, { key: 'sch-div-1', data: tabAData, contentName: tabAContentName, team: this.props.team, sport: this.props.sport, isMobile: isMobile });
	      var tabBContChildren = _react2.default.createElement(ScheduleDiv, { key: 'sch-div-2', data: tabBData, contentName: tabBContentName, team: this.props.team, sport: this.props.sport, isMobile: isMobile });
	
	      var tabsModule = {
	        key: 'tm',
	        type: 'module',
	        moduleClassName: 'club-schedule alt',
	        tabSizeClassName: 'lg',
	        heading: {
	          component: tabHeadingChildren
	        },
	        tabs: [{
	          name: tabAContentName,
	          text: tabAContentText,
	          active: true,
	          content: {
	            component: tabAContChildren
	          }
	        }, {
	          name: tabBContentName,
	          text: tabBContentText,
	          content: {
	            component: tabBContChildren
	          }
	        }]
	      };
	
	      return _react2.default.createElement(_Tabs.TabsModule, { key: tabsModule.key, type: tabsModule.type, data: tabsModule });
	    }
	  }]);
	  return FixturesAndResults;
	}(_react2.default.Component), _class2.propTypes = {
	  children: _react.PropTypes.object
	}, _temp2);
	exports.default = FixturesAndResults;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabsModule = exports.TabContent = exports.Tab = exports.Tabs = undefined;
	
	var _keys = __webpack_require__(415);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tabs = exports.Tabs = function Tabs(_ref) {
	  var heading = _ref.heading,
	      tabs = _ref.tabs,
	      content = _ref.content,
	      moduleClassName = _ref.moduleClassName;
	
	  return _react2.default.createElement(
	    "section",
	    { className: moduleClassName },
	    _react2.default.createElement(
	      "header",
	      null,
	      heading ? heading : null,
	      _react2.default.createElement(
	        "div",
	        { className: "filter form-group button-group", "data-behavior": "tabs" },
	        tabs
	      )
	    ),
	    content
	  );
	};
	
	var Tab = exports.Tab = function Tab(_ref2) {
	  var props = _ref2.props,
	      isActive = _ref2.isActive,
	      switchTab = _ref2.switchTab;
	
	  if (typeof props === 'undefined') {
	    return _react2.default.createElement("span", null);
	  }
	  var tabName = props.tabName,
	      text = props.text,
	      tabSizeClassName = props.tabSizeClassName;
	
	  var defaultClassname = 'button-filter-alt ' + tabSizeClassName;
	  var activeClassname = 'button-filter-alt ' + tabSizeClassName + ' active';
	  var currTabClassName = isActive === tabName ? activeClassname : defaultClassname;
	  return _react2.default.createElement(
	    "a",
	    { onClick: switchTab.bind(null, tabName), className: currTabClassName },
	    text
	  );
	};
	
	var TabContent = exports.TabContent = function TabContent(_ref3) {
	  var props = _ref3.props,
	      isActive = _ref3.isActive;
	
	  if (typeof props === 'undefined') {
	    return _react2.default.createElement("span", null);
	  }
	  //console.info('=======>props',props)
	
	  var defStyle = isActive === props.contentName ? { display: 'block' } : { display: 'none' };
	  if (props.name) {
	    return _react2.default.createElement(
	      "div",
	      { id: props.name, style: defStyle },
	      props.component
	    );
	  } else {
	    return _react2.default.createElement("span", null);
	  }
	};
	
	var TabsModule = exports.TabsModule = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(TabsModule, _React$Component);
	
	  function TabsModule(props) {
	    (0, _classCallCheck3.default)(this, TabsModule);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TabsModule.__proto__ || (0, _getPrototypeOf2.default)(TabsModule)).call(this, props));
	
	    _this.state = { active: '' };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TabsModule, [{
	    key: "getActiveTab",
	    value: function getActiveTab(d) {
	      var _this2 = this;
	
	      if (typeof d !== 'undefined') {
	        (0, _keys2.default)(d).forEach(function (i) {
	          if (i === 'tabs') {
	            var tabs = d[i] || [];
	            var key = d.key;
	            var dLen = tabs.length;
	            for (var j = 0; j < dLen; j++) {
	              var isActive = tabs[j].active ? tabs[j].active : false;
	              if (isActive === true) {
	                _this2.setState({ active: key + '' + j });
	              }
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "switchTab",
	    value: function switchTab(name, e) {
	      this.setState({ active: name });
	      e.preventDefault();
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (this.state.active === '') {
	        if (typeof this.props.data !== 'undefined') {
	          this.getActiveTab.call(this, this.props.data);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var data = this.props.data;
	
	      if (typeof data === 'undefined') {
	        return _react2.default.createElement("span", null);
	      }
	      var _data$tabSizeClassNam = data.tabSizeClassName,
	          tabSizeClassName = _data$tabSizeClassNam === undefined ? '' : _data$tabSizeClassNam,
	          _data$moduleClassName = data.moduleClassName,
	          moduleClassName = _data$moduleClassName === undefined ? '' : _data$moduleClassName,
	          _data$tabs = data.tabs,
	          tabs = _data$tabs === undefined ? [] : _data$tabs,
	          heading = data.heading,
	          key = data.key;
	
	
	      if (typeof tabs === 'undefined') {
	        return _react2.default.createElement("span", null);
	      }
	
	      var tabsArr = [],
	          tabsContentArr = [],
	          tabsCompArr = [],
	          tabsHeadingArr = [],
	          tabProps = {};
	
	      if (typeof heading !== 'undefined') {
	        tabsHeadingArr.push(heading.component);
	      }
	
	      tabProps.wrapKey = key + '-tabs';
	      tabProps.contentWrapKey = tabProps.wrapKey + '-cont';
	      moduleClassName = moduleClassName + ' ' + tabProps.wrapKey;
	
	      var tabsLen = tabs.length;
	
	      var _loop = function _loop(i) {
	        //object key from tab config
	        tabs[i].tabName = key + '' + i;
	        tabs[i].key = tabProps.wrapKey + '-' + i;
	        tabs[i].tabSizeClassName = tabSizeClassName;
	        tabsArr.push(_react2.default.createElement(Tab, { key: tabs[i].key, props: tabs[i], isActive: _this3.state.active, switchTab: _this3.switchTab.bind(_this3) }));
	        (0, _keys2.default)(tabs[i]).forEach(function (j) {
	          var currTab = tabs[i][j];
	          if (j === 'content') {
	            //object key from tab config
	            currTab.name = tabs[i].name;
	            currTab.contentName = tabs[i].tabName;
	            currTab.key = tabs[i].key + '-cont';
	            tabsCompArr.push(_react2.default.createElement(TabContent, { key: currTab.key, props: currTab, isActive: _this3.state.active }));
	          }
	        });
	
	        tabsContentArr = [_react2.default.createElement(
	          "div",
	          { key: tabProps.contentWrapKey, className: "content" },
	          tabsCompArr
	        )];
	      };
	
	      for (var i = 0; i < tabsLen; i++) {
	        _loop(i);
	      }
	
	      //console.info('========> tabsHeadingArr',tabsHeadingArr)
	      //console.info('========> tabsArr',tabsArr)
	      //console.info('========> tabsCompArr',tabsCompArr)
	
	      return _react2.default.createElement(Tabs, { key: tabProps.wrapKey, props: tabs, heading: tabsHeadingArr, tabs: tabsArr, content: tabsContentArr, moduleClassName: moduleClassName });
	    }
	  }]);
	  return TabsModule;
	}(_react2.default.Component), _class.propTypes = {
	  children: _react.PropTypes.array
	}, _temp);
	exports.default = TabsModule;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Video = exports.formatDuration = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _common = __webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatDuration = exports.formatDuration = function formatDuration(totalSeconds) {
	  var hours = Math.floor(totalSeconds / 3600);
	  var minutes = Math.floor((totalSeconds - hours * 3600) / 60);
	  var seconds = totalSeconds - hours * 3600 - minutes * 60;
	
	  seconds = Math.round(seconds * 100) / 100;
	  var result = '';
	  if (hours !== 0) {
	    result = (hours < 10 ? '0' + hours : hours) + ':';
	  }
	  result += minutes < 10 ? '0' + minutes : minutes;
	  result += ':' + (seconds < 10 ? '0' + seconds : seconds);
	  return result;
	};
	
	/**
	 * React Video element
	 * @param {String} id - The video id
	 * @param {String} headline - The video headline
	 * @param {String} description - The video description
	 * @param {String} source - The video source CMS ex: (intl, deportes, espn)
	 * @param {String} thumbnail - The video thumbnail URL
	 * @param {String} scoringPlay - Whether or not the video is of a scoring play
	 * @return {React.PropTypes.element} Video elem
	 */
	
	// TODO: localize 'play' label
	var Video = exports.Video = function Video(_ref) {
	  var _ref$id = _ref.id,
	      id = _ref$id === undefined ? '' : _ref$id,
	      _ref$headline = _ref.headline,
	      headline = _ref$headline === undefined ? '' : _ref$headline,
	      _ref$description = _ref.description,
	      description = _ref$description === undefined ? '' : _ref$description,
	      _ref$source = _ref.source,
	      source = _ref$source === undefined ? '' : _ref$source,
	      _ref$thumbnail = _ref.thumbnail,
	      thumbnail = _ref$thumbnail === undefined ? '' : _ref$thumbnail,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$duration = _ref.duration,
	      duration = _ref$duration === undefined ? '' : _ref$duration,
	      _ref$feedItemFigure = _ref.feedItemFigure,
	      feedItemFigure = _ref$feedItemFigure === undefined ? false : _ref$feedItemFigure,
	      _ref$showCaption = _ref.showCaption,
	      showCaption = _ref$showCaption === undefined ? false : _ref$showCaption,
	      _ref$forNewsFeed = _ref.forNewsFeed,
	      forNewsFeed = _ref$forNewsFeed === undefined ? false : _ref$forNewsFeed,
	      _ref$inlineStyles = _ref.inlineStyles,
	      inlineStyles = _ref$inlineStyles === undefined ? {} : _ref$inlineStyles,
	      _ref$thumbs = _ref.thumbs,
	      thumbs = _ref$thumbs === undefined ? [] : _ref$thumbs,
	      _ref$showDuration = _ref.showDuration,
	      showDuration = _ref$showDuration === undefined ? true : _ref$showDuration;
	
	  if (!thumbs.length) {
	    thumbs = [{
	      srcSet: (0, _common.urlWithParams)(thumbnail, 'w=943', 'h=530'),
	      mediaQuery: '(min-width: 376px)'
	    }, {
	      srcSet: [(0, _common.urlWithParams)(thumbnail, 'w=375'), (0, _common.urlWithParams)(thumbnail, 'w=750', 'cquality=40 2x')].join(','),
	      mediaQuery: '(max-width: 375px)'
	    }];
	  }
	  var durationMarkup = !forNewsFeed && showDuration ? '<span class="video-length">' + (duration ? formatDuration(duration) : '') + '</span>' : '';
	  var imgWrapContents = '\n    <picture>\n      ' + thumbs.map(function (thumb) {
	    return '<source data-srcset="' + thumb.srcSet + '" media="' + thumb.mediaQuery + '" />';
	  }) + '\n      <img class="lazyload" data-image-container=".article-figure" />\n    </picture>\n    <span class="video-play-button" data-id="' + id + '">play</span>\n    ' + durationMarkup + '\n  ';
	  /*
	  // Settings for all sources of the video thumbnail images
	  let allSources = [ {
	    config: [ {
	      combinerOptions: {
	        w: 943,/
	        h: 530
	      }
	    } ],
	    mediaQuery: '(min-width: 376px)'
	  }, {
	    config: [ {
	      combinerOptions: {
	        w: 375
	      }
	    }, {
	      combinerOptions: {
	        w: 750,
	        cquality: 40
	      },
	      others: '2x'
	    } ],
	    mediaQuery: '(max-width: 375px)'
	  } ]
	  */
	  var Entities = __webpack_require__(652).XmlEntities;
	  var entities = new Entities();
	  var textDescription = entities.decode(description);
	  var textHeadline = entities.decode(headline);
	
	  return _react2.default.createElement(
	    'figure',
	    { style: inlineStyles, 'data-video': 'native,640,360,' + id, className: (0, _classnames2.default)(className, feedItemFigure ? 'feed-item-figure' : 'iframe-video', 'article-figure', 'video'), 'data-source': source },
	    _react2.default.createElement('div', { className: 'img-wrap', dangerouslySetInnerHTML: { __html: imgWrapContents } }),
	    showCaption && _react2.default.createElement(
	      'figcaption',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'caption-wrapper' },
	        forNewsFeed && _react2.default.createElement(
	          'div',
	          { className: 'text-container' },
	          _react2.default.createElement(
	            'span',
	            { className: 'headline' },
	            headline,
	            ' (',
	            duration ? formatDuration(duration) : '',
	            ')'
	          )
	        ),
	        !forNewsFeed && _react2.default.createElement(
	          'div',
	          { className: 'text-container' },
	          _react2.default.createElement(
	            'span',
	            { className: 'headline' },
	            headline
	          ),
	          _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: textDescription || textHeadline } })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Video;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Bet365 = exports.scoresBetModule = exports.gamepackageBetModule = undefined;
	
	var _keys = __webpack_require__(415);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var gamepackageBetModule = exports.gamepackageBetModule = function gamepackageBetModule() {
	  var oddsDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaultLink = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var defaultMsg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var affiliateCodeOverwrite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	  var oddsItems = oddsDetails.items || {};
	  var keys = (0, _keys2.default)(oddsItems);
	
	  var markup = ['<img src="http://a.espncdn.com/redesign/assets/img/logos/bet365.png" /> ' + (oddsDetails.text ? oddsDetails.text : '')];
	  var keysLen = keys.length || 0;
	
	  var credit = '<a href="http://www.bet365.com/home/default.asp?deeplink=1&cid=3&affiliate=365_307576" target="_blank" class="bet-link icon-font-after icon-external-outline2-after">Bet now</a>';
	
	  if (keysLen > 0) {
	    for (var i = 0; i < keysLen; i++) {
	      var oddsItem = oddsItems[keys[i]] || {};
	      if (affiliateCodeOverwrite) {
	        oddsItem.href = updateAffiliateCode(oddsItem.href, affiliateCodeOverwrite);
	        credit = updateAffiliateCode(credit, affiliateCodeOverwrite);
	      }
	      var nextBatsmen = keys[i] || '';
	      var anchor = oddsItem.href ? '<a href=' + oddsItem.href + ' target="_blank">' + oddsItem.summary + '</a>' : oddsItem.odds;
	      markup.push('<span>' + nextBatsmen + ' ' + anchor + (keysLen - 1 == i ? '. ' + credit : '') + '</span>');
	    }
	  } else {
	    if (affiliateCodeOverwrite) {
	      credit = updateAffiliateCode(credit, affiliateCodeOverwrite);
	    }
	    markup.push('<span>' + defaultMsg + ' ' + credit + '</span>');
	  }
	
	  markup = markup.join('');
	  return markup;
	};
	
	var scoresBetModule = exports.scoresBetModule = function scoresBetModule() {
	  var oddsDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaultLink = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var defaultMsg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var affiliateCodeOverwrite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	  var oddsItems = oddsDetails.items || {};
	  var keys = (0, _keys2.default)(oddsItems);
	
	  var markup = [];
	  if (affiliateCodeOverwrite) {
	    defaultLink = updateAffiliateCode(defaultLink, affiliateCodeOverwrite);
	  }
	
	  if (keys.length > 0) {
	    markup.push('<ul>');
	    for (var i = 0; i < keys.length; i++) {
	      var oddsItem = oddsItems[keys[i]] || {};
	      if (affiliateCodeOverwrite) {
	        oddsItem.href = updateAffiliateCode(oddsItem.href, affiliateCodeOverwrite);
	      }
	      var anchor = oddsItem.href ? '<a href=' + oddsItem.href + ' target="_blank">' + oddsItem.summary + '</a>' : oddsItem.summary;
	      if (oddsItem.summary) {
	        markup.push('<li>' + keys[i] + ': ' + anchor + '</li>');
	      }
	    }
	    markup.push('</ul>');
	  }
	
	  markup.push('<div class="scoreCollection__provider">Odds by <a href=' + defaultLink + ' class="external" target="_blank">bet365</a></div>');
	  markup = markup.join('');
	
	  return markup;
	};
	
	var Bet365 = exports.Bet365 = function Bet365(_ref) {
	  var _ref$type = _ref.type,
	      type = _ref$type === undefined ? '' : _ref$type,
	      _ref$defaultLink = _ref.defaultLink,
	      defaultLink = _ref$defaultLink === undefined ? '' : _ref$defaultLink,
	      _ref$situationNodeOdd = _ref.situationNodeOdd,
	      situationNodeOdd = _ref$situationNodeOdd === undefined ? {} : _ref$situationNodeOdd,
	      _ref$odds = _ref.odds,
	      odds = _ref$odds === undefined ? {} : _ref$odds,
	      _ref$defaultMsg = _ref.defaultMsg,
	      defaultMsg = _ref$defaultMsg === undefined ? '' : _ref$defaultMsg,
	      _ref$affiliateCodeOve = _ref.affiliateCodeOverwrite,
	      affiliateCodeOverwrite = _ref$affiliateCodeOve === undefined ? '' : _ref$affiliateCodeOve,
	      _ref$pageType = _ref.pageType,
	      pageType = _ref$pageType === undefined ? '' : _ref$pageType;
	
	
	  var oddsDetails = {};
	  var classParent = '';
	  var betmarkup = void 0;
	
	  if (type === 'odds') {
	    oddsDetails = odds;
	  } else {
	    oddsDetails = situationNodeOdd;
	  }
	  if (pageType === 'scores') {
	    classParent = 'scoreCollection__odds';
	    betmarkup = scoresBetModule(oddsDetails, defaultLink, defaultMsg, affiliateCodeOverwrite);
	  } else {
	    betmarkup = gamepackageBetModule(oddsDetails, defaultLink, defaultMsg, affiliateCodeOverwrite);
	  }
	
	  return _react2.default.createElement('div', { className: classParent, dangerouslySetInnerHTML: { __html: betmarkup } });
	};
	
	var updateAffiliateCode = function updateAffiliateCode() {
	  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var affiliateCodeOverwrite = arguments[1];
	
	  var queryParam = link.indexOf('affiliatecode=') > -1 ? 'affiliatecode=' : 'affiliate=';
	  var regex = new RegExp('(' + queryParam + ').*?(&|\")');
	
	  return link.replace(regex, '$1' + affiliateCodeOverwrite + '$2');
	};
	
	exports.default = Bet365;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VideoSlider = undefined;
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Video = __webpack_require__(708);
	
	var _common = __webpack_require__(423);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global espn_ui jQuery */
	var VideoSlider = exports.VideoSlider = function (_React$Component) {
	  (0, _inherits3.default)(VideoSlider, _React$Component);
	
	  function VideoSlider() {
	    (0, _classCallCheck3.default)(this, VideoSlider);
	    return (0, _possibleConstructorReturn3.default)(this, (VideoSlider.__proto__ || (0, _getPrototypeOf2.default)(VideoSlider)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(VideoSlider, [{
	    key: 'loadVideoBehavior',
	    value: function loadVideoBehavior() {
	      try {
	        if (!this.slider.querySelectorAll('.slick-track').length) {
	          jQuery(this.slider).data('videoPackageEnabled', false);
	          espn_ui.loadBehaviorNamed('video_package', this.slider);
	        }
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var nextVideos = (0, _selectn2.default)('videos', nextProps) || [];
	      var prevVideos = (0, _selectn2.default)('props.videos', this) || [];
	      var isPlaying = jQuery(this.slider).find('object, video').size() ? true : false;
	      var shouldUpdate = false;
	
	      if (nextVideos.length != prevVideos.length) {
	        shouldUpdate = isPlaying ? false : true;
	      }
	
	      return shouldUpdate;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadVideoBehavior();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.loadVideoBehavior();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$videos = this.props.videos,
	          videos = _props$videos === undefined ? [] : _props$videos;
	
	
	      var videoList = videos.slice(0, 5).map(function (video, i) {
	
	        var thumbnail = video.thumbnail;
	        var duration = video.duration;
	        var desktopThumb = (0, _common.urlWithParams)(thumbnail, 'w=943', 'h=530');
	        var mobileThumb = [(0, _common.urlWithParams)(thumbnail, 'w=375'), (0, _common.urlWithParams)(thumbnail, 'w=750', 'cquality=40 2x')].join(',');
	
	        return '\n        <div class="item" data-id="' + video.id + '" data-index="' + i + '">\n          <div class="item-content">\n            <div class="caption">\n                <div class="content">\n                  <span>' + video.headline + '</span>\n                </div>\n            </div>\n            <figure class="feed-item-figure video video-carousel" data-source="' + video.source + '" data-id="' + video.id + '" data-video="native,640,360,' + video.id + '">\n              <div class="img-wrap">\n                <picture>\n                  <source srcset="' + desktopThumb + '" media="(min-width: 376px)" />\n                  <source srcset="' + mobileThumb + '" media="(max-width: 375px)" />\n                  <img class="lazyloaded imageLoaded" data-image-container=".article-figure">\n                </picture>\n                <span class="video-play-button ">Play</span>\n                <span class="video-length">' + (duration ? (0, _Video.formatDuration)(duration) : '') + '</span>\n              </div>\n            </figure>\n          </div>\n        </div>\n      ';
	      });
	
	      var videoHtml = '\n      <div id="carousel" class="carousel video-playlist">\n          ' + videoList.join('') + '\n      </div>\n    ';
	
	      var content = _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement('article', { ref: function ref(_ref) {
	            return _this2.slider = _ref;
	          }, className: 'carousel-item', 'data-behavior': 'video_package', dangerouslySetInnerHTML: { __html: videoHtml } })
	      );
	
	      return videos.length ? content : _react2.default.createElement('div', { style: { display: 'none' } });
	    }
	  }]);
	  return VideoSlider;
	}(_react2.default.Component);
	// Should move to common utils
	
	
	exports.default = VideoSlider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentSummary = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(423);
	
	var _index = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSummary = exports.ContentSummary = function ContentSummary(_ref) {
	  var _ref$date = _ref.date,
	      date = _ref$date === undefined ? '' : _ref$date,
	      _ref$source = _ref.source,
	      source = _ref$source === undefined ? '' : _ref$source,
	      _ref$href = _ref.href,
	      href = _ref$href === undefined ? '#' : _ref$href,
	      _ref$headline = _ref.headline,
	      headline = _ref$headline === undefined ? '' : _ref$headline,
	      _ref$description = _ref.description,
	      description = _ref$description === undefined ? '' : _ref$description;
	
	
	  return _react2.default.createElement(
	    'header',
	    null,
	    (date || source) && _react2.default.createElement(
	      'div',
	      { className: 'meta' },
	      _react2.default.createElement(
	        'span',
	        { className: 'timestamp', 'data-behavior': 'date_time', 'data-date': date },
	        _react2.default.createElement(
	          'span',
	          { className: 'date', 'data-dateformat': 'date2' },
	          (0, _common.relativeDate)(new Date(date))
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'author' },
	        _react2.default.createElement(
	          'span',
	          null,
	          source
	        )
	      )
	    ),
	    headline && _react2.default.createElement(
	      'h1',
	      null,
	      _react2.default.createElement(_index.AnchorLink, { trackingName: '&lpos=:editorial', to: href, text: headline })
	    ),
	    description && _react2.default.createElement(
	      'p',
	      null,
	      description
	    )
	  );
	};
	
	exports.default = ContentSummary;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TopStories = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TopStories = exports.TopStories = function TopStories(_ref) {
	  var _ref$title = _ref.title,
	      title = _ref$title === undefined ? '' : _ref$title,
	      _ref$content = _ref.content,
	      content = _ref$content === undefined ? {} : _ref$content,
	      _ref$videos = _ref.videos,
	      videos = _ref$videos === undefined ? [] : _ref$videos,
	      _ref$image = _ref.image,
	      image = _ref$image === undefined ? {} : _ref$image,
	      _ref$href = _ref.href,
	      href = _ref$href === undefined ? '#' : _ref$href,
	      _ref$hasMoreVideosTab = _ref.hasMoreVideosTab,
	      hasMoreVideosTab = _ref$hasMoreVideosTab === undefined ? false : _ref$hasMoreVideosTab,
	      _ref$showFooter = _ref.showFooter,
	      showFooter = _ref$showFooter === undefined ? false : _ref$showFooter,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var allSources = [{
	    config: [{
	      combinerOptions: {
	        w: 576,
	        h: 324
	      }
	    }]
	  }];
	
	  var module = _react2.default.createElement(
	    'article',
	    { className: (0, _classnames2.default)('sub-module', className, { 'top-stories has-media': content.id }) },
	    title && _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        title
	      )
	    ) || null,
	    videos.length ? _react2.default.createElement(_index.VideoSlider, { videos: videos }) : image.url && _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'figure',
	        { className: 'feed-item-figure' },
	        _react2.default.createElement(
	          'div',
	          { className: 'img-wrap' },
	          _react2.default.createElement(_index.Picture, { thumbnail: image.url, className: 'feed-item-figure', allSources: allSources })
	        )
	      )
	    ) || null,
	    content.date || content.headline ? _react2.default.createElement(_index.ContentSummary, content) : null,
	    (showFooter || !content.id) && hasMoreVideosTab && _react2.default.createElement(
	      'footer',
	      null,
	      _react2.default.createElement(_index.AnchorLink, { to: href, text: 'More Videos' })
	    )
	  );
	
	  return videos.length || content.id ? module : _react2.default.createElement('article', { style: { display: 'none' } });
	};
	
	exports.default = TopStories;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /* global jQuery */
	
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactWaypoint = __webpack_require__(714);
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _index = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lazyload = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Lazyload, _React$Component);
	
	  function Lazyload() {
	    (0, _classCallCheck3.default)(this, Lazyload);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Lazyload.__proto__ || (0, _getPrototypeOf2.default)(Lazyload)).call(this));
	
	    _this._handleLazyLoad = _this._handleLazyLoad.bind(_this);
	
	    _this.scrollableAncestor = typeof window !== 'undefined' && window, _this.state = {
	      shouldForceLazyload: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Lazyload, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var currentPage = nextProps.page;
	      var _props = this.props,
	          prevPage = _props.page,
	          increment = _props.increment;
	
	      var isLoadingComplete = increment > 0 ? currentPage > prevPage : currentPage < prevPage;
	
	      // update for the state
	      var stateUpdate = {
	        shouldForceLazyload: isLoadingComplete
	
	        /**
	         * set `isLoading` false if previous lazyload request is complete
	         * or current page is `1`
	         */
	      };if (isLoadingComplete === true || currentPage === 1) {
	        stateUpdate.isLoading = false;
	      }
	
	      this.setState(stateUpdate);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var enableForceLazyload = this.props.enableForceLazyload;
	      var _state = this.state,
	          shouldForceLazyload = _state.shouldForceLazyload,
	          isLoading = _state.isLoading;
	
	
	      if (enableForceLazyload && shouldForceLazyload && !isLoading) {
	        this._forceTriggerLazyLoad();
	      }
	    }
	  }, {
	    key: '_forceTriggerLazyLoad',
	    value: function _forceTriggerLazyLoad() {
	      var _props2 = this.props,
	          hasMore = _props2.hasMore,
	          threshold = _props2.threshold;
	      var _refs$wayPoint = this.refs.wayPoint,
	          wayPoint = _refs$wayPoint === undefined ? '' : _refs$wayPoint;
	
	      var $window = jQuery(window);
	      var docViewCovered = $window.height() * (1 + threshold) + $window.scrollTop();
	
	      // if no further data present or not browser rendering
	      if (!(hasMore && process.browser)) {
	        return;
	      }
	
	      /*
	       * force trigger lazy load if
	       * wayPoint is in trigger area even after update of previous request
	       */
	      if (jQuery(wayPoint) != undefined && jQuery(wayPoint).offset().top <= docViewCovered) {
	        this._handleLazyLoad(true);
	      }
	    }
	  }, {
	    key: '_handleLazyLoad',
	    value: function _handleLazyLoad(isForceLazyload) {
	      var _props3 = this.props,
	          page = _props3.page,
	          updateMore = _props3.updateMore,
	          increment = _props3.increment;
	      var isLoading = this.state.isLoading;
	
	      var nextPage = void 0;
	
	      if (!page) {
	        return;
	      }
	
	      // no lazyload api request if previous request is in progress
	      if (isLoading === true) {
	        return;
	      }
	
	      // next page
	      nextPage = page + (increment ? increment : 1);
	
	      this.setState({
	        isLoading: true
	      });
	
	      // update the next page
	      updateMore(nextPage, isForceLazyload);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          hasMore = _props4.hasMore,
	          threshold = _props4.threshold,
	          enableLoader = _props4.enableLoader;
	      var isLoading = this.state.isLoading;
	
	
	      if (hasMore) {
	        // render lazyload component if more content available
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { ref: 'wayPoint', style: { clear: 'both', width: 0, height: 0, visibility: 'hidden' } },
	            _react2.default.createElement(_reactWaypoint2.default, {
	              onEnter: this._handleLazyLoad,
	              threshold: threshold,
	              scrollableAncestor: this.scrollableAncestor })
	          ),
	          enableLoader && isLoading && _react2.default.createElement(_index.LoaderIcon, null)
	        );
	      } else {
	        // render empty if no content
	        return _react2.default.createElement('span', { style: { display: 'none' } });
	      }
	    }
	  }]);
	  return Lazyload;
	}(_react2.default.Component), _class.propTypes = {
	  page: _react.PropTypes.number,
	  updateMore: _react.PropTypes.func.isRequired,
	  hasMore: _react.PropTypes.bool.isRequired,
	  threshold: _react.PropTypes.number,
	  enableForceLazyload: _react.PropTypes.bool,
	  increment: _react.PropTypes.number
	}, _temp);
	exports.default = Lazyload;
	
	
	Lazyload.defaultProps = {
	  threshold: 0.3,
	  enableForceLazyload: false
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var consolidatedEvents = __webpack_require__(715);
	var PropTypes = _interopDefault(__webpack_require__(246));
	var React = _interopDefault(__webpack_require__(9));
	
	/**
	 * Attempts to parse the offset provided as a prop as a percentage. For
	 * instance, if the component has been provided with the string "20%" as
	 * a value of one of the offset props. If the value matches, then it returns
	 * a numeric version of the prop. For instance, "20%" would become `0.2`.
	 * If `str` isn't a percentage, then `undefined` will be returned.
	 *
	 * @param {string} str The value of an offset prop to be converted to a
	 *   number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was not a percentage.
	 */
	function parseOffsetAsPercentage(str) {
	  if (str.slice(-1) === '%') {
	    return parseFloat(str.slice(0, -1)) / 100;
	  }
	}
	
	/**
	 * Attempts to parse the offset provided as a prop as a pixel value. If
	 * parsing fails, then `undefined` is returned. Three examples of values that
	 * will be successfully parsed are:
	 * `20`
	 * "20px"
	 * "20"
	 *
	 * @param {string|number} str A string of the form "{number}" or "{number}px",
	 *   or just a number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was neither a number nor string ending in "px".
	 */
	function parseOffsetAsPixels(str) {
	  if (!isNaN(parseFloat(str)) && isFinite(str)) {
	    return parseFloat(str);
	  } else if (str.slice(-2) === 'px') {
	    return parseFloat(str.slice(0, -2));
	  }
	}
	
	/**
	 * @param {string|number} offset
	 * @param {number} contextHeight
	 * @return {number} A number representing `offset` converted into pixels.
	 */
	function computeOffsetPixels(offset, contextHeight) {
	  var pixelOffset = parseOffsetAsPixels(offset);
	
	  if (typeof pixelOffset === 'number') {
	    return pixelOffset;
	  }
	
	  var percentOffset = parseOffsetAsPercentage(offset);
	  if (typeof percentOffset === 'number') {
	    return percentOffset * contextHeight;
	  }
	}
	
	var constants = {
	  above: 'above',
	  inside: 'inside',
	  below: 'below',
	  invisible: 'invisible'
	};
	
	function debugLog() {
	  if (false) {
	    console.log(arguments); // eslint-disable-line no-console
	  }
	}
	
	var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
	
	/**
	 * Raise an error if more that one child was provided to "children"
	 *
	 * @param {?React.element} children
	 * @return {undefined}
	 */
	function ensureChildrenIsValid(children) {
	  if (children) {
	    try {
	      React.Children.only(children);
	    } catch (e) {
	      throw new Error(errorMessage);
	    }
	  }
	}
	
	/**
	 * When an element's type is a string, it represents a DOM node with that tag name
	 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
	 *
	 * @param {React.element} Component
	 * @return {bool} Whether the component is a DOM Element
	 */
	function isDOMElement(Component) {
	  return typeof Component.type === 'string';
	}
	
	var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
	
	/**
	 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
	 *
	 * @param {?React.element} children
	 * @param {?HTMLElement} ref
	 * @return {undefined}
	 */
	function ensureRefIsProvidedByChild(children, ref) {
	  if (children && !isDOMElement(children) && !ref) {
	    throw new Error(errorMessage$1);
	  }
	}
	
	/**
	 * @param {object} bounds An object with bounds data for the waypoint and
	 *   scrollable parent
	 * @return {string} The current position of the waypoint in relation to the
	 *   visible portion of the scrollable parent. One of `constants.above`,
	 *   `constants.below`, or `constants.inside`.
	 */
	function getCurrentPosition(bounds) {
	  if (bounds.viewportBottom - bounds.viewportTop === 0) {
	    return constants.invisible;
	  }
	
	  // top is within the viewport
	  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
	    return constants.inside;
	  }
	
	  // bottom is within the viewport
	  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
	    return constants.inside;
	  }
	
	  // top is above the viewport and bottom is below the viewport
	  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
	    return constants.inside;
	  }
	
	  if (bounds.viewportBottom < bounds.waypointTop) {
	    return constants.below;
	  }
	
	  if (bounds.waypointTop < bounds.viewportTop) {
	    return constants.above;
	  }
	
	  return constants.invisible;
	}
	
	var timeout = void 0;
	var timeoutQueue = [];
	
	function onNextTick(cb) {
	  timeoutQueue.push(cb);
	
	  if (!timeout) {
	    timeout = setTimeout(function () {
	      timeout = null;
	
	      // Drain the timeoutQueue
	      var item = void 0;
	      // eslint-disable-next-line no-cond-assign
	      while (item = timeoutQueue.shift()) {
	        item();
	      }
	    }, 0);
	  }
	
	  var isSubscribed = true;
	
	  return function () {
	    function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      var index = timeoutQueue.indexOf(cb);
	      if (index === -1) {
	        return;
	      }
	
	      timeoutQueue.splice(index, 1);
	
	      if (!timeoutQueue.length && timeout) {
	        clearTimeout(timeout);
	        timeout = null;
	      }
	    }
	
	    return unsubscribe;
	  }();
	}
	
	function resolveScrollableAncestorProp(scrollableAncestor) {
	  // When Waypoint is rendered on the server, `window` is not available.
	  // To make Waypoint easier to work with, we allow this to be specified in
	  // string form and safely convert to `window` here.
	  if (scrollableAncestor === 'window') {
	    return global.window;
	  }
	
	  return scrollableAncestor;
	}
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultProps = {
	  topOffset: '0px',
	  bottomOffset: '0px',
	  horizontal: false,
	  onEnter: function () {
	    function onEnter() {}
	
	    return onEnter;
	  }(),
	  onLeave: function () {
	    function onLeave() {}
	
	    return onLeave;
	  }(),
	  onPositionChange: function () {
	    function onPositionChange() {}
	
	    return onPositionChange;
	  }(),
	
	  fireOnRapidScroll: true
	};
	
	/**
	 * Calls a function when you scroll to the element.
	 */
	
	var Waypoint = function (_React$Component) {
	  _inherits(Waypoint, _React$Component);
	
	  function Waypoint(props) {
	    _classCallCheck(this, Waypoint);
	
	    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));
	
	    _this.refElement = function (e) {
	      return _this._ref = e;
	    };
	    return _this;
	  }
	
	  _createClass(Waypoint, [{
	    key: 'componentWillMount',
	    value: function () {
	      function componentWillMount() {
	        ensureChildrenIsValid(this.props.children);
	      }
	
	      return componentWillMount;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _this2 = this;
	
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        // this._ref may occasionally not be set at this time. To help ensure that
	        // this works smoothly, we want to delay the initial execution until the
	        // next tick.
	        this.cancelInitialTimeout = onNextTick(function () {
	          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
	          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);
	
	          _this2._handleScroll = _this2._handleScroll.bind(_this2);
	          _this2.scrollableAncestor = _this2._findScrollableAncestor();
	
	          if (false) {
	            debugLog('scrollableAncestor', _this2.scrollableAncestor);
	          }
	
	          _this2.scrollEventListenerUnsubscribe = consolidatedEvents.addEventListener(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });
	
	          _this2.resizeEventListenerUnsubscribe = consolidatedEvents.addEventListener(window, 'resize', _this2._handleScroll, { passive: true });
	
	          _this2._handleScroll(null);
	        });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(newProps) {
	        ensureChildrenIsValid(newProps.children);
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate() {
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        if (!this.scrollableAncestor) {
	          // The Waypoint has not yet initialized.
	          return;
	        }
	
	        // The element may have moved.
	        this._handleScroll(null);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        if (this.scrollEventListenerUnsubscribe) {
	          this.scrollEventListenerUnsubscribe();
	        }
	        if (this.resizeEventListenerUnsubscribe) {
	          this.resizeEventListenerUnsubscribe();
	        }
	
	        if (this.cancelInitialTimeout) {
	          this.cancelInitialTimeout();
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	
	    /**
	     * Traverses up the DOM to find an ancestor container which has an overflow
	     * style that allows for scrolling.
	     *
	     * @return {Object} the closest ancestor element with an overflow style that
	     *   allows for scrolling. If none is found, the `window` object is returned
	     *   as a fallback.
	     */
	
	  }, {
	    key: '_findScrollableAncestor',
	    value: function () {
	      function _findScrollableAncestor() {
	        var _props = this.props,
	            horizontal = _props.horizontal,
	            scrollableAncestor = _props.scrollableAncestor;
	
	
	        if (scrollableAncestor) {
	          return resolveScrollableAncestorProp(scrollableAncestor);
	        }
	
	        var node = this._ref;
	
	        while (node.parentNode) {
	          node = node.parentNode;
	
	          if (node === document.body) {
	            // We've reached all the way to the root node.
	            return window;
	          }
	
	          var style = window.getComputedStyle(node);
	          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
	          var overflow = overflowDirec || style.getPropertyValue('overflow');
	
	          if (overflow === 'auto' || overflow === 'scroll') {
	            return node;
	          }
	        }
	
	        // A scrollable ancestor element was not found, which means that we need to
	        // do stuff on window.
	        return window;
	      }
	
	      return _findScrollableAncestor;
	    }()
	
	    /**
	     * @param {Object} event the native scroll event coming from the scrollable
	     *   ancestor, or resize event coming from the window. Will be undefined if
	     *   called by a React lifecyle method
	     */
	
	  }, {
	    key: '_handleScroll',
	    value: function () {
	      function _handleScroll(event) {
	        if (!this._ref) {
	          // There's a chance we end up here after the component has been unmounted.
	          return;
	        }
	
	        var bounds = this._getBounds();
	        var currentPosition = getCurrentPosition(bounds);
	        var previousPosition = this._previousPosition;
	
	        if (false) {
	          debugLog('currentPosition', currentPosition);
	          debugLog('previousPosition', previousPosition);
	        }
	
	        // Save previous position as early as possible to prevent cycles
	        this._previousPosition = currentPosition;
	
	        if (previousPosition === currentPosition) {
	          // No change since last trigger
	          return;
	        }
	
	        var callbackArg = {
	          currentPosition: currentPosition,
	          previousPosition: previousPosition,
	          event: event,
	          waypointTop: bounds.waypointTop,
	          waypointBottom: bounds.waypointBottom,
	          viewportTop: bounds.viewportTop,
	          viewportBottom: bounds.viewportBottom
	        };
	        this.props.onPositionChange.call(this, callbackArg);
	
	        if (currentPosition === constants.inside) {
	          this.props.onEnter.call(this, callbackArg);
	        } else if (previousPosition === constants.inside) {
	          this.props.onLeave.call(this, callbackArg);
	        }
	
	        var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
	        var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;
	
	        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
	          // If the scroll event isn't fired often enough to occur while the
	          // waypoint was visible, we trigger both callbacks anyway.
	          this.props.onEnter.call(this, {
	            currentPosition: constants.inside,
	            previousPosition: previousPosition,
	            event: event,
	            waypointTop: bounds.waypointTop,
	            waypointBottom: bounds.waypointBottom,
	            viewportTop: bounds.viewportTop,
	            viewportBottom: bounds.viewportBottom
	          });
	          this.props.onLeave.call(this, {
	            currentPosition: currentPosition,
	            previousPosition: constants.inside,
	            event: event,
	            waypointTop: bounds.waypointTop,
	            waypointBottom: bounds.waypointBottom,
	            viewportTop: bounds.viewportTop,
	            viewportBottom: bounds.viewportBottom
	          });
	        }
	      }
	
	      return _handleScroll;
	    }()
	  }, {
	    key: '_getBounds',
	    value: function () {
	      function _getBounds() {
	        var horizontal = this.props.horizontal;
	
	        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
	            left = _ref$getBoundingClien.left,
	            top = _ref$getBoundingClien.top,
	            right = _ref$getBoundingClien.right,
	            bottom = _ref$getBoundingClien.bottom;
	
	        var waypointTop = horizontal ? left : top;
	        var waypointBottom = horizontal ? right : bottom;
	
	        var contextHeight = void 0;
	        var contextScrollTop = void 0;
	        if (this.scrollableAncestor === window) {
	          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
	          contextScrollTop = 0;
	        } else {
	          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
	          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
	        }
	
	        if (false) {
	          debugLog('waypoint top', waypointTop);
	          debugLog('waypoint bottom', waypointBottom);
	          debugLog('scrollableAncestor height', contextHeight);
	          debugLog('scrollableAncestor scrollTop', contextScrollTop);
	        }
	
	        var _props2 = this.props,
	            bottomOffset = _props2.bottomOffset,
	            topOffset = _props2.topOffset;
	
	        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
	        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
	        var contextBottom = contextScrollTop + contextHeight;
	
	        return {
	          waypointTop: waypointTop,
	          waypointBottom: waypointBottom,
	          viewportTop: contextScrollTop + topOffsetPx,
	          viewportBottom: contextBottom - bottomOffsetPx
	        };
	      }
	
	      return _getBounds;
	    }()
	
	    /**
	     * @return {Object}
	     */
	
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this3 = this;
	
	        var children = this.props.children;
	
	
	        if (!children) {
	          // We need an element that we can locate in the DOM to determine where it is
	          // rendered relative to the top of its context.
	          return React.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
	        }
	
	        if (isDOMElement(children)) {
	          var ref = function () {
	            function ref(node) {
	              _this3.refElement(node);
	              if (children.ref) {
	                children.ref(node);
	              }
	            }
	
	            return ref;
	          }();
	
	          return React.cloneElement(children, { ref: ref });
	        }
	
	        return React.cloneElement(children, { innerRef: this.refElement });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return Waypoint;
	}(React.Component);
	
	 false ? Waypoint.propTypes = {
	  children: PropTypes.node,
	  debug: PropTypes.bool,
	  onEnter: PropTypes.func,
	  onLeave: PropTypes.func,
	  onPositionChange: PropTypes.func,
	  fireOnRapidScroll: PropTypes.bool,
	  scrollableAncestor: PropTypes.any,
	  horizontal: PropTypes.bool,
	
	  // `topOffset` can either be a number, in which case its a distance from the
	  // top of the container in pixels, or a string value. Valid string values are
	  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
	  // as a percentage of the height of the containing element.
	  // For instance, if you pass "-20%", and the containing element is 100px tall,
	  // then the waypoint will be triggered when it has been scrolled 20px beyond
	  // the top of the containing element.
	  topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	
	  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
	  bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	} : void 0;
	
	Waypoint.above = constants.above;
	Waypoint.below = constants.below;
	Waypoint.inside = constants.inside;
	Waypoint.invisible = constants.invisible;
	Waypoint.getWindow = function () {
	  if (typeof window !== 'undefined') {
	    return window;
	  }
	};
	Waypoint.defaultProps = defaultProps;
	Waypoint.displayName = 'Waypoint';
	
	module.exports = Waypoint;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EVENT_HANDLERS_KEY = undefined;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	
	var _normalizeEventOptions = __webpack_require__(716);
	
	var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);
	
	var _TargetEventHandlers = __webpack_require__(719);
	
	var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Export to make testing possible.
	var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
	  }
	  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	// Deprecated
	function removeEventListener(unsubscribeFn) {
	  unsubscribeFn();
	}

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = normalizeEventOptions;
	
	var _canUsePassiveEventListeners = __webpack_require__(717);
	
	var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!(0, _canUsePassiveEventListeners2['default'])()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = canUsePassiveEventListeners;
	
	var _canUseDOM = __webpack_require__(718);
	
	var _canUseDOM2 = _interopRequireDefault(_canUseDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
	function testPassiveEventListeners() {
	  if (!_canUseDOM2['default']) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    window.addEventListener('test', null, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports['default'] = CAN_USE_DOM;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventOptionsKey = __webpack_require__(720);
	
	var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ensureCanMutateNextEventHandlers(eventHandlers) {
	  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
	    // eslint-disable-next-line no-param-reassign
	    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
	  }
	}
	
	var TargetEventHandlers = function () {
	  function TargetEventHandlers(target) {
	    _classCallCheck(this, TargetEventHandlers);
	
	    this.target = target;
	    this.events = {};
	  }
	
	  _createClass(TargetEventHandlers, [{
	    key: 'getEventHandlers',
	    value: function () {
	      function getEventHandlers(eventName, options) {
	        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));
	
	        if (!this.events[key]) {
	          this.events[key] = {
	            handlers: [],
	            handleEvent: undefined
	          };
	          this.events[key].nextHandlers = this.events[key].handlers;
	        }
	
	        return this.events[key];
	      }
	
	      return getEventHandlers;
	    }()
	  }, {
	    key: 'handleEvent',
	    value: function () {
	      function handleEvent(eventName, options, event) {
	        var eventHandlers = this.getEventHandlers(eventName, options);
	        eventHandlers.handlers = eventHandlers.nextHandlers;
	        eventHandlers.handlers.forEach(function (handler) {
	          if (handler) {
	            // We need to check for presence here because a handler function may
	            // cause later handlers to get removed. This can happen if you for
	            // instance have a waypoint that unmounts another waypoint as part of an
	            // onEnter/onLeave handler.
	            handler(event);
	          }
	        });
	      }
	
	      return handleEvent;
	    }()
	  }, {
	    key: 'add',
	    value: function () {
	      function add(eventName, listener, options) {
	        var _this = this;
	
	        // options has already been normalized at this point.
	        var eventHandlers = this.getEventHandlers(eventName, options);
	
	        ensureCanMutateNextEventHandlers(eventHandlers);
	
	        if (eventHandlers.nextHandlers.length === 0) {
	          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	        }
	
	        eventHandlers.nextHandlers.push(listener);
	
	        var isSubscribed = true;
	        var unsubscribe = function () {
	          function unsubscribe() {
	            if (!isSubscribed) {
	              return;
	            }
	
	            isSubscribed = false;
	
	            ensureCanMutateNextEventHandlers(eventHandlers);
	            var index = eventHandlers.nextHandlers.indexOf(listener);
	            eventHandlers.nextHandlers.splice(index, 1);
	
	            if (eventHandlers.nextHandlers.length === 0) {
	              // All event handlers have been removed, so we want to remove the event
	              // listener from the target node.
	
	              if (_this.target) {
	                // There can be a race condition where the target may no longer exist
	                // when this function is called, e.g. when a React component is
	                // unmounting. Guarding against this prevents the following error:
	                //
	                //   Cannot read property 'removeEventListener' of undefined
	                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	              }
	
	              eventHandlers.handleEvent = undefined;
	            }
	          }
	
	          return unsubscribe;
	        }();
	        return unsubscribe;
	      }
	
	      return add;
	    }()
	  }]);
	
	  return TargetEventHandlers;
	}();
	
	exports['default'] = TargetEventHandlers;

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = eventOptionsKey;
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackToTop = function BackToTop(_ref) {
	  var _ref$newsFeed = _ref.newsFeed,
	      newsFeed = _ref$newsFeed === undefined ? false : _ref$newsFeed;
	
	
	  var onClick = function onClick(e) {
	    e.preventDefault();
	    try {
	      window.scrollTo(0, 0);
	    } catch (e) {
	      console.log(e);
	    }
	  };
	
	  return newsFeed ? _react2.default.createElement(
	    "span",
	    { className: "backtotop" },
	    "Back to Top"
	  ) : _react2.default.createElement("a", { onClick: onClick, className: "back-to-top button-alt icon-font-before icon-arrow-up-solid-before" });
	};
	
	exports.default = BackToTop;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoaderIcon = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoaderIcon = exports.LoaderIcon = function LoaderIcon() {
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "style",
	      null,
	      "\n        .loader {\n          display: block;\n          min-height: 64px;\n          position: relative;\n          width: 100%\n        }\n        .loader:after {\n          -webkit-transform: translate(-50%, -50%);\n          -moz-transform: translate(-50%, -50%);\n          -o-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n          background: url(http://a.espncdn.com/redesign/assets/img/icons/shim2.gif) no-repeat;\n          background-position: 50% 50% !important;\n          background-size: 32px 32px;\n          content: \" \";\n          display: table;\n          height: 64px;\n          left: 50%;\n          position: absolute;\n          top: 50%;\n          width: 32px\n        }\n        "
	    ),
	    _react2.default.createElement("div", { className: "news-feed-item loader" })
	  );
	};
	
	exports.default = LoaderIcon;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Input = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Input = exports.Input = function Input(props) {
	  var input = props.input,
	      groupClass = props.groupClass,
	      _props$showLabel = props.showLabel,
	      showLabel = _props$showLabel === undefined ? false : _props$showLabel,
	      values = props.values,
	      errors = props.errors;
	  var name = input.name,
	      label = input.label,
	      id = input.id,
	      required = input.required;
	
	  var error = errors[name];
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('form__group', groupClass, { 'form__group--required': required, 'form__group--danger': error, 'form__group--labeled': showLabel }) },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: id, className: 'form__label' },
	      required && _react2.default.createElement(
	        'span',
	        { className: 'form__required' },
	        '*'
	      ),
	      label
	    ),
	    _react2.default.createElement('input', (0, _extends3.default)({}, input, {
	      value: values[name] || '',
	      className: (0, _classnames2.default)('form__control', { 'form__group--danger': error }),
	      'aria-describedby': 'form__' + name,
	      placeholder: label }))
	  );
	};
	
	exports.default = Input;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Button = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = exports.Button = function Button(props) {
	  var groupClass = props.groupClass,
	      id = props.id,
	      disabled = props.disabled,
	      submitting = props.submitting,
	      success = props.success,
	      tabindex = props.tabindex;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('form__group', groupClass) },
	    _react2.default.createElement(
	      'button',
	      { id: id, disabled: disabled, tabIndex: tabindex, className: (0, _classnames2.default)('button--preloader button--lg icon-font-before icon-check-solid-before', { 'button--active': !disabled, 'button--loading': submitting, 'button--success': success }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'button__text' },
	        'Submit'
	      ),
	      _react2.default.createElement('div', { className: (0, _classnames2.default)('button__ripple', { 'button__ripple--active': success }) }),
	      _react2.default.createElement(
	        'div',
	        { className: 'preloader-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'preloader preloader--lg preloader--active' },
	          _react2.default.createElement(
	            'div',
	            { className: 'preloader__spinner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'preloader__clipper preloader__clipper--left' },
	              _react2.default.createElement('div', { className: 'preloader__circle' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'preloader__gap-patch' },
	              _react2.default.createElement('div', { className: 'preloader__circle' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'preloader__clipper preloader__clipper--right' },
	              _react2.default.createElement('div', { className: 'preloader__circle' })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Button;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Textarea = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Textarea = exports.Textarea = function Textarea(props) {
	  var input = props.input,
	      groupClass = props.groupClass,
	      _props$showLabel = props.showLabel,
	      showLabel = _props$showLabel === undefined ? false : _props$showLabel,
	      values = props.values,
	      errors = props.errors;
	  var name = input.name,
	      label = input.label,
	      required = input.required;
	
	  var error = errors[name];
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('form__group commentary__message', groupClass, { 'form__group--required': required, 'form__group--danger': error, 'form__group--labeled': showLabel }) },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: 'form__message', className: 'form__label' },
	      label
	    ),
	    _react2.default.createElement('textarea', (0, _extends3.default)({}, input, {
	      value: values[name] || '',
	      className: 'form__control',
	      role: 'textbox' }))
	  );
	};
	
	exports.default = Textarea;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(412);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleRecaptcha = __webpack_require__(727);
	
	var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Recaptcha = function (_React$Component) {
	  (0, _inherits3.default)(Recaptcha, _React$Component);
	
	  function Recaptcha() {
	    (0, _classCallCheck3.default)(this, Recaptcha);
	    return (0, _possibleConstructorReturn3.default)(this, (Recaptcha.__proto__ || (0, _getPrototypeOf2.default)(Recaptcha)).call(this));
	  }
	
	  (0, _createClass3.default)(Recaptcha, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      try {
	        var wrapper = this.refs.wrapper;
	        this.refs.wrapper.addEventListener('load', function (e) {
	          e.target.tabIndex = _this2.props.tabindex;
	          wrapper.querySelector('textarea').setAttribute('required', true);
	        }, true);
	      } catch (err) {
	        console.error(err);
	      }
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.refs.recaptcha.reset();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      /* eslint-disable no-unused-vars */
	      var _props = this.props,
	          groupClass = _props.groupClass,
	          tabindex = _props.tabindex,
	          rest = (0, _objectWithoutProperties3.default)(_props, ['groupClass', 'tabindex']);
	      /* eslint-enable no-unused-vars */
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('form__group', groupClass), ref: 'wrapper' },
	        _react2.default.createElement(_reactGoogleRecaptcha2.default, (0, _extends3.default)({}, rest, { ref: 'recaptcha' }))
	      );
	    }
	  }]);
	  return Recaptcha;
	}(_react2.default.Component); /* jQuery */
	
	
	exports.default = Recaptcha;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(728)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recaptcha = __webpack_require__(729);
	
	var _recaptcha2 = _interopRequireDefault(_recaptcha);
	
	var _reactAsyncScript = __webpack_require__(747);
	
	var _reactAsyncScript2 = _interopRequireDefault(_reactAsyncScript);
	
	var callbackName = "onloadcallback";
	var lang = typeof window !== "undefined" && window.recaptchaOptions && window.recaptchaOptions.lang ? "&hl=" + window.recaptchaOptions.lang : "";
	var URL = "https://www.google.com/recaptcha/api.js?onload=" + callbackName + "&render=explicit" + lang;
	var globalName = "grecaptcha";
	
	exports["default"] = (0, _reactAsyncScript2["default"])(_recaptcha2["default"], URL, {
	  callbackName: callbackName,
	  globalName: globalName,
	  exposeFuncs: ["getValue", "reset"]
	});
	module.exports = exports["default"];

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};
	
	exports.__esModule = true;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _objectWithoutProperties = __webpack_require__(730)["default"];
	
	var _extends = __webpack_require__(731)["default"];
	
	var _interopRequireDefault = __webpack_require__(728)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var ReCAPTCHA = _react2["default"].createClass({
	  displayName: "reCAPTCHA",
	  propTypes: {
	    sitekey: _react.PropTypes.string.isRequired,
	    onChange: _react.PropTypes.func.isRequired,
	    grecaptcha: _react.PropTypes.object,
	    theme: _react.PropTypes.oneOf(["dark", "light"]),
	    type: _react.PropTypes.oneOf(["image", "audio"]),
	    tabindex: _react.PropTypes.number,
	    onExpired: _react.PropTypes.func,
	    size: _react.PropTypes.oneOf(["compact", "normal"]),
	    stoken: _react.PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      theme: "light",
	      type: "image",
	      tabindex: 0,
	      size: "normal"
	    };
	  },
	
	  getValue: function getValue() {
	    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
	      return this.props.grecaptcha.getResponse(this.state.widgetId);
	    }
	    return null;
	  },
	
	  reset: function reset() {
	    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
	      this.props.grecaptcha.reset(this.state.widgetId);
	    }
	  },
	
	  handleExpired: function handleExpired() {
	    if (this.props.onExpired) {
	      this.props.onExpired();
	    } else if (this.props.onChange) {
	      this.props.onChange(null);
	    }
	  },
	
	  explicitRender: function explicitRender(cb) {
	    if (this.props.grecaptcha && this.state.widgetId === undefined) {
	      var id = this.props.grecaptcha.render(this.refs.captcha, {
	        sitekey: this.props.sitekey,
	        callback: this.props.onChange,
	        theme: this.props.theme,
	        type: this.props.type,
	        tabindex: this.props.tabindex,
	        "expired-callback": this.handleExpired,
	        size: this.props.size,
	        stoken: this.props.stoken
	      });
	      this.setState({
	        widgetId: id
	      }, cb);
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.explicitRender();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.explicitRender();
	  },
	
	  render: function render() {
	    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
	    /* eslint-disable no-unused-vars */
	    var _props = this.props;
	    var sitekey = _props.sitekey;
	    var onChange = _props.onChange;
	    var theme = _props.theme;
	    var type = _props.type;
	    var tabindex = _props.tabindex;
	    var onExpired = _props.onExpired;
	    var size = _props.size;
	    var stoken = _props.stoken;
	    var grecaptcha = _props.grecaptcha;
	
	    var childProps = _objectWithoutProperties(_props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "size", "stoken", "grecaptcha"]);
	
	    /* eslint-enable no-unused-vars */
	    return _react2["default"].createElement("div", _extends({}, childProps, { ref: "captcha" }));
	  }
	});
	
	exports["default"] = ReCAPTCHA;
	module.exports = exports["default"];

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$assign = __webpack_require__(732)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(733), __esModule: true };

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(734);
	module.exports = __webpack_require__(737).Object.assign;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(735);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(740)});

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(736)
	  , core      = __webpack_require__(737)
	  , ctx       = __webpack_require__(738)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(739);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(741)
	  , toObject = __webpack_require__(742)
	  , IObject  = __webpack_require__(744);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(746)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(743);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(745);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _objectWithoutProperties = __webpack_require__(748)["default"];
	
	var _extends = __webpack_require__(749)["default"];
	
	var _Map = __webpack_require__(751)["default"];
	
	var _getIterator = __webpack_require__(791)["default"];
	
	var _interopRequireDefault = __webpack_require__(794)["default"];
	
	exports.__esModule = true;
	exports["default"] = makeAsyncScript;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var SCRIPT_MAP = new _Map();
	
	// A counter used to generate a unique id for each component that uses the function
	var idCount = 0;
	
	function makeAsyncScript(Component, scriptURL, options) {
	  options = options || {};
	  var funcs = {
	    displayName: "AsyncScriptLoader",
	
	    propTypes: {
	      asyncScriptOnLoad: _react.PropTypes.func
	    },
	
	    statics: {
	      asyncScriptLoaderTriggerOnScriptLoaded: function asyncScriptLoaderTriggerOnScriptLoaded() {
	        var mapEntry = SCRIPT_MAP.get(scriptURL);
	        if (!mapEntry || !mapEntry.loaded) {
	          throw new Error("Script is not loaded.");
	        }
	        for (var _iterator = mapEntry.observers.values(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	          var _ref;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	          }
	
	          var observer = _ref;
	
	          observer(mapEntry);
	        }
	        delete window[options.callbackName];
	      }
	    },
	
	    getInitialState: function getInitialState() {
	      return {};
	    },
	
	    asyncScriptLoaderGetScriptLoaderID: function asyncScriptLoaderGetScriptLoaderID() {
	      if (!this.__scriptLoaderID) {
	        this.__scriptLoaderID = "async-script-loader-" + idCount++;
	      }
	      return this.__scriptLoaderID;
	    },
	
	    getComponent: function getComponent() {
	      return this.childComponent;
	    },
	
	    componentDidMount: function componentDidMount() {
	      var _this = this;
	
	      var key = this.asyncScriptLoaderGetScriptLoaderID();
	      var _options = options;
	      var globalName = _options.globalName;
	      var callbackName = _options.callbackName;
	
	      if (globalName && typeof window[globalName] !== "undefined") {
	        SCRIPT_MAP.set(scriptURL, { loaded: true, observers: new _Map() });
	      }
	
	      if (SCRIPT_MAP.has(scriptURL)) {
	        var entry = SCRIPT_MAP.get(scriptURL);
	        if (entry.loaded || entry.errored) {
	          this.asyncScriptLoaderHandleLoad(entry);
	          return;
	        }
	        entry.observers.set(key, this.asyncScriptLoaderHandleLoad);
	        return;
	      }
	
	      var observers = new _Map();
	      observers.set(key, this.asyncScriptLoaderHandleLoad);
	      SCRIPT_MAP.set(scriptURL, {
	        loaded: false,
	        observers: observers
	      });
	
	      var script = document.createElement("script");
	
	      script.src = scriptURL;
	      script.async = 1;
	
	      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
	        if (SCRIPT_MAP.has(scriptURL)) {
	          var mapEntry = SCRIPT_MAP.get(scriptURL);
	          var observersMap = mapEntry.observers;
	
	          for (var _iterator2 = observersMap, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	            var _ref2;
	
	            if (_isArray2) {
	              if (_i2 >= _iterator2.length) break;
	              _ref2 = _iterator2[_i2++];
	            } else {
	              _i2 = _iterator2.next();
	              if (_i2.done) break;
	              _ref2 = _i2.value;
	            }
	
	            var obsKey = _ref2[0];
	            var observer = _ref2[1];
	
	            if (func(observer)) {
	              observersMap["delete"](obsKey);
	            }
	          }
	        }
	      };
	
	      if (callbackName && typeof window !== "undefined") {
	        window[callbackName] = AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded;
	      }
	
	      script.onload = function () {
	        var mapEntry = SCRIPT_MAP.get(scriptURL);
	        mapEntry.loaded = true;
	        callObserverFuncAndRemoveObserver(function (observer) {
	          if (callbackName) {
	            return false;
	          }
	          observer(mapEntry);
	          return true;
	        });
	      };
	      script.onerror = function (event) {
	        var mapEntry = SCRIPT_MAP.get(scriptURL);
	        mapEntry.errored = true;
	        callObserverFuncAndRemoveObserver(function (observer) {
	          observer(mapEntry);
	          return true;
	        });
	      };
	
	      // (old) MSIE browsers may call "onreadystatechange" instead of "onload"
	      script.onreadystatechange = function () {
	        if (_this.readyState === "loaded") {
	          // wait for other events, then call onload if default onload hadn't been called
	          window.setTimeout(function () {
	            if (SCRIPT_MAP.get(scriptURL).loaded !== true) {
	              script.onload();
	            }
	          }, 0);
	        }
	      };
	
	      document.body.appendChild(script);
	    },
	
	    asyncScriptLoaderHandleLoad: function asyncScriptLoaderHandleLoad(state) {
	      this.setState(state, this.props.asyncScriptOnLoad);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      // Clean the observer entry
	      var mapEntry = SCRIPT_MAP.get(scriptURL);
	      if (mapEntry) {
	        mapEntry.observers["delete"](this.asyncScriptLoaderGetScriptLoaderID());
	      }
	    },
	
	    render: function render() {
	      var _this2 = this;
	
	      var globalName = options.globalName;
	      var _props = this.props;
	      var asyncScriptOnLoad = _props.asyncScriptOnLoad;
	
	      var childProps = _objectWithoutProperties(_props, ["asyncScriptOnLoad"]);
	
	      if (globalName && typeof window !== "undefined") {
	        childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
	      }
	      return _react2["default"].createElement(Component, _extends({ ref: function (comp) {
	          _this2.childComponent = comp;
	        } }, childProps));
	    }
	
	  };
	
	  if (options.exposeFuncs) {
	    var _loop = function () {
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) return "break";
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) return "break";
	        _ref3 = _i3.value;
	      }
	
	      var funcToExpose = _ref3;
	
	      /* eslint-disable no-loop-func */
	      funcs[funcToExpose] = function () {
	        var _childComponent;
	
	        return (_childComponent = this.childComponent)[funcToExpose].apply(_childComponent, arguments);
	      };
	      /* eslint-enable no-loop-func */
	    };
	
	    for (var _iterator3 = options.exposeFuncs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	      var _ref3;
	
	      var _ret = _loop();
	
	      if (_ret === "break") break;
	    }
	  }
	  var AsyncScriptLoader = _react2["default"].createClass(funcs);
	
	  return AsyncScriptLoader;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$assign = __webpack_require__(750)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(733), __esModule: true };

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(752), __esModule: true };

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(753);
	__webpack_require__(754);
	__webpack_require__(770);
	__webpack_require__(775);
	__webpack_require__(789);
	module.exports = __webpack_require__(737).Map;

/***/ }),
/* 753 */
/***/ (function(module, exports) {



/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(755)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(757)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(756)
	  , defined   = __webpack_require__(743);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(758)
	  , $export        = __webpack_require__(735)
	  , redefine       = __webpack_require__(759)
	  , hide           = __webpack_require__(760)
	  , has            = __webpack_require__(763)
	  , Iterators      = __webpack_require__(764)
	  , $iterCreate    = __webpack_require__(765)
	  , setToStringTag = __webpack_require__(766)
	  , getProto       = __webpack_require__(741).getProto
	  , ITERATOR       = __webpack_require__(767)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	module.exports = true;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(760);

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(741)
	  , createDesc = __webpack_require__(761);
	module.exports = __webpack_require__(762) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(746)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(741)
	  , descriptor     = __webpack_require__(761)
	  , setToStringTag = __webpack_require__(766)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(760)(IteratorPrototype, __webpack_require__(767)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(741).setDesc
	  , has = __webpack_require__(763)
	  , TAG = __webpack_require__(767)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(768)('wks')
	  , uid    = __webpack_require__(769)
	  , Symbol = __webpack_require__(736).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(736)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(771);
	var Iterators = __webpack_require__(764);
	Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(772)
	  , step             = __webpack_require__(773)
	  , Iterators        = __webpack_require__(764)
	  , toIObject        = __webpack_require__(774);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(757)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(744)
	  , defined = __webpack_require__(743);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(776);
	
	// 23.1 Map Objects
	__webpack_require__(788)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $            = __webpack_require__(741)
	  , hide         = __webpack_require__(760)
	  , redefineAll  = __webpack_require__(777)
	  , ctx          = __webpack_require__(738)
	  , strictNew    = __webpack_require__(778)
	  , defined      = __webpack_require__(743)
	  , forOf        = __webpack_require__(779)
	  , $iterDefine  = __webpack_require__(757)
	  , step         = __webpack_require__(773)
	  , ID           = __webpack_require__(769)('id')
	  , $has         = __webpack_require__(763)
	  , isObject     = __webpack_require__(782)
	  , setSpecies   = __webpack_require__(787)
	  , DESCRIPTORS  = __webpack_require__(762)
	  , isExtensible = Object.isExtensible || isObject
	  , SIZE         = DESCRIPTORS ? '_s' : 'size'
	  , id           = 0;
	
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!$has(it, ID)){
	    // can't set id to frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add id
	    if(!create)return 'E';
	    // add missing object id
	    hide(it, ID, ++id);
	  // return object id with prefix
	  } return 'O' + it[ID];
	};
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = $.create(null); // index
	      that._f = undefined;      // first entry
	      that._l = undefined;      // last entry
	      that[SIZE] = 0;           // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(759);
	module.exports = function(target, src){
	  for(var key in src)redefine(target, key, src[key]);
	  return target;
	};

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(738)
	  , call        = __webpack_require__(780)
	  , isArrayIter = __webpack_require__(783)
	  , anObject    = __webpack_require__(781)
	  , toLength    = __webpack_require__(784)
	  , getIterFn   = __webpack_require__(785);
	module.exports = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(781);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(782);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 782 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(764)
	  , ITERATOR   = __webpack_require__(767)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(756)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(786)
	  , ITERATOR  = __webpack_require__(767)('iterator')
	  , Iterators = __webpack_require__(764);
	module.exports = __webpack_require__(737).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(745)
	  , TAG = __webpack_require__(767)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var core        = __webpack_require__(737)
	  , $           = __webpack_require__(741)
	  , DESCRIPTORS = __webpack_require__(762)
	  , SPECIES     = __webpack_require__(767)('species');
	
	module.exports = function(KEY){
	  var C = core[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(741)
	  , global         = __webpack_require__(736)
	  , $export        = __webpack_require__(735)
	  , fails          = __webpack_require__(746)
	  , hide           = __webpack_require__(760)
	  , redefineAll    = __webpack_require__(777)
	  , forOf          = __webpack_require__(779)
	  , strictNew      = __webpack_require__(778)
	  , isObject       = __webpack_require__(782)
	  , setToStringTag = __webpack_require__(766)
	  , DESCRIPTORS    = __webpack_require__(762);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	  } else {
	    C = wrapper(function(target, iterable){
	      strictNew(target, C, NAME);
	      target._c = new Base;
	      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    $.each.call('add,clear,delete,forEach,get,has,set,keys,values,entries'.split(','),function(KEY){
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
	        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    if('size' in proto)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(735);
	
	$export($export.P, 'Map', {toJSON: __webpack_require__(790)('Map')});

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var forOf   = __webpack_require__(779)
	  , classof = __webpack_require__(786);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    var arr = [];
	    forOf(this, false, arr.push, arr);
	    return arr;
	  };
	};

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(792), __esModule: true };

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(770);
	__webpack_require__(754);
	module.exports = __webpack_require__(793);

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(781)
	  , get      = __webpack_require__(785);
	module.exports = __webpack_require__(737).getIterator = function(it){
	  var iterFn = get(it);
	  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};
	
	exports.__esModule = true;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlayerStats = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Iterate over player stats and markup one span for each stat. Wrap it in li.
	 *
	 * @param {Array} stats         players stats
	 * @param {Array} excludeStats  list of stats that need not be shown
	 *                              e.g. ['R', 'B']
	 * @return {React.Element} list of stats
	 */
	var PlayerStats = exports.PlayerStats = function PlayerStats(_ref) {
	  var _ref$stats = _ref.stats,
	      stats = _ref$stats === undefined ? [] : _ref$stats,
	      _ref$excludeStats = _ref.excludeStats,
	      excludeStats = _ref$excludeStats === undefined ? [] : _ref$excludeStats;
	
	  // init stats string
	  var allStats = '';
	  stats.map(function () {
	    var stat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // Display stat only if it is not found in excludeStats array
	    if (excludeStats.indexOf(stat.text) == -1 && stat.value !== '-') {
	      allStats += '<span class="cricinfo__table__list__item__label">' + stat.text + ': </span>' + stat.value;
	    }
	  });
	
	  var allStatsMarkup = { __html: allStats };
	
	  return _react2.default.createElement('li', { className: 'cricinfo__table__list__item', dangerouslySetInnerHTML: allStatsMarkup });
	};
	
	exports.default = PlayerStats;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BatsmanLite = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(423);
	
	var _index = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Display stats for a batsman for lite view (featurephone)
	 * @param {Object}        batsman batsman details
	 * @param {Number}        bId     batsman iterator (0,1,2 etc)
	 * @param {Boolean}       showOutComms  true if out commentary for batsman
	 *                                      should show
	 * @return {React.Element} batsman stats for featurephone
	 */
	var BatsmanLite = exports.BatsmanLite = function BatsmanLite(_ref) {
	  var _ref$batsman = _ref.batsman,
	      batsman = _ref$batsman === undefined ? {} : _ref$batsman,
	      bId = _ref.bId,
	      _ref$showOutComms = _ref.showOutComms,
	      showOutComms = _ref$showOutComms === undefined ? false : _ref$showOutComms;
	
	
	  var stats = batsman.stats || [];
	  var runsScored = (0, _selectn2.default)('[0].value', stats) || '';
	
	  return _react2.default.createElement(
	    'tr',
	    { className: 'cricinfo__table__tr', key: bId },
	    _react2.default.createElement(
	      'td',
	      { valign: 'top', className: 'cricinfo__table__td' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'cricinfo__table__list' },
	        _react2.default.createElement('li', { className: 'cricinfo__table__list__item',
	          dangerouslySetInnerHTML: (0, _common.getPlayerRoles)(batsman.name, batsman.roles) }),
	        _react2.default.createElement(_index.PlayerStats, { stats: stats, excludeStats: ['R'] }),
	        showOutComms ? _react2.default.createElement(
	          'li',
	          { className: 'cricinfo__table__list__item' },
	          _react2.default.createElement('span', { className: 'cricinfo__table__list__item__label',
	            dangerouslySetInnerHTML: (0, _common.getBatsmanComm)(batsman, bId, 0, true) })
	        ) : null
	      )
	    ),
	    _react2.default.createElement(
	      'td',
	      { valign: 'top', className: 'cricinfo__table__td cricinfo__type__align--right cricinfo__type__weight--bold' },
	      runsScored
	    )
	  );
	};
	
	exports.default = BatsmanLite;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BowlerLite = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(423);
	
	var _index = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Display stats for a bowler for lite view (featurephone)
	 *
	 * @param {Object} bowler   bowler details
	 * @param {Number}  bId     bowler iterator (0,1,2 etc)
	 * @return {React.Element}  bowler stats for featurephone
	 */
	
	//import selectn from 'selectn'
	var BowlerLite = exports.BowlerLite = function BowlerLite(_ref) {
	  var _ref$bowler = _ref.bowler,
	      bowler = _ref$bowler === undefined ? {} : _ref$bowler,
	      bId = _ref.bId;
	
	
	  var stats = bowler.stats || [];
	  // Only 4 stats on one line, remaining stats need to be pushed to next
	  var secondSet = stats.splice(4) || [];
	  //let runsScored = selectn('[0].value', stats)
	  return _react2.default.createElement(
	    'tr',
	    { className: 'cricinfo__table__tr', key: bId },
	    _react2.default.createElement(
	      'td',
	      { colSpan: '2', className: 'cricinfo__table__td' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'cricinfo__table__list' },
	        _react2.default.createElement('li', { className: 'cricinfo__table__list__item',
	          dangerouslySetInnerHTML: (0, _common.getPlayerRoles)(bowler.name, bowler.roles) }),
	        _react2.default.createElement(_index.PlayerStats, { stats: stats }),
	        _react2.default.createElement(_index.PlayerStats, { stats: secondSet })
	      )
	    )
	  );
	};
	
	exports.default = BowlerLite;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TopHighlights = undefined;
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(686);
	
	var _Video = __webpack_require__(708);
	
	var _common = __webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global espn_ui jQuery */
	
	var TopHighlights = exports.TopHighlights = function (_React$Component) {
	  (0, _inherits3.default)(TopHighlights, _React$Component);
	
	  function TopHighlights() {
	    (0, _classCallCheck3.default)(this, TopHighlights);
	    return (0, _possibleConstructorReturn3.default)(this, (TopHighlights.__proto__ || (0, _getPrototypeOf2.default)(TopHighlights)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TopHighlights, [{
	    key: 'loadVideoBehavior',
	    value: function loadVideoBehavior() {
	      var videoPlaylist = this.refs.videoPlaylist;
	
	      try {
	        if (!videoPlaylist.querySelectorAll('.video-playlist-item').length) {
	          jQuery(this.slider).data('videoPlayListEnabled', false);
	          espn_ui.loadBehaviorNamed('video_package', jQuery(videoPlaylist));
	        }
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadVideoBehavior();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.loadVideoBehavior();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$title = _props.title,
	          title = _props$title === undefined ? '' : _props$title,
	          _props$videos = _props.videos,
	          videos = _props$videos === undefined ? [] : _props$videos,
	          _props$href = _props.href,
	          href = _props$href === undefined ? '#' : _props$href,
	          _props$hasMoreVideosT = _props.hasMoreVideosTab,
	          hasMoreVideosTab = _props$hasMoreVideosT === undefined ? false : _props$hasMoreVideosT,
	          _props$videoCount = _props.videoCount,
	          videoCount = _props$videoCount === undefined ? 3 : _props$videoCount;
	
	      var firstVideo = videos[0] || {};
	      var thumbnail = firstVideo.thumbnail;
	      var duration = firstVideo.duration;
	      var thumb = (0, _common.urlWithParams)(thumbnail, 'w=943', 'h=530');
	      var videoCountIndex = parseInt(videoCount, 10);
	      videoCountIndex = isNaN(videoCountIndex) === false ? videoCountIndex : 3;
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'sub-module top-highlights no-thumb mediaList mediaList--highlights' },
	        title ? _react2.default.createElement(
	          'header',
	          null,
	          ' ',
	          _react2.default.createElement(
	            'h1',
	            null,
	            title
	          ),
	          ' '
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'mediaList__content' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'mediaList__list', 'data-behavior': 'video_playlist', ref: 'videoPlaylist' },
	            _react2.default.createElement(
	              'figure',
	              { className: 'feed-item-figure video ', 'data-source': 'espn', 'data-id': firstVideo.id, 'data-video': 'native,640,360,' + firstVideo.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'img-wrap' },
	                _react2.default.createElement(
	                  'a',
	                  { name: '&lpos=ncf:teamclubhouse:shop', 'data-sport': 'cricket', 'data-mptype': 'image' },
	                  _react2.default.createElement(
	                    'picture',
	                    null,
	                    _react2.default.createElement('source', { 'data-srcset': thumb, media: '(min-width: 414px)' }),
	                    _react2.default.createElement('img', { 'data-default-src': thumb, className: ' lazyload', 'data-image-container': '.feed-item-figure' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'video-play-button ', 'data-playtxt': 'PLAY', 'data-id': firstVideo.id },
	                  'play'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'video-length' },
	                  duration ? (0, _Video.formatDuration)(duration) : ''
	                )
	              )
	            ),
	            videos.slice(0, videoCountIndex).map(function () {
	              var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	              var i = arguments[1];
	
	              var duration = video.duration;
	
	              return _react2.default.createElement(
	                'li',
	                { key: i, className: 'mediaList__item video-playlist-item', 'data-source': video.source, 'data-id': video.id, 'data-video': 'native,640,360,' + video.id, 'data-cerebro-id': video.cerebroId },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'mediaList__link' },
	                  _react2.default.createElement('span', { className: 'mediaList__button icon-font-before icon-play-solid-before' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'mediaList__description' },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      video.headline
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'mediaList__time' },
	                      duration ? (0, _Video.formatDuration)(duration) : ''
	                    )
	                  )
	                )
	              );
	            })
	          )
	        ),
	        hasMoreVideosTab && _react2.default.createElement(
	          'footer',
	          null,
	          _react2.default.createElement(_index.AnchorLink, { to: href, text: 'View More' })
	        )
	      );
	    }
	  }]);
	  return TopHighlights;
	}(_react2.default.Component);
	
	exports.default = TopHighlights;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AnchorLink = __webpack_require__(682);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DesktopScoreboard = function DesktopScoreboard(_ref) {
	  var _ref$title = _ref.title,
	      title = _ref$title === undefined ? '' : _ref$title,
	      _ref$textDescription = _ref.textDescription,
	      textDescription = _ref$textDescription === undefined ? '' : _ref$textDescription,
	      _ref$link = _ref.link,
	      link = _ref$link === undefined ? {
	    text: '',
	    href: '#'
	  } : _ref$link;
	
	  if (title === '' && textDescription === '') {
	    return null;
	  }
	  var target = { target: '_blank' };
	  var DesktopScoreboardModule = _react2.default.createElement(
	    'article',
	    { className: 'sub-module' },
	    _react2.default.createElement(
	      'header',
	      { className: 'bordered' },
	      _react2.default.createElement(
	        'h1',
	        { key: 'h' },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'p',
	        null,
	        textDescription
	      )
	    ),
	    _react2.default.createElement(
	      'footer',
	      null,
	      _react2.default.createElement(_AnchorLink2.default, (0, _extends3.default)({ classes: 'external', key: 'a', to: link.href, text: link.text, isRouterLink: false }, target))
	    )
	  );
	  return DesktopScoreboardModule;
	};
	
	exports.default = DesktopScoreboard;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.SearchResultsList = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(366);
	
	var _common = __webpack_require__(624);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AnchorLink = __webpack_require__(682);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Component to display search results as list
	 * @param  {object} search state with all results
	 * @param  {object} compStyle is style for show/hide of component
	 * @param  {string} q holds searched value
	 * @param  {string} message to display if search fails / return no results
	 * @return {component} component to show search results
	 */
	var SearchResultsList = exports.SearchResultsList = function SearchResultsList(_ref) {
	  var search = _ref.search,
	      searchUrl = _ref.searchUrl,
	      compStyle = _ref.compStyle,
	      message = _ref.message,
	      q = _ref.q;
	
	  var tempstyle2 = {
	    zIndex: '1',
	    position: 'relative'
	  };
	  var noResults = _react2.default.createElement(
	    'div',
	    { className: 'global-search' },
	    _react2.default.createElement(
	      'div',
	      { className: 'search-results search_results--active', style: { boxShadow: '0 1px 4px rgba(0,0,0,0.22)' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'search-results__wrapper', style: { 'width': '100%', background: '#fff' } },
	        _react2.default.createElement(
	          'ul',
	          { style: compStyle, className: 'search_results__suggestions search_results__suggestions--cat' },
	          _react2.default.createElement(
	            'li',
	            { className: 'search_results__item' },
	            _react2.default.createElement(
	              'div',
	              { className: 'search_results__link detailed' },
	              _react2.default.createElement(
	                'div',
	                { className: 'search_results__details' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'search_results__label' },
	                  message
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	  //dont render lists if no result / keyword
	  var resultsHtml = [];
	  var viewAllmsg = 'View all results for ' + q;
	  if (q.length <= 0 || search.totalRecords === undefined) {
	    return _react2.default.createElement('span', null);
	  } else if (search.totalRecords <= 0) {
	    return noResults;
	  } else {
	    var resultsObj = search.results || [];
	    compStyle = tempstyle2;
	    resultsObj.map(function (item) {
	      resultsHtml.push(_react2.default.createElement(
	        'li',
	        { className: 'search_results__item', key: 'srcl-' + item.id },
	        _react2.default.createElement(
	          _AnchorLink2.default,
	          { to: item.href, isRouterLink: false, className: 'search_results__link detailed' },
	          _react2.default.createElement(
	            'div',
	            { className: 'search_results__img' },
	            _react2.default.createElement('img', { 'data-src': item.img, className: 'lazyload' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'search_results__details' },
	            _react2.default.createElement(
	              'span',
	              { className: 'search_results__label' },
	              item.text
	            )
	          )
	        )
	      ));
	    });
	  }
	  return resultsHtml.length > 0 && _react2.default.createElement(
	    'div',
	    { className: 'global-search' },
	    _react2.default.createElement(
	      'div',
	      { className: 'search_results search_results--active', style: { boxShadow: '0 1px 4px rgba(0,0,0,0.22)' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'search-results__wrapper', style: { 'width': '100%' } },
	        _react2.default.createElement(
	          'ul',
	          { style: compStyle, className: 'search_results__suggestions search_results__suggestions--cat' },
	          resultsHtml
	        )
	      ),
	      _react2.default.createElement(
	        'footer',
	        null,
	        _react2.default.createElement(
	          _AnchorLink2.default,
	          { isRouterLink: false, to: searchUrl },
	          viewAllmsg
	        )
	      )
	    )
	  ) || _react2.default.createElement('span', null);
	};
	/**
	 * Search component to show typeahead results for leagues search
	 */
	
	var Search = function (_React$Component) {
	  (0, _inherits3.default)(Search, _React$Component);
	
	  function Search(props) {
	    (0, _classCallCheck3.default)(this, Search);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call(this, props));
	
	    var defaultSearchProps = {
	      q: '',
	      results: 0,
	      search: {
	        totalRecords: undefined,
	        results: []
	      }
	    };
	    _this.state = (0, _extends3.default)({}, defaultSearchProps, {
	      compStyle: { display: 'none !important' },
	      searchUrl: '/',
	      message: ''
	    });
	    _this.defaultSearchProps = defaultSearchProps;
	    _this._onSubmit = _this._onSubmit.bind(_this);
	    _this._searchLeague = _this._searchLeague.bind(_this);
	    _this._searchTimeout;
	    return _this;
	  }
	  //update state with search data
	
	
	  (0, _createClass3.default)(Search, [{
	    key: '_getLeagueSearchData',
	    value: function _getLeagueSearchData(edition, params) {
	      var _this2 = this;
	
	      var additionalQuery = { q: this.state.q, results: this.state.results };
	      var leagueSearchPromise = (0, _index.getLeagueSearch)(edition, params, additionalQuery);
	      if (leagueSearchPromise) {
	        leagueSearchPromise.then(function (data) {
	          if (data) {
	            var res = _common2.default.leagues.searchLeagueResults(data) || {};
	            if (res.results && res.totalRecords >= 0) {
	              _this2.setState({
	                search: {
	                  results: res.results,
	                  totalRecords: res.totalRecords
	                },
	                message: res.message,
	                compStyle: { display: 'block !important' }
	              });
	            } else {
	              _this2.setState({
	                search: {
	                  results: [],
	                  totalRecords: res.totalRecords
	                },
	                message: ''
	              });
	            }
	          }
	        }).catch(function (error) {
	          console.error(error);
	        });
	      }
	    }
	    //update state with latest keyword and call api
	
	  }, {
	    key: '_searchLeague',
	    value: function _searchLeague(event) {
	      var _this3 = this;
	
	      var hasSearchVal = event.target.value.length > 0 ? true : false;
	      //reset state if no keyword
	      if (!hasSearchVal) {
	        this.setState({
	          search: {
	            totalRecords: undefined,
	            results: []
	          }
	        });
	      }
	      //set state to create search url
	      this.setState({ q: event.target.value }, function () {
	        _this3.state.searchUrl = _this3._createSearchUrl();
	      });
	      //search for keyword in api
	      if (hasSearchVal) {
	        //debounce and search api
	        window.clearTimeout(this._searchTimeout);
	        this._searchTimeout = setTimeout(function () {
	          var _props = _this3.props,
	              edition = _props.edition,
	              params = _props.params;
	
	          _this3._getLeagueSearchData(edition, params);
	        }, 500);
	      }
	    }
	    //create a search URL to redirect to search page on return key
	
	  }, {
	    key: '_createSearchUrl',
	    value: function _createSearchUrl() {
	      var url = '';
	      var queryVal = this.state.q;
	      if (queryVal !== '' && queryVal.length > 0) {
	        var urlProps = {
	          domain: 'http://' + this.props.edition.domain,
	          path: '/search/results',
	          q: encodeURIComponent(queryVal)
	        };
	        var domain = urlProps.domain,
	            path = urlProps.path,
	            q = urlProps.q;
	        var _props$params = this.props.params,
	            params = _props$params === undefined ? {} : _props$params;
	
	        url = [domain, path].join('') + '?';
	        if (params.sport == 'cricket') {
	          url += 'filter=cricket&';
	        }
	        url += 'q=' + q;
	      }
	      return url;
	    }
	    //on submit redirect to search page
	
	  }, {
	    key: '_onSubmit',
	    value: function _onSubmit(event) {
	      event.preventDefault();
	      if (this.state.searchUrl !== '' && this.state.searchUrl !== '/') {
	        window.location.href = this.state.searchUrl;
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      document.addEventListener('click', function (e) {
	        var searchBoxId = e.target && e.target.id ? e.target.id : '';
	        if (searchBoxId !== 's-box') {
	          _this4.setState((0, _extends3.default)({}, _this4.defaultSearchProps));
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.enabled) {
	        return '</span>';
	      }
	      return _react2.default.createElement(
	        'section',
	        { className: (0, _classnames2.default)('search-section', 'icon-font-before', 'icon-search-solid-before') },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this._onSubmit },
	          _react2.default.createElement('input', { type: 'text', id: 's-box', className: 'search-box', value: this.state.q, placeholder: 'Search for England tour of Australia etc.', autoComplete: 'off', onChange: this._searchLeague })
	        ),
	        _react2.default.createElement(SearchResultsList, { key: 'll', searchUrl: this.state.searchUrl, compStyle: this.state.compStyle, search: this.state.search, q: this.state.q, message: this.state.message })
	      );
	    }
	  }]);
	  return Search;
	}(_react2.default.Component);
	
	exports.default = Search;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Ad = __webpack_require__(687);
	
	var _Ad2 = _interopRequireDefault(_Ad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LongStripAd = function LongStripAd(_ref) {
	  var _ref$edition = _ref.edition,
	      edition = _ref$edition === undefined ? {} : _ref$edition,
	      _ref$type = _ref.type,
	      type = _ref$type === undefined ? '' : _ref$type,
	      _ref$adblock = _ref.adblock,
	      adblock = _ref$adblock === undefined ? false : _ref$adblock;
	
	
	  var details = [];
	  var excludeVal1 = ['s'];
	  var excludeVal2 = ['s', 'm'];
	
	  if (edition.isAsiaRegion) {
	    details.push(_react2.default.createElement(
	      'div',
	      { key: 'LongStripAd', className: 'ad-double-longstrip-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { key: 'longstrip1', className: 'ad-double-longstrip' },
	        _react2.default.createElement(_Ad2.default, { className: 'react-ad ad-slot-longstrip ad-wrapper', slotType: 'longstripGamepackage', kvpos: 'left', exclude: excludeVal1, isAdBlock: adblock })
	      ),
	      type === 'game' && _react2.default.createElement(
	        'div',
	        { key: 'longstrip2', className: 'ad-double-longstrip' },
	        _react2.default.createElement(_Ad2.default, { className: 'react-ad ad-slot-longstrip ad-wrapper', slotType: 'longstripGamepackage', kvpos: 'right', exclude: excludeVal2, isAdBlock: adblock })
	      )
	    ));
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    details
	  );
	};
	
	exports.default = LongStripAd;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GameHeaderLiveData = function GameHeaderLiveData(_ref) {
	  var _ref$crr = _ref.crr,
	      crr = _ref$crr === undefined ? '' : _ref$crr,
	      _ref$rrr = _ref.rrr,
	      rrr = _ref$rrr === undefined ? '' : _ref$rrr,
	      _ref$minRemainingOver = _ref.minRemainingOvers,
	      minRemainingOvers = _ref$minRemainingOver === undefined ? '' : _ref$minRemainingOver,
	      isLimitedOvers = _ref.isLimitedOvers,
	      _ref$lastNForInnings = _ref.lastNForInnings,
	      lastNForInnings = _ref$lastNForInnings === undefined ? {} : _ref$lastNForInnings;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'gp__cricket__statistics' },
	    crr && _react2.default.createElement(
	      'div',
	      { className: 'gp__cricket__stat' },
	      _react2.default.createElement(
	        'div',
	        { className: 'gp__cricket__stat__title' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'gp__cricket__title gp__cricket__title--desktop' },
	          'Current Run Rate'
	        ),
	        _react2.default.createElement(
	          'h3',
	          { className: 'gp__cricket__title gp__cricket__title--mobile' },
	          'CRR'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        crr
	      )
	    ) || null,
	
	    //show RRR when isLimitedOvers flag is true
	    rrr && isLimitedOvers && rrr > 0 && _react2.default.createElement(
	      'div',
	      { className: 'gp__cricket__stat' },
	      _react2.default.createElement(
	        'div',
	        { className: 'gp__cricket__stat__title' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'gp__cricket__title gp__cricket__title--desktop' },
	          'Required Run Rate'
	        ),
	        _react2.default.createElement(
	          'h3',
	          { className: 'gp__cricket__title gp__cricket__title--mobile' },
	          'RRR'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        rrr
	      )
	    ) || null,
	
	    //if isLimitedOvers flag is true do not show the minRemainingOvers value
	    minRemainingOvers && minRemainingOvers > 0 && !isLimitedOvers && _react2.default.createElement(
	      'div',
	      { className: 'gp__cricket__stat' },
	      _react2.default.createElement(
	        'div',
	        { className: 'gp__cricket__stat__title' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'gp__cricket__title gp__cricket__title--desktop' },
	          'Minimum Ov. Rem'
	        ),
	        _react2.default.createElement(
	          'h3',
	          { className: 'gp__cricket__title gp__cricket__title--mobile' },
	          'Min. Ov. Rem'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        minRemainingOvers
	      )
	    ) || null,
	    lastNForInnings && lastNForInnings.showModule && _react2.default.createElement(
	      'div',
	      { className: 'gp__cricket__stat gp__cricket__stat--full' },
	      _react2.default.createElement(
	        'div',
	        { className: 'gp__cricket__stat__title' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'gp__cricket__title gp__cricket__title--desktop' },
	          'Last ',
	          lastNForInnings.duration,
	          ' Ov (Run Rate)'
	        ),
	        _react2.default.createElement(
	          'h3',
	          { className: 'gp__cricket__title gp__cricket__title--mobile' },
	          'Last ',
	          lastNForInnings.duration,
	          ' Ov (RR)'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        lastNForInnings.runs + '/' + lastNForInnings.wickets + ' ' + (lastNForInnings.rr ? '(' + lastNForInnings.rr + ')' : '')
	      )
	    ) || null
	  );
	};
	
	exports.default = GameHeaderLiveData;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Graphics = __webpack_require__(705);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerOfTheMatch = function PlayerOfTheMatch(_ref) {
	  var _ref$pom = _ref.pom,
	      pom = _ref$pom === undefined ? [] : _ref$pom,
	      _ref$isMedium = _ref.isMedium,
	      isMedium = _ref$isMedium === undefined ? false : _ref$isMedium;
	
	  var singleOrDoubleClass = 'gp__cricket__player-match__player gp__cricket__player-match__player--';
	  var singlePlayer = false;
	  if (pom && pom.length === 1) {
	    singleOrDoubleClass = singleOrDoubleClass + 'single';
	    singlePlayer = true;
	  } else if (pom && pom.length === 2) {
	    singleOrDoubleClass = singleOrDoubleClass + 'double';
	  }
	  var content = _react2.default.createElement(
	    'div',
	    { className: 'gp__cricket__player-match' },
	    _react2.default.createElement(
	      'div',
	      { className: 'gp__cricket__player-match__title' },
	      'Player',
	      pom.length > 1 ? 's' : '',
	      ' of the Match'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'gp__cricket__playerDetails' },
	      _react2.default.createElement(
	        'div',
	        { className: singleOrDoubleClass },
	        pom && pom.map(function () {
	          var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var i = arguments[1];
	
	          return [singlePlayer && m.headshot && !/default-player-logo/.test(m.headshot) ? _react2.default.createElement('a', { name: m.trackingName, href: m.href, className: 'gp__cricket__player-match__player__headshot headshot-lg athlete', dangerouslySetInnerHTML: { __html: '<img data-src="' + m.headshot + '" class="lazyload"/>' } }) : singlePlayer && _react2.default.createElement(_Graphics.AthleteJersey, { trackingName: m.trackingName, href: m.href, isMedium: isMedium }), _react2.default.createElement(
	            'div',
	            { key: i, className: 'gp__cricket__player-match__player__detail' },
	            _react2.default.createElement('a', { name: m.trackingName, href: m.href, className: 'gp__cricket__player-match__player__detail__link', dangerouslySetInnerHTML: { __html: m.name + '<span>' + m.team + '</span>' } })
	          )];
	        })
	      )
	    )
	  );
	  return pom.length ? content : _react2.default.createElement('div', { className: 'gp__cricket__player-match' });
	};
	
	exports.default = PlayerOfTheMatch;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlayersToWatch = undefined;
	
	var _keys = __webpack_require__(415);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _PlayerDetails = __webpack_require__(805);
	
	var _PlayerDetails2 = _interopRequireDefault(_PlayerDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var chunk = function chunk(arr, len) {
	  var chunks = [];
	  var n = arr.length;
	  var i = 0;
	
	  while (i < n) {
	    chunks.push(arr.slice(i, i += len));
	  }
	  return chunks;
	};
	
	var PlayerSet = function PlayerSet(_ref) {
	  var _ref$players = _ref.players,
	      players = _ref$players === undefined ? [] : _ref$players;
	
	  var playerList = players.map(function (p, j) {
	    return _react2.default.createElement(
	      'li',
	      { key: j },
	      _react2.default.createElement(_PlayerDetails2.default, { href: p.href || '#', img: p.img, name: p.name, team: p.team, isMedium: true }),
	      _react2.default.createElement(
	        'dl',
	        { className: 'player-stats' },
	        (p.stats || []).map(function (s, i) {
	          return _react2.default.createElement(
	            'dd',
	            { key: i },
	            _react2.default.createElement(
	              'span',
	              { className: 'value' },
	              s.value
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              s.text || s.abbreviation
	            )
	          );
	        })
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    'ul',
	    { className: 'two-col-table split' },
	    playerList
	  );
	};
	
	var PlayersToWatch = exports.PlayersToWatch = function PlayersToWatch(_ref2) {
	  var _ref2$roles = _ref2.roles,
	      roles = _ref2$roles === undefined ? {} : _ref2$roles;
	
	  var hasPlayers = false;
	  var playersToWatch = _react2.default.createElement(
	    'div',
	    { className: 'sub-module players-to-watch' },
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      (0, _keys2.default)(roles).map(function (role, i) {
	        var players = roles[role] && roles[role].players || [];
	        players = chunk(players, 2) || [];
	        // if players to watch is yet to be decided show empty place holders.
	        if (players.length === 1) {
	          var tbdStats = (0, _selectn2.default)('[0][0].stats', players) || [];
	          var tbdPlayerDetails = {
	            'name': 'TBD',
	            'team': (0, _selectn2.default)('tbdTeam', roles) || '',
	            'stats': [{
	              'abbreviation': 'M',
	              'text': 'MAT',
	              'value': '-'
	            }, {
	              'abbreviation': (0, _selectn2.default)('[1].abbreviation', tbdStats) === 'R' ? 'R' : 'W',
	              'text': (0, _selectn2.default)('[1].text', tbdStats) === 'RUNS' ? 'RUNS' : 'W',
	              'value': '-'
	            }, {
	              'abbreviation': (0, _selectn2.default)('[2].abbreviation', tbdStats) === 'BTA' ? 'BTA' : 'ER',
	              'text': (0, _selectn2.default)('[2].text', tbdStats) === 'AVG' ? 'AVG' : 'ECO',
	              'value': '-'
	            }, {
	              'abbreviation': (0, _selectn2.default)('[3].abbreviation', tbdStats) === 'BTSR' ? 'BTSR' : 'BWSR',
	              'text': 'SR',
	              'value': '-'
	            }]
	          };
	          var tbdPlayers = [];
	          for (var _i = 0; _i < 2; _i++) {
	            tbdPlayers.push(tbdPlayerDetails);
	          }
	          players.push(tbdPlayers);
	        }
	        if (players.length) {
	          hasPlayers = true;
	          return _react2.default.createElement(
	            'div',
	            { key: i, className: 'player-container' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Players To Watch - ',
	              role
	            ),
	            players.map(function (p, j) {
	              return _react2.default.createElement(PlayerSet, { key: j, players: p });
	            })
	          );
	        }
	        return null;
	      })
	    )
	  );
	  return (0, _keys2.default)(roles).length && hasPlayers ? playersToWatch : _react2.default.createElement('div', { className: 'sub-module players-to-watch' });
	};
	
	exports.default = {
	  PlayersToWatch: PlayersToWatch
	};

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Graphics = __webpack_require__(705);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerDetails = function PlayerDetails(_ref) {
	  var _ref$href = _ref.href,
	      href = _ref$href === undefined ? '#' : _ref$href,
	      _ref$img = _ref.img,
	      img = _ref$img === undefined ? '' : _ref$img,
	      _ref$name = _ref.name,
	      name = _ref$name === undefined ? '' : _ref$name,
	      _ref$team = _ref.team,
	      team = _ref$team === undefined ? '' : _ref$team,
	      _ref$isMedium = _ref.isMedium,
	      isMedium = _ref$isMedium === undefined ? false : _ref$isMedium;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'player-details' },
	    img && !/default-player-logo/.test(img) ? _react2.default.createElement('a', { href: href, className: 'headshot-md athlete', dangerouslySetInnerHTML: { __html: '<img data-src="' + img + '" class="lazyload"/>' } }) : _react2.default.createElement(_Graphics.AthleteJersey, { href: href, isMedium: isMedium }),
	    _react2.default.createElement(
	      'div',
	      { className: 'player-name' },
	      _react2.default.createElement(
	        'span',
	        null,
	        name
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'team' },
	        team
	      )
	    )
	  );
	};
	
	exports.default = PlayerDetails;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeadToHead = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamLink = function TeamLink(_ref) {
	  var _ref$team = _ref.team,
	      team = _ref$team === undefined ? {} : _ref$team,
	      _ref$isWebView = _ref.isWebView,
	      isWebView = _ref$isWebView === undefined ? false : _ref$isWebView;
	
	  var teamLink = null;
	  if (!isWebView) {
	    teamLink = _react2.default.createElement(
	      'a',
	      { href: team.href },
	      _react2.default.createElement(
	        'span',
	        { className: 'long-name' },
	        team.abbrev ? team.abbrev : team.name
	      ),
	      _react2.default.createElement(
	        'abbr',
	        null,
	        team.abbrev
	      )
	    );
	  } else {
	    teamLink = _react2.default.createElement(
	      'a',
	      { 'data-linktype': 'clubhouse', className: 'app_partial', 'data-uid': team.uid },
	      _react2.default.createElement(
	        'span',
	        { className: 'long-name' },
	        team.abbrev ? team.abbrev : team.name
	      ),
	      _react2.default.createElement(
	        'abbr',
	        null,
	        team.abbrev
	      )
	    );
	  }
	  return teamLink;
	};
	
	var TeamLogo = function TeamLogo(_ref2) {
	  var _ref2$team = _ref2.team,
	      team = _ref2$team === undefined ? {} : _ref2$team,
	      _ref2$isWebView = _ref2.isWebView,
	      isWebView = _ref2$isWebView === undefined ? false : _ref2$isWebView;
	
	  var teamLogo = null;
	  if (!isWebView) {
	    teamLogo = _react2.default.createElement(
	      'a',
	      { href: team.href },
	      _react2.default.createElement('img', { 'data-src': team.logo, className: 'lazyload' })
	    );
	  } else {
	    teamLogo = _react2.default.createElement(
	      'a',
	      { 'data-linktype': 'clubhouse', className: 'app_partial', 'data-uid': team.uid },
	      _react2.default.createElement('img', { 'data-src': team.logo, className: 'lazyload' })
	    );
	  }
	  return teamLogo;
	};
	
	var CricketRow = function CricketRow(_ref3) {
	  var _ref3$home = _ref3.home,
	      home = _ref3$home === undefined ? {} : _ref3$home,
	      _ref3$away = _ref3.away,
	      away = _ref3$away === undefined ? {} : _ref3$away,
	      _ref3$result = _ref3.result,
	      result = _ref3$result === undefined ? '' : _ref3$result,
	      _ref3$date = _ref3.date,
	      date = _ref3$date === undefined ? '' : _ref3$date,
	      _ref3$leagueName = _ref3.leagueName,
	      leagueName = _ref3$leagueName === undefined ? '' : _ref3$leagueName,
	      _ref3$url = _ref3.url,
	      url = _ref3$url === undefined ? '#' : _ref3$url,
	      _ref3$isWebView = _ref3.isWebView,
	      isWebView = _ref3$isWebView === undefined ? false : _ref3$isWebView;
	
	
	  return _react2.default.createElement(
	    'tr',
	    { className: '' },
	    _react2.default.createElement(
	      'td',
	      null,
	      _react2.default.createElement(TeamLink, { key: 'thl-a', isWebView: isWebView, team: home })
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'logo' },
	      home.logo && _react2.default.createElement(TeamLogo, { key: 'thl-b', isWebView: isWebView, team: home })
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      home.score && _react2.default.createElement('a', { href: url, dangerouslySetInnerHTML: { __html: home.score } })
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'outcome' },
	      result && _react2.default.createElement(
	        'a',
	        { href: url },
	        result
	      )
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'align-right' },
	      away.score && _react2.default.createElement('a', { href: url, dangerouslySetInnerHTML: { __html: away.score } })
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'logo' },
	      away.logo && _react2.default.createElement(TeamLogo, { key: 'thl-c', isWebView: isWebView, team: away })
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      _react2.default.createElement(TeamLink, { key: 'thl-d', isWebView: isWebView, team: away })
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      date
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'competition wrap' },
	      _react2.default.createElement(
	        'span',
	        null,
	        leagueName
	      )
	    )
	  );
	};
	
	var HeadToHead = exports.HeadToHead = function HeadToHead(_ref4) {
	  var _ref4$sport = _ref4.sport,
	      sport = _ref4$sport === undefined ? '' : _ref4$sport,
	      _ref4$keys = _ref4.keys,
	      keys = _ref4$keys === undefined ? [] : _ref4$keys,
	      _ref4$games = _ref4.games,
	      games = _ref4$games === undefined ? [] : _ref4$games,
	      _ref4$isWebView = _ref4.isWebView,
	      isWebView = _ref4$isWebView === undefined ? false : _ref4$isWebView;
	
	
	  var head2Head = _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('sub-module last-games head-to-head', sport) },
	    _react2.default.createElement(
	      'header',
	      { className: 'bordered' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Head To Head'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content', style: { overflowX: 'auto' } },
	      _react2.default.createElement(
	        'table',
	        { 'data-fix-cols': '0' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            keys.map(function (k, i) {
	              return _react2.default.createElement(
	                'th',
	                { key: i, colSpan: k.colSpan || '' },
	                k.title
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          games.map(function (g, i) {
	            // TODO: select row based on sport
	            return _react2.default.createElement(CricketRow, (0, _extends3.default)({ key: i }, g, { isWebView: isWebView }));
	          })
	        )
	      )
	    )
	  );
	
	  return games.length ? head2Head : _react2.default.createElement('div', null);
	};
	
	exports.default = HeadToHead;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VideoGrid = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(415);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _common = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoGrid = exports.VideoGrid = function (_React$Component) {
	  (0, _inherits3.default)(VideoGrid, _React$Component);
	
	  function VideoGrid() {
	    (0, _classCallCheck3.default)(this, VideoGrid);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (VideoGrid.__proto__ || (0, _getPrototypeOf2.default)(VideoGrid)).call(this));
	
	    _this.state = {
	      active: 'all'
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(VideoGrid, [{
	    key: '_switchTab',
	    value: function _switchTab(type) {
	      this.setState({
	        active: type
	      });
	
	      return false;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _refs$gamepackageVide = this.refs.gamepackageVideos,
	          gamepackageVideos = _refs$gamepackageVide === undefined ? '' : _refs$gamepackageVide;
	
	      var highlights = jQuery(gamepackageVideos).find('.highlight');
	      var highlightsSample = highlights.eq(0);
	      var thumbWidth = highlightsSample.width();
	      var thumbHeight = thumbWidth * 9 / 16;
	
	      highlights.css('min-height', thumbHeight);
	
	      highlights.find('img').on('load error', function () {
	        highlights.css('min-height', 0);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ enableLazyload: true });
	    }
	  }, {
	    key: '_renderTabs',
	    value: function _renderTabs() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$videos = _props.videos,
	          videos = _props$videos === undefined ? [] : _props$videos,
	          _props$tabs = _props.tabs,
	          tabs = _props$tabs === undefined ? {} : _props$tabs;
	      var active = this.state.active;
	
	      var tabsKey = (0, _keys2.default)(tabs);
	      var tabsToShow = [];
	      var displayTabs = void 0;
	
	      tabsToShow.push(tabs['all']);
	
	      // map videos with pre-defined tabs
	      videos.map(function (v) {
	        var coverageType = v.coverageType || '';
	        coverageType = coverageType.toLowerCase();
	        var tab = tabs[coverageType];
	
	        /*
	         * if 'coverageType' is available in 'tabsKey' and
	         * if the tab is not available already in 'tabsToShow'
	         */
	        if (tabsKey.indexOf(coverageType) !== -1 && tabsToShow.indexOf(tab) === -1) {
	          tabsToShow.push(tab);
	        }
	      });
	
	      // show tabs only if the tabs count is more than one
	      displayTabs = tabsToShow.length > 1 ? 'block' : 'none';
	
	      return _react2.default.createElement(
	        'header',
	        { className: 'video-toggle', style: { 'display': displayTabs } },
	        _react2.default.createElement(
	          'div',
	          { className: 'button-group', 'data-behavior': 'tabs' },
	          tabsToShow.map(function () {
	            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var i = arguments[1];
	
	            return _react2.default.createElement(
	              'a',
	              {
	                className: (0, _classnames2.default)('button-filter-alt lg fixed', { 'active': active === t.type }),
	                key: i,
	                router: false,
	                onClick: _this2._switchTab.bind(_this2, t.type) },
	              t.displayValue
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          _props2$videos = _props2.videos,
	          videos = _props2$videos === undefined ? [] : _props2$videos,
	          _props2$page = _props2.page,
	          page = _props2$page === undefined ? 1 : _props2$page,
	          _props2$hasMore = _props2.hasMore,
	          hasMore = _props2$hasMore === undefined ? true : _props2$hasMore,
	          updateMoreVideos = _props2.updateMoreVideos;
	      var _state = this.state,
	          enableLazyload = _state.enableLazyload,
	          active = _state.active;
	
	      var tabs = this._renderTabs();
	      var enableForceLazyload = active === 'all';
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'gamepackage-videos', 'data-module': 'video', ref: 'gamepackageVideos' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sub-module game-package-video', 'data-behavior': 'gamepackage_video' },
	          tabs,
	          videos.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            videos.map(function () {
	              var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	              var i = arguments[1];
	
	              var showVideo = void 0;
	
	              if (active === 'all' || active === (video.coverageType || '').toLowerCase()) {
	                showVideo = 'block';
	              } else {
	                showVideo = 'none';
	              }
	
	              return _react2.default.createElement(
	                'article',
	                { key: i, className: (0, _classnames2.default)('highlight'), style: { 'display': showVideo, 'minHeight': '200px' } },
	                _react2.default.createElement(_common.Video, (0, _extends3.default)({ showCaption: true }, video))
	              );
	            }),
	            enableLazyload && _react2.default.createElement(_common.Lazyload, { page: page, threshold: 0.3, hasMore: hasMore, updateMore: updateMoreVideos, enableForceLazyload: enableForceLazyload })
	          )
	        )
	      );
	    }
	  }]);
	  return VideoGrid;
	}(_react2.default.Component); /* global jQuery */
	
	
	exports.default = VideoGrid;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getAppView = __webpack_require__(809);
	
	var _getAppView2 = _interopRequireDefault(_getAppView);
	
	var _getAppView3 = __webpack_require__(824);
	
	var _getAppView4 = _interopRequireDefault(_getAppView3);
	
	var _getAppViewLite = __webpack_require__(846);
	
	var _getAppViewLite2 = _interopRequireDefault(_getAppViewLite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Compose the Game package view
	 * based on sport and page type
	 * TODO: Add logic for other sports
	 * 
	 * @param  {String} options.pageType PageType
	 * @param  {Object} options.state    Game package state
	 * @return {Object}                  App view
	 */
	var composeView = function composeView(_ref) {
	  var _ref$pageType = _ref.pageType,
	      pageType = _ref$pageType === undefined ? 'game' : _ref$pageType,
	      _ref$state = _ref.state,
	      state = _ref$state === undefined ? {} : _ref$state,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params,
	      _ref$query = _ref.query,
	      query = _ref$query === undefined ? {} : _ref$query,
	      _ref$isAppLite = _ref.isAppLite,
	      isAppLite = _ref$isAppLite === undefined ? false : _ref$isAppLite;
	
	
	  var view = void 0;
	  var args = {
	    pageType: pageType,
	    state: state,
	    params: params,
	    query: query
	  };
	
	  switch (params.sport) {
	    case 'cricket':
	      if (isAppLite) {
	        view = (0, _getAppViewLite2.default)(args);
	      } else {
	        view = (0, _getAppView4.default)(args);
	      }
	      break;
	    case 'rugby-league':
	    case 'rugby':
	      view = (0, _getAppView2.default)({
	        pageType: pageType,
	        state: state,
	        params: params,
	        query: query
	      });
	      break;
	  }
	
	  return view;
	};
	
	exports.default = composeView;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRugbyView = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MatchDetails = __webpack_require__(810);
	
	var _MatchDetails2 = _interopRequireDefault(_MatchDetails);
	
	var _MatchStats = __webpack_require__(811);
	
	var _MatchStats2 = _interopRequireDefault(_MatchStats);
	
	var _MatchEvents = __webpack_require__(815);
	
	var _MatchEvents2 = _interopRequireDefault(_MatchEvents);
	
	var _PlayersList = __webpack_require__(818);
	
	var _PlayersList2 = _interopRequireDefault(_PlayersList);
	
	var _Conversation = __webpack_require__(819);
	
	var _Conversation2 = _interopRequireDefault(_Conversation);
	
	var _Commentary = __webpack_require__(820);
	
	var _Commentary2 = _interopRequireDefault(_Commentary);
	
	var _PlayerStats = __webpack_require__(821);
	
	var _PlayerStats2 = _interopRequireDefault(_PlayerStats);
	
	var _Glossary = __webpack_require__(822);
	
	var _Glossary2 = _interopRequireDefault(_Glossary);
	
	var _MatchHistory = __webpack_require__(823);
	
	var _MatchHistory2 = _interopRequireDefault(_MatchHistory);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(686);
	
	var _common2 = __webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generate the Game package view for Rugby
	 * @param  {String} options.pageType PageType
	 * @param  {Object} options.state    Application state
	 * @return {Object}                  Arrays having React components for each column
	 */
	var getRugbyView = exports.getRugbyView = function getRugbyView(_ref) {
	  var _ref$pageType = _ref.pageType,
	      pageType = _ref$pageType === undefined ? 'game' : _ref$pageType,
	      _ref$state = _ref.state,
	      state = _ref$state === undefined ? {} : _ref$state,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params;
	
	
	  var appView = '';
	  var bet365Kiosk = (0, _common2.isBet365KioskEdition)(state.edition);
	
	  var columnThree = [bet365Kiosk && _react2.default.createElement(
	    'div',
	    { key: 'kiosk-ad', className: 'sub-module' },
	    _react2.default.createElement(_common.Ad, { id: 'bet365', className: 'ad-slot-incontent-strip ad-wrapper', slotType: 'incontentstrip' })
	  ), _react2.default.createElement(
	    'div',
	    { key: 'ad', className: 'sub-module' },
	    _react2.default.createElement(_common.Ad, { id: 'mpu', className: 'ad-slot-incontent ad-wrapper', slotType: 'incontent' })
	  ), _react2.default.createElement(_common.StandingsModule, (0, _extends3.default)({ key: 's' }, state.standings)), _react2.default.createElement(_common.NewsModule, (0, _extends3.default)({ key: 'nm' }, state.news))];
	
	  switch (pageType) {
	    case 'game':
	    case 'match':
	      appView = getSummary({ state: state, columnThree: columnThree, params: params });
	      break;
	
	    case 'commentary':
	      appView = getCommentary({ state: state, columnThree: columnThree });
	      break;
	
	    case 'matchstats':
	      appView = getMatchStats({ state: state, columnThree: columnThree });
	      break;
	
	    case 'playerstats':
	      appView = getPlayerStats({ state: state, columnThree: columnThree });
	      break;
	
	    case 'lineups':
	      appView = getLineups({ state: state, columnThree: columnThree });
	      break;
	
	    case 'conversation':
	      appView = getConversation({ state: state, columnThree: columnThree });
	      break;
	
	    case 'preview':
	    case 'report':
	      appView = getArticleContent({ state: state, columnThree: columnThree });
	      break;
	  }
	
	  return appView;
	};
	//import TeamStats    from './components/TeamStats'
	
	//import Article    from './components/article'
	
	
	var getMatchStats = function getMatchStats(_ref2) {
	  var state = _ref2.state,
	      columnThree = _ref2.columnThree;
	
	  var isTeamLinkActive = (0, _selectn2.default)('matchStats.isTeamLinkActive', state);
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout-bc' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-b' },
	      _react2.default.createElement(_MatchEvents2.default, (0, _extends3.default)({ key: 'mevt' }, state.matchEvents)),
	      _react2.default.createElement(_MatchEvents2.default, (0, _extends3.default)({ key: 'matt' }, state.matchAttacking)),
	      _react2.default.createElement(_MatchEvents2.default, (0, _extends3.default)({ key: 'mdef' }, state.matchDefending)),
	      _react2.default.createElement(_MatchEvents2.default, (0, _extends3.default)({ key: 'mdis' }, state.matchDiscipline)),
	      _react2.default.createElement(_MatchHistory2.default, (0, _extends3.default)({ key: 'h2h' }, state.headToHead, { sport: 'rugby', head2head: 'true', isTeamLinkActive: isTeamLinkActive, isWebView: state.isWebView })),
	      _react2.default.createElement(_MatchHistory2.default, (0, _extends3.default)({ key: 'hf' }, state.matchHomeForm, { isTeamLinkActive: isTeamLinkActive, isWebView: state.isWebView })),
	      _react2.default.createElement(_MatchHistory2.default, (0, _extends3.default)({ key: 'af' }, state.matchAwayForm, { isTeamLinkActive: isTeamLinkActive, isWebView: state.isWebView }))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-c' },
	      columnThree
	    )
	  );
	};
	
	var getPlayerStats = function getPlayerStats(_ref3) {
	  var state = _ref3.state,
	      columnThree = _ref3.columnThree;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout-bc' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-b' },
	      _react2.default.createElement(_PlayerStats2.default, (0, _extends3.default)({ key: 'ps' }, state.matchLineUp, { glossary: state.matchGlossary.playerStats })),
	      _react2.default.createElement(_Glossary2.default, { key: 'gloss', glossary: state.matchGlossary.playerStats })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-c' },
	      columnThree
	    )
	  );
	};
	
	var getConversation = function getConversation(_ref4) {
	  var state = _ref4.state,
	      columnThree = _ref4.columnThree;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout-bc' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-b' },
	      _react2.default.createElement(_Conversation2.default, (0, _extends3.default)({ key: 'conv' }, state.matchConversation))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-c' },
	      columnThree
	    )
	  );
	};
	
	var getLineups = function getLineups(_ref5) {
	  var state = _ref5.state,
	      columnThree = _ref5.columnThree;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout-bc' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-b' },
	      _react2.default.createElement(_PlayersList2.default, (0, _extends3.default)({ key: 'sq' }, state.matchLineUp))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-c' },
	      columnThree
	    )
	  );
	};
	
	var getArticleContent = function getArticleContent(_ref6) {
	  var state = _ref6.state,
	      columnThree = _ref6.columnThree;
	
	  var articleMarkup = (0, _selectn2.default)('article.html', state) || '';
	  articleMarkup = articleMarkup.replace('<\\/script>', '<\/script>');
	  return _react2.default.createElement(
	    'div',
	    { className: 'main-content react-content' },
	    _react2.default.createElement(
	      'div',
	      { id: 'gamepackage-wrap' },
	      _react2.default.createElement(
	        'div',
	        { id: 'gamepackage-content-wrap', className: 'layout-bc' },
	        _react2.default.createElement('section', { id: 'article-feed', className: 'col-b',
	          'data-behavior': 'author_overlay article_header_news_feed_item_meta social_tools comment',
	          dangerouslySetInnerHTML: { __html: articleMarkup } }),
	        _react2.default.createElement(
	          'section',
	          { className: 'col-c' },
	          columnThree
	        )
	      )
	    )
	  );
	};
	
	var getCommentary = function getCommentary(_ref7) {
	  var state = _ref7.state,
	      columnThree = _ref7.columnThree;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout-cbc' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-one' },
	      _react2.default.createElement(_PlayersList2.default, (0, _extends3.default)({ key: 'sq' }, state.matchLineUp)),
	      _react2.default.createElement(_MatchDetails2.default, (0, _extends3.default)({ key: 'm' }, state.matchDetails))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-two' },
	      _react2.default.createElement(_Commentary2.default, (0, _extends3.default)({ key: 'conv' }, state.matchCommentary, { showAll: true }))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-three' },
	      columnThree
	    )
	  );
	};
	
	var TopStory = function TopStory(_ref8) {
	  var _ref8$article = _ref8.article,
	      article = _ref8$article === undefined ? {} : _ref8$article;
	
	
	  if (!article) {
	    return null;
	  }
	
	  return _react2.default.createElement(_common.TopStories, { key: 't', content: article, image: article.images && article.images[0] || {} });
	};
	
	var getSummary = function getSummary(_ref9) {
	  var state = _ref9.state,
	      columnThree = _ref9.columnThree;
	
	
	  var isSmallDevice = state.isSmallDevice || false;
	  var isTabletDevice = state.isTabletDevice || false;
	  var isSmallDesktopDevice = state.isSmallDesktopDevice || false;
	  var matchLineUp = state.matchLineUp || {};
	
	  // default columns 'pre' state
	  var columnOne = isSmallDevice ? [] : [matchLineUp.show && _react2.default.createElement(_PlayersList2.default, (0, _extends3.default)({ key: 'sq' }, matchLineUp)), _react2.default.createElement(_MatchDetails2.default, (0, _extends3.default)({ key: 'm' }, state.matchDetails))];
	
	  var matchDetails = isSmallDevice || isTabletDevice || isSmallDesktopDevice ? _react2.default.createElement(_MatchDetails2.default, (0, _extends3.default)({ key: 'm' }, state.matchDetails)) : '';
	
	  var isTeamLinkActive = (0, _selectn2.default)('matchStats.isTeamLinkActive', state);
	  var columnTwo = [_react2.default.createElement(TopStory, { key: 't', article: state.article }), _react2.default.createElement(_Commentary2.default, (0, _extends3.default)({ key: 'c' }, state.matchCommentary)), _react2.default.createElement(_MatchHistory2.default, (0, _extends3.default)({ key: 'h2h' }, state.headToHead, { sport: 'rugby', head2head: 'true', isTeamLinkActive: isTeamLinkActive, isWebView: state.isWebView })), _react2.default.createElement(_MatchHistory2.default, (0, _extends3.default)({ key: 'hf' }, state.matchHomeForm, { isTeamLinkActive: isTeamLinkActive, isWebView: state.isWebView })), _react2.default.createElement(_MatchHistory2.default, (0, _extends3.default)({ key: 'af' }, state.matchAwayForm, { isTeamLinkActive: isTeamLinkActive, isWebView: state.isWebView })), matchDetails, !state.isWebView && _react2.default.createElement(_Conversation2.default, (0, _extends3.default)({ key: 'conv' }, state.matchConversation))];
	
	  switch (state.gameState) {
	    case 'live':
	      columnOne = isSmallDevice ? [] : [matchLineUp.show && _react2.default.createElement(_PlayersList2.default, (0, _extends3.default)({ key: 'sq' }, matchLineUp)), _react2.default.createElement(_MatchDetails2.default, (0, _extends3.default)({ key: 'm' }, state.matchDetails))];
	      columnTwo = [_react2.default.createElement(_Commentary2.default, (0, _extends3.default)({ key: 'c' }, state.matchCommentary)), _react2.default.createElement(_MatchStats2.default, (0, _extends3.default)({ key: 'ms' }, state.matchStats)), matchDetails, !state.isWebView && _react2.default.createElement(_Conversation2.default, (0, _extends3.default)({ key: 'conv' }, state.matchConversation))];
	      break;
	
	    case 'final':
	      columnOne = isSmallDevice ? [] : [matchLineUp.show && _react2.default.createElement(_PlayersList2.default, (0, _extends3.default)({ key: 'sq' }, matchLineUp)), _react2.default.createElement(_MatchDetails2.default, (0, _extends3.default)({ key: 'm' }, state.matchDetails))];
	      columnTwo = [_react2.default.createElement(_common.TopStories, { key: 't', content: state.article, image: state.article.images && state.article.images[0] || {} }), _react2.default.createElement(_Commentary2.default, (0, _extends3.default)({ key: 'c' }, state.matchCommentary)), _react2.default.createElement(_MatchStats2.default, (0, _extends3.default)({ key: 'ms' }, state.matchStats)), matchDetails, !state.isWebView && _react2.default.createElement(_Conversation2.default, (0, _extends3.default)({ key: 'conv' }, state.matchConversation))];
	      break;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout-cbc' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-one' },
	      columnOne
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-two' },
	      columnTwo
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-three' },
	      columnThree
	    )
	  );
	};
	
	exports.default = getRugbyView;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Attendance = function Attendance(_ref) {
	  var _ref$attendance = _ref.attendance,
	      attendance = _ref$attendance === undefined ? 0 : _ref$attendance,
	      _ref$percent = _ref.percent,
	      percent = _ref$percent === undefined ? 0 : _ref$percent,
	      _ref$text = _ref.text,
	      text = _ref$text === undefined ? '' : _ref$text;
	
	  if (attendance && percent) {
	    percent += '%';
	    return _react2.default.createElement(
	      'div',
	      { className: 'attendance' },
	      _react2.default.createElement(
	        'div',
	        { className: 'people' },
	        _react2.default.createElement('div', { className: 'people-all' }),
	        _react2.default.createElement('div', { className: 'attendance-bar', style: { width: percent } })
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'percentage' },
	        percent
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'capacity' },
	        text,
	        ': ',
	        attendance
	      )
	    );
	  } else {
	    return _react2.default.createElement(
	      'div',
	      { className: 'capacity' },
	      text,
	      ': ',
	      attendance
	    );
	  }
	};
	
	var MatchDetails = function MatchDetails(_ref2) {
	  var _ref2$coverage = _ref2.coverage,
	      coverage = _ref2$coverage === undefined ? '' : _ref2$coverage,
	      _ref2$venue = _ref2.venue,
	      venue = _ref2$venue === undefined ? '' : _ref2$venue,
	      _ref2$address = _ref2.address,
	      address = _ref2$address === undefined ? '' : _ref2$address,
	      _ref2$attendance = _ref2.attendance,
	      attendance = _ref2$attendance === undefined ? 0 : _ref2$attendance,
	      _ref2$percent = _ref2.percent,
	      percent = _ref2$percent === undefined ? 0 : _ref2$percent,
	      _ref2$capacity = _ref2.capacity,
	      capacity = _ref2$capacity === undefined ? 0 : _ref2$capacity,
	      _ref2$date = _ref2.date,
	      date = _ref2$date === undefined ? '' : _ref2$date,
	      _ref2$text = _ref2.text,
	      text = _ref2$text === undefined ? {} : _ref2$text;
	
	
	  return _react2.default.createElement(
	    'article',
	    { className: 'sub-module game-information' },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        text.heading || ''
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'game-field' },
	        venue && _react2.default.createElement(
	          'div',
	          { className: 'game-details location-details' },
	          _react2.default.createElement(
	            'div',
	            { className: 'capacity' },
	            text.venue || '',
	            ': ',
	            venue
	          )
	        ) || null,
	        _react2.default.createElement(
	          'div',
	          { className: 'game-details' },
	          _react2.default.createElement(
	            'div',
	            { className: 'game-date-time' },
	            date
	          ),
	          coverage && _react2.default.createElement(
	            'div',
	            { className: 'game-network' },
	            text.coverage || '',
	            ': ',
	            coverage
	          ) || _react2.default.createElement('div', { className: 'game-network' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'location-details' },
	        address && _react2.default.createElement(
	          'ul',
	          { key: 'location' },
	          _react2.default.createElement(
	            'li',
	            { className: 'icon-font-before icon-location-solid-before' },
	            address
	          )
	        ) || null,
	        capacity && capacity !== '0' && _react2.default.createElement(
	          'div',
	          { className: 'capacity' },
	          text.capacity || '',
	          ': ',
	          capacity
	        ) || null,
	        attendance && attendance !== '0' && _react2.default.createElement(Attendance, { percent: percent, attendance: attendance, text: text.attendance || '' }) || null
	      )
	    )
	  );
	};
	
	exports.default = MatchDetails;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VisPercent = __webpack_require__(812);
	
	var _VisPercent2 = _interopRequireDefault(_VisPercent);
	
	var _TeamCompareHeader = __webpack_require__(813);
	
	var _TeamCompareHeader2 = _interopRequireDefault(_TeamCompareHeader);
	
	var _StatsTable = __webpack_require__(814);
	
	var _StatsTable2 = _interopRequireDefault(_StatsTable);
	
	var _AnchorLink = __webpack_require__(682);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchStats = function MatchStats(_ref) {
	  var _ref$title = _ref.title,
	      title = _ref$title === undefined ? '' : _ref$title,
	      _ref$dataVis = _ref.dataVis,
	      dataVis = _ref$dataVis === undefined ? [] : _ref$dataVis,
	      _ref$home = _ref.home,
	      home = _ref$home === undefined ? {} : _ref$home,
	      _ref$away = _ref.away,
	      away = _ref$away === undefined ? {} : _ref$away,
	      _ref$table = _ref.table,
	      table = _ref$table === undefined ? {} : _ref$table,
	      _ref$link = _ref.link,
	      link = _ref$link === undefined ? {} : _ref$link,
	      _ref$sport = _ref.sport,
	      sport = _ref$sport === undefined ? 'rugby' : _ref$sport;
	
	
	  var sClass = 'sub-module ' + sport;
	  if (sport == 'rugby') {
	    sClass += ' match-stats';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: sClass },
	    _react2.default.createElement(
	      'header',
	      { className: 'bordered' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content', style: { overflow: 'auto' } },
	      sport == 'rugby' && _react2.default.createElement(
	        'div',
	        { className: 'data-vis' },
	        _react2.default.createElement(_TeamCompareHeader2.default, { heading: dataVis[0].text, home: home, away: away }),
	        _react2.default.createElement(_VisPercent2.default, (0, _extends3.default)({ homeColor: home.color, awayColor: away.color }, dataVis[0])),
	        _react2.default.createElement(_TeamCompareHeader2.default, { heading: dataVis[1].text, noTeams: 'no-teams' }),
	        _react2.default.createElement(_VisPercent2.default, (0, _extends3.default)({ large: true, homeColor: home.color, awayColor: away.color }, dataVis[1]))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'stat-list' },
	        _react2.default.createElement(_TeamCompareHeader2.default, { bordered: true, home: home, away: away }),
	        _react2.default.createElement(_StatsTable2.default, { stats: table })
	      )
	    ),
	    _react2.default.createElement(
	      'footer',
	      null,
	      _react2.default.createElement(_AnchorLink2.default, link)
	    )
	  );
	};
	
	exports.default = MatchStats;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VisPercent = function VisPercent(_ref) {
	  var _ref$homeColor = _ref.homeColor,
	      homeColor = _ref$homeColor === undefined ? '' : _ref$homeColor,
	      _ref$awayColor = _ref.awayColor,
	      awayColor = _ref$awayColor === undefined ? '' : _ref$awayColor,
	      _ref$homeValue = _ref.homeValue,
	      homeValue = _ref$homeValue === undefined ? 0 : _ref$homeValue,
	      _ref$awayValue = _ref.awayValue,
	      awayValue = _ref$awayValue === undefined ? 0 : _ref$awayValue,
	      _ref$homeText = _ref.homeText,
	      homeText = _ref$homeText === undefined ? '' : _ref$homeText,
	      _ref$awayText = _ref.awayText,
	      awayText = _ref$awayText === undefined ? '' : _ref$awayText,
	      _ref$large = _ref.large,
	      large = _ref$large === undefined ? false : _ref$large;
	
	
	  //const backgroundColor = ;
	  if (homeValue == 0 && awayValue == 0) {
	    awayColor = '#e5e5e5';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'stat-graph compareLineGraph twoTeam largeLabels' + (large ? ' large' : '') },
	    _react2.default.createElement(
	      'span',
	      { className: 'chartValue' },
	      homeText
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'bar-wrap' },
	      _react2.default.createElement(
	        'span',
	        { style: { backgroundColor: awayColor }, className: 'bar-total' },
	        _react2.default.createElement('span', { style: { backgroundColor: homeValue > 100 ? awayColor : homeColor, width: homeValue + '%' }, className: 'bar-percentage' })
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'chartValue' },
	        awayText
	      )
	    )
	  );
	};
	
	exports.default = VisPercent;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamCompareHeader = function TeamCompareHeader(_ref) {
	  var _ref$bordered = _ref.bordered,
	      bordered = _ref$bordered === undefined ? false : _ref$bordered,
	      _ref$noTeams = _ref.noTeams,
	      noTeams = _ref$noTeams === undefined ? false : _ref$noTeams,
	      _ref$home = _ref.home,
	      home = _ref$home === undefined ? {} : _ref$home,
	      _ref$away = _ref.away,
	      away = _ref$away === undefined ? {} : _ref$away,
	      _ref$heading = _ref.heading,
	      heading = _ref$heading === undefined ? '' : _ref$heading;
	
	  var classNames = ['teamCompareHeaderWrap', noTeams ? 'no-teams' : '', bordered ? 'bordered' : ''];
	  return _react2.default.createElement(
	    'div',
	    { className: classNames.join(' ') },
	    _react2.default.createElement(
	      'div',
	      { className: 'teamCompareHeader' },
	      _react2.default.createElement(
	        'div',
	        { className: 'team team1' },
	        _react2.default.createElement('img', { className: 'imageLoaded', src: home.logo }),
	        _react2.default.createElement(
	          'span',
	          { className: 'record' },
	          home.name
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        heading
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'team team2' },
	        _react2.default.createElement(
	          'span',
	          { className: 'record' },
	          away.name
	        ),
	        _react2.default.createElement('img', { className: 'imageLoaded', src: away.logo })
	      )
	    )
	  );
	};
	
	exports.default = TeamCompareHeader;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatRow = function StatRow(_ref) {
	  var _ref$stat = _ref.stat,
	      stat = _ref$stat === undefined ? {
	    homeValue: '-',
	    text: '-',
	    awayValue: '-'
	  } : _ref$stat;
	
	  return _react2.default.createElement(
	    'tr',
	    null,
	    _react2.default.createElement(
	      'td',
	      { className: 'score', colSpan: '2' },
	      stat.homeValue
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'label', colSpan: '2' },
	      stat.text
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'score', colSpan: '2' },
	      stat.awayValue
	    )
	  );
	};
	
	var StatsTable = function StatsTable(_ref2) {
	  var _ref2$stats = _ref2.stats,
	      stats = _ref2$stats === undefined ? [] : _ref2$stats;
	
	  var iLen = stats.length || 0;
	  var aRows = [];
	
	  for (var i = 0, l = iLen; i < l; i++) {
	    aRows.push(_react2.default.createElement(StatRow, { key: i, stat: stats[i] }));
	  }
	
	  return _react2.default.createElement(
	    'table',
	    { className: 'compareTable' },
	    _react2.default.createElement(
	      'tbody',
	      null,
	      aRows
	    )
	  );
	};
	
	exports.default = StatsTable;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TeamCompareHeader = __webpack_require__(813);
	
	var _TeamCompareHeader2 = _interopRequireDefault(_TeamCompareHeader);
	
	var _VisPercent = __webpack_require__(812);
	
	var _VisPercent2 = _interopRequireDefault(_VisPercent);
	
	var _VisIcons = __webpack_require__(816);
	
	var _VisIcons2 = _interopRequireDefault(_VisIcons);
	
	var _VisCircle = __webpack_require__(817);
	
	var _VisCircle2 = _interopRequireDefault(_VisCircle);
	
	var _StatsTable = __webpack_require__(814);
	
	var _StatsTable2 = _interopRequireDefault(_StatsTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchStatsCol = function MatchStatsCol(_ref) {
	  var _ref$home = _ref.home,
	      home = _ref$home === undefined ? {} : _ref$home,
	      _ref$away = _ref.away,
	      away = _ref$away === undefined ? {} : _ref$away,
	      _ref$stats = _ref.stats,
	      stats = _ref$stats === undefined ? [] : _ref$stats,
	      _ref$split = _ref.split,
	      split = _ref$split === undefined ? false : _ref$split,
	      _ref$colLen = _ref.colLen,
	      colLen = _ref$colLen === undefined ? 2 : _ref$colLen,
	      _ref$colNo = _ref.colNo,
	      colNo = _ref$colNo === undefined ? 0 : _ref$colNo;
	
	
	  var iStatsLen = stats.length;
	  var aData = [];
	  var aClassNames = ['content'];
	
	  for (var i = 0; i < iStatsLen; i++) {
	    var oStats = stats[i];
	
	    if (i === 0) {
	      var extra = {};
	      extra['bordered'] = true;
	      if ((oStats.type === 'dataVis' || oStats.type === 'dataVisIcons' || oStats.type === 'dataVisPie' || oStats.type === 'dataVisCount') && oStats.data.text) {
	        extra['heading'] = oStats.data.text || '';
	        extra['bordered'] = false;
	      }
	
	      aData.push(_react2.default.createElement(_TeamCompareHeader2.default, (0, _extends3.default)({ key: 'tc' + i, home: home, away: away }, extra)));
	    }
	
	    if (oStats.type === 'table') {
	      aData.push(_react2.default.createElement(_StatsTable2.default, { key: 'st' + i, stats: oStats.data }));
	    } else if (oStats.type === 'dataVis' || oStats.type === 'dataVisIcons' || oStats.type === 'dataVisCount') {
	      if (i !== 0) {
	        aData.push(_react2.default.createElement(_TeamCompareHeader2.default, { key: 'tc' + i, noTeams: true, heading: oStats.data.text || '' }));
	      }
	      if (oStats.type === 'dataVisIcons') {
	        aData.push(_react2.default.createElement(_VisIcons2.default, (0, _extends3.default)({ key: 'dvi' + i, homeColor: home.color, awayColor: away.color }, oStats.data)));
	      } else if (oStats.type === 'dataVisCount') {
	        aData.push(_react2.default.createElement(_VisIcons2.default, (0, _extends3.default)({ key: 'dvi' + i, type: 'count', homeColor: home.color, awayColor: away.color }, oStats.data)));
	      } else {
	        aData.push(_react2.default.createElement(_VisPercent2.default, (0, _extends3.default)({ key: 'dv1' + i, large: oStats.size === 'large' ? true : false, homeColor: home.color, awayColor: away.color }, oStats.data)));
	      }
	    } else if (oStats.type === 'dataVisPie') {
	      aData.push(_react2.default.createElement(
	        'div',
	        { className: 'chart-container parallel', key: 'dvph' + i },
	        _react2.default.createElement(_VisCircle2.default, { color: home.color, won: oStats.data.homeWon, total: oStats.data.homeTotal })
	      ));
	
	      aData.push(_react2.default.createElement(
	        'div',
	        { className: 'chart-container parallel', key: 'dvpa' + i },
	        _react2.default.createElement(_VisCircle2.default, { color: away.color, won: oStats.data.awayWon, total: oStats.data.awayTotal })
	      ));
	    }
	  }
	
	  var hackWidth = {
	    style: { overflow: 'auto' }
	  };
	  if (split !== true && colLen > 1) {
	    if (colNo === 0) {
	      aClassNames.push('col-a');
	    } else {
	      aClassNames.push('col-b');
	    }
	    hackWidth.style = { marginRight: 0 /* remove when they fix */
	    };
	  }
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: aClassNames.join(' ') }, hackWidth),
	    aData
	  );
	};
	
	var MatchEvents = function MatchEvents(_ref2) {
	  var _ref2$title = _ref2.title,
	      title = _ref2$title === undefined ? '' : _ref2$title,
	      _ref2$col = _ref2.col,
	      col = _ref2$col === undefined ? [] : _ref2$col,
	      _ref2$split = _ref2.split,
	      split = _ref2$split === undefined ? false : _ref2$split,
	      _ref2$home = _ref2.home,
	      home = _ref2$home === undefined ? {} : _ref2$home,
	      _ref2$away = _ref2.away,
	      away = _ref2$away === undefined ? {} : _ref2$away;
	
	
	  /* itterate columns */
	  var aTitle = title;
	
	  if (aTitle.constructor !== Array) {
	    aTitle = [aTitle];
	  }
	  var iColLen = col.length;
	
	  /* No data so show nothing */
	  if (iColLen == 0) {
	    return _react2.default.createElement('div', null);
	  }
	
	  var aCols = [];
	
	  for (var i = 0; i < iColLen; i++) {
	    var aStats = col[i];
	    aCols.push(_react2.default.createElement(MatchStatsCol, { key: i, split: split, home: home, away: away, stats: aStats, colNo: i, colLen: iColLen }));
	  }
	
	  if (split === true) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'sub-module-split' },
	      _react2.default.createElement(
	        'div',
	        { className: 'module-split' },
	        _react2.default.createElement(
	          'article',
	          { className: 'sub-module equal-height countChartList height-reset' },
	          aTitle[0] && _react2.default.createElement(
	            'header',
	            { className: 'bordered' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              aTitle[0]
	            )
	          ) || null,
	          aCols[0]
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'module-split' },
	        _react2.default.createElement(
	          'article',
	          { className: 'sub-module equal-height countChartList height-reset' },
	          aTitle[1] && _react2.default.createElement(
	            'header',
	            { className: 'bordered' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              aTitle[1]
	            )
	          ) || null,
	          aCols[1]
	        )
	      )
	    );
	  } else {
	    return _react2.default.createElement(
	      'article',
	      { className: 'sub-module', style: { overflow: 'auto' } },
	      aTitle[0] && _react2.default.createElement(
	        'header',
	        { className: 'bordered' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          aTitle[0]
	        )
	      ) || null,
	      _react2.default.createElement(
	        'div',
	        { className: 'stacked-rl' },
	        aCols
	      )
	    );
	  }
	};
	
	exports.default = MatchEvents;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icon = function Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#e5e5e5' : _ref$color,
	      _ref$type = _ref.type,
	      type = _ref$type === undefined ? '' : _ref$type;
	
	  if (type !== 'count') {
	    return _react2.default.createElement('span', { className: 'circle countIcon filled', style: { backgroundColor: color } });
	  }
	  return _react2.default.createElement('span', { className: 'icon-font countIcon', style: { color: color }, dangerouslySetInnerHTML: { __html: '<' } });
	};
	
	var Icons = function Icons(_ref2) {
	  var _ref2$color = _ref2.color,
	      color = _ref2$color === undefined ? '' : _ref2$color,
	      _ref2$total = _ref2.total,
	      total = _ref2$total === undefined ? 0 : _ref2$total,
	      _ref2$won = _ref2.won,
	      won = _ref2$won === undefined ? 0 : _ref2$won,
	      _ref2$type = _ref2.type,
	      type = _ref2$type === undefined ? '' : _ref2$type;
	
	
	  var filledCircles = [];
	  var emptyCircles = [];
	
	  for (var i = 0; i < won; i++) {
	    filledCircles.push(_react2.default.createElement(Icon, { key: 'cl.' + i, color: color, type: type }));
	  }
	
	  if (type !== 'count') {
	    var remain = total - won;
	    if (remain < 0) {
	      remain = 0;
	    }
	    for (var _i = 0; _i < remain; _i++) {
	      emptyCircles.push(_react2.default.createElement(Icon, { key: 'cw.' + _i }));
	    }
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'countIcons' },
	    filledCircles.concat(emptyCircles)
	  );
	};
	
	var Lable = function Lable(_ref3) {
	  var _ref3$type = _ref3.type,
	      type = _ref3$type === undefined ? '' : _ref3$type,
	      _ref3$won = _ref3.won,
	      won = _ref3$won === undefined ? 0 : _ref3$won,
	      _ref3$total = _ref3.total,
	      total = _ref3$total === undefined ? 0 : _ref3$total,
	      _ref3$homeAway = _ref3.homeAway,
	      homeAway = _ref3$homeAway === undefined ? 'home' : _ref3$homeAway;
	
	  var percent = parseInt(parseInt(won) / parseInt(total) * 100);
	
	  if (type !== 'count') {
	    if (homeAway === 'home') {
	      return _react2.default.createElement(
	        'div',
	        { className: 'countLabel' },
	        won + '/' + total,
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { className: 'percentage' },
	          '(' + percent + '%)'
	        )
	      );
	    } else {
	      return _react2.default.createElement(
	        'div',
	        { className: 'countLabel' },
	        _react2.default.createElement(
	          'span',
	          { className: 'percentage' },
	          '(' + percent + '%)'
	        ),
	        ' ' + won + '/' + total
	      );
	    }
	  } else {
	    return _react2.default.createElement(
	      'div',
	      { className: 'countLabel' },
	      won
	    );
	  }
	};
	
	var VisIcons = function VisIcons(_ref4) {
	  var _ref4$homeColor = _ref4.homeColor,
	      homeColor = _ref4$homeColor === undefined ? '' : _ref4$homeColor,
	      _ref4$awayColor = _ref4.awayColor,
	      awayColor = _ref4$awayColor === undefined ? '' : _ref4$awayColor,
	      _ref4$homeTotal = _ref4.homeTotal,
	      homeTotal = _ref4$homeTotal === undefined ? 0 : _ref4$homeTotal,
	      _ref4$awayTotal = _ref4.awayTotal,
	      awayTotal = _ref4$awayTotal === undefined ? 0 : _ref4$awayTotal,
	      _ref4$homeWon = _ref4.homeWon,
	      homeWon = _ref4$homeWon === undefined ? 0 : _ref4$homeWon,
	      _ref4$awayWon = _ref4.awayWon,
	      awayWon = _ref4$awayWon === undefined ? 0 : _ref4$awayWon,
	      _ref4$type = _ref4.type,
	      type = _ref4$type === undefined ? '' : _ref4$type;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'countChart' },
	    _react2.default.createElement(
	      'div',
	      { className: 'home' },
	      _react2.default.createElement(Lable, { won: homeWon, total: homeTotal, homwAway: 'home', type: type }),
	      _react2.default.createElement(Icons, { type: type, color: homeColor, won: homeWon, total: homeTotal })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'away' },
	      _react2.default.createElement(Lable, { won: awayWon, total: awayTotal, homwAway: 'away', type: type }),
	      _react2.default.createElement(Icons, { type: type, color: awayColor, won: awayWon, total: awayTotal })
	    )
	  );
	};
	
	exports.default = VisIcons;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VisCircle = function VisCircle(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? '' : _ref$color,
	      _ref$total = _ref.total,
	      total = _ref$total === undefined ? 0 : _ref$total,
	      _ref$won = _ref.won,
	      won = _ref$won === undefined ? 0 : _ref$won;
	
	
	  var percent = Math.round(parseInt(won) / parseInt(total) * 100);
	  var rotationAngle = Math.round(360 * (percent / 100));
	  var backgroundColor = '#e5e5e5';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'data-chart', 'data-chart': "1", style: { width: '135px', height: '135px' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'outer-circle' },
	      _react2.default.createElement(
	        'div',
	        { 'data-wedge-id': 'a', className: 'wedge-container', style: { transform: 'rotate(0deg)', WebkitTransform: 'rotate(0deg)', clip: 'auto', msTransform: 'rotate(0deg)' } },
	        _react2.default.createElement('div', { className: 'wedge', style: { msTransform: 'rotate(' + rotationAngle + 'deg)', WebkitTransform: 'rotate(' + rotationAngle + 'deg)', transform: 'rotate(' + rotationAngle + 'deg)', clip: 'rect(0px 73px 150px 0px)', backgroundColor: rotationAngle < 180 ? backgroundColor : color } }),
	        _react2.default.createElement('div', { className: 'wedge-extension', style: { opacity: 1, msTransform: 'rotate(180deg)', WebkitTransform: 'rotate(180deg)', transform: 'rotate(180deg)', clip: 'rect(0px 75px 150px 0px)', backgroundColor: rotationAngle < 180 ? backgroundColor : color } })
	      ),
	      _react2.default.createElement(
	        'div',
	        { 'data-wedge-id': 'b', className: 'wedge-container', style: { msTransform: 'rotate(' + rotationAngle + 'deg)', WebkitTransform: 'rotate(' + rotationAngle + 'deg)', transform: 'rotate(' + rotationAngle + 'deg)', clip: 'rect(0px 150px 150px 75px)' } },
	        _react2.default.createElement('div', { className: 'wedge', style: { msTransform: 'rotate(' + (360 - rotationAngle) + 'deg)', WebkitTransform: 'rotate(' + (360 - rotationAngle) + 'deg)', transform: 'rotate(' + (360 - rotationAngle) + 'deg)', clip: 'rect(0px 73px 150px 0px)', backgroundColor: rotationAngle < 180 ? color : backgroundColor } }),
	        _react2.default.createElement('div', { className: 'wedge-extension', style: { opacity: 0 } })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'inner-circle' },
	      _react2.default.createElement('span', { className: 'team-logo' }),
	      _react2.default.createElement('span', { className: 'team-name' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'home-team' },
	        won + '/' + total
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'away-team' },
	        percent + '%'
	      )
	    )
	  );
	};
	
	exports.default = VisCircle;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(424);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EVENT_ICON_CODE = { 1: 'T', 2: '&#xE09F;', 3: '&#xE0A0;', 4: '&#xE097;', 5: '', 6: '' };
	var EVENT_ICON_ORDER = [1, 2, 3, 4, 5, 6];
	var FIXED_WIDTH = { width: '33px' };
	var PlayerList = function PlayerList(_ref) {
	  var _ref$name = _ref.name,
	      name = _ref$name === undefined ? '-' : _ref$name,
	      _ref$logo = _ref.logo,
	      logo = _ref$logo === undefined ? '' : _ref$logo,
	      _ref$team = _ref.team,
	      team = _ref$team === undefined ? [] : _ref$team,
	      _ref$reserves = _ref.reserves,
	      reserves = _ref$reserves === undefined ? [] : _ref$reserves,
	      _ref$text = _ref.text,
	      text = _ref$text === undefined ? {} : _ref$text,
	      _ref$matchState = _ref.matchState,
	      matchState = _ref$matchState === undefined ? '' : _ref$matchState;
	
	
	  /*
	  if(aPlayerList.home.team.length <= 0){
	    aPlayerList.home.team.push((
	      <tr key="noHome">
	        <td colSpan="3" style={{padding:'20px',textAlign:'center'}}>Line-ups not yet available</td>
	      </tr>
	    ));
	  }
	    if(aPlayerList.away.team.length <= 0){
	    aPlayerList.away.team.push((
	      <tr key="noAway">
	        <td colSpan="3" style={{padding:'20px',textAlign:'center'}}>Line-ups not yet available</td>
	      </tr>
	    ));
	  }
	  */
	
	  return _react2.default.createElement(
	    'table',
	    { 'data-behavior': 'table_accordion', className: 'table-accordion' },
	    _react2.default.createElement(
	      'caption',
	      null,
	      logo && _react2.default.createElement('img', { src: logo }),
	      name
	    ),
	    _react2.default.createElement(
	      'thead',
	      null,
	      matchState === 'pregame' ? _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          { className: 'number', style: FIXED_WIDTH },
	          text.col2 || '-'
	        ),
	        _react2.default.createElement(
	          'th',
	          { className: 'name', colSpan: '2' },
	          text.col3 || '-'
	        )
	      ) : _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement('th', { style: FIXED_WIDTH }),
	        _react2.default.createElement(
	          'th',
	          { className: 'number' },
	          text.col2 || '-'
	        ),
	        _react2.default.createElement(
	          'th',
	          { className: 'name' },
	          text.col3 || '-'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      team.map(function (p, i) {
	        return _react2.default.createElement(PlayerListRow, (0, _extends3.default)({ key: i }, p, { text: text, matchState: matchState }));
	      })
	    ),
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        { className: 'secondTableHeader' },
	        _react2.default.createElement(
	          'th',
	          { colSpan: '3' },
	          text.split || '-'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      reserves.map(function (p, i) {
	        return _react2.default.createElement(PlayerListRow, (0, _extends3.default)({ key: i }, p, { text: text, matchState: matchState }));
	      })
	    )
	  );
	};
	
	var ExpandedStats = function ExpandedStats(_ref2) {
	  var _ref2$tackles = _ref2.tackles,
	      tackles = _ref2$tackles === undefined ? {} : _ref2$tackles,
	      _ref2$missedtackles = _ref2.missedtackles,
	      missedtackles = _ref2$missedtackles === undefined ? {} : _ref2$missedtackles,
	      _ref2$tries = _ref2.tries,
	      tries = _ref2$tries === undefined ? {} : _ref2$tries,
	      _ref2$runs = _ref2.runs,
	      runs = _ref2$runs === undefined ? {} : _ref2$runs,
	      _ref2$metres = _ref2.metres,
	      metres = _ref2$metres === undefined ? {} : _ref2$metres;
	
	
	  var iTotalTackles = parseInt(tackles.value) + parseInt(missedtackles.value);
	  var iTacklesPerc = parseInt(tackles.value / iTotalTackles * 100);
	  var iMissedPerc = parseInt(missedtackles.value / iTotalTackles * 100);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'accordion-content open' },
	    _react2.default.createElement(
	      'div',
	      { className: 'lineup-stats' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'stats' },
	        _react2.default.createElement(
	          'li',
	          { className: 'stat' },
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            tries.name
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'value' },
	            tries.value
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'stat' },
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            runs.name
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'value' },
	            runs.value
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'stat' },
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            metres.name
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'value' },
	            metres.value
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'fouls' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'compareLineGraph sameTeam' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'chartLabel' },
	              tackles.name
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: { backgroundColor: '#f2f2f2' }, className: 'bar-total' },
	              _react2.default.createElement('span', { style: { backgroundColor: '#dd2126', width: iTacklesPerc + '%' }, className: 'bar-percentage' })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'chartValue' },
	              tackles.value
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: { backgroundColor: '#f2f2f2' }, className: 'bar-total' },
	              _react2.default.createElement('span', { style: { backgroundColor: '#dd2126', width: iMissedPerc + '%' }, className: 'bar-percentage' })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'chartValue' },
	              missedtackles.value
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'chartLabel' },
	              missedtackles.name
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var PlayerListRow = function (_React$Component) {
	  (0, _inherits3.default)(PlayerListRow, _React$Component);
	
	  function PlayerListRow(props) {
	    (0, _classCallCheck3.default)(this, PlayerListRow);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PlayerListRow.__proto__ || (0, _getPrototypeOf2.default)(PlayerListRow)).call(this, props));
	
	    _this.state = {
	      expanded: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(PlayerListRow, [{
	    key: 'expandRow',
	    value: function expandRow() {
	      if (this.state.expanded) {
	        this.setState({ expanded: false });
	      } else {
	        this.setState({ expanded: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      if (this.props.matchState === 'pregame') {
	        return _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            { className: 'number' },
	            this.props.number || '-'
	          ),
	          _react2.default.createElement(
	            'td',
	            { colSpan: '2', className: 'date' },
	            (this.props.name || '-') + ', ' + (this.props.position || '-') + ' '
	          )
	        );
	      } else {
	
	        var aIcons = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(EVENT_ICON_ORDER), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var iEventType = _step.value;
	
	            if (typeof this.props.eventTimes[iEventType] !== 'undefined') {
	
	              var iQuant = this.props.eventTimes[iEventType].length;
	              var sClassStr = 'icon-font rugby-icon';
	              if (iEventType == 5) {
	                sClassStr = 'game-icon icon-font-before icon-soccer-card02-solid-before icon-yellowcard';
	              } else if (iEventType == 6) {
	                sClassStr = 'game-icon icon-font-before icon-soccer-card02-solid-before icon-redcard';
	              }
	
	              aIcons.push(_react2.default.createElement(
	                'div',
	                { key: 'icon.' + iEventType, className: 'tooltip', 'data-tooltip': '(' + this.props.eventTimes[iEventType].join(',') + ')' },
	                _react2.default.createElement('span', { className: sClassStr, dangerouslySetInnerHTML: { __html: EVENT_ICON_CODE[iEventType] } })
	              ));
	              if (iQuant > 1) {
	                aIcons.push(_react2.default.createElement(
	                  'span',
	                  { key: 'icon.sub.' + iEventType, className: 'subscript' },
	                  iQuant
	                ));
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return _react2.default.createElement(
	          'tr',
	          { className: this.state.expanded ? 'active' : null },
	          _react2.default.createElement(
	            'td',
	            { colSpan: '3', className: this.state.expanded ? 'active' : null },
	            _react2.default.createElement(
	              'div',
	              { className: 'accordion-item ' },
	              _react2.default.createElement(
	                'div',
	                { className: 'accordion-header lineup-player', onClick: this.props.wasActive ? this.expandRow.bind(this) : '' },
	                this.props.wasActive && _react2.default.createElement('span', { key: 'btn', className: 'icon-accordion btn-accordion' + (this.state.expanded ? ' active' : '') }),
	                this.props.subbed && _react2.default.createElement(
	                  'div',
	                  { key: 'icon.subbed', className: 'tooltip', 'data-tooltip': this.props.subToolTip },
	                  _react2.default.createElement('span', { className: 'icon-font icon-soccer-substitution-before' })
	                ) || null,
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontWeight: this.props.onPitch ? 'bold' : 'normal' }, key: 'no', className: 'number' },
	                  this.props.number || '-'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { key: 'name' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'name', style: { fontWeight: this.props.onPitch ? 'bold' : 'normal' } },
	                    (this.props.name || '-') + ', ' + (this.props.position || '-') + ' '
	                  ),
	                  aIcons
	                )
	              ),
	              this.state.expanded && this.props.wasActive && _react2.default.createElement(ExpandedStats, this.props) || null
	            )
	          )
	        );
	      }
	    }
	  }]);
	  return PlayerListRow;
	}(_react2.default.Component);
	
	var PlayersList = function (_React$Component2) {
	  (0, _inherits3.default)(PlayersList, _React$Component2);
	
	  function PlayersList(props) {
	    (0, _classCallCheck3.default)(this, PlayersList);
	
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PlayersList.__proto__ || (0, _getPrototypeOf2.default)(PlayersList)).call(this, props));
	
	    _this2.state = {
	      combined: true,
	      homeAway: 'home'
	    };
	    return _this2;
	  }
	
	  (0, _createClass3.default)(PlayersList, [{
	    key: 'swapTeam',
	    value: function swapTeam(sTeam) {
	      this.setState({ homeAway: sTeam });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var home = this.props.home || {};
	      var away = this.props.away || {};
	      var matchState = this.props.gameState || 'pregame';
	      var bForceSplit = this.props.split || false;
	      var bSplit = this.state.split || false;
	
	      var aHomeStyle = { display: 'block' };
	      var aAwayStyle = { display: 'block' };
	      if (!bSplit || !bForceSplit) {
	        if (this.state.homeAway === 'home') {
	          aAwayStyle = { display: 'none' };
	        } else {
	          aHomeStyle = { display: 'none' };
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'gamepackage-game-lineups-expanded', 'data-module': 'lineups', 'data-sport': 'rugby' },
	        _react2.default.createElement(
	          'article',
	          { className: 'boxscore-tabs sub-module-mobile-combine-split' + (this.state.combined ? ' combined' : ''), 'data-behavior': 'content_tab_mobile' },
	          _react2.default.createElement(
	            'header',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'filter form-group button-group' },
	              _react2.default.createElement(
	                'button',
	                { className: 'button-filter-alt lg fixed' + (this.state.homeAway === 'home' ? ' active' : ''), onClick: this.swapTeam.bind(this, 'home') },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'team-name' },
	                  home.name || '-'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'team-name-short' },
	                  home.name || '-'
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'button-filter-alt lg fixed' + (this.state.homeAway === 'away' ? ' active' : ''), onClick: this.swapTeam.bind(this, 'away') },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'team-name' },
	                  away.name || '-'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'team-name-short' },
	                  away.name || '-'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content-tab', style: aHomeStyle },
	              _react2.default.createElement(
	                'div',
	                { className: 'col column-one' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sub-module rugby' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement(PlayerList, (0, _extends3.default)({}, home, { text: this.props.text, matchState: matchState }))
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'content-tab', style: aAwayStyle },
	              _react2.default.createElement(
	                'div',
	                { className: 'col column-two' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sub-module rugby' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement(PlayerList, (0, _extends3.default)({}, away, { text: this.props.text, matchState: matchState }))
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: { fontSize: '11px', color: '#6c6d6f', padding: '12px' } },
	            (0, _selectn2.default)('props.text.note', this)
	          )
	        )
	      );
	    }
	  }]);
	  return PlayersList;
	}(_react2.default.Component);
	
	exports.default = PlayersList;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Conversation = function (_React$Component) {
	  (0, _inherits3.default)(Conversation, _React$Component);
	
	  function Conversation() {
	    (0, _classCallCheck3.default)(this, Conversation);
	    return (0, _possibleConstructorReturn3.default)(this, (Conversation.__proto__ || (0, _getPrototypeOf2.default)(Conversation)).call(this));
	  }
	
	  (0, _createClass3.default)(Conversation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      try {
	        espn.plugins.getFacebook(function () {
	          if (!$('.fb-comments iframe').length) {
	            FB.XFBML.parse(document.body);
	          }
	        });
	      } catch (e) {
	        //no empties...
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      if (this.props.href == nextProps.href) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var text = this.props.text || {};
	      var href = this.props.href || '';
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'sub-module conversation' },
	        _react2.default.createElement(
	          'header',
	          { className: 'bordered' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            text.heading || ''
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement('p', { className: 'condition', dangerouslySetInnerHTML: { __html: text.description || '' } }),
	          _react2.default.createElement('div', { className: 'fb-comments', 'data-numposts': '5', 'data-href': href, 'data-width': '100%' })
	        )
	      );
	    }
	  }]);
	  return Conversation;
	}(_react2.default.Component); /* global espn FB $ */
	
	
	exports.default = Conversation;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _htmlEntities = __webpack_require__(652);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AnchorLink = __webpack_require__(682);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global twttr */
	var entities = new _htmlEntities.XmlEntities();
	
	var Commentary = function (_React$Component) {
	  (0, _inherits3.default)(Commentary, _React$Component);
	
	  function Commentary(props) {
	    (0, _classCallCheck3.default)(this, Commentary);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Commentary.__proto__ || (0, _getPrototypeOf2.default)(Commentary)).call(this, props));
	
	    _this.state = {
	      tab: 'all', // all, key
	      displayQuantity: 3
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Commentary, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      try {
	        /* Check for instance of tweet code in tweet and action if exists. */
	        var myJs = document.getElementById('twitter-wjs');
	        if (myJs == null) {
	          var js = document.createElement('script');
	          js.id = 'twitter-wjs';
	          js.src = '//platform.twitter.com/widgets.js';
	          document.getElementsByTagName('head')[0].appendChild(js);
	        } else {
	          twttr.widgets.load();
	        }
	      } catch (e) {
	        // no empties...
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      try {
	        // Load Twitter widgets upon component update
	        twttr.widgets.load();
	      } catch (e) {
	        // no empties...
	      }
	    }
	  }, {
	    key: 'swapTab',
	    value: function swapTab(sView) {
	      if (sView === 'all' || sView === 'key') {
	        this.setState({ tab: sView });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var aEvents = this.props.events || [];
	      var hText = this.props.text || {};
	      var link = this.props.link || {};
	      var sport = this.props.sport || '';
	      var bShowAll = this.props.showAll === true ? true : false;
	
	      var iEventLen = aEvents.length;
	      var aEventsList = [];
	      var rHeader = null;
	      var rSubHeader = null;
	      var rFooter = null;
	      var sViewName = hText['viewAll'] || '';
	
	      var tryId = 1;
	
	      if (iEventLen === 0) {
	        return null;
	      }
	
	      if (!bShowAll && iEventLen > this.state.displayQuantity) {
	        iEventLen = this.state.displayQuantity;
	      }
	
	      for (var i = 0; i < iEventLen; i++) {
	        var oEvent = aEvents[i];
	        var props = {
	          type: oEvent.type,
	          text: oEvent.text,
	          time: oEvent.time,
	          homeScore: oEvent.homeScore,
	          awayScore: oEvent.awayScore,
	          sport: sport
	        };
	
	        if (this.state.tab !== 'all') {
	          if (sport == 'rugby-league') {
	            if (oEvent.type == 24 || oEvent.type == 26) {
	              tryId = oEvent.type;
	            }
	          }
	          if (oEvent.type == tryId || oEvent.type == 2 || oEvent.type == 3 || oEvent.type == 4 || oEvent.type == 5 || oEvent.type == 6 || oEvent.type == 14) {
	            aEventsList.push(_react2.default.createElement(CommentaryRow, (0, _extends3.default)({ key: i }, props)));
	          }
	        } else {
	          aEventsList.push(_react2.default.createElement(CommentaryRow, (0, _extends3.default)({ key: i }, props)));
	        }
	      }
	
	      if (bShowAll) {
	
	        var aAllBtnClass = ['button-filter-alt', 'lg', 'fixed'];
	        var aKeyBtnClass = ['button-filter-alt', 'lg', 'fixed'];
	
	        if (this.state.tab === 'all') {
	          aAllBtnClass.push('active');
	        } else {
	          aKeyBtnClass.push('active');
	          sViewName = hText['viewKey'] || '';
	        }
	
	        rHeader = _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'button-group', 'data-behavior': 'tabs' },
	            _react2.default.createElement(
	              'a',
	              { className: (0, _classnames2.default)(aAllBtnClass), onClick: this.swapTab.bind(this, 'all') },
	              hText['allBtn'] || ''
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: (0, _classnames2.default)(aKeyBtnClass), onClick: this.swapTab.bind(this, 'key') },
	              hText['keyBtn'] || ''
	            )
	          )
	        );
	
	        rSubHeader = _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            sViewName
	          )
	        );
	      } else {
	        rHeader = _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { style: { textAlign: 'left' } },
	            sViewName
	          )
	        );
	        rFooter = _react2.default.createElement(
	          'footer',
	          null,
	          _react2.default.createElement(_AnchorLink2.default, link)
	        );
	      }
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'sub-module match-commentary', 'data-behavior': 'accordion' },
	        rHeader,
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { id: 'tab1' },
	            rSubHeader,
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'tbody',
	                null,
	                aEventsList
	              )
	            )
	          )
	        ),
	        rFooter
	      );
	    }
	  }]);
	  return Commentary;
	}(_react2.default.Component);
	
	var CommentaryRow = function CommentaryRow(_ref) {
	  var _ref$type = _ref.type,
	      type = _ref$type === undefined ? 0 : _ref$type,
	      _ref$text = _ref.text,
	      text = _ref$text === undefined ? '' : _ref$text,
	      _ref$time = _ref.time,
	      time = _ref$time === undefined ? '' : _ref$time,
	      _ref$homeScore = _ref.homeScore,
	      homeScore = _ref$homeScore === undefined ? 0 : _ref$homeScore,
	      _ref$awayScore = _ref.awayScore,
	      awayScore = _ref$awayScore === undefined ? 0 : _ref$awayScore,
	      _ref$sport = _ref.sport,
	      sport = _ref$sport === undefined ? '' : _ref$sport;
	
	
	  var bShowScore = false;
	  var aIconClass = ['game-icon', 'icon-font-before'];
	
	  var subOnId = 8;
	  var subOffId = 7;
	  var tryId = 1;
	
	  if (sport == 'rugby-league') {
	    subOffId = 17;
	    if (type == 24 || type == 26) {
	      tryId = type;
	    }
	  }
	
	  if (type == tryId || type == 14) {
	    //try or penalty try
	    bShowScore = true;
	    aIconClass.push('icon-rugby-solid-before');
	  } else if (type == 2) {
	    //conversion
	    bShowScore = true;
	    aIconClass.push('icon-rugby-conversion-solid-before');
	  } else if (type == 3) {
	    //penalty kick
	    bShowScore = true;
	    aIconClass.push('icon-rugby-penalty-solid-before');
	  } else if (type == 4) {
	    //drop goal
	    bShowScore = true;
	    aIconClass.push('icon-rugby-drop-goal-solid-before');
	  } else if (type == 5) {
	    //yellow
	    aIconClass.push('icon-soccer-card02-solid-before');
	    aIconClass.push('icon-yellowcard');
	  } else if (type == 6) {
	    aIconClass.push('icon-soccer-card02-solid-before');
	    aIconClass.push('icon-redcard');
	  } else if (type == subOffId || type == subOnId) {
	    aIconClass.push('icon-soccer-substitution-before');
	  } else if (type == 9 || type == 10 || type == 11 || type == 12 || type == 13) {
	    bShowScore = true;
	    aIconClass.push('icon-soccer-foul-solid-before');
	  }
	
	  /* TODO hide icon on mobile so tweets fit properly */
	
	  /* decode back to normal HTML */
	  text = entities.decode(text); //'('+type+') '+
	
	  if (bShowScore) {
	    text = '<span class="current-score">' + homeScore + '-' + awayScore + '</span> ' + text;
	  }
	
	  return _react2.default.createElement(
	    'tr',
	    null,
	    _react2.default.createElement(
	      'td',
	      { className: 'time-stamp' },
	      time
	    ),
	    _react2.default.createElement('td', { className: (0, _classnames2.default)(aIconClass) }),
	    _react2.default.createElement('td', { className: 'game-details', dangerouslySetInnerHTML: { __html: text } })
	  );
	};
	
	exports.default = Commentary;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATS_TABS_FILTER = [{ tab: 'scoring', data: ['tries', 'tryassists', 'conversiongoals', 'penaltygoals', 'dropgoalsconverted', 'points'] }, { tab: 'attacking', data: ['kicks', 'passes', 'runs', 'metres', 'cleanbreaks', 'defendersbeaten', 'offload', 'lineoutwonsteal'] }, { tab: 'defending', data: ['turnoversconceded', 'tackles', 'missedtackles', 'lineoutswon'] }, { tab: 'discipline', data: ['penaltiesconceded', 'yellowcards', 'redcards'] }];
	
	var PlayerTable = function PlayerTable(_ref) {
	  var _ref$team = _ref.team,
	      team = _ref$team === undefined ? {} : _ref$team,
	      _ref$stats = _ref.stats,
	      stats = _ref$stats === undefined ? [] : _ref$stats,
	      _ref$glossary = _ref.glossary,
	      glossary = _ref$glossary === undefined ? {} : _ref$glossary;
	
	
	  var rows = [];
	  var headings = [_react2.default.createElement(
	    'th',
	    { key: 'logo' },
	    _react2.default.createElement('img', { src: team.logo, className: 'imageLoaded' }),
	    ' ',
	    team.name
	  )];
	
	  var players = team.team.concat(team.reserves);
	  var len = players.length;
	  var lenStats = stats.length;
	
	  for (var a = 0; a < len; a++) {
	
	    var player = players[a];
	    var nameParts = (player.name || '').split(' ');
	    var firstChar = (player.name || '')[0];
	    var lastName = nameParts[nameParts.length - 1] || '';
	    var playerName = firstChar + ' ' + lastName;
	
	    var cell = [_react2.default.createElement(
	      'td',
	      { key: player.id },
	      player.url && _react2.default.createElement(
	        'a',
	        { target: '_blank', href: player.url },
	        playerName
	      ) || _react2.default.createElement(
	        'span',
	        null,
	        playerName
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: { fontFamily: 'inherit', paddingLeft: '3px' }, className: 'tooltip icon-font icon-soccer-goal-solid', 'data-tooltip': player.position },
	        player.position
	      )
	    )];
	
	    for (var b = 0; b < lenStats; b++) {
	      cell.push(_react2.default.createElement(
	        'td',
	        { key: b },
	        player[stats[b]].value
	      ));
	
	      if (a === 0) {
	        var headGloss = glossary[stats[b]] || {};
	        headings.push(_react2.default.createElement(
	          'th',
	          { key: b },
	          _react2.default.createElement(
	            'span',
	            { style: { fontFamily: 'inherit', fontWeight: 'inherit' }, className: 'tooltip icon-font icon-soccer-goal-solid', 'data-tooltip': headGloss.desc || headGloss.abbr || '-' },
	            headGloss.abbr || '-'
	          )
	        ));
	      }
	    }
	
	    rows.push(_react2.default.createElement(
	      'tr',
	      { key: 'r.' + a },
	      cell
	    ));
	  }
	
	  return _react2.default.createElement(
	    'table',
	    { className: 'mod-data' },
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        { className: 'header' },
	        headings
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      rows
	    )
	  );
	};
	
	var Tables = function Tables(_ref2) {
	  var _ref2$home = _ref2.home,
	      home = _ref2$home === undefined ? {} : _ref2$home,
	      _ref2$away = _ref2.away,
	      away = _ref2$away === undefined ? {} : _ref2$away,
	      _ref2$stats = _ref2.stats,
	      stats = _ref2$stats === undefined ? [] : _ref2$stats,
	      _ref2$team = _ref2.team,
	      team = _ref2$team === undefined ? [] : _ref2$team,
	      _ref2$glossary = _ref2.glossary,
	      glossary = _ref2$glossary === undefined ? {} : _ref2$glossary;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'table-wrap' + (team === 'home' ? ' active' : '') },
	      _react2.default.createElement(PlayerTable, { team: home, stats: stats, glossary: glossary })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'table-wrap' + (team === 'away' ? ' active' : '') },
	      _react2.default.createElement(PlayerTable, { team: away, stats: stats, glossary: glossary })
	    )
	  );
	};
	
	var PlayerStats = function (_React$Component) {
	  (0, _inherits3.default)(PlayerStats, _React$Component);
	
	  function PlayerStats(props) {
	    (0, _classCallCheck3.default)(this, PlayerStats);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PlayerStats.__proto__ || (0, _getPrototypeOf2.default)(PlayerStats)).call(this, props));
	
	    _this.state = {
	      selected: 'scoring',
	      selectedTeam: 'home'
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(PlayerStats, [{
	    key: 'clickHandler',
	    value: function clickHandler(selected) {
	      this.setState({
	        selected: selected
	      });
	    }
	  }, {
	    key: 'switchTeam',
	    value: function switchTeam(team) {
	      this.setState({
	        selectedTeam: team
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var home = this.props.home || {};
	      var away = this.props.away || {};
	      var text = this.props.text || {};
	      var sport = this.props.sport || 'rugby';
	      var iLen = STATS_TABS_FILTER.length || 0;
	      var selected = this.state.selected;
	      var stats = [];
	      var tabsList = [];
	
	      for (var i = 0, l = iLen; i < l; i++) {
	        var tabInfo = STATS_TABS_FILTER[i];
	        var props = {};
	        if (selected === tabInfo.tab) {
	          props.className = 'active';
	          stats = tabInfo.data;
	          if (selected == 'defending' && sport == 'rugby-league') {
	            stats = ['turnoversconceded', 'tackles', 'missedtackles'];
	          } else if (selected == 'attacking' && sport == 'rugby-league') {
	            stats = ['kicks', 'passes', 'runs', 'metres', 'cleanbreaks', 'defendersbeaten', 'offload'];
	          }
	        }
	        tabsList.push(_react2.default.createElement(
	          'li',
	          (0, _extends3.default)({ onClick: this.clickHandler.bind(this, tabInfo.tab), key: tabInfo.tab }, props),
	          _react2.default.createElement(
	            'span',
	            null,
	            text[tabInfo.tab] || '-'
	          )
	        ));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sub-module tabbedTable', style: { overflowX: 'auto' } },
	        _react2.default.createElement(
	          'header',
	          { className: 'hidden-sm hidden-md hidden-lg' },
	          _react2.default.createElement(
	            'div',
	            { className: 'filter form-group button-group' },
	            _react2.default.createElement(
	              'button',
	              { onClick: this.switchTeam.bind(this, 'home'), className: 'button-filter-alt lg fixed' + (this.state.selectedTeam === 'home' ? ' active' : '') },
	              _react2.default.createElement(
	                'span',
	                { className: 'team-name' },
	                home.name
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              { onClick: this.switchTeam.bind(this, 'away'), className: 'button-filter-alt lg fixed' + (this.state.selectedTeam === 'away' ? ' active' : '') },
	              _react2.default.createElement(
	                'span',
	                { className: 'team-name' },
	                away.name
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tab-container alt' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'tabs alt', 'data-behavior': 'tabs_transform' },
	            tabsList
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tab-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-pane' + this.state.selected == 'scoring' ? ' active' : '' },
	            _react2.default.createElement(Tables, { team: this.state.selectedTeam, home: home, away: away, stats: stats, glossary: this.props.glossary })
	          )
	        )
	      );
	    }
	  }]);
	  return PlayerStats;
	}(_react2.default.Component);
	
	exports.default = PlayerStats;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Glossary = function Glossary(_ref) {
	  var _ref$glossary = _ref.glossary,
	      glossary = _ref$glossary === undefined ? {} : _ref$glossary;
	
	
	  var list = [];
	  for (var key in glossary) {
	    list.push(_react2.default.createElement('li', { key: key, dangerouslySetInnerHTML: { __html: '<span>' + glossary[key].abbr + ': </span>' + glossary[key].desc } }));
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'sub-module' },
	    _react2.default.createElement(
	      'div',
	      { className: 'glossary comp' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Glossary'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        list
	      )
	    )
	  );
	};
	
	exports.default = Glossary;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(440);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _AnchorLink = __webpack_require__(682);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	var _createReactClass = __webpack_require__(691);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamName = function TeamName(_ref) {
	  var _ref$team = _ref.team,
	      team = _ref$team === undefined ? [] : _ref$team,
	      _ref$isTeamLinkActive = _ref.isTeamLinkActive,
	      isTeamLinkActive = _ref$isTeamLinkActive === undefined ? false : _ref$isTeamLinkActive,
	      _ref$isWebView = _ref.isWebView,
	      isWebView = _ref$isWebView === undefined ? false : _ref$isWebView;
	
	  // if isTeamLinkActive is true wrap team names in anchor tag
	  var teamNameText = [_react2.default.createElement(
	    'span',
	    { key: 'long-name', className: 'long-name' },
	    team.name || team.abbreviation
	  ), _react2.default.createElement(
	    'abbr',
	    { key: 'abbr' },
	    team.abbreviation
	  )];
	  var teamLinkComp = _react2.default.createElement(
	    _AnchorLink2.default,
	    (0, _extends3.default)({ key: 'n' }, team.link),
	    teamNameText
	  );
	  var defaultLinkProps = {};
	  if (isWebView && team.uid !== '') {
	    defaultLinkProps = { 'data-uid': team.uid, 'className': 'app_partial', 'data-linktype': 'clubhouse' };
	    teamLinkComp = _react2.default.createElement(
	      'a',
	      (0, _extends3.default)({ key: 'n1' }, defaultLinkProps),
	      teamNameText
	    );
	  }
	  return isTeamLinkActive ? isWebView ? teamLinkComp : _react2.default.createElement(
	    _AnchorLink2.default,
	    (0, _extends3.default)({ key: 'n' }, team.link),
	    teamNameText
	  ) : _react2.default.createElement(
	    'div',
	    { key: 'n' },
	    teamNameText
	  );
	};
	
	var TeamLogo = function TeamLogo(_ref2) {
	  var _ref2$team = _ref2.team,
	      team = _ref2$team === undefined ? [] : _ref2$team,
	      _ref2$isTeamLinkActiv = _ref2.isTeamLinkActive,
	      isTeamLinkActive = _ref2$isTeamLinkActiv === undefined ? false : _ref2$isTeamLinkActiv,
	      _ref2$isWebView = _ref2.isWebView,
	      isWebView = _ref2$isWebView === undefined ? false : _ref2$isWebView;
	
	  // if isTeamLinkActive is true wrap team logos in anchor tag
	  var teamLogoImg = _react2.default.createElement('img', { key: 'tli', src: team.logo });
	  var teamLinkComp = _react2.default.createElement(
	    _AnchorLink2.default,
	    (0, _extends3.default)({ key: 'l' }, team.link),
	    teamLogoImg
	  );
	  var defaultLinkProps = {};
	  if (isWebView && team.uid !== '') {
	    defaultLinkProps = { 'data-uid': team.uid, 'className': 'app_partial', 'data-linktype': 'clubhouse' };
	    teamLinkComp = _react2.default.createElement(
	      'a',
	      (0, _extends3.default)({ key: 'n2' }, defaultLinkProps),
	      teamLogoImg
	    );
	  }
	  return isTeamLinkActive ? isWebView ? teamLinkComp : _react2.default.createElement(
	    _AnchorLink2.default,
	    (0, _extends3.default)({ key: 'l2' }, team.link),
	    teamLogoImg
	  ) : teamLogoImg;
	};
	
	var TableBody = (0, _createReactClass2.default)({
	  displayName: 'TableBody',
	
	  render: function render() {
	
	    var data = this.props.data || [];
	    var tableRows = [];
	    var classNames = {
	      W: 'win',
	      L: 'loss',
	      D: ''
	    };
	    var isWebView = this.props.isWebView;
	
	    var isTeamLinkActive = this.props.isTeamLinkActive;
	    data.map(function (game, i) {
	      var gameResult = null;
	      if (!this.props.head2head) {
	        gameResult = _react2.default.createElement(
	          'td',
	          { className: classNames[game.result] },
	          game.resultValue
	        );
	      }
	      tableRows.push(_react2.default.createElement(
	        'tr',
	        { key: 'game.' + i },
	        gameResult,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(TeamName, { team: game.home, isTeamLinkActive: isTeamLinkActive, isWebView: isWebView })
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'logo' },
	          _react2.default.createElement(TeamLogo, { team: game.home, isTeamLinkActive: isTeamLinkActive, isWebView: isWebView })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _AnchorLink2.default,
	            game.link,
	            game.score
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'logo' },
	          _react2.default.createElement(TeamLogo, { team: game.away, isTeamLinkActive: isTeamLinkActive, isWebView: isWebView })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(TeamName, { team: game.away, isTeamLinkActive: isTeamLinkActive, isWebView: isWebView })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          (0, _moment2.default)(game.date.replace('Z', '')).utcOffset(0).format('Do MMM, YYYY')
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          game.league
	        )
	      ));
	    }.bind(this));
	
	    return _react2.default.createElement(
	      'tbody',
	      null,
	      tableRows
	    );
	  }
	});
	
	var MatchHistory = (0, _createReactClass2.default)({
	  displayName: 'MatchHistory',
	
	
	  render: function render() {
	
	    var data = this.props.data || [];
	    var team = this.props.team || {};
	    var text = this.props.text || {};
	    var teamLogo = team.logo;
	    var isTeamLinkActive = this.props.isTeamLinkActive;
	    var isWebView = this.props.isWebView;
	
	    if (this.props.head2head) {
	      teamLogo = data && data[0] && data[0].home.logo;
	    }
	
	    /* react wraps a span around the word so lets force it as it breaks the css*/
	    var sDisplayTitle = this.props.head2head ? text.title : '<img src="' + teamLogo + '" />' + text.title;
	    return _react2.default.createElement(
	      'div',
	      { className: 'sub-module last-games soccer' + (this.props.head2head ? ' head-to-head' : '') },
	      _react2.default.createElement(
	        'header',
	        { className: '' },
	        _react2.default.createElement('h1', { dangerouslySetInnerHTML: { __html: sDisplayTitle } })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'content', style: { overflowX: 'auto' } },
	        _react2.default.createElement(
	          'table',
	          { 'data-fix-cols': '0', 'data-behavior': 'responsive_table' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { colSpan: this.props.head2head ? 5 : 6 },
	                text.col1
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                text.col2
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                text.col3
	              )
	            )
	          ),
	          data.length ? _react2.default.createElement(TableBody, { head2head: this.props.head2head, data: data, isTeamLinkActive: isTeamLinkActive, isWebView: isWebView }) : _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                { colSpan: '8' },
	                'No data available'
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	module.exports = MatchHistory;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCricketView = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(412);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__(406);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _VideoGrid = __webpack_require__(807);
	
	var _VideoGrid2 = _interopRequireDefault(_VideoGrid);
	
	var _PlayersToWatch = __webpack_require__(804);
	
	var _HeadToHead = __webpack_require__(806);
	
	var _MatchCards = __webpack_require__(825);
	
	var _index = __webpack_require__(826);
	
	var _Statistics = __webpack_require__(834);
	
	var _Charts = __webpack_require__(843);
	
	var _Partnerships = __webpack_require__(835);
	
	var _common = __webpack_require__(686);
	
	var _api = __webpack_require__(366);
	
	var _utils = __webpack_require__(669);
	
	var _cricket = __webpack_require__(668);
	
	var _GameBreak = __webpack_require__(845);
	
	var _GameHeader = __webpack_require__(684);
	
	var _common2 = __webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generate the Game package view for Cricket
	 * @param  {String} options.pageType PageType
	 * @param  {Object} options.state    Application state
	 * @return {Object}                  Arrays having React components for each column
	 */
	var getCricketView = exports.getCricketView = function getCricketView(_ref) {
	  var _ref$pageType = _ref.pageType,
	      pageType = _ref$pageType === undefined ? 'game' : _ref$pageType,
	      _ref$state = _ref.state,
	      state = _ref$state === undefined ? {} : _ref$state,
	      params = _ref.params,
	      query = _ref.query;
	
	
	  var appView = '';
	  var excludeVal = ['m', 's'];
	  var isCricinfoAsia = (0, _selectn2.default)('edition.isAsiaRegion', state) || false;
	  var isEspnCricinfo = (0, _selectn2.default)('edition.isEspnCricinfo', state) || false;
	  var editionDomain = (0, _selectn2.default)('edition.domain', state) || '';
	  var bet365Kiosk = (0, _common2.isBet365KioskEdition)(state.edition);
	  var matchFlags = (0, _selectn2.default)('matchFlags', state);
	  var playerOfTheMatch = (0, _selectn2.default)('matchDetails.playerOfMatch', state);
	  var typeOfDevice = (0, _selectn2.default)('appProps.device', state) || {};
	  var _state$gameStrip = state.gameStrip,
	      gameStrip = _state$gameStrip === undefined ? {} : _state$gameStrip,
	      _state$gameStateClass = state.gameStateClassMobile,
	      gameStateClassMobile = _state$gameStateClass === undefined ? '' : _state$gameStateClass,
	      _state$links = state.links,
	      links = _state$links === undefined ? [] : _state$links,
	      _state$summary = state.summary,
	      summary = _state$summary === undefined ? '' : _state$summary,
	      _state$showGameDetail = state.showGameDetailFooter,
	      showGameDetailFooter = _state$showGameDetail === undefined ? false : _state$showGameDetail,
	      _state$innings = state.innings,
	      innings = _state$innings === undefined ? {} : _state$innings,
	      _state$gameState = state.gameState,
	      gameState = _state$gameState === undefined ? '' : _state$gameState,
	      _state$watchESPNLink = state.watchESPNLink,
	      watchESPNLink = _state$watchESPNLink === undefined ? {} : _state$watchESPNLink,
	      isWebView = state.isWebView,
	      adblock = state.adblock;
	
	  var gameHeaderProps = {
	    gameStrip: gameStrip,
	    sport: params.sport,
	    gameStateClassMobile: gameStateClassMobile,
	    links: links,
	    pageType: pageType,
	    summaryText: summary,
	    showGameDetailFooter: showGameDetailFooter,
	    innings: innings,
	    gameState: gameState,
	    matchFlags: matchFlags,
	    playerOfTheMatch: playerOfTheMatch,
	    watchESPNLink: watchESPNLink,
	    isWebView: isWebView,
	    device: typeOfDevice
	  };
	  var gameheader = _react2.default.createElement(_GameHeader.GameHeader, gameHeaderProps);
	  var gameheaderFull = _react2.default.createElement(_GameHeader.GameHeader, (0, _extends3.default)({ key: 'ghf', fullWidth: true }, gameHeaderProps));
	  var highlightsVideoCount = (0, _selectn2.default)('videoSlider.videos.length', state);
	
	  var mobileAdPlaceholder = [_react2.default.createElement(_common.Ad, { key: 'gs-ad-m1', id: 'banner', className: 'react-ad ad-banner-mobile ad-wrapper', slotType: 'banner', kvpos: 'top', include: ['s'], isAdBlock: adblock }), isCricinfoAsia && _react2.default.createElement(_common.Ad, { key: 'gs-ad-m2', id: 'presbymobile', className: 'react-ad ad-slot-presby ad-wrapper', slotType: 'presbyMobile', kvpos: 'top', include: ['s'], isAdBlock: adblock })];
	
	  var mobileIncontentAd = _react2.default.createElement(_common.Ad, { key: 'gs-ad-4', id: 'mpu', className: 'ad-slot-independent ad-slot-mobile-incontent ad-wrapper', slotType: 'incontent', kvpos: 'top', inView: 'true', include: ['s', 'm'], isAdBlock: adblock });
	  if (state.isWebView) {
	    mobileIncontentAd = _react2.default.createElement(_common.Ad, { key: 'gs-ad-4', id: 'mpu', className: 'ad-slot-inview ad-slot-mobile-incontent ad-wrapper', slotType: 'incontent', kvpos: 'top', include: ['s', 'm'], isAdBlock: adblock });
	  }
	
	  var mpuIndex = (0, _common2.getMpuIndex)(highlightsVideoCount, state.standings, state.matchcards, state.news) || 4;
	
	  var nativeAdSlotsAsia = [];
	  if (isCricinfoAsia) {
	    nativeAdSlotsAsia = [_react2.default.createElement(_common.Ad, { key: 'native2', className: 'sub-module ad-slot-independent ad-slot-native ad-wrapper', slotType: 'native2', inView: 'true', exclude: excludeVal, isAdBlock: adblock }), _react2.default.createElement(_common.Ad, { key: 'native3', className: 'sub-module ad-slot-independent ad-slot-native ad-wrapper', slotType: 'native3', inView: 'true', exclude: excludeVal, isAdBlock: adblock }), _react2.default.createElement(_common.Ad, { key: 'native4', className: 'sub-module ad-slot-independent ad-slot-native ad-wrapper', slotType: 'native4', inView: 'true', exclude: excludeVal, isAdBlock: adblock }), _react2.default.createElement(_common.Ad, { key: 'native5', className: 'sub-module ad-slot-independent ad-slot-native ad-wrapper', slotType: 'native5', inView: 'true', exclude: excludeVal, isAdBlock: adblock })];
	  }
	
	  var columnThree = [bet365Kiosk && _react2.default.createElement(
	    'div',
	    { key: 'kiosk-ad', className: 'sub-module' },
	    _react2.default.createElement(_common.Ad, { id: 'bet365', className: 'ad-slot-incontent-strip ad-wrapper', slotType: 'incontentstrip', kvpos: 'top', exclude: excludeVal, isAdBlock: adblock })
	  ), isEspnCricinfo && _react2.default.createElement(
	    'div',
	    { key: 'adinstr', className: 'sub-module' },
	    _react2.default.createElement(_common.Ad, { id: 'instrip', className: 'ad-slot-incontent-strip ad-wrapper', slotType: 'incontentstrip', kvpos: 'top', exclude: excludeVal, isAdBlock: adblock })
	  ), _react2.default.createElement(
	    'div',
	    { key: 'ad', className: 'sub-module' },
	    _react2.default.createElement(_common.Ad, { id: 'mpu', className: 'ad-slot-incontent ad-wrapper', slotType: 'incontent', kvpos: 'top', exclude: excludeVal, isAdBlock: adblock })
	  ), isCricinfoAsia && _react2.default.createElement(_common.Ad, { key: 'promoad', className: 'sub-module ad-slot-independent ad-slot-promobox ad-wrapper', slotType: 'promobox', inView: 'true', kvpos: 'top', exclude: excludeVal, isAdBlock: adblock }), _react2.default.createElement(_MatchCards.MatchCardSlider, { key: 'mc', title: 'Match Cards', matchcards: state.matchcards }), _react2.default.createElement(_common.StandingsModule, (0, _extends3.default)({ key: 's', title: 'Cricket Table' }, state.standings)), _react2.default.createElement(_common.Ad, { key: 'native1', className: 'sub-module ad-slot-independent ad-slot-native ad-wrapper', slotType: 'native1', inView: 'true', exclude: excludeVal, isAdBlock: adblock })].concat((0, _toConsumableArray3.default)(nativeAdSlotsAsia));
	
	  // Hide match top videos module in the 3rd column on video page, and for tablet
	  if (pageType !== 'video') {
	    typeOfDevice.desktop && highlightsVideoCount && columnThree.splice(3, 0, _react2.default.createElement(_common.TopHighlights, (0, _extends3.default)({}, state.videoSlider, { title: 'Videos' })));
	  }
	
	  // Hide match coverage module in the 3rd column on coverage page
	  if (pageType !== 'coverage') {
	    var insertIndex = 5;
	    if (pageType === 'video') {
	      insertIndex = 3;
	    }
	    columnThree.splice(insertIndex, 0, _react2.default.createElement(_common.NewsModule, (0, _extends3.default)({ key: 'nm', title: 'Match Coverage' }, state.news)));
	  }
	
	  columnThree.splice(mpuIndex, 0, _react2.default.createElement(_common.Ad, { key: 'mpu2', className: 'sub-module ad-slot-independent ad-slot-incontent ad-wrapper', slotType: 'incontent2', kvpos: 'bottom', inView: 'true', exclude: excludeVal, isAdBlock: adblock }));
	
	  switch (pageType) {
	    case 'game':
	    case 'match':
	      appView = getSummary({ state: state, columnThree: columnThree, params: params, query: query, isCricinfoAsia: isCricinfoAsia, gameheader: gameheader, mobileAdPlaceholder: mobileAdPlaceholder, editionDomain: editionDomain, mobileIncontentAd: mobileIncontentAd });
	      break;
	
	    case 'scorecard':
	      appView = getScorecard({ state: state, columnThree: columnThree, isCricinfoAsia: isCricinfoAsia, gameheader: gameheader, mobileAdPlaceholder: mobileAdPlaceholder, mobileIncontentAd: mobileIncontentAd });
	      break;
	
	    case 'commentary':
	      appView = getCommentary({ state: state, columnThree: columnThree, showFilters: true, params: params, query: query, isCricinfoAsia: isCricinfoAsia, gameheader: gameheader, mobileAdPlaceholder: mobileAdPlaceholder, editionDomain: editionDomain, mobileIncontentAd: mobileIncontentAd });
	      break;
	
	    case 'statistics':
	      appView = getStatistics({ state: state, columnThree: columnThree, isCricinfoAsia: isCricinfoAsia, gameheader: gameheader, mobileAdPlaceholder: mobileAdPlaceholder, mobileIncontentAd: mobileIncontentAd });
	      break;
	
	    case 'video':
	      appView = getVideos({ state: state, columnThree: columnThree, params: params, query: query, gameheader: gameheader, mobileAdPlaceholder: mobileAdPlaceholder });
	      break;
	
	    case 'coverage':
	      appView = getMatchCoverage({ state: state, columnThree: columnThree, gameheader: gameheader, mobileAdPlaceholder: mobileAdPlaceholder });
	      break;
	
	    case 'preview':
	      appView = getArticleContent({ state: state, columnThree: columnThree, gameheader: gameheader, mobileAdPlaceholder: mobileAdPlaceholder });
	      break;
	
	    case 'report':
	      appView = getArticleContent({ state: state, columnThree: columnThree, gameheader: gameheader, mobileAdPlaceholder: mobileAdPlaceholder });
	      break;
	
	    case 'hawkeye':
	      appView = getHawkEye({ state: state, columnThree: columnThree, gameheader: gameheader, mobileAdPlaceholder: mobileAdPlaceholder });
	      break;
	  }
	
	  return [gameheaderFull, appView];
	};
	
	var getArticleContent = function getArticleContent(_ref2) {
	  var state = _ref2.state,
	      columnThree = _ref2.columnThree,
	      gameheader = _ref2.gameheader,
	      mobileAdPlaceholder = _ref2.mobileAdPlaceholder;
	
	  return _react2.default.createElement(
	    'div',
	    { key: 'a', className: 'main-content react-content' },
	    _react2.default.createElement(
	      'div',
	      { id: 'gamepackage-wrap' },
	      _react2.default.createElement(
	        'div',
	        { id: 'gamepackage-content-wrap', className: 'layout-bc' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-b' },
	          gameheader,
	          mobileAdPlaceholder,
	          _react2.default.createElement(_index.Article, { article: state.article })
	        ),
	        !state.isMobile && _react2.default.createElement(
	          'section',
	          { className: 'col-c' },
	          columnThree
	        )
	      )
	    )
	  );
	};
	
	var getSummary = function getSummary(_ref3) {
	  var state = _ref3.state,
	      columnThree = _ref3.columnThree,
	      params = _ref3.params,
	      query = _ref3.query,
	      isCricinfoAsia = _ref3.isCricinfoAsia,
	      gameheader = _ref3.gameheader,
	      mobileAdPlaceholder = _ref3.mobileAdPlaceholder,
	      editionDomain = _ref3.editionDomain,
	      mobileIncontentAd = _ref3.mobileIncontentAd;
	
	  var stateTypeId = parseInt(state.stateTypeId, 10);
	  var isLimitedOvers = (0, _selectn2.default)('matchFlags.limitedOvers', state);
	  var isUpdatesOnly = (0, _selectn2.default)('matchFlags.updatesOnly', state);
	  var partCommentary = (0, _selectn2.default)('partCommentary', state) || {};
	  var commentPreText = (0, _selectn2.default)('partCommentary.commentPreText', state) || '';
	  var bowlingStarted = ((0, _selectn2.default)('partCommentary.overs', state) || []).length > 0;
	  var adblock = (0, _selectn2.default)('adblock', state) || false;
	
	  var isCommentaryAvailable = false;
	  if (bowlingStarted || commentPreText.length > 0) {
	    isCommentaryAvailable = true;
	  }
	
	  var updatesOnlyComms = isUpdatesOnly && isCommentaryAvailable;
	  var scoringSourceFeedback = (0, _selectn2.default)('scoringSource.isFeedback', state);
	  var videoSlider = state.videoSlider || {};
	  var _videoSlider$articleV = videoSlider.articleVideos,
	      articleVideos = _videoSlider$articleV === undefined ? [] : _videoSlider$articleV,
	      _videoSlider$videos = videoSlider.videos,
	      videos = _videoSlider$videos === undefined ? [] : _videoSlider$videos,
	      videoSliderRest = (0, _objectWithoutProperties3.default)(videoSlider, ['articleVideos', 'videos']);
	
	  var activePlayer = (0, _selectn2.default)('innings.activePlayers', state) || [];
	
	  var isDesktop = true;
	  if (process.browser) {
	    var device = (0, _common2.deviceType)() || {};
	    isDesktop = device.isDesktop || device.isDesktopXX;
	  } else {
	    isDesktop = (0, _selectn2.default)('appProps.device.desktop', state);
	  }
	  var isTablet = (0, _selectn2.default)('appProps.device.tablet', state) || false;
	  videos = isDesktop && !isTablet ? articleVideos : videos;
	  var topStoriesClassName = isDesktop && !isTablet ? 'single-video' : '';
	  var groundTime = (0, _selectn2.default)('partCommentary.groundTime', state);
	  var scorer = (0, _selectn2.default)('partCommentary.scorer', state);
	  var commentator = (0, _selectn2.default)('partCommentary.commentator', state);
	
	  var commsNts = [_react2.default.createElement(_common.TopStories, (0, _extends3.default)({ key: 't' }, videoSliderRest, { videos: videos, content: state.article, className: topStoriesClassName })), isCricinfoAsia && videos.length > 0 && _react2.default.createElement(_common.Ad, { key: 'gs-ad-m3', id: 'banner', className: 'react-ad ad-banner-mobile ad-wrapper', slotType: 'banner', include: ['s'], kvpos: 'bottom', isAdBlock: adblock })];
	
	  if (state.gameState === 'pregame' && commentPreText) {
	    commsNts.shift();
	  }
	
	  // default columns 'pre' state
	  var columnSmall = [_react2.default.createElement(_index.SquadTabs, (0, _extends3.default)({ key: 'st' }, state.rosters)), _react2.default.createElement(_index.SquadModule, (0, _extends3.default)({ key: 's' }, state.rosters)), _react2.default.createElement(_index.MatchDetails, (0, _extends3.default)({ key: 'm' }, state.matchDetails))];
	
	  var columnB = [].concat(commsNts);
	
	  var columnLarge = [_react2.default.createElement(_index.Commentary, (0, _extends3.default)({ key: 'c' }, partCommentary, { isPartCommentary: true, showFooter: !updatesOnlyComms, showFilters: false, bet365: state.bet365, editionDomain: editionDomain, gameState: state.gameState, isSmallDevice: state.isSmallDevice })), commentPreText && _react2.default.createElement(_index.CommentaryFeedback, (0, _extends3.default)({ isUpdatesOnly: isUpdatesOnly, key: 'cfb', gameId: params.gameId, postCommentryFeedback: state.postCommentryFeedback }, state.commentaryFeedback)), _react2.default.createElement(_PlayersToWatch.PlayersToWatch, { key: 'p', roles: state.playersToWatch }), _react2.default.createElement(_HeadToHead.HeadToHead, (0, _extends3.default)({ key: 'h' }, state.headToHead, { sport: 'cricket', isWebView: state.isWebView }))];
	
	  switch (state.gameState) {
	    case 'live':
	      columnSmall = [!state.isMobile && scoringSourceFeedback && _react2.default.createElement(_Statistics.Statistics, (0, _extends3.default)({ key: 's' }, state.statistics, { showFooter: true, gameState: state.gameState })), !bowlingStarted && _react2.default.createElement(_index.SquadTabs, (0, _extends3.default)({ key: 'st' }, state.rosters)), !bowlingStarted && _react2.default.createElement(_index.SquadModule, (0, _extends3.default)({ key: 's' }, state.rosters)), _react2.default.createElement(_index.MatchDetails, (0, _extends3.default)({ key: 'm' }, state.matchDetails))];
	      columnB = [_react2.default.createElement(_index.InningsSummary, (0, _extends3.default)({ key: 'i' }, state.innings, { isSmallDevice: state.isSmallDevice, updateDeviceType: updateDeviceType(state.dispatch), isWebView: state.isWebView, isLimitedOvers: isLimitedOvers, bet365: state.bet365, editionDomain: editionDomain, groundTime: groundTime })), isDesktop && _react2.default.createElement(_GameBreak.GameBreak, { key: 'gb', gamebreak: state.ads.gamebreak, gamestatus: state.gameStateClass, gamebreakstatus: state.gameBreakStatus, params: params, query: query }), !isDesktop && _react2.default.createElement(_common.TopStories, (0, _extends3.default)({ key: 't' }, videoSliderRest, { videos: videoSlider.highlightVideos, showFooter: true, title: 'Video highlights', className: topStoriesClassName })), isCricinfoAsia && activePlayer.length > 0 && _react2.default.createElement(_common.Ad, { key: 'gs-ad-3', id: 'banner', className: 'react-ad ad-banner-mobile ad-wrapper', slotType: 'banner', include: ['s'], kvpos: 'bottom', isAdBlock: adblock })];
	      columnLarge = [_react2.default.createElement(_index.Commentary, (0, _extends3.default)({ key: 'c' }, state.partCommentary, { showFooter: !updatesOnlyComms, showFilters: false, isPartCommentary: true, isWebView: state.isWebView, isLimitedOvers: isLimitedOvers, bet365: state.bet365, editionDomain: editionDomain, gameState: state.gameState, isSmallDevice: state.isSmallDevice })), _react2.default.createElement(_index.CommentaryFeedback, (0, _extends3.default)({ isUpdatesOnly: isUpdatesOnly, key: 'cfb', gameId: params.gameId, postCommentryFeedback: state.postCommentryFeedback }, state.commentaryFeedback))];
	      break;
	
	    case 'final':
	      columnSmall = [!state.isMobile && scoringSourceFeedback && _react2.default.createElement(_Statistics.Statistics, (0, _extends3.default)({ titles: { batsmen: 'Best performances - Batsmen', bowlers: 'Best performances - Bowlers' }, key: 's' }, state.statistics, { showFooter: true })), _react2.default.createElement(_index.MatchDetails, (0, _extends3.default)({ key: 'm' }, state.matchDetails))];
	      columnB = [_react2.default.createElement(_common.TopStories, (0, _extends3.default)({ key: 't' }, videoSliderRest, { videos: videos, content: state.article, className: topStoriesClassName })), isCricinfoAsia && _react2.default.createElement(_common.Ad, { key: 'gs-ad-1', id: 'banner', className: 'react-ad ad-banner-mobile ad-wrapper', slotType: 'banner', include: ['s'], kvpos: 'bottom', isAdBlock: adblock })];
	      columnLarge = [_react2.default.createElement(_index.ScorecardSummary, (0, _extends3.default)({ key: 'ss' }, state.scorecardSummary, { isLimitedOvers: isLimitedOvers })), !isUpdatesOnly && _react2.default.createElement(_index.Commentary, (0, _extends3.default)({ key: 'c', gameState: state.gameState }, state.partCommentary, { showFooter: true, showFilters: false, isPartCommentary: true, isWebView: state.isWebView, isLimitedOvers: isLimitedOvers, bet365: state.bet365, editionDomain: editionDomain }))];
	      break;
	  }
	
	  /*
	     Description for each game state id
	    1 | won
	    2 | lost
	    3 | match tied
	    4 | match drawn
	    5 | no result
	    6 | match abandoned without a ball bowled
	    7 | match cancelled without a ball bowled
	     'Drinks' => 100,
	    'Match delayed by rain' => 101,
	    'Match delayed by a wet outfield' => 102,
	    'Innings break' => 103,
	    'Match delayed by bad light' => 104,
	    'Match delayed by a wet pitch' => 105,
	    'Lunch' => 106,
	    'Match delayed by bad weather' => 107,
	    'Match delayed by a floodlight failure' => 108,
	    'Tea' => 109,
	    'Dinner' => 110,
	    'Match delayed' => 111,
	    'Stumps' => 112
	   */
	
	  // If match is abandoned, show squads
	  if (stateTypeId === 6) {
	    columnSmall.unshift(_react2.default.createElement(_index.SquadTabs, (0, _extends3.default)({ key: 'sq' }, state.rosters)));
	  }
	
	  //ground time only for Pre match
	  var printGroundTime = '';
	  if (state.gameState === 'pregame' && groundTime) {
	    printGroundTime = '<span>Ground time: ' + groundTime + '</span>';
	  }
	  var innerWrapperFooter = [mobileIncontentAd, _react2.default.createElement(_common.Outbrain, (0, _extends3.default)({ key: 'ob' }, state.outbrainSettings, { url: state.pageURL }))];
	  var innerWrapper = [_react2.default.createElement(
	    'div',
	    { className: 'inner-wrapper' },
	    _react2.default.createElement(
	      'header',
	      { className: 'inner-header bordered' },
	      _react2.default.createElement('h1', { dangerouslySetInnerHTML: { __html: 'Match Centre ' + printGroundTime } }),
	      (scorer || commentator) && state.gameState !== 'final' && !state.isMobile && _react2.default.createElement(_index.Scorers, { scorer: scorer, commentator: commentator }) || null
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'inner-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-small inner' },
	        columnSmall
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-large inner' },
	        columnLarge
	      ),
	      innerWrapperFooter
	    )
	  )];
	  var squadsAvailable = (0, _selectn2.default)('rosters.isAvailable', state);
	  var headToHeadAvailable = (0, _selectn2.default)('headToHead.isAvailable', state);
	  var playersToWatchAvailable = (0, _selectn2.default)('playersToWatch.isAvailable', state);
	  var scorecardSummaryAvailable = (0, _selectn2.default)('scorecardSummary.isAvailable', state);
	  var statisticsAvailable = (0, _selectn2.default)('statistics.enabled', state);
	  var preGameModules = state.gameState === 'pregame' && !squadsAvailable && !headToHeadAvailable && !playersToWatchAvailable && !isCommentaryAvailable || false;
	  var liveGameModules = state.gameState === 'live' && !statisticsAvailable && !isCommentaryAvailable || false;
	  var postGameModules = state.gameState === 'final' && !scorecardSummaryAvailable && !statisticsAvailable && !isCommentaryAvailable || false;
	  // show bronze layout if no modules available in match center
	  var showBronzeLayout = preGameModules || liveGameModules || postGameModules;
	  if (showBronzeLayout) {
	    innerWrapper = [_react2.default.createElement(_index.MatchDetails, (0, _extends3.default)({ key: 'm' }, state.matchDetails))].concat(innerWrapperFooter);
	  }
	  return _react2.default.createElement(
	    'div',
	    { key: 'bc', className: 'layout-bc' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-b' },
	      gameheader,
	      mobileAdPlaceholder,
	      columnB,
	      innerWrapper
	    ),
	    !state.isMobile && _react2.default.createElement(
	      'div',
	      { className: 'col-c' },
	      columnThree
	    )
	  );
	};
	
	var getScorecard = function getScorecard(_ref4) {
	  var state = _ref4.state,
	      columnThree = _ref4.columnThree,
	      isCricinfoAsia = _ref4.isCricinfoAsia,
	      gameheader = _ref4.gameheader,
	      mobileAdPlaceholder = _ref4.mobileAdPlaceholder,
	      mobileIncontentAd = _ref4.mobileIncontentAd;
	
	  return _react2.default.createElement(
	    'div',
	    { key: 'bc', className: 'layout-bc' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-b' },
	      gameheader,
	      mobileAdPlaceholder,
	      _react2.default.createElement(_index.Innings, (0, _extends3.default)({ key: 'im' }, state.scorecard, { isWebView: state.isWebView, isSmallDevice: state.isSmallDevice, rosters: state.rosters, gameState: state.gameStateActual })),
	      isCricinfoAsia && _react2.default.createElement(_common.Ad, { key: 'gs-ad-3', id: 'banner', className: 'react-ad ad-banner-mobile ad-wrapper', slotType: 'banner', include: ['s'], kvpos: 'bottom', isAdBlock: state.adblock }),
	      _react2.default.createElement(_index.MatchDetails, (0, _extends3.default)({ key: 'md' }, state.matchDetails)),
	      _react2.default.createElement(_index.CloseOfPlay, state.closeOfPlay),
	      _react2.default.createElement(_index.MatchNotes, state.noteGroups),
	      mobileIncontentAd,
	      _react2.default.createElement(_common.Outbrain, (0, _extends3.default)({}, state.outbrainSettings, { url: state.pageURL }))
	    ),
	    !state.isMobile && _react2.default.createElement(
	      'div',
	      { className: 'col-c' },
	      columnThree
	    )
	  );
	};
	
	var getCommentary = function getCommentary(_ref5) {
	  var state = _ref5.state,
	      columnThree = _ref5.columnThree,
	      showFilters = _ref5.showFilters,
	      params = _ref5.params,
	      isCricinfoAsia = _ref5.isCricinfoAsia,
	      gameheader = _ref5.gameheader,
	      mobileAdPlaceholder = _ref5.mobileAdPlaceholder,
	      editionDomain = _ref5.editionDomain,
	      mobileIncontentAd = _ref5.mobileIncontentAd;
	
	  var isLimitedOvers = (0, _selectn2.default)('matchFlags.limitedOvers', state);
	
	  var contentArea = [_react2.default.createElement(_index.Commentary, (0, _extends3.default)({ key: 'c'
	  }, state.fullCommentary, {
	    showFilters: showFilters,
	    allInnings: state.allInnings,
	    selInnings: state.selInnings,
	    cmtryFilter: state.cmtryFilter,
	    selFilter: state.selCmtryFilter && state.selCmtryFilter.text,
	    updateMoreCommentary: updateMoreCommentary(state.edition, params, state.location, state.dispatch, state.appProps),
	    isWebView: state.isWebView,
	    routerPush: state.routerPush,
	    bet365: state.bet365,
	    isLimitedOvers: isLimitedOvers,
	    editionDomain: editionDomain }))];
	  {
	    isCricinfoAsia && contentArea.push(_react2.default.createElement(_common.Ad, { key: 'gs-ad-3', id: 'banner', className: 'react-ad ad-banner-mobile ad-wrapper', slotType: 'banner', include: ['s'], kvpos: 'bottom', isAdBlock: state.adblock }));
	  }
	  contentArea.push(mobileIncontentAd);
	  // Append outbrain for only connectionspeed 'full' in all commentary filters except full commentary
	  if ((0, _selectn2.default)('selCmtryFilter.playtype', state) !== 'full' && (0, _selectn2.default)('siteType', state) === 'full') {
	
	    contentArea.push(_react2.default.createElement(_common.Outbrain, (0, _extends3.default)({ key: 'ob' }, state.outbrainSettings, { url: state.pageURL })));
	  }
	  return _react2.default.createElement(
	    'div',
	    { key: 'bc', className: 'layout-bc gamepackage-commentary' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-b' },
	      gameheader,
	      mobileAdPlaceholder,
	      contentArea
	    ),
	    !state.isMobile && _react2.default.createElement(
	      'div',
	      { className: 'col-c' },
	      columnThree
	    )
	  );
	};
	
	var getStatistics = function getStatistics(_ref6) {
	  var state = _ref6.state,
	      columnThree = _ref6.columnThree,
	      isCricinfoAsia = _ref6.isCricinfoAsia,
	      gameheader = _ref6.gameheader,
	      mobileAdPlaceholder = _ref6.mobileAdPlaceholder,
	      mobileIncontentAd = _ref6.mobileIncontentAd;
	
	  var statistics = state.statistics || {};
	  var gameStrip = state.gameStrip || {};
	  var scoringSourceFeedback = (0, _selectn2.default)('scoringSource.isFeedback', state);
	  var bestPerformersStats = [_react2.default.createElement(_Statistics.BestPerformers, { title: statistics.bestPerformersBatTitle, type: 'batsman', players: statistics.batsmen }), _react2.default.createElement(_Statistics.BestPerformers, { title: statistics.bestPerformersBowlTitle, type: 'bowler', players: statistics.bowlers })];
	
	  return _react2.default.createElement(
	    'div',
	    { key: 'bc', className: 'layout-bc gamepackage-stats' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-b' },
	      gameheader,
	      mobileAdPlaceholder,
	      scoringSourceFeedback && bestPerformersStats,
	      isCricinfoAsia && _react2.default.createElement(_common.Ad, { key: 'gs-ad-3', id: 'banner', className: 'react-ad ad-banner-mobile ad-wrapper', slotType: 'banner', include: ['s'], kvpos: 'bottom', isAdBlock: state.adblock }),
	      scoringSourceFeedback && _react2.default.createElement(_Partnerships.Partnerships, (0, _extends3.default)({}, statistics.allPartnerships, { teams: gameStrip.teams, uiControls: statistics.uiControls, pshipByInnings: statistics.pshipByInnings })),
	      _react2.default.createElement(_Charts.Charts, (0, _extends3.default)({ id: 'chart' }, state.comparison, { uiControls: statistics.uiControls, teams: gameStrip.teams })),
	      mobileIncontentAd,
	      _react2.default.createElement(_common.Outbrain, (0, _extends3.default)({}, state.outbrainSettings, { url: state.pageURL }))
	    ),
	    !state.isMobile && _react2.default.createElement(
	      'div',
	      { className: 'col-c' },
	      columnThree
	    )
	  );
	};
	
	var getMatchCoverage = function getMatchCoverage(_ref7) {
	  var state = _ref7.state,
	      columnThree = _ref7.columnThree,
	      gameheader = _ref7.gameheader,
	      mobileAdPlaceholder = _ref7.mobileAdPlaceholder;
	
	  return _react2.default.createElement(
	    'div',
	    { key: 'bc', className: 'layout-bc' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-b' },
	      gameheader,
	      mobileAdPlaceholder,
	      _react2.default.createElement(_index.Coverage, { matchCoverage: state.matchCoverage })
	    ),
	    !state.isMobile && _react2.default.createElement(
	      'div',
	      { className: 'col-c' },
	      columnThree
	    )
	  );
	};
	
	var getVideos = function getVideos(_ref8) {
	  var state = _ref8.state,
	      columnThree = _ref8.columnThree,
	      params = _ref8.params,
	      gameheader = _ref8.gameheader,
	      mobileAdPlaceholder = _ref8.mobileAdPlaceholder;
	
	  var edition = state.edition;
	  var location = state.location;
	  return _react2.default.createElement(
	    'div',
	    { key: 'bc', className: 'layout-bc' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-b' },
	      gameheader,
	      mobileAdPlaceholder,
	      _react2.default.createElement(_VideoGrid2.default, (0, _extends3.default)({}, state.allVideos, { updateMoreVideos: updateMoreVideos(edition, params, location, state.dispatch) }))
	    ),
	    !state.isMobile && _react2.default.createElement(
	      'div',
	      { className: 'col-c' },
	      columnThree
	    )
	  );
	};
	var getHawkEye = function getHawkEye(_ref9) {
	  var state = _ref9.state,
	      columnThree = _ref9.columnThree,
	      gameheader = _ref9.gameheader,
	      mobileAdPlaceholder = _ref9.mobileAdPlaceholder;
	
	  if (state.isMobile) {
	    return;
	  }
	  return _react2.default.createElement(
	    'div',
	    { key: 'bc', className: 'layout-bc' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-b' },
	      gameheader,
	      mobileAdPlaceholder,
	      _react2.default.createElement(_index.HawkEye, state.hawkEye)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-c' },
	      columnThree
	    )
	  );
	};
	/**
	 * construct a handle function to update the next page commenatary
	 * @param  {Object} edition     edition config
	 * @param  {Object} params      router params
	 * @param  {Object} location    router location
	 * @param  {Function} dispatch  Store dispatcher function
	 * @param  {Object} appProps appProps
	 * @return {Function}           hanlder function
	 */
	var updateMoreCommentary = function updateMoreCommentary(edition, params, location, dispatch, appProps) {
	  return function (page) {
	    dispatch((0, _cricket.getPlayByPlayMore)({ edition: edition, params: params, location: location, page: page, appProps: appProps }));
	  };
	};
	
	var updateMoreVideos = function updateMoreVideos(edition, params, location, dispatch) {
	  return function (nextPage) {
	    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      rest[_key - 1] = arguments[_key];
	    }
	
	    dispatch((0, _api.getVideosMore)((0, _extends3.default)({ edition: edition, params: params, location: location, nextPage: nextPage }, rest)));
	  };
	};
	
	/**
	 * update the devive type
	 * @param  {Function} dispatch Store dispatcher function
	 * @return {Function}          hanlder function on window resize
	 */
	var updateDeviceType = function updateDeviceType(dispatch) {
	  return function (width) {
	    dispatch((0, _utils.setDeviceType)(width));
	  };
	};
	
	exports.default = getCricketView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MatchCardSlider = exports.PrevNext = exports.PollResult = exports.PollCard = exports.PieChartCard = exports.PartnershipsCard = exports.BowlingCard = exports.InningsCard = exports.PlayerCard = exports.SpecialsCard = exports.VideoCard = exports.PhotoCard = exports.FeaturesCard = exports.TheCordonCard = exports.NumberCrunching = exports.QuoteCard = undefined;
	
	var _keys = __webpack_require__(415);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(424);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	exports.formatVideoTime = formatVideoTime;
	exports.getPercentage = getPercentage;
	exports.convertToPieAngle = convertToPieAngle;
	exports.convertPollToPercentage = convertPollToPercentage;
	exports.convertTotalVotes = convertTotalVotes;
	exports.convertnumberdigitstowords = convertnumberdigitstowords;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * [Component to display Quote Unquote Card]
	 * This has 3 layouts
	 *  - with headshot, primary text, secondary text
	 *  - without headshot, primary text, secondary text
	 *  - with headshot, primary text
	 * @param  {[type]} options.data   [details of an quote]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [Quote Unquote as a div]
	 */
	var QuoteCard = exports.QuoteCard = function QuoteCard(_ref) {
	  var data = _ref.data,
	      style = _ref.style,
	      index = _ref.index,
	      states = _ref.states;
	
	  var slideContent = _react2.default.createElement('span', null);
	  var hasHeadshot = false;
	  var slideclassname;
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (typeof data.headline === 'undefined') {
	    return _react2.default.createElement('span', null);
	  }
	  if (typeof data.image === 'undefined') {
	    hasHeadshot = false;
	    slideContent = _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'p',
	        { className: 'primary-text' },
	        data.quote
	      ),
	      _react2.default.createElement('span', { className: 'spacer arrow' }),
	      _react2.default.createElement(
	        'p',
	        { className: 'secondary-text' },
	        data.attribution
	      )
	    );
	  }
	  if (typeof data.attribution === 'undefined' && typeof data.image !== 'undefined' && typeof data.quote !== 'undefined') {
	    hasHeadshot = true;
	    slideContent = _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'a',
	        { href: data.href, className: 'headshot headshot-xl athlete', tabIndex: '0' },
	        _react2.default.createElement('img', { 'data-src': 'http://a.espncdn.com/combiner/i?img=/i/headshots/nhl/players/full/3114.png&w=168&h=168&scale=crop&transparent=true', className: 'lazyload' })
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'primary-text' },
	        data.quote
	      ),
	      _react2.default.createElement('span', { className: 'spacer arrow' }),
	      _react2.default.createElement(
	        'a',
	        { href: data.href, className: 'read-more', tabIndex: '0' },
	        'Read more'
	      )
	    );
	  }
	  if (typeof data.attribution !== 'undefined' && typeof data.image !== 'undefined' && typeof data.quote !== 'undefined') {
	    hasHeadshot = true;
	    slideContent = _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'a',
	        { href: data.href, className: 'headshot headshot-md athlete', tabIndex: '0' },
	        _react2.default.createElement('img', { 'data-src': _common.common.resizeCombinerLogo(data.image, { w: 108, h: 108, transparent: true, scale: 'crop' }), className: 'lazyload' })
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'primary-text' },
	        data.quote
	      ),
	      _react2.default.createElement('span', { className: 'spacer arrow' }),
	      _react2.default.createElement(
	        'p',
	        { className: 'secondary-text' },
	        data.attribution
	      )
	    );
	  }
	  if (hasHeadshot === false) {
	    slideclassname = 'sub-module match-cards slick-slide';
	  } else {
	    slideclassname = 'sub-module match-cards has-headshot slick-slide';
	  }
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        data.headline
	      ),
	      slideContent
	    )
	  );
	};
	/**
	 * [Component to display Number Crunching]
	 * @param  {[type]} options.data   [details of an innings]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [Number Crunching as a div]
	 */
	var NumberCrunching = exports.NumberCrunching = function NumberCrunching(_ref2) {
	  var data = _ref2.data,
	      style = _ref2.style,
	      index = _ref2.index,
	      states = _ref2.states;
	
	  var slideclassname = 'sub-module match-cards has-headshot slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  if (typeof data.number === 'undefined') {
	    return _react2.default.createElement('span', null);
	  }
	  if (typeof data.number !== 'undefined') {
	    if (data.number === '') {
	      return _react2.default.createElement('span', null);
	    }
	  }
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        data.headline
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'p',
	        { className: 'points lg' },
	        data.number
	      ),
	      _react2.default.createElement('span', { className: 'spacer' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'v-align' },
	        _react2.default.createElement(
	          'p',
	          { className: 'secondary-text' },
	          data.summary
	        )
	      )
	    )
	  );
	};
	
	/**
	 * [Component to display The Cordon card]
	 * @param  {[type]} options.data   [details of the specials]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [The Cordon fact slide as a div]
	 */
	var TheCordonCard = exports.TheCordonCard = function TheCordonCard(_ref3) {
	  var data = _ref3.data,
	      style = _ref3.style,
	      index = _ref3.index,
	      states = _ref3.states;
	
	  if (typeof data.name === 'undefined') {
	    return _react2.default.createElement('span', null);
	  }
	  var slideclassname = 'sub-module match-cards the-cordon-card is-feature has-headshot slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  var spacer = {};
	  if (typeof data.href !== 'undefined') {
	    spacer = _react2.default.createElement('span', { className: 'spacer arrow' });
	  } else {
	    spacer = _react2.default.createElement('span', null);
	  }
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        'The Cordon'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'a',
	        { href: data.href, className: 'headshot headshot-xl athlete', tabIndex: '0' },
	        _react2.default.createElement('img', { 'data-src': data.image, className: 'lazyload' })
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        data.name
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'primary-text' },
	        data.text
	      ),
	      spacer,
	      _react2.default.createElement(
	        'a',
	        { href: data.href, className: 'read-more', tabIndex: '0' },
	        'Read more'
	      )
	    )
	  );
	};
	
	/**
	 * [Component to display Features card]
	 * This has 2 layouts
	 *  - with heading and primary text
	 *  - without heading and only primary text
	 * @param  {[type]} options.data   [details of the features]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [Features slide as a div]
	 */
	var FeaturesCard = exports.FeaturesCard = function FeaturesCard(_ref4) {
	  var data = _ref4.data,
	      style = _ref4.style,
	      index = _ref4.index,
	      states = _ref4.states;
	
	  if (typeof data.headline === 'undefined') {
	    if (typeof data.summary === 'undefined') {
	      return _react2.default.createElement('span', null);
	    }
	  }
	  var slideclassname = 'sub-module match-cards is-feature has-media slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	
	  var headlineTag = void 0;
	  var summaryTag = void 0;
	  var pageLink = void 0;
	  if (typeof data.url !== 'undefined') {
	    pageLink = data.url;
	  }
	  if (typeof data.headline !== 'undefined') {
	    if (data.headline.length > 0) {
	      headlineTag = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: pageLink, target: '_blank' },
	          data.headline
	        )
	      );
	    }
	  }
	  if (typeof data.summary !== 'undefined') {
	    if (data.summary.length > 0) {
	      summaryTag = _react2.default.createElement(
	        'p',
	        { className: 'primary-text' },
	        _react2.default.createElement(
	          'a',
	          { href: pageLink, target: '_blank' },
	          data.summary
	        )
	      );
	    }
	  }
	  if (typeof data.headline === 'undefined' && typeof data.summary !== 'undefined') {
	    if (data.summary.length > 0) {
	      summaryTag = _react2.default.createElement(
	        'p',
	        { className: 'primary-text' },
	        _react2.default.createElement(
	          'a',
	          { href: pageLink, target: '_blank' },
	          data.summary
	        )
	      );
	    }
	  }
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Feature'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      headlineTag,
	      summaryTag,
	      _react2.default.createElement('span', { className: 'spacer' })
	    )
	  );
	};
	
	/**
	 * [Component to display Photo card]
	 * @param  {[type]} options.data   [details of the photo card]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [photo slide as a div]
	 */
	var PhotoCard = exports.PhotoCard = function PhotoCard(_ref5) {
	  var data = _ref5.data,
	      style = _ref5.style,
	      index = _ref5.index,
	      states = _ref5.states;
	
	  if (typeof data.headline === 'undefined' || typeof data.image === 'undefined') {
	    return _react2.default.createElement('span', null);
	  }
	  var slideclassname = 'sub-module match-cards photo-card has-media slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  var photoLink = void 0;
	  if (typeof data.href !== 'undefined') {
	    photoLink = data.href;
	  }
	  var copyright = void 0;
	  if (typeof data.copyright !== 'undefined') {
	    copyright = data.copyright ? data.copyright : '';
	  }
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'div',
	      { className: 'content no-thumb' },
	      _react2.default.createElement(
	        'figure',
	        { className: 'feed-item-figure' },
	        _react2.default.createElement(
	          'div',
	          { className: 'img-wrap external', href: '#' },
	          _react2.default.createElement(
	            'picture',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: photoLink, target: '_blank' },
	              _react2.default.createElement('img', { 'data-src': data.image, className: 'lazyload' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'secondary-text' },
	        _react2.default.createElement(
	          'a',
	          { href: photoLink, target: '_blank' },
	          data.headline,
	          ' ',
	          _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: copyright } })
	        )
	      )
	    )
	  );
	};
	/**
	 * [formatVideoTime change time format to strip extra zeros]
	 * @param  {[type]} t [time duration]
	 * @return {[type]}   [returns duration without zeros]
	 */
	function formatVideoTime(t) {
	  if (t.length > 0) {
	    var duration_arr = t.split(':');
	    var duration_arr_n = [];
	    var duration_arr_val = [];
	    var duration = '';
	    for (var i in duration_arr) {
	      duration_arr_val = parseInt(duration_arr[i], 10);
	      if (duration_arr_val > 0) {
	        duration_arr_n.push(duration_arr_val);
	      }
	    }
	    duration = duration_arr_n.join(':');
	    return duration;
	  }
	}
	/**
	 * [Component to display Video card]
	 * @param  {[type]} options.data   [details of the video card]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [video slide as a div]
	 */
	var VideoCard = exports.VideoCard = function VideoCard(_ref6) {
	  var data = _ref6.data,
	      style = _ref6.style,
	      index = _ref6.index,
	      states = _ref6.states;
	
	  if (typeof data.headline === 'undefined' || typeof data.duration === 'undefined' || typeof data.image === 'undefined') {
	    return _react2.default.createElement('span', null);
	  }
	  var slideclassname = 'sub-module match-cards video-card has-media slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  var duration = void 0;
	  var videoLink = void 0;
	  if (typeof data.duration !== 'undefined') {
	    if (data.duration !== '') {
	      duration = formatVideoTime(data.duration);
	    }
	  }
	  if (typeof data.image === 'undefined' || typeof data.duration === 'undefined') {
	    if (data.duration === '' || data.image === '') {
	      return _react2.default.createElement('span', null);
	    }
	  }
	  if (typeof data.href !== 'undefined') {
	    videoLink = data.href;
	  }
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'div',
	      { className: 'content video-wrapper' },
	      _react2.default.createElement(
	        'figure',
	        { className: 'feed-item-figure video' },
	        _react2.default.createElement(
	          'div',
	          { className: 'img-wrap' },
	          _react2.default.createElement(
	            'picture',
	            null,
	            _react2.default.createElement('img', { src: data.image, className: 'imageLoaded' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'video-play-button' },
	            'Play'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'video-length' },
	            duration
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'secondary-text' },
	        _react2.default.createElement(
	          'a',
	          { href: videoLink, target: '_blank' },
	          data.headline
	        )
	      )
	    )
	  );
	};
	/**
	 * [Component to display Specials card]
	 * @param  {[type]} options.data   [details of the specials]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [Specials slide as a div]
	 */
	var SpecialsCard = exports.SpecialsCard = function SpecialsCard(_ref7) {
	  var data = _ref7.data,
	      style = _ref7.style,
	      index = _ref7.index,
	      states = _ref7.states;
	
	  if (typeof data.text === 'undefined') {
	    return _react2.default.createElement('span', null);
	  }
	  var slideclassname = 'sub-module match-cards specials-card has-media slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Specials'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content no-thumb' },
	      _react2.default.createElement(
	        'figure',
	        { className: 'feed-item-figure sm' },
	        _react2.default.createElement(
	          'div',
	          { className: 'img-wrap external', href: '#' },
	          _react2.default.createElement(
	            'picture',
	            null,
	            _react2.default.createElement('img', { src: data.image, className: 'imageLoaded' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'secondary-text' },
	        data.text
	      )
	    )
	  );
	};
	
	/**
	 * [Component to display Player card]
	 * @param  {[type]} options.data   [details of an innings]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [Player slide as a div]
	 */
	var PlayerCard = exports.PlayerCard = function PlayerCard(_ref8) {
	  var data = _ref8.data,
	      style = _ref8.style,
	      index = _ref8.index,
	      states = _ref8.states;
	
	  var slideclassname = 'sub-module match-cards player-card slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  var playerListData = [{}];
	  if (typeof data.list !== 'undefined') {
	    playerListData = data.list;
	  }
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        data.name
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'player-detail' },
	        _react2.default.createElement(
	          'div',
	          { className: 'detail' },
	          _react2.default.createElement(
	            'a',
	            { href: data.url, className: 'headshot-md athlete' },
	            _react2.default.createElement('img', { 'data-src': data.image, className: 'lazyload' })
	          )
	        ),
	        _react2.default.createElement('div', { className: 'detail', dangerouslySetInnerHTML: { __html: '<span>In at No ' + data.position + '</span> (' + data.score + ')' } }),
	        _react2.default.createElement('div', { className: 'detail', dangerouslySetInnerHTML: { __html: '<span>Last 5 innings</span> ' + data.last5 } })
	      ),
	      _react2.default.createElement(
	        'table',
	        { cellSpacing: '0', className: 'player-detail-table' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement('th', { width: '50' }),
	            _react2.default.createElement(
	              'th',
	              { width: '150', className: 'align-right' },
	              'CAREER'
	            ),
	            _react2.default.createElement(
	              'th',
	              { className: 'align-right' },
	              'v ',
	              data.opposition
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          playerListData.map(function (player, j) {
	            return _react2.default.createElement(
	              'tr',
	              { key: j },
	              _react2.default.createElement(
	                'td',
	                { className: 'align-center' },
	                player.name
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-right' },
	                player.overall
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-right' },
	                player.versus
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	/**
	 * [Component to display Innings Slide]
	 * @param  {[type]} options.data   [details of an innings]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [Innings slide as a div]
	 */
	var InningsCard = exports.InningsCard = function InningsCard(_ref9) {
	  var data = _ref9.data,
	      style = _ref9.style,
	      index = _ref9.index,
	      states = _ref9.states;
	
	  var slideclassname = 'sub-module match-cards innings-card slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  var inningsListData = [{}];
	  if (typeof data.playerDetails !== 'undefined') {
	    inningsListData = data.playerDetails;
	  }
	  var inningsName = void 0;
	  if (typeof data.inningsID !== 'undefined') {
	    var inningsID = parseInt(data.inningsID, 10);
	
	    if (inningsID === 1) {
	      inningsName = inningsID + 'st';
	    } else if (inningsID === 2) {
	      inningsName = inningsID + 'nd';
	    } else if (inningsID === 3) {
	      inningsName = inningsID + 'rd';
	    } else if (inningsID === 2) {
	      inningsName = inningsID + 'th';
	    }
	  }
	  var playerLink = void 0;
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'table',
	        { cellSpacing: '0', className: 'match-table innings' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { style: { backgroundColor: '#fff' } },
	            _react2.default.createElement(
	              'th',
	              { width: '110' },
	              data.teamName,
	              ' ',
	              inningsName,
	              ' INNINGS'
	            ),
	            _react2.default.createElement('th', null),
	            _react2.default.createElement(
	              'th',
	              { width: '25', className: 'align-right' },
	              'R'
	            ),
	            _react2.default.createElement(
	              'th',
	              { width: '25', className: 'align-right' },
	              'B'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          inningsListData.map(function (player, i) {
	            if (typeof player.href !== 'undefined') {
	              playerLink = player.href;
	            } else {
	              playerLink = '';
	            }
	            return _react2.default.createElement(
	              'tr',
	              { key: i },
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: playerLink, target: '_blank' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    player.playerName
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  player.dismissal
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-right' },
	                player.runs
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-right' },
	                player.ballsFaced
	              )
	            );
	          }),
	          _react2.default.createElement(
	            'tr',
	            { className: 'total' },
	            _react2.default.createElement(
	              'td',
	              { colSpan: '1' },
	              'EXTRAS'
	            ),
	            _react2.default.createElement(
	              'td',
	              { colSpan: '3', className: 'align-right' },
	              data.extras
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'total' },
	            _react2.default.createElement(
	              'td',
	              { colSpan: '1' },
	              'TOTAL'
	            ),
	            _react2.default.createElement(
	              'td',
	              { colSpan: '3', className: 'align-right' },
	              data.runs + ' ' + data.total
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	/**
	 * [Component to display Bowling Slide]
	 * @param  {[type]} options.data   [details of an innings]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [Innings slide as a div]
	 */
	var BowlingCard = exports.BowlingCard = function BowlingCard(_ref10) {
	  var data = _ref10.data,
	      style = _ref10.style,
	      index = _ref10.index,
	      states = _ref10.states;
	
	  var slideclassname = 'sub-module match-cards bowling-card slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  var inningsListData = [{}];
	  if (typeof data.playerDetails !== 'undefined') {
	    inningsListData = data.playerDetails;
	  }
	  var teamName = data.teamName || '';
	  /*let inningsName
	  if(typeof data.inningsNumber !== 'undefined') {
	    let inningsNumber = parseInt(data.inningsNumber, 10)
	     if(inningsNumber === 1) {
	      inningsName = inningsNumber + 'st innings'
	    }else if(inningsNumber === 2) {
	      inningsName = inningsNumber + 'nd innings'
	    }else if(inningsNumber === 3) {
	      inningsName = inningsNumber + 'rd innings'
	    }else if(inningsNumber === 4) {
	      inningsName = inningsNumber + 'th innings'
	    }
	  }*/
	  var playerLink = void 0;
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'table',
	        { cellSpacing: '0', className: 'match-table' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { style: { backgroundColor: '#fff' } },
	            _react2.default.createElement(
	              'th',
	              { width: '110', className: 'align-left' },
	              teamName,
	              ' BOWLING'
	            ),
	            _react2.default.createElement(
	              'th',
	              { width: '20', className: 'align-right' },
	              'O'
	            ),
	            _react2.default.createElement(
	              'th',
	              { width: '20', className: 'align-right' },
	              'M'
	            ),
	            _react2.default.createElement(
	              'th',
	              { width: '20', className: 'align-right' },
	              'R'
	            ),
	            _react2.default.createElement(
	              'th',
	              { width: '20', className: 'align-right' },
	              'W'
	            ),
	            _react2.default.createElement(
	              'th',
	              { width: '35', className: 'align-right' },
	              'Econ'
	            ),
	            _react2.default.createElement('th', { width: '45', className: 'align-left' })
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          inningsListData.map(function (player, i) {
	            if (typeof player.href !== 'undefined') {
	              playerLink = player.href;
	            } else {
	              playerLink = '';
	            }
	
	            return _react2.default.createElement(
	              'tr',
	              { key: i },
	              _react2.default.createElement(
	                'td',
	                { className: 'align-left' },
	                _react2.default.createElement(
	                  'a',
	                  { href: playerLink, target: '_blank' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    player.playerName
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-right' },
	                player.overs
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-right' },
	                player.maidens
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-right' },
	                player.conceded
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-right' },
	                player.wickets
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-right' },
	                player.economyRate
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-left' },
	                player.nbw
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	/**
	 * [Component to display Bowling Slide]
	 * @param  {[type]} options.data   [details of an innings]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [Innings slide as a div]
	 */
	var PartnershipsCard = exports.PartnershipsCard = function PartnershipsCard(_ref11) {
	  var data = _ref11.data,
	      style = _ref11.style,
	      index = _ref11.index,
	      states = _ref11.states;
	
	  var slideclassname = 'sub-module match-cards partnerships-card slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  var inningsListData = [{}];
	  if (typeof data.playerDetails !== 'undefined') {
	    inningsListData = data.playerDetails;
	  }
	  var teamName = data.teamName || '';
	  var inningsName = void 0;
	  if (typeof data.inningsNumber !== 'undefined') {
	    var inningsNumber = parseInt(data.inningsNumber, 10);
	
	    if (inningsNumber === 1) {
	      inningsName = inningsNumber + 'st innings';
	    } else if (inningsNumber === 2) {
	      inningsName = inningsNumber + 'nd innings';
	    } else if (inningsNumber === 3) {
	      inningsName = inningsNumber + 'rd innings';
	    } else if (inningsNumber === 4) {
	      inningsName = inningsNumber + 'th innings';
	    }
	  }
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        teamName,
	        ' ',
	        inningsName,
	        ' Partnerships'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'table',
	        { cellSpacing: '0', className: 'match-table', style: { marginTop: 0 } },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { style: { backgroundColor: '#fff' } },
	            _react2.default.createElement(
	              'th',
	              { width: '50', className: 'align-center' },
	              'Wkt'
	            ),
	            _react2.default.createElement(
	              'th',
	              { width: '20', className: 'align-right' },
	              'Runs'
	            ),
	            _react2.default.createElement(
	              'th',
	              { width: '100', className: 'align-right' },
	              'Players'
	            ),
	            _react2.default.createElement('th', { width: '100', className: 'align-right' })
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          inningsListData.map(function (player, i) {
	            return _react2.default.createElement(
	              'tr',
	              { key: i },
	              _react2.default.createElement(
	                'td',
	                { className: 'align-center' },
	                player.partnershipWicketNAme
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-right' },
	                player.partnershipRuns
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-right' },
	                player.player1Name
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'align-right' },
	                player.player2Name
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	/**
	 * [getPercentage get percentage from values for data]
	 * @param  {[type]} val   [value to be shown]
	 * @param  {[type]} total [total of both values]
	 * @return {[type]}       [returns percentage/100]
	 */
	function getPercentage(val, total) {
	  var perc = 0;
	  val = parseFloat(val, 10).toFixed(0);
	  val = parseInt(val, 10);
	  perc = val / total;
	  return perc;
	}
	/**
	 * [convertToPieAngle function to change value to use for rotate property css3]
	 * @param  {[type]} val [value of percentage]
	 * @return {[type]}     [returns rotation angle]
	 */
	function convertToPieAngle(val) {
	  var rotateAngle = 0;
	  rotateAngle = Math.ceil(val * 360);
	  return rotateAngle;
	}
	/**
	 * [Component to display Pie chart data Slide]
	 * @param  {[type]} options.data   [details of a graph]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [pie chart as as a div]
	 */
	var PieChartCard = exports.PieChartCard = function PieChartCard(_ref12) {
	  var data = _ref12.data,
	      style = _ref12.style,
	      index = _ref12.index,
	      states = _ref12.states;
	
	  var slideclassname = 'sub-module match-cards pie-chart slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  var chartWrapStyle = {
	    'width': '170px',
	    'height': '170px'
	  };
	  var item1Value = void 0;
	  var item2Value = void 0;
	  var valueTotal = void 0;
	  var item1Name = void 0;
	  var item2Name = void 0;
	  var item1Logo = void 0;
	  var item2Logo = void 0;
	  var listData = [{}];
	
	  if (typeof data.list === 'undefined') {
	    return _react2.default.createElement('span', null);
	  }
	  if (typeof data.list !== 'undefined') {
	    listData = data.list;
	  }
	  listData.map(function (item) {
	    if (item.type === 'boundaries') {
	      item1Value = item.value;
	      item1Name = item.name.toUpperCase();
	      item1Logo = item.image;
	    } else {
	      item2Value = item.value;
	      item2Name = item.name.toUpperCase();
	      item2Logo = item.image;
	    }
	  });
	
	  valueTotal = item1Value + item2Value;
	
	  var transformWedgeStyle1 = 'rotate(' + convertToPieAngle(getPercentage(item1Value, valueTotal)) + 'deg)';
	  var transformWedgeStyle2 = 'rotate(' + convertToPieAngle(getPercentage(item2Value, valueTotal)) + 'deg)';
	
	  item1Value = (getPercentage(item1Value, valueTotal) * 100).toFixed();
	  item2Value = (getPercentage(item2Value, valueTotal) * 100).toFixed();
	
	  var rgb1 = 'rgb(108, 213, 255)';
	  var rgb2 = 'rgb(80, 171, 214)';
	  var clipDefault1 = 'rect(0px 83px 170px 0px)';
	  var clipDefault2 = 'auto';
	  var transformWedgeContStyle1 = 'rotate(0deg)';
	  var transformWedgeContStyle2 = 'rotate(' + convertToPieAngle(getPercentage(item1Value, valueTotal)) + 'deg)';
	  var transformWedgeExtStyle1 = 'rotate(180deg)';
	
	  //flip the values so the percentages/type of runs remain same with wedges
	  //choose different template values to mirror graph
	  if (item1Value < item2Value) {
	    transformWedgeStyle1 = 'rotate(1deg)';
	    transformWedgeStyle2 = 'rotate(' + (1 + convertToPieAngle(getPercentage(item2Value, valueTotal))) + 'deg)';
	    transformWedgeContStyle2 = 'rotate(' + (179 - convertToPieAngle(getPercentage(item2Value, valueTotal))) + 'deg)';
	    transformWedgeExtStyle1 = 'rotate(' + -(180 - convertToPieAngle(getPercentage(item1Value, valueTotal))) + 'deg)';
	
	    rgb1 = 'rgb(80, 171, 214)';
	    rgb2 = 'rgb(108, 213, 255)';
	  }
	
	  var wedgeStyle1 = {
	    'transform': transformWedgeStyle1,
	    'clip': clipDefault1,
	    'backgroundColor': rgb1
	  };
	  var wedgeStyle2 = {
	    'transform': transformWedgeStyle2,
	    'clip': clipDefault1,
	    'backgroundColor': rgb2
	  };
	  var wedgeContStyle1 = {
	    'transform': transformWedgeContStyle1,
	    'clip': clipDefault2
	  };
	  var wedgeContStyle2 = {
	    'transform': transformWedgeContStyle2,
	    'clip': 'rect(0px 170px 170px 85px)'
	  };
	  var wedgeExtStyle1 = {
	    'opacity': '1',
	    'transform': transformWedgeExtStyle1,
	    'clip': 'rect(0px 85px 170px 0px)',
	    'backgroundColor': rgb1
	  };
	  var wedgeExtStyle2 = {
	    'opacity': '0'
	  };
	
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        data.title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'chart-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'data-chart', 'data-chart': '4', style: chartWrapStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'outer-circle' },
	          _react2.default.createElement(
	            'div',
	            { 'data-wedge-id': 'a', className: 'wedge-container', style: wedgeContStyle1 },
	            _react2.default.createElement('div', { className: 'wedge', style: wedgeStyle1 }),
	            _react2.default.createElement('div', { className: 'wedge-extension', style: wedgeExtStyle1 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-wedge-id': 'b', className: 'wedge-container', style: wedgeContStyle2 },
	            _react2.default.createElement('div', { className: 'wedge', style: wedgeStyle2 }),
	            _react2.default.createElement('div', { className: 'wedge-extension', style: wedgeExtStyle2 })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'inner-circle' },
	          _react2.default.createElement(
	            'span',
	            { className: 'team-logo' },
	            _react2.default.createElement('img', { src: item1Logo, className: 'imageLoaded' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'team-logo' },
	            _react2.default.createElement('img', { src: item2Logo, className: 'imageLoaded' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'team-name' },
	            item1Name
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'home-team' },
	            item2Name
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'away-team' },
	            item1Name
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'value-home' },
	        item1Value
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'value-away' },
	        item2Value
	      )
	    )
	  );
	};
	
	/**
	 * [Component to display Poll Slide]
	 * @param  {[type]} options.data   [questions and answers]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [Poll question slide as a div]
	 */
	var PollCard = exports.PollCard = function PollCard(_ref13) {
	  var data = _ref13.data,
	      style = _ref13.style,
	      index = _ref13.index,
	      states = _ref13.states;
	
	  var slideclassname = 'sub-module match-cards poll-results slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  var pollOptionsData = [{}];
	  if (typeof data.options !== 'undefined') {
	    pollOptionsData = data.options;
	  }
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        data.question
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content mod-poll' },
	      _react2.default.createElement(
	        'form',
	        { id: 'poll-results', action: 'poll_results_submit', method: 'post' },
	        pollOptionsData.map(function (item, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i, className: 'wrap' },
	            _react2.default.createElement('input', { id: 'radio_' + convertnumberdigitstowords(i), type: 'radio', name: 'poll', value: i, tabIndex: '0' }),
	            _react2.default.createElement('label', { htmlFor: 'radio_' + convertnumberdigitstowords(i) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'label' },
	              item.option
	            )
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement('input', { type: 'submit', value: 'Vote', className: 'button lg', tabIndex: '0' })
	        )
	      )
	    )
	  );
	};
	/**
	 * [convertPollToPercentage converts poll percentage from number of votes]
	 * @param  {[type]} votes [integer]
	 * @param  {[type]} total [total votes as integer]
	 * @return {[type]}       [returns total votes as percentage accurate to 2 decimals]
	 */
	function convertPollToPercentage(votes, total) {
	  var perc = 0;
	  if (typeof votes === 'number' && typeof total === 'number') {
	    perc = votes / total * 100;
	    var q = perc.toString();
	    var v = q.split('.');
	    if (typeof v[1] !== 'undefined') {
	      v = v.splice(0, 1);
	    }
	    perc = v.join('.');
	  }
	  return perc;
	}
	
	/**
	 * [convertTotalVotes convert votes count to comma separated format]
	 * @param  {[type]} totalVotes [number]
	 * @return {[type]}            [votes with message as a string]
	 */
	function convertTotalVotes(totalVotes) {
	  var c = 0;
	  if (typeof totalVotes === 'number') {
	    c = totalVotes;
	    if (c >= 1000) {
	      c = c / 1000;
	    }
	    var msg = 'vote';
	    if (c === 1 && c > 0) {
	      msg = ' vote ';
	    } else if (c > 1) {
	      msg = ' total votes';
	    } else {
	      msg = '';
	    }
	    c = c.toString();
	    c = c.split('.');
	    c = c.join(',') + msg;
	  }
	  return c;
	}
	
	/**
	 * [Component to display Poll Result]
	 * @param  {[type]} options.data   [questions and options]
	 * @param  {[type]} options.style  [default style for current class and display of slide]
	 * @param  {[type]} options.index  [index of current slide in matchcards]
	 * @param  {[type]} options.states [all available states]
	 * @return {[type]}                [Poll result slide as a div]
	 */
	var PollResult = exports.PollResult = function PollResult(_ref14) {
	  var data = _ref14.data,
	      style = _ref14.style,
	      index = _ref14.index,
	      states = _ref14.states;
	
	  var slideclassname = 'sub-module match-cards poll-results slick-slide';
	  style = {
	    'display': 'block',
	    'position': 'absolute',
	    'left': '0',
	    'top': '0',
	    'opacity': '0',
	    'zIndex': '998'
	  };
	  if (states.activeslideindex === index) {
	    slideclassname = slideclassname + ' slick-active slick-current';
	    style = {
	      'display': 'block',
	      'position': 'absolute',
	      'left': '0',
	      'top': '0',
	      'opacity': '1',
	      'transition': 'opacity 500ms ease',
	      'zIndex': '999'
	    };
	  }
	  var barDefaultStyle = {
	    'backgroundColor': '#f2f2f2',
	    'maxWidth': '100%'
	  };
	  var barPollStyle = {
	    'backgroundColor': '#5FC8F2 !important',
	    'width': '0%'
	  };
	  var totalVotes = convertTotalVotes(data.totalVotes);
	  var pollOptionsData = [{}];
	  if (typeof data.options !== 'undefined') {
	    pollOptionsData = data.options;
	  }
	  return _react2.default.createElement(
	    'article',
	    { className: slideclassname, style: style, index: index },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        data.question
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content mod-poll' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'compareLineGraph' },
	        pollOptionsData.map(function (item, i) {
	          var perc = convertPollToPercentage(item.votes, data.totalVotes);
	          barPollStyle = {
	            'backgroundColor': '#5FC8F2 !important',
	            'width': perc + '%'
	          };
	          return _react2.default.createElement(
	            'li',
	            { key: 'pres' + i },
	            _react2.default.createElement(
	              'span',
	              { className: 'poll-text' },
	              item.option
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: barDefaultStyle, className: 'bar-total' },
	              _react2.default.createElement('span', { style: barPollStyle, className: 'bar-percentage' })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'chartValue' },
	              perc + '%'
	            )
	          );
	        }),
	        _react2.default.createElement(
	          'span',
	          { className: 'chartLabel' },
	          totalVotes
	        )
	      )
	    )
	  );
	};
	
	/**
	 * [convertnumberdigitstowords helper for poll radio button ids, converts 1,2,3 etc to words]
	 * @param  {[type]} n [number]
	 * @return {[type]}   [word]
	 */
	function convertnumberdigitstowords(n) {
	  var numbArr = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight'];
	  return numbArr[n];
	}
	
	/**
	 * [create functional component for prev next]
	 * @param  {[type]} options.handleclickprev  [previous click event]
	 * @param  {[type]} options.handleclicknext  [next click event]
	 * @param  {[type]} options.activeslideindex [current slide index]
	 * @param  {[type]} options.totalslides      [total no: of slides]
	 * @param  {[type]} options.buttonstyle      [button default style]
	 * @param  {[type]} options.ulstyle          [button wrap style]
	 * @return {[type]}                          [returns navigation component]
	 */
	var PrevNext = exports.PrevNext = function PrevNext(_ref15) {
	  var handleclickprev = _ref15.handleclickprev,
	      handleclicknext = _ref15.handleclicknext,
	      activeslideindex = _ref15.activeslideindex,
	      totalslides = _ref15.totalslides,
	      buttonstyle = _ref15.buttonstyle,
	      ulstyle = _ref15.ulstyle;
	
	
	  var prevbuttonclassname = 'icon-font-before icon-caret-left-solid-before slick-arrow';
	  var nextbuttonclassname = 'icon-font-before icon-caret-right-solid-before slick-arrow';
	  if (totalslides > 0 && totalslides === activeslideindex) {
	    nextbuttonclassname += ' slick-disabled';
	  }
	  if (totalslides > 0 && activeslideindex === 1) {
	    prevbuttonclassname += ' slick-disabled';
	  }
	  var arrowstyle = {
	    'position': 'relative',
	    'zIndex': '1000'
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: 'match-slick-arrows', style: arrowstyle },
	    _react2.default.createElement(
	      'div',
	      { className: 'wrap' },
	      _react2.default.createElement('div', { onClick: handleclickprev, className: prevbuttonclassname, style: buttonstyle }),
	      _react2.default.createElement(
	        'ul',
	        { className: 'custom_paging', style: ulstyle, role: 'tablist' },
	        _react2.default.createElement(
	          'li',
	          { className: 'mc-active slick-active' },
	          activeslideindex,
	          '/',
	          totalslides
	        )
	      ),
	      _react2.default.createElement('div', { onClick: handleclicknext, className: nextbuttonclassname, style: buttonstyle })
	    )
	  );
	};
	
	/**
	 * Create Class for Match card slider
	 * with previous and next buttons
	 */
	var MatchCardSlider = exports.MatchCardSlider = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(MatchCardSlider, _React$Component);
	
	  function MatchCardSlider(props) {
	    (0, _classCallCheck3.default)(this, MatchCardSlider);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MatchCardSlider.__proto__ || (0, _getPrototypeOf2.default)(MatchCardSlider)).call(this, props));
	
	    _this.state = {
	      activeslideindex: props.activeslideindex,
	      totalslides: props.totalslides
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(MatchCardSlider, [{
	    key: 'handleClickPrev',
	
	
	    /**
	     * [handleClickPrev Click handler to show previous slide]
	     * @return {[type]} [updates current slide index]
	     */
	    value: function handleClickPrev() {
	      var activeslideindex = this.state.activeslideindex;
	      var totalslides = this.state.totalslides;
	      if (totalslides > 0 && activeslideindex > 1) {
	        activeslideindex = activeslideindex - 1;
	        this.setState({ activeslideindex: activeslideindex });
	      }
	    }
	    /**
	     * [handleClickNext Click handler to show next slide]
	     * @return {[type]} [updates current slide index]
	     */
	
	  }, {
	    key: 'handleClickNext',
	    value: function handleClickNext() {
	      var activeslideindex = this.state.activeslideindex + 1;
	      var totalslides = this.state.totalslides;
	      if (totalslides > 0 && activeslideindex <= totalslides) {
	        this.setState({ activeslideindex: activeslideindex });
	      }
	    }
	
	    /**
	     * [componentDidMount Invoked after first render]
	     * @return {[component]} [match cards module]
	     */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var matchcards = this.props.matchcards;
	
	
	      if (typeof matchcards !== 'undefined') {
	        matchcards = this.filterMatchCardsByTypeID(matchcards);
	        var totalslides = 0;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(matchcards), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var i = _step.value;
	
	            if (typeof i !== 'undefined') {
	              totalslides = totalslides + 1;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        this.setState({ activeslideindex: 1, totalslides: totalslides });
	      }
	    }
	    /**
	     * [componentWillReceiveProps Updated whenever the new set of filtered slides are updated in this.props]
	     * @param  {[type]} nextProps [updated match cards / filtered ones]
	     * @return {[type]}           [updates slides, active, total count]
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var matchcards = nextProps.matchcards;
	
	      if (typeof matchcards !== 'undefined') {
	        matchcards = this.filterMatchCardsByTypeID(matchcards);
	        var totalslides = 0;
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(matchcards), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var i = _step2.value;
	
	            if (typeof i !== 'undefined') {
	              totalslides = totalslides + 1;
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        if (totalslides > 0) {
	          if (this.state.activeslideindex > totalslides) {
	            this.setState({ activeslideindex: totalslides, totalslides: totalslides });
	          } else {
	            this.setState({ totalslides: totalslides });
	          }
	        }
	      }
	    }
	
	    /**
	     * [createSlideComponent Creates the Match card slide functional component]
	     * @param  {[type]} index    [index of each slide in the matchcards object]
	     * @param  {[type]} key      [unique key for reactjs]
	     * @param  {[type]} itemdata [data for each slide]
	     * @return {[type]}          [returns sldier component]
	     */
	
	  }, {
	    key: 'createSlideComponent',
	    value: function createSlideComponent(index, key, itemdata) {
	      switch (key) {
	        case 1:
	          return _react2.default.createElement(FeaturesCard, { key: 'slide' + index + 1, index: index + 1, data: itemdata, states: this.state });
	        case 2:
	          return _react2.default.createElement(PhotoCard, { key: 'slide' + index + 1, index: index + 1, data: itemdata, states: this.state });
	        case 4:
	          return _react2.default.createElement(QuoteCard, { key: 'slide' + index + 1, index: index + 1, data: itemdata, states: this.state });
	        case 6:
	          return _react2.default.createElement(NumberCrunching, { key: 'slide' + index + 1, index: index + 1, data: itemdata, states: this.state });
	        case 11:
	          return _react2.default.createElement(InningsCard, { key: 'slide' + index + 1, index: index + 1, data: itemdata, states: this.state });
	        case 12:
	          return _react2.default.createElement(BowlingCard, { key: 'slide' + index + 1, index: index + 1, data: itemdata, states: this.state });
	        case 13:
	          return _react2.default.createElement(PartnershipsCard, { key: 'slide' + index + 1, index: index + 1, data: itemdata, states: this.state });
	        /*
	        case 3:
	          return <VideoCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
	        case 'theCordonCard':
	          return <TheCordonCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
	        case 'specialsCard':
	          return <SpecialsCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
	        case 'playerCard':
	          return <PlayerCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
	        case 'pieChartCard':
	          return <PieChartCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
	        case 'pollCard':
	          return <PollCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
	        case 'pollResult':
	          return <PollResult key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
	        */
	      }
	    }
	    /*
	      //Cards and type_ids implemented
	      type_id == 1 featuresCard
	      type_id == 2 photoCard
	      type_id == 4 quoteCard
	      type_id == 6 numberCrunching
	      type_id == 11 InningsCard
	      type_id == 12 Bowling
	      type_id == 13 Partnerships
	    */
	    /**
	     * [filterMatchCardsByTypeID Filters match cards that are implemented]
	     * @param  {[type]} matchcards [array of unfiltered cards]
	     * @return {[type]}            [returns array of cards]
	     */
	
	  }, {
	    key: 'filterMatchCardsByTypeID',
	    value: function filterMatchCardsByTypeID(matchcards) {
	      var allowed_typeids = [1, 2, 4, 6, 11, 12, 13];
	      var cards = [];
	      for (var i in matchcards) {
	        if (matchcards[i].hasOwnProperty('typeID') === true) {
	          if (typeof matchcards[i].typeID !== 'undefined') {
	            var typeID = parseInt(matchcards[i].typeID, 10);
	            var card = allowed_typeids.indexOf(typeID);
	            if (typeof card !== 'undefined' && card >= 0) {
	              cards.push(matchcards[i]);
	            }
	          }
	        }
	      }
	      return cards;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var PrevNextButtons = void 0;
	      var slides = void 0;
	      var prevNextStyle = {
	        'display': 'inline-block'
	      };
	      var ulStyle = {
	        'display': 'inline-block'
	
	        //return nothing if matchcards is not found
	      };if (typeof this.props.matchcards === 'undefined') {
	        return _react2.default.createElement('div', null);
	      }
	
	      var matchcards = this.props.matchcards;
	
	      matchcards = this.filterMatchCardsByTypeID(matchcards);
	      if (typeof matchcards !== 'undefined') {
	        var itemdata = {};
	        slides = (0, _keys2.default)(matchcards).map(function (index, key) {
	          index = parseInt(index, 10);
	          if (typeof matchcards[key] !== 'undefined') {
	            key = parseInt(matchcards[key].typeID, 10);
	            itemdata = matchcards[index];
	            return _this2.createSlideComponent(index, key, itemdata);
	          }
	        });
	        if (this.state.totalslides > 0) {
	          PrevNextButtons = _react2.default.createElement(PrevNext, { key: 'pn', buttonstyle: prevNextStyle, ulstyle: ulStyle, totalslides: this.state.totalslides, activeslideindex: this.state.activeslideindex, handleclicknext: this.handleClickNext.bind(this), handleclickprev: this.handleClickPrev.bind(this) });
	        }
	      }
	
	      var content = _react2.default.createElement(
	        'div',
	        { className: 'match-cards-slider slick-initialized slick-slider' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sub-module match-cards' },
	          slides
	        ),
	        PrevNextButtons
	      );
	
	      return slides.length ? content : _react2.default.createElement('div', { className: 'match-cards-slider slick-initialized slick-slider' });
	    }
	  }]);
	  return MatchCardSlider;
	}(_react2.default.Component), _class.propTypes = {
	  children: _react.PropTypes.object }, _temp);
	
	// Set default state for current slide and total slide
	
	MatchCardSlider.defaultProps = {
	  totalslides: 0,
	  activeslideindex: 0
	};
	
	exports.default = MatchCardSlider;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Scorers = exports.CloseOfPlay = exports.HawkEye = exports.Article = exports.CommentaryFeedback = exports.getAppView = exports.SquadModule = exports.SquadTabs = exports.ScorecardSummary = exports.Statistics = exports.MatchNotes = exports.InningsSummary = exports.Innings = exports.Coverage = exports.Commentary = exports.MatchDetails = undefined;
	
	var _MatchDetails = __webpack_require__(827);
	
	var _MatchDetails2 = _interopRequireDefault(_MatchDetails);
	
	var _Commentary = __webpack_require__(828);
	
	var _Commentary2 = _interopRequireDefault(_Commentary);
	
	var _Coverage = __webpack_require__(830);
	
	var _Coverage2 = _interopRequireDefault(_Coverage);
	
	var _Innings = __webpack_require__(831);
	
	var _Innings2 = _interopRequireDefault(_Innings);
	
	var _InningsSummary = __webpack_require__(832);
	
	var _InningsSummary2 = _interopRequireDefault(_InningsSummary);
	
	var _MatchNotes = __webpack_require__(833);
	
	var _MatchNotes2 = _interopRequireDefault(_MatchNotes);
	
	var _Statistics = __webpack_require__(834);
	
	var _Statistics2 = _interopRequireDefault(_Statistics);
	
	var _ScorecardSummary = __webpack_require__(836);
	
	var _ScorecardSummary2 = _interopRequireDefault(_ScorecardSummary);
	
	var _Squad = __webpack_require__(837);
	
	var _getAppView = __webpack_require__(824);
	
	var _getAppView2 = _interopRequireDefault(_getAppView);
	
	var _CommentaryFeedback = __webpack_require__(838);
	
	var _CommentaryFeedback2 = _interopRequireDefault(_CommentaryFeedback);
	
	var _Article = __webpack_require__(839);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _HawkEye = __webpack_require__(840);
	
	var _HawkEye2 = _interopRequireDefault(_HawkEye);
	
	var _CloseOfPlay = __webpack_require__(841);
	
	var _CloseOfPlay2 = _interopRequireDefault(_CloseOfPlay);
	
	var _Scorers = __webpack_require__(842);
	
	var _Scorers2 = _interopRequireDefault(_Scorers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MatchDetails = _MatchDetails2.default;
	exports.Commentary = _Commentary2.default;
	exports.Coverage = _Coverage2.default;
	exports.Innings = _Innings2.default;
	exports.InningsSummary = _InningsSummary2.default;
	exports.MatchNotes = _MatchNotes2.default;
	exports.Statistics = _Statistics2.default;
	exports.ScorecardSummary = _ScorecardSummary2.default;
	exports.SquadTabs = _Squad.SquadTabs;
	exports.SquadModule = _Squad.SquadModule;
	exports.getAppView = _getAppView2.default;
	exports.CommentaryFeedback = _CommentaryFeedback2.default;
	exports.Article = _Article2.default;
	exports.HawkEye = _HawkEye2.default;
	exports.CloseOfPlay = _CloseOfPlay2.default;
	exports.Scorers = _Scorers2.default;
	exports.default = {
	  MatchDetails: _MatchDetails2.default,
	  Commentary: _Commentary2.default,
	  Coverage: _Coverage2.default,
	  Innings: _Innings2.default,
	  InningsSummary: _InningsSummary2.default,
	  MatchNotes: _MatchNotes2.default,
	  Statistics: _Statistics2.default,
	  ScorecardSummary: _ScorecardSummary2.default,
	  SquadTabs: _Squad.SquadTabs,
	  SquadModule: _Squad.SquadModule,
	  getAppView: _getAppView2.default,
	  CommentaryFeedback: _CommentaryFeedback2.default,
	  Article: _Article2.default,
	  HawkEye: _HawkEye2.default,
	  CloseOfPlay: _CloseOfPlay2.default,
	  Scorers: _Scorers2.default
	};

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Use this component to display non linked details like Toss
	var OtherDetail = function OtherDetail(_ref) {
	  var _ref$type = _ref.type,
	      type = _ref$type === undefined ? '' : _ref$type,
	      _ref$value = _ref.value,
	      value = _ref$value === undefined ? '' : _ref$value;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'match-detail--item' },
	    _react2.default.createElement(
	      'div',
	      { className: 'match-detail--left' },
	      type && _react2.default.createElement(
	        'h4',
	        null,
	        type
	      ) || ''
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'match-detail--right' },
	      value && _react2.default.createElement(
	        'span',
	        null,
	        value
	      ) || ''
	    )
	  );
	};
	
	var MatchDetailItem = function MatchDetailItem(_ref2) {
	  var _ref2$type = _ref2.type,
	      type = _ref2$type === undefined ? '' : _ref2$type,
	      _ref2$persons = _ref2.persons,
	      persons = _ref2$persons === undefined ? [] : _ref2$persons;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'match-detail--item' },
	    _react2.default.createElement(
	      'div',
	      { className: 'match-detail--left' },
	      persons.length && _react2.default.createElement(
	        'h4',
	        null,
	        type
	      ) || ''
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'match-detail--right' },
	      persons.map(function (o, i) {
	        return _react2.default.createElement('span', { key: i, dangerouslySetInnerHTML: { __html: (o.imgicon ? '<img data-src=' + o.imgicon + ' class="lazyload"/>' : '') + ('<a name=' + o.trackingName + ' href=' + o.href + '>' + o.name + '</a>') } });
	      })
	    )
	  );
	};
	
	/**
	 * React Match Details element
	 * @return {React.PropTypes.element} Match details
	 */
	var MatchDetails = function MatchDetails(_ref3) {
	  var _ref3$officials = _ref3.officials,
	      officials = _ref3$officials === undefined ? {} : _ref3$officials,
	      _ref3$debuts = _ref3.debuts,
	      debuts = _ref3$debuts === undefined ? [] : _ref3$debuts,
	      _ref3$hoursOfPlay = _ref3.hoursOfPlay,
	      hoursOfPlay = _ref3$hoursOfPlay === undefined ? '' : _ref3$hoursOfPlay,
	      _ref3$venue = _ref3.venue,
	      venue = _ref3$venue === undefined ? '' : _ref3$venue,
	      _ref3$venueLink = _ref3.venueLink,
	      venueLink = _ref3$venueLink === undefined ? '' : _ref3$venueLink,
	      _ref3$temperature = _ref3.temperature,
	      temperature = _ref3$temperature === undefined ? '' : _ref3$temperature,
	      _ref3$location = _ref3.location,
	      location = _ref3$location === undefined ? {} : _ref3$location,
	      _ref3$hideShowClass = _ref3.hideShowClass,
	      hideShowClass = _ref3$hideShowClass === undefined ? false : _ref3$hideShowClass,
	      _ref3$toss = _ref3.toss,
	      toss = _ref3$toss === undefined ? '' : _ref3$toss,
	      _ref3$playerOfMatch = _ref3.playerOfMatch,
	      playerOfMatch = _ref3$playerOfMatch === undefined ? [] : _ref3$playerOfMatch,
	      _ref3$playerOfSeries = _ref3.playerOfSeries,
	      playerOfSeries = _ref3$playerOfSeries === undefined ? [] : _ref3$playerOfSeries,
	      _ref3$matchFormat = _ref3.matchFormat,
	      matchFormat = _ref3$matchFormat === undefined ? '' : _ref3$matchFormat,
	      _ref3$series = _ref3.series,
	      series = _ref3$series === undefined ? [] : _ref3$series,
	      _ref3$seriesResult = _ref3.seriesResult,
	      seriesResult = _ref3$seriesResult === undefined ? '' : _ref3$seriesResult,
	      _ref3$matchNo = _ref3.matchNo,
	      matchNo = _ref3$matchNo === undefined ? '' : _ref3$matchNo,
	      _ref3$season = _ref3.season,
	      season = _ref3$season === undefined ? '' : _ref3$season,
	      _ref3$matchDays = _ref3.matchDays,
	      matchDays = _ref3$matchDays === undefined ? '' : _ref3$matchDays,
	      _ref3$points = _ref3.points,
	      points = _ref3$points === undefined ? '' : _ref3$points,
	      _ref3$ballsPerOver = _ref3.ballsPerOver,
	      ballsPerOver = _ref3$ballsPerOver === undefined ? '' : _ref3$ballsPerOver,
	      _ref3$playersperside = _ref3.playersperside,
	      playersperside = _ref3$playersperside === undefined ? '' : _ref3$playersperside,
	      _ref3$featuredAthlete = _ref3.featuredAthletesDetails,
	      featuredAthletesDetails = _ref3$featuredAthlete === undefined ? [] : _ref3$featuredAthlete,
	      _ref3$playerReplaceme = _ref3.playerReplacement,
	      playerReplacement = _ref3$playerReplaceme === undefined ? [] : _ref3$playerReplaceme;
	
	  var umpire = officials.umpire && officials.umpire || [];
	  var tvUmpire = officials['tv umpire'] && officials['tv umpire'] || [];
	  var reserveUmpire = officials['reserve umpire'] && officials['reserve umpire'] || [];
	  var referee = officials.referee && officials.referee || [];
	  var props = [debuts.length, umpire.length, tvUmpire.length, reserveUmpire.length, referee.length, hoursOfPlay, location.shortName, location.summary, venue, venueLink, temperature, playerOfMatch.length, playerOfSeries.length, matchFormat, featuredAthletesDetails.length];
	  var show = false;
	
	  // loops through all props and sets show=true
	  // if any one of them is available
	  for (var i = 0; i < props.length; i++) {
	    if (props[i]) {
	      show = true;
	    }
	  }
	
	  var content = _react2.default.createElement(
	    'div',
	    { className: hideShowClass ? 'hide-show mobile' : '' },
	    _react2.default.createElement(
	      'article',
	      { className: 'sub-module game-information pre' },
	      _react2.default.createElement(
	        'header',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Match Details'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'match-detail-container' },
	          venue && _react2.default.createElement(
	            'div',
	            { className: 'stadium-details' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              venueLink ? _react2.default.createElement(
	                'a',
	                { name: venue, href: venueLink },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  venue
	                )
	              ) : _react2.default.createElement(
	                'span',
	                null,
	                venue
	              )
	            )
	          ),
	          series.length && _react2.default.createElement(MatchDetailItem, { type: 'Series', persons: series }) || null,
	          playersperside && _react2.default.createElement(OtherDetail, { type: 'Players per side', value: playersperside }) || null,
	          toss && _react2.default.createElement(OtherDetail, { type: 'Toss', value: toss }) || null,
	          featuredAthletesDetails && featuredAthletesDetails.map(function (item, i) {
	            if (item[1].length === 0) {
	              return null;
	            }
	            var featuredAthleteType = (0, _selectn2.default)('[0].featuredAthletesType', item[1]) || '';
	            return _react2.default.createElement(MatchDetailItem, { key: i, type: featuredAthleteType, persons: item[1] });
	          }),
	          seriesResult.length && _react2.default.createElement(OtherDetail, { type: 'Series result', value: seriesResult }) || null,
	          matchNo.name && _react2.default.createElement(MatchDetailItem, { type: 'Match number', persons: [matchNo] }) || null,
	          season.name && _react2.default.createElement(MatchDetailItem, { type: 'Season', persons: [season] }) || null,
	          hoursOfPlay && _react2.default.createElement(OtherDetail, { type: 'Hours of play (local time)', value: hoursOfPlay }) || null,
	          matchDays.length && _react2.default.createElement(OtherDetail, { type: 'Match days', value: matchDays }) || null,
	          debuts.length && _react2.default.createElement(MatchDetailItem, { type: matchFormat + ' debut', persons: debuts }) || null,
	          playerReplacement.map(function (item) {
	            var links = item.links || [];
	            if (links.length === 0) {
	              return null;
	            }
	            return _react2.default.createElement(
	              'div',
	              { className: 'match-detail--item' },
	              _react2.default.createElement(
	                'div',
	                { className: 'match-detail--left' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  item.text
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'match-detail--right' },
	                links.map(function (link) {
	                  return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: link } });
	                })
	              )
	            );
	          }),
	          umpire.length && _react2.default.createElement(MatchDetailItem, { type: 'Umpires', persons: officials.umpire }) || null,
	          tvUmpire.length && _react2.default.createElement(MatchDetailItem, { type: 'TV Umpires', persons: officials['tv umpire'] }) || null,
	          reserveUmpire.length && _react2.default.createElement(MatchDetailItem, { type: 'Reserve Umpire', persons: officials['reserve umpire'] }) || null,
	          referee.length && _react2.default.createElement(MatchDetailItem, { type: 'Match Referee', persons: officials.referee }) || null,
	          points.length && _react2.default.createElement(OtherDetail, { type: 'Points', value: points }) || null,
	          ballsPerOver.length && _react2.default.createElement(OtherDetail, { type: 'Balls per over', value: ballsPerOver }) || null
	        )
	      )
	    )
	  );
	
	  return show ? content : _react2.default.createElement('article', { className: 'sub-module game-information pre' });
	};
	
	exports.default = MatchDetails;
	
	'';

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _common = __webpack_require__(686);
	
	var _common2 = __webpack_require__(423);
	
	var _index = __webpack_require__(826);
	
	var _bet365AffiliateCodes = __webpack_require__(829);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Entities = __webpack_require__(652).XmlEntities;
	
	var entities = new Entities();
	
	var EndOfOver = function EndOfOver(_ref) {
	  var _ref$details = _ref.details,
	      details = _ref$details === undefined ? '' : _ref$details,
	      _ref$batsmen = _ref.batsmen,
	      batsmen = _ref$batsmen === undefined ? [] : _ref$batsmen,
	      _ref$bowlers = _ref.bowlers,
	      bowlers = _ref$bowlers === undefined ? [] : _ref$bowlers,
	      _ref$bet = _ref.bet365,
	      bet365 = _ref$bet === undefined ? {} : _ref$bet,
	      _ref$endOfOverRunsReq = _ref.endOfOverRunsReq,
	      endOfOverRunsReq = _ref$endOfOverRunsReq === undefined ? '' : _ref$endOfOverRunsReq,
	      isLimitedOvers = _ref.isLimitedOvers,
	      _ref$editionDomain = _ref.editionDomain,
	      editionDomain = _ref$editionDomain === undefined ? '' : _ref$editionDomain;
	
	  var affiliateCode = editionDomain === 'www.espncricinfo.com' ? _bet365AffiliateCodes.bet365AffiliateCodes.endOfOver : _bet365AffiliateCodes.bet365AffiliateCodes.editions;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'commentary-item end-of-over' },
	    _react2.default.createElement(
	      'h4',
	      null,
	      'END OF OVER:',
	      _react2.default.createElement(
	        'div',
	        null,
	        details + ' ',
	        isLimitedOvers ? endOfOverRunsReq : null
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'two-col-table' },
	      batsmen.map(function () {
	        var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var i = arguments[1];
	
	        return _react2.default.createElement('li', { key: i, dangerouslySetInnerHTML: { __html: player.name + '<span>' + player.stat + '</span>' } });
	      })
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'two-col-table' },
	      bowlers.map(function () {
	        var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var i = arguments[1];
	
	        return _react2.default.createElement('li', { key: i, dangerouslySetInnerHTML: { __html: player.name + '<span>' + player.stat + '</span>' } });
	      })
	    ),
	    bet365.showInEdition && bet365.showInGeo && _react2.default.createElement(
	      'div',
	      { className: 'bet' },
	      _react2.default.createElement(_common.Bet365, (0, _extends3.default)({}, bet365, { type: 'odds', pageType: 'game', affiliateCodeOverwrite: affiliateCode }))
	    )
	  );
	};
	
	var CommentaryItem = function CommentaryItem(_ref2) {
	  var _ref2$text = _ref2.text,
	      text = _ref2$text === undefined ? '' : _ref2$text,
	      _ref2$timeStamp = _ref2.timeStamp,
	      timeStamp = _ref2$timeStamp === undefined ? '' : _ref2$timeStamp,
	      _ref2$pre = _ref2.pre,
	      pre = _ref2$pre === undefined ? '' : _ref2$pre,
	      _ref2$post = _ref2.post,
	      post = _ref2$post === undefined ? '' : _ref2$post,
	      _ref2$video = _ref2.video,
	      video = _ref2$video === undefined ? {} : _ref2$video,
	      event = _ref2.event,
	      _ref2$hasVideoId = _ref2.hasVideoId,
	      hasVideoId = _ref2$hasVideoId === undefined ? false : _ref2$hasVideoId,
	      _ref2$videoId = _ref2.videoId,
	      videoId = _ref2$videoId === undefined ? '' : _ref2$videoId,
	      isWebView = _ref2.isWebView,
	      _ref2$commId = _ref2.commId,
	      commId = _ref2$commId === undefined ? '' : _ref2$commId,
	      _ref2$commSeq = _ref2.commSeq,
	      commSeq = _ref2$commSeq === undefined ? '' : _ref2$commSeq,
	      _ref2$dismissalText = _ref2.dismissalText,
	      dismissalText = _ref2$dismissalText === undefined ? '' : _ref2$dismissalText;
	
	
	  var eventClassName = (0, _common2.getBallClass)(event);
	
	  //console.info('isPartCommentary', isPartCommentary)
	
	  var topComms = post;
	  var bottomComms = pre;
	  var commDefaultText = entities.decode(text.replace(/\n/gm, '<br/>'));
	
	  /*
	  let videoStyles = {
	    position: 'absolute',
	    margin: 'auto 0'
	  }
	  */
	  //console.info('video in jsx', video)
	  return _react2.default.createElement(
	    'div',
	    { className: 'commentary-item ' + (pre || post ? 'pre' : '') + ' ' + (hasVideoId ? 'commentary-item--hasVideo' : '') },
	    topComms && entities.decode(topComms).split('\n\n').map(function (text, i) {
	      var tKey = 't' + commSeq + commId + i;
	      //console.info('topCommsID', tKey)
	      return _react2.default.createElement('p', { className: 'comment', key: tKey, dangerouslySetInnerHTML: { __html: text } });
	    }) || null,
	    timeStamp && _react2.default.createElement(
	      'div',
	      { className: 'item-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'over' },
	        _react2.default.createElement(
	          'div',
	          { className: 'time-stamp' },
	          timeStamp
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(eventClassName) },
	          _react2.default.createElement(
	            'span',
	            { className: 'over-score' },
	            event
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: 'description', dangerouslySetInnerHTML: { __html: commDefaultText } }),
	      hasVideoId && _react2.default.createElement(
	        'div',
	        { key: videoId, className: 'highlight active' },
	        _react2.default.createElement(
	          'a',
	          { 'data-linktype': 'lecvideo', className: (0, _classnames2.default)('highlight icon-font-after icon-play-solid-after gamepackage_bloom module_bloom_behavior', { 'app_partial': isWebView }), 'data-behavior': 'module_bloom', 'data-id': videoId },
	          _react2.default.createElement(_common.Video, (0, _extends3.default)({}, video, { showCaption: true, className: '' }))
	        )
	      ) || null
	    ) || null,
	    dismissalText.length && _react2.default.createElement('p', { className: 'dismissal', dangerouslySetInnerHTML: { __html: dismissalText } }) || null,
	    bottomComms && entities.decode(bottomComms).split('\n\n').map(function (text, i) {
	      var bKey = 'b' + commSeq + commId + i;
	      //console.info('bottomCommsID', bKey)
	      return _react2.default.createElement('p', { className: 'comment', key: bKey, dangerouslySetInnerHTML: { __html: text } });
	    }) || null
	  );
	};
	
	/**
	 * React Commentary element
	 * @return {React.PropTypes.element} Commentary
	 */
	var Commentary = function Commentary(_ref3) {
	  var _ref3$scorer = _ref3.scorer,
	      scorer = _ref3$scorer === undefined ? '' : _ref3$scorer,
	      _ref3$commentator = _ref3.commentator,
	      commentator = _ref3$commentator === undefined ? '' : _ref3$commentator,
	      _ref3$showFooter = _ref3.showFooter,
	      showFooter = _ref3$showFooter === undefined ? false : _ref3$showFooter,
	      _ref3$href = _ref3.href,
	      href = _ref3$href === undefined ? '' : _ref3$href,
	      _ref3$overs = _ref3.overs,
	      overs = _ref3$overs === undefined ? [] : _ref3$overs,
	      _ref3$allInnings = _ref3.allInnings,
	      allInnings = _ref3$allInnings === undefined ? [] : _ref3$allInnings,
	      _ref3$selInnings = _ref3.selInnings,
	      selInnings = _ref3$selInnings === undefined ? '' : _ref3$selInnings,
	      _ref3$showFilters = _ref3.showFilters,
	      showFilters = _ref3$showFilters === undefined ? false : _ref3$showFilters,
	      cmtryFilter = _ref3.cmtryFilter,
	      selFilter = _ref3.selFilter,
	      _ref3$page = _ref3.page,
	      page = _ref3$page === undefined ? null : _ref3$page,
	      _ref3$hasMore = _ref3.hasMore,
	      hasMore = _ref3$hasMore === undefined ? true : _ref3$hasMore,
	      updateMoreCommentary = _ref3.updateMoreCommentary,
	      _ref3$isPartCommentar = _ref3.isPartCommentary,
	      isPartCommentary = _ref3$isPartCommentar === undefined ? false : _ref3$isPartCommentar,
	      _ref3$commentPreText = _ref3.commentPreText,
	      commentPreText = _ref3$commentPreText === undefined ? '' : _ref3$commentPreText,
	      _ref3$trackingName = _ref3.trackingName,
	      trackingName = _ref3$trackingName === undefined ? '' : _ref3$trackingName,
	      _ref3$isWebView = _ref3.isWebView,
	      isWebView = _ref3$isWebView === undefined ? false : _ref3$isWebView,
	      routerPush = _ref3.routerPush,
	      _ref3$bet = _ref3.bet365,
	      bet365 = _ref3$bet === undefined ? {} : _ref3$bet,
	      isLimitedOvers = _ref3.isLimitedOvers,
	      isSmallDevice = _ref3.isSmallDevice,
	      _ref3$gameState = _ref3.gameState,
	      gameState = _ref3$gameState === undefined ? '' : _ref3$gameState,
	      _ref3$editionDomain = _ref3.editionDomain,
	      editionDomain = _ref3$editionDomain === undefined ? '' : _ref3$editionDomain;
	
	
	  var commentary = _react2.default.createElement(
	    'article',
	    { className: (0, _classnames2.default)('sub-module match-commentary cricket', { 'add-padding': !isPartCommentary }) },
	    showFilters && allInnings.length && _react2.default.createElement(
	      'header',
	      { className: 'bordered' },
	      _react2.default.createElement(
	        'div',
	        { className: 'filters' },
	        _react2.default.createElement(_common.Dropdown, { items: allInnings, selected: selInnings.name, routerPush: routerPush }),
	        cmtryFilter && _react2.default.createElement(_common.Dropdown, { items: cmtryFilter, selected: selFilter, routerPush: routerPush })
	      )
	    ) || null,
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	
	      //this should appear only on mobile and when match is not final 
	      (scorer || commentator) && gameState !== 'final' && isSmallDevice && _react2.default.createElement(_index.Scorers, { scorer: scorer, commentator: commentator }) || null,
	      //this should appear in all breakpoints when match is in Final
	      (scorer || commentator) && gameState === 'final' && _react2.default.createElement(_index.Scorers, { scorer: scorer, commentator: commentator }) || null,
	      overs.map(function (o, i) {
	        var eodProps = {
	          details: o.endOfOver,
	          batsmen: o.batsmen,
	          bowlers: o.bowlers,
	          endOfOverRunsReq: o.endOfOverRunsReq,
	          isLimitedOvers: isLimitedOvers,
	          editionDomain: editionDomain
	        };
	
	        if (o.endOfOver && o.hasLastEndOfOver && (selInnings.isCurrent || isPartCommentary)) {
	          eodProps.bet365 = bet365;
	        }
	        var comms = (o.comments || []).map(function (c) {
	          return _react2.default.createElement(CommentaryItem, (0, _extends3.default)({ key: c.commSeq, timeStamp: c.timeStamp, commId: c.commId, commSeq: c.commSeq }, c, { index: i, isWebView: isWebView }));
	        });
	        var overSummary = [o.endOfOver && _react2.default.createElement(EndOfOver, (0, _extends3.default)({ key: i }, eodProps)) || null, comms];
	        return overSummary;
	      }),
	      updateMoreCommentary && _react2.default.createElement(_common.Lazyload, { page: page, threshold: 0.3, hasMore: hasMore, updateMore: updateMoreCommentary, enableLoader: true, enableForceLazyload: true, increment: -1 })
	    ),
	    page > 1 && _react2.default.createElement(_common.BackToTop, null),
	    showFooter && href && _react2.default.createElement(
	      'footer',
	      null,
	      _react2.default.createElement(_common.AnchorLink, { name: trackingName, to: href, text: 'Full Commentary' })
	    )
	  );
	
	  return overs.length || overs.length === 0 && commentPreText ? commentary : _react2.default.createElement('article', { className: 'sub-module match-commentary cricket' });
	};
	
	exports.default = Commentary;

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var bet365AffiliateCodes = exports.bet365AffiliateCodes = {
	  nextBatsmanOut: '365_728176',
	  endOfOver: '365_728177',
	  scoreboard: '365_728175',
	  editions: '365_728182',
	  scoreboardEdition: '365_728181'
	};

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Coverage = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(412);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(686);
	
	var _common2 = __webpack_require__(423);
	
	var _common3 = __webpack_require__(624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var articleTypeLabels = {
	  Recap: 'Report',
	  Preview: 'Preview'
	};
	
	var ConditionalAnchorLink = function ConditionalAnchorLink(params) {
	  var isReactEnabledLink = params.isReactEnabledLink,
	      rest = (0, _objectWithoutProperties3.default)(params, ['isReactEnabledLink']);
	
	  return isReactEnabledLink ? _react2.default.createElement(_common.AnchorLink, rest) : _react2.default.createElement(
	    'a',
	    { href: rest.to, className: rest.classes, name: rest.trackingName },
	    rest.text
	  );
	};
	
	var CoverageArticle = function CoverageArticle(_ref) {
	  var _ref$id = _ref.id,
	      id = _ref$id === undefined ? '' : _ref$id,
	      _ref$headline = _ref.headline,
	      headline = _ref$headline === undefined ? '' : _ref$headline,
	      _ref$type = _ref.type,
	      type = _ref$type === undefined ? '' : _ref$type,
	      _ref$description = _ref.description,
	      description = _ref$description === undefined ? '' : _ref$description,
	      _ref$isReactEnabledLi = _ref.isReactEnabledLink,
	      isReactEnabledLink = _ref$isReactEnabledLi === undefined ? false : _ref$isReactEnabledLi,
	      _ref$href = _ref.href,
	      href = _ref$href === undefined ? '' : _ref$href,
	      _ref$image = _ref.image,
	      image = _ref$image === undefined ? {} : _ref$image,
	      _ref$video = _ref.video,
	      video = _ref$video === undefined ? {} : _ref$video,
	      _ref$published = _ref.published,
	      published = _ref$published === undefined ? '' : _ref$published,
	      _ref$author = _ref.author,
	      author = _ref$author === undefined ? '' : _ref$author,
	      _ref$trackingName = _ref.trackingName,
	      trackingName = _ref$trackingName === undefined ? '' : _ref$trackingName;
	
	
	  var categoryLink = articleTypeLabels[type] ? _react2.default.createElement(
	    'div',
	    { className: 'category-link' },
	    _react2.default.createElement(ConditionalAnchorLink, { isReactEnabledLink: isReactEnabledLink, to: href, text: articleTypeLabels[type] })
	  ) : '';
	
	  var allSources = [{
	    config: [{
	      combinerOptions: {
	        w: 208,
	        h: 117
	      }
	    }],
	    mediaQuery: '(min-width: 414px)'
	  }, {
	    config: [{
	      combinerOptions: {
	        w: 156,
	        h: 156,
	        cquality: 40,
	        scale: 'crop'
	      },
	      others: '2x'
	    }],
	    mediaQuery: '(max-width: 413px)'
	  }];
	
	  var thumbnailUrl = video.thumbnail || image.url;
	  var articleMedia = thumbnailUrl ? _react2.default.createElement(
	    'figure',
	    { className: 'feed-item-figure' },
	    _react2.default.createElement(ConditionalAnchorLink, { isReactEnabledLink: isReactEnabledLink, classes: 'img-wrap', to: href, name: trackingName, text: _react2.default.createElement(_common.Picture, {
	        thumbnail: _common3.common.getCombinerImage(thumbnailUrl),
	        imgClasses: { lazyload: true },
	        allSources: allSources
	      }) })
	  ) : '';
	
	  return _react2.default.createElement(
	    'article',
	    { 'data-id': id, className: 'news-feed-item' },
	    _react2.default.createElement(ConditionalAnchorLink, { isReactEnabledLink: isReactEnabledLink, to: href, name: trackingName }),
	    articleMedia,
	    _react2.default.createElement(
	      'div',
	      { className: 'text-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'item-info-wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'news-feed_item-meta' },
	          categoryLink,
	          _react2.default.createElement('span', { className: 'timestamp', dangerouslySetInnerHTML: { __html: (0, _common2.relativeDate)(new Date(published)) } }),
	          _react2.default.createElement('span', { className: 'author', dangerouslySetInnerHTML: { __html: author || '' } })
	        ),
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(ConditionalAnchorLink, { isReactEnabledLink: isReactEnabledLink, classes: 'realStory', to: href, name: trackingName, text: headline })
	        ),
	        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: description } })
	      )
	    )
	  );
	};
	
	var CoverageDay = function CoverageDay(_ref2) {
	  var label = _ref2.label,
	      _ref2$params = _ref2.params,
	      params = _ref2$params === undefined ? {} : _ref2$params,
	      _ref2$articles = _ref2.articles,
	      articles = _ref2$articles === undefined ? [] : _ref2$articles;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'feed-section' },
	    _react2.default.createElement('header', { className: 'comp section-header', dangerouslySetInnerHTML: { __html: label ? '<h1>' + label + '</h1>' : '' } }),
	    articles.map(function (article, i) {
	      return _react2.default.createElement(CoverageArticle, (0, _extends3.default)({}, article, { params: params, key: i }));
	    })
	  );
	};
	
	var Coverage = exports.Coverage = function Coverage(_ref3) {
	  var _ref3$matchCoverage = _ref3.matchCoverage,
	      matchCoverage = _ref3$matchCoverage === undefined ? [] : _ref3$matchCoverage,
	      _ref3$params = _ref3.params,
	      params = _ref3$params === undefined ? {} : _ref3$params;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    matchCoverage.map(function (matchCoverageDay, i) {
	      return _react2.default.createElement(CoverageDay, (0, _extends3.default)({ key: i, params: params }, matchCoverageDay));
	    })
	  );
	};
	
	exports.default = Coverage;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Innings = exports.Inning = undefined;
	
	var _keys = __webpack_require__(415);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(686);
	
	var _common2 = __webpack_require__(423);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Entities = __webpack_require__(652).XmlEntities;
	
	var entities = new Entities();
	
	/**
	 * Print a inline list of players
	 * @return {React.Element} list of players
	 */
	var MultiplePlayers = function MultiplePlayers(_ref) {
	  var _ref$players = _ref.players,
	      players = _ref$players === undefined ? [] : _ref$players,
	      _ref$remainingBatsmen = _ref.remainingBatsmen,
	      remainingBatsmen = _ref$remainingBatsmen === undefined ? '' : _ref$remainingBatsmen;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex-row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'wrap dnb' },
	      _react2.default.createElement(
	        'div',
	        { className: 'cell' },
	        _react2.default.createElement(
	          'span',
	          { className: 'text-bold' },
	          remainingBatsmen,
	          ': '
	        ),
	        players.map(function () {
	          var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var i = arguments[1];
	          return _react2.default.createElement(
	            'a',
	            { key: i, href: p.href },
	            _react2.default.createElement('span', { dangerouslySetInnerHTML: (0, _common2.getPlayerRoles)(p.name, p.roles, i == players.length - 1 ? '' : ', ') })
	          );
	        })
	      )
	    )
	  );
	};
	
	/**
	 * get fall of wicket markup.
	 * Function is required since text appears in text nodes and not inside any
	 * wrapper nodes.
	 *
	 * @param  {Array}  fows strings of wickets fallen
	 * @return {Object}      html markup object
	 */
	function getFowMarkup() {
	  var fows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var fowMarkup = '';
	  if (fows.length > 0) {
	    fowMarkup = '<span class="text-bold">Fall of wickets: </span>' + fows.join(', ');
	  }
	  return { __html: fowMarkup };
	}
	
	/**
	 * Get markup of the commentary for each out batsman.
	 * @param  {Object}  batsman
	 * Format is {over number } {out commentary} {fall of wicket i.e. runs/wicket}
	 * @return {Object} markup html
	 */
	function getCommentaryMarkup() {
	  var batsman = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var overs = (0, _selectn2.default)('runningOver.overs', batsman) || '';
	  var runs = (0, _selectn2.default)('runningScore.runs', batsman);
	  var wickets = (0, _selectn2.default)('runningScore.wickets', batsman) || '';
	  var commentary = [];
	  if (overs != '') {
	    commentary.push('<span class="text-bold"> ' + overs + ' </span>');
	  }
	
	  if (typeof batsman.commentary != 'undefined' && batsman.commentary != '') {
	    commentary.push(batsman.commentary);
	  }
	
	  // Store run and wickets
	  var runsWickets = [];
	  // Push runs and wickets if available
	  if (typeof runs !== 'undefined') {
	    runsWickets.push(runs);
	  }
	  if (wickets !== '') {
	    runsWickets.push(wickets);
	  }
	
	  // Append to comms only if runs/wickets are available
	  if (runsWickets.length !== 0) {
	    commentary.push('<span class="text-bold"> ' + runsWickets.join('/') + ' </span>');
	  }
	  return { __html: entities.decode(commentary.join(' ')) };
	}
	
	var Batting = function Batting(_ref2) {
	  var _ref2$batsmen = _ref2.batsmen,
	      batsmen = _ref2$batsmen === undefined ? [] : _ref2$batsmen,
	      _ref2$didNotBat = _ref2.didNotBat,
	      didNotBat = _ref2$didNotBat === undefined ? [] : _ref2$didNotBat,
	      _ref2$absent = _ref2.absent,
	      absent = _ref2$absent === undefined ? [] : _ref2$absent,
	      _ref2$total = _ref2.total,
	      total = _ref2$total === undefined ? '' : _ref2$total,
	      _ref2$extras = _ref2.extras,
	      extras = _ref2$extras === undefined ? '' : _ref2$extras,
	      _ref2$remainingBatsme = _ref2.remainingBatsmen,
	      remainingBatsmen = _ref2$remainingBatsme === undefined ? '' : _ref2$remainingBatsme,
	      id = _ref2.id,
	      _ref2$isWebView = _ref2.isWebView,
	      isWebView = _ref2$isWebView === undefined ? false : _ref2$isWebView,
	      _ref2$keys = _ref2.keys,
	      keys = _ref2$keys === undefined ? {} : _ref2$keys,
	      _ref2$fows = _ref2.fows,
	      fows = _ref2$fows === undefined ? [] : _ref2$fows;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'scorecard-section batsmen' },
	    batsmen.map(function () {
	      var batsman = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { stats: [] };
	      var i = arguments[1];
	
	      var stats = batsman ? batsman.stats : [];
	      return batsman && _react2.default.createElement(
	        'div',
	        { key: i, className: 'flex-row' },
	        i === 0 && _react2.default.createElement(
	          'div',
	          { className: 'wrap header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'cell batsmen' },
	            'BATSMEN'
	          ),
	          _react2.default.createElement('div', { className: 'cell commentary' }),
	          stats && stats.map(function () {
	            var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var j = arguments[1];
	            return keys[s.name] == true ? _react2.default.createElement(
	              'div',
	              { key: j, className: 'cell runs' },
	              s && s.text
	            ) : null;
	          }),
	          _react2.default.createElement('div', { className: 'cell highlight' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap batsmen' },
	          _react2.default.createElement(
	            'div',
	            { className: 'cell batsmen' },
	            _react2.default.createElement('a', { name: batsman.trackingName, href: batsman.href, dangerouslySetInnerHTML: (0, _common2.getPlayerRoles)(batsman.name, batsman.roles) })
	          ),
	          _react2.default.createElement('div', { className: 'cell commentary', dangerouslySetInnerHTML: (0, _common2.getBatsmanComm)(batsman, i, id) }),
	          stats && stats.map(function () {
	            var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var j = arguments[1];
	            return keys[s.name] == true ? _react2.default.createElement(
	              'div',
	              { key: j, className: 'cell runs' },
	              s && s.value
	            ) : null;
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'cell highlight active' },
	            batsman.hasVideoId && _react2.default.createElement(
	              'a',
	              { key: batsman.videoId, 'data-linktype': 'lecvideo', className: (0, _classnames2.default)('highlight icon-font-after icon-play-solid-after gamepackage_bloom module_bloom_behavior', { 'app_partial': isWebView }), 'data-behavior': 'module_bloom', 'data-id': batsman.videoId },
	              _react2.default.createElement(_common.Video, (0, _extends3.default)({}, batsman.video, { showCaption: true, className: '' }))
	            ) || null
	          )
	        ),
	        batsman.commentary && _react2.default.createElement(
	          'div',
	          { id: 'commentary-00' + (i + 1) + '-' + id, className: 'commentary-content collapse' },
	          _react2.default.createElement('div', { className: 'content', dangerouslySetInnerHTML: getCommentaryMarkup(batsman) })
	        ) || null
	      );
	    }),
	    absent.map(function () {
	      var absentHurt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var i = arguments[1];
	
	      return absentHurt && _react2.default.createElement(
	        'div',
	        { key: i, className: 'flex-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap batsmen' },
	          _react2.default.createElement(
	            'div',
	            { className: 'cell batsmen' },
	            _react2.default.createElement('a', { name: absentHurt.trackingName, href: absentHurt.href, dangerouslySetInnerHTML: (0, _common2.getPlayerRoles)(absentHurt.name, absentHurt.roles) })
	          ),
	          _react2.default.createElement('div', { className: 'cell commentary', dangerouslySetInnerHTML: (0, _common2.getBatsmanComm)(absentHurt, i, id) }),
	          _react2.default.createElement(
	            'div',
	            { className: 'cell runs', style: { clear: 'both', width: '26%', textAlign: 'left' } },
	            ' - '
	          )
	        )
	      );
	    }),
	    extras && _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrap extras' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cell' },
	          'Extras'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cell' },
	          extras
	        )
	      )
	    ),
	    total && _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrap total' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cell' },
	          'TOTAL'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cell' },
	          total
	        )
	      )
	    ),
	    didNotBat && didNotBat.length && _react2.default.createElement(MultiplePlayers, { players: didNotBat, remainingBatsmen: remainingBatsmen }) || null,
	    fows && fows.length > 0 && _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrap dnb' },
	        _react2.default.createElement('div', { className: 'cell', dangerouslySetInnerHTML: getFowMarkup(fows) })
	      )
	    ) || null
	  );
	};
	
	var Bowling = function Bowling(_ref3) {
	  var _ref3$bowlers = _ref3.bowlers,
	      bowlers = _ref3$bowlers === undefined ? [] : _ref3$bowlers,
	      isWebView = _ref3.isWebView,
	      _ref3$keys = _ref3.keys,
	      keys = _ref3$keys === undefined ? {} : _ref3$keys;
	
	
	  var firstBowler = bowlers[0] || {};
	  var stats = firstBowler.stats || [];
	  var playIconClass = (0, _classnames2.default)('highlight icon-font-after icon-play-solid-after gamepackage_bloom module_bloom_behavior', { 'app_partial': isWebView });
	
	  if (bowlers && bowlers.length === 0) {
	    return _react2.default.createElement('span', null);
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'scorecard-section bowling' },
	    _react2.default.createElement(
	      'table',
	      { cellSpacing: '0', cellPadding: '0', 'data-fix-cols': '0', 'data-behavior': 'responsive_table' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Bowling'
	          ),
	          _react2.default.createElement('th', { className: 'highlight mobile' }),
	          stats.map(function () {
	            var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var j = arguments[1];
	
	            return s && s.value != '' && keys[s.name] && _react2.default.createElement(
	              'th',
	              { key: j, className: 'cell runs' },
	              s.text
	            );
	          }),
	          _react2.default.createElement('th', { className: 'highlight' })
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        bowlers.map(function () {
	          var bowler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var i = arguments[1];
	
	          return bowler && _react2.default.createElement(
	            'tr',
	            { key: i },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'a',
	                { name: bowler.trackingName, href: bowler.href },
	                '' + bowler.name
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'highlight mobile active' },
	              bowler.hasVideoId && _react2.default.createElement(
	                'a',
	                { 'data-linktype': 'lecvideo', className: playIconClass, 'data-behavior': 'module_bloom', 'data-id': bowler.videoId },
	                _react2.default.createElement(_common.Video, (0, _extends3.default)({}, bowler.video, { showCaption: true, className: '' }))
	              ) || null
	            ),
	            (bowler && bowler.stats || []).map(function () {
	              var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	              var j = arguments[1];
	
	              return s && s.value != '' && keys[s.name] && _react2.default.createElement(
	                'td',
	                { key: j },
	                s.value
	              );
	            }),
	            _react2.default.createElement(
	              'td',
	              { className: 'highlight active' },
	              bowler.hasVideoId && _react2.default.createElement(
	                'a',
	                { 'data-linktype': 'lecvideo', className: playIconClass, 'data-behavior': 'module_bloom', 'data-id': bowler.videoId },
	                _react2.default.createElement(_common.Video, (0, _extends3.default)({}, bowler.video, { showCaption: true, className: '' }))
	              ) || null
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	var Team = function Team(_ref4) {
	  var _ref4$details = _ref4.details,
	      details = _ref4$details === undefined ? {} : _ref4$details;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'scorecard-section board' },
	    _react2.default.createElement(
	      'table',
	      { cellSpacing: '0', cellPadding: '0' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            { colSpan: '2' },
	            details.name,
	            ' Team'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        details.players.map(function () {
	          var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var i = arguments[1];
	
	          return _react2.default.createElement(
	            'tr',
	            { key: i },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement('a', { href: player.href, dangerouslySetInnerHTML: (0, _common2.getPlayerRoles)(player.name, player.roles) })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              player.athleteRole || player.role
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	var Inning = exports.Inning = function Inning(_ref5) {
	  var _ref5$title = _ref5.title,
	      title = _ref5$title === undefined ? 'Innings' : _ref5$title,
	      _ref5$batsmen = _ref5.batsmen,
	      batsmen = _ref5$batsmen === undefined ? [] : _ref5$batsmen,
	      _ref5$bowlers = _ref5.bowlers,
	      bowlers = _ref5$bowlers === undefined ? [] : _ref5$bowlers,
	      _ref5$didNotBat = _ref5.didNotBat,
	      didNotBat = _ref5$didNotBat === undefined ? [] : _ref5$didNotBat,
	      _ref5$absent = _ref5.absent,
	      absent = _ref5$absent === undefined ? [] : _ref5$absent,
	      _ref5$total = _ref5.total,
	      total = _ref5$total === undefined ? '' : _ref5$total,
	      _ref5$extras = _ref5.extras,
	      extras = _ref5$extras === undefined ? '' : _ref5$extras,
	      _ref5$remainingBatsme = _ref5.remainingBatsmen,
	      remainingBatsmen = _ref5$remainingBatsme === undefined ? '' : _ref5$remainingBatsme,
	      _ref5$fows = _ref5.fows,
	      fows = _ref5$fows === undefined ? [] : _ref5$fows,
	      id = _ref5.id,
	      _ref5$otherTeamDetail = _ref5.otherTeamDetails,
	      otherTeamDetails = _ref5$otherTeamDetail === undefined ? {} : _ref5$otherTeamDetail,
	      _ref5$isWebView = _ref5.isWebView,
	      isWebView = _ref5$isWebView === undefined ? false : _ref5$isWebView,
	      _ref5$batsmenKeys = _ref5.batsmenKeys,
	      batsmenKeys = _ref5$batsmenKeys === undefined ? {} : _ref5$batsmenKeys,
	      _ref5$bowlerKeys = _ref5.bowlerKeys,
	      bowlerKeys = _ref5$bowlerKeys === undefined ? {} : _ref5$bowlerKeys,
	      _ref5$headerInfo = _ref5.headerInfo,
	      headerInfo = _ref5$headerInfo === undefined ? '' : _ref5$headerInfo,
	      isSmallDevice = _ref5.isSmallDevice,
	      _ref5$isCurrent = _ref5.isCurrent,
	      isCurrent = _ref5$isCurrent === undefined ? false : _ref5$isCurrent,
	      _ref5$gameState = _ref5.gameState,
	      gameState = _ref5$gameState === undefined ? '' : _ref5$gameState;
	
	  var inningsTitle = isSmallDevice === false ? title + ' ' + headerInfo : '' + title;
	  var openClose = gameState === 'live' ? isCurrent : true;
	  var ariaExpanded = openClose ? true : false;
	  return _react2.default.createElement(
	    'article',
	    { className: 'sub-module scorecard' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'css-accordion' },
	      _react2.default.createElement(
	        'li',
	        { className: 'accordion-item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'accordion-header' },
	          _react2.default.createElement(
	            'a',
	            { role: 'button', 'data-toggle': 'collapse', href: '#gp-inning-0' + id, 'aria-expanded': ariaExpanded, 'aria-controls': 'gp-inning-0' + id, className: openClose ? '' : 'collapsed' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              inningsTitle
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'gp-inning-0' + id, className: (0, _classnames2.default)('accordion-content collapse', { 'in': openClose }), 'aria-expanded': ariaExpanded },
	          _react2.default.createElement(Batting, { id: id, batsmen: batsmen, didNotBat: didNotBat, absent: absent, total: total, extras: extras, remainingBatsmen: remainingBatsmen, fows: fows, isWebView: isWebView, keys: batsmenKeys }),
	          _react2.default.createElement(Bowling, { id: id, bowlers: bowlers, isWebView: isWebView, keys: bowlerKeys }),
	          otherTeamDetails && otherTeamDetails.players.length && _react2.default.createElement(Team, { details: otherTeamDetails }) || null
	        )
	      )
	    )
	  );
	};
	
	var Innings = exports.Innings = function Innings(_ref6) {
	  var _ref6$innings = _ref6.innings,
	      innings = _ref6$innings === undefined ? {} : _ref6$innings,
	      _ref6$otherTeamDetail = _ref6.otherTeamDetails,
	      otherTeamDetails = _ref6$otherTeamDetail === undefined ? {} : _ref6$otherTeamDetail,
	      _ref6$isWebView = _ref6.isWebView,
	      isWebView = _ref6$isWebView === undefined ? false : _ref6$isWebView,
	      isSmallDevice = _ref6.isSmallDevice,
	      _ref6$showSquads = _ref6.showSquads,
	      showSquads = _ref6$showSquads === undefined ? false : _ref6$showSquads,
	      _ref6$rosters = _ref6.rosters,
	      rosters = _ref6$rosters === undefined ? {} : _ref6$rosters,
	      _ref6$gameState = _ref6.gameState,
	      gameState = _ref6$gameState === undefined ? '' : _ref6$gameState;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    (0, _keys2.default)(innings).map(function (inning, i) {
	      return _react2.default.createElement(Inning, (0, _extends3.default)({ key: i, id: i }, innings[inning], { otherTeamDetails: otherTeamDetails, isWebView: isWebView, isSmallDevice: isSmallDevice, gameState: gameState }));
	    }),
	    showSquads && [rosters.home, rosters.away].map(function (team, i) {
	      return _react2.default.createElement(
	        'article',
	        { key: i, className: 'sub-module scorecard' },
	        team && team.players.length && _react2.default.createElement(Team, { details: team }) || ''
	      );
	    })
	  );
	};
	
	exports.default = Innings;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _class, _temp; /* global jQuery */
	
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _common = __webpack_require__(686);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common2 = __webpack_require__(423);
	
	var _bet365AffiliateCodes = __webpack_require__(829);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecentOvers = function RecentOvers(_ref) {
	  var _ref$overs = _ref.overs,
	      overs = _ref$overs === undefined ? [] : _ref$overs;
	
	
	  var recent = [];
	
	  overs.map(function (over, i) {
	    recent.push(over.map(function (r, j) {
	
	      // TODO: update logic
	      var isDot = r == '0';
	      var circleClass = isDot ? '' : (0, _common2.getBallClass)(r);
	
	      return _react2.default.createElement(
	        'div',
	        { key: i + '.' + j, className: circleClass },
	        isDot ? '.' : _react2.default.createElement(
	          'span',
	          { className: 'over-score' },
	          r
	        )
	      );
	    }));
	    // Add separator, If not last
	    // TODO: use Array.reduce and refactor
	    if (i !== overs.length - 1) {
	      recent.push(_react2.default.createElement(
	        'div',
	        { key: i + '.p' },
	        '|'
	      ));
	    }
	  });
	
	  return _react2.default.createElement(
	    'tr',
	    { className: 'results' },
	    _react2.default.createElement(
	      'td',
	      { colSpan: '12', className: 'recent-overs' },
	      _react2.default.createElement(
	        'div',
	        { className: 'recent-overs-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'label' },
	          'Recent'
	        ),
	        recent
	      )
	    )
	  );
	};
	
	var listStatKeys = function listStatKeys() {
	  var playerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return (playerType.keys || []).map(function (k, i) {
	    return _react2.default.createElement(
	      'th',
	      { key: i, className: k.className, colSpan: k.colspan },
	      k.name || k.id
	    );
	  });
	};
	
	/**
	 * Get video icon markup with video data
	 * @param  {Object} player player details
	 * @param  {Boolean} isWebView flag to determine if webview
	 * @return {Object}        React element
	 */
	function getVideoIcon() {
	  var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var isWebView = arguments[1];
	
	  /*
	  let videoStyles = {
	    position: 'absolute',
	    margin: 'auto 0'
	  }
	  */
	
	  var markup = '';
	  if (player.hasVideoId === true) {
	    markup = _react2.default.createElement(
	      'div',
	      { key: player.videoId, className: 'highlight active' },
	      _react2.default.createElement(
	        'a',
	        { 'data-linktype': 'lecvideo', className: (0, _classnames2.default)('highlight icon-font-after icon-play-solid-after gamepackage_bloom module_bloom_behavior', { 'app_partial': isWebView }), 'data-behavior': 'module_bloom', 'data-id': player.videoId },
	        _react2.default.createElement(_common.Video, (0, _extends3.default)({}, player.video, { showCaption: true, className: '' }))
	      )
	    );
	  }
	  return markup;
	}
	
	/**
	 * Get markup for small screen video player
	 * @param  {Object} player player details
	 * @param  {Boolean} isWebView flag to determine if webview
	 * @return {Object}        React element
	 */
	function getSmallScreenVideo() {
	  var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var isWebView = arguments[1];
	
	  return _react2.default.createElement(
	    'td',
	    { className: 'col-highlight' },
	    _react2.default.createElement(
	      'a',
	      { className: 'long-name', href: player.href || '#' },
	      player.fullName
	    ),
	    _react2.default.createElement(
	      'a',
	      { className: 'short-name', href: player.href || '#' },
	      player.name
	    ),
	    player.style ? '(' + player.style + ')' : '',
	    getVideoIcon(player, isWebView)
	  );
	}
	
	/**
	 * Get stats for a player
	 * @param  {Object} player     playerdetails
	 * @param  {Object} playerType batsman/bowler column details
	 * @param  {Boolean} isWebView flag to determine if webview
	 * @return {Object}            React Element (list of td's)
	 *
	 * As of now, FE team has chosen not to display LEC video icon at the end of row
	 * So, commenting out code from here. In case, it's added back in future,
	 * uncomment this section of code & add videoMarkup after {stat}.
	 */
	function getPlayerStat() /*isWebView*/{
	  var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var playerType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var playerStats = player.stats || [];
	  // Iterate over set of player stats and build each td
	  return playerStats.map(function (stat, j) {
	
	    var colmClass = (0, _selectn2.default)('keys[' + j + '].className', playerType) || '';
	    var colmSpan = (0, _selectn2.default)('keys[' + j + '].colspan', playerType) || '';
	
	    /*
	    let videoMarkup = null
	    if(j == playerStats.length-1) {
	      if (player.hasVideoId === true) {
	        videoMarkup = getVideoIcon(player, isWebView)
	        //console.info('videoMarkup', videoMarkup)
	      }
	    }
	    //console.info('stat', stat)
	    */
	
	    return _react2.default.createElement(
	      'td',
	      { key: j, className: colmClass, colSpan: colmSpan },
	      stat
	    );
	  });
	}
	
	var listStats = function listStats() {
	  var playerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var isWebView = arguments[1];
	
	  return (playerType.list || []).map(function () {
	    var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var i = arguments[1];
	
	    var playerRow = _react2.default.createElement('tr', { key: i });
	
	    var stats = player.stats || [];
	    if (player.name && stats.length > 0) {
	      playerRow = _react2.default.createElement(
	        'tr',
	        { key: i },
	        getSmallScreenVideo(player, isWebView),
	        getPlayerStat(player, playerType, isWebView)
	      );
	    }
	    return playerRow;
	  });
	};
	
	/**
	 * Get markup for last N overs data
	 * @param  {Object} lastNForInnings processed data for last N overs
	 * @return {Object}                 html markup object
	 */
	function getLastnMarkup() {
	  var lastNForInnings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var lastNMarkup = '';
	  if (lastNForInnings.showModule === true) {
	    lastNMarkup = 'Last ' + lastNForInnings.duration + ' Overs:<span>' + lastNForInnings.runs + '/' + lastNForInnings.wickets + '</span>';
	  }
	  return lastNMarkup;
	}
	
	/**
	 * Get markup for team reviews
	 * @param  {Array}  reviews reviews data for each team
	 * @param  {Number}  numColumns number of coloums
	 * @return {String}         html markup
	 */
	function getReviewsMarkup() {
	  var reviews = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var numColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
	
	  var markup = '';
	  var numReviews = reviews.length;
	  // Proceed only if reviews are found
	  if (numReviews > 0) {
	    var reviewDetails = '';
	    // Iterate over both teams and construct string for the reviews
	    for (var i = 0; i < numReviews; i++) {
	      var team = reviews[i] || {};
	      var teamReviews = team.reviews || {};
	      var isFirstReview = i != numReviews - 1;
	      // Get remaining, successful, unsuccessful reviews
	      var remaining = teamReviews.remaining || '';
	      var successful = teamReviews.successful || '';
	      var unsuccessful = teamReviews.unsuccessful || '';
	
	      // construct markup
	      reviewDetails += '\n        <div class="label full">' + team.name + '</div>\n        <div class="label short">' + team.abbreviation + '</div> ' + remaining + '\n        <div class="label full">(' + successful + ' successful, ' + unsuccessful + ' unsuccessful)' + (isFirstReview ? ';' : '') + '</div>\n        ' + (isFirstReview ? '<div class="label short">|</div>' : '') + '\n      ';
	    }
	    //console.info('reviewDetails', reviewDetails)
	    markup = '<td colspan=' + numColumns + '><div class="label">Reviews remaining:</div>' + reviewDetails + '</td>';
	  }
	  return markup;
	}
	
	var getColGroup = function getColGroup(colLen) {
	  var cols = [];
	
	  for (var i = 0; i < colLen; i++) {
	    cols.push(_react2.default.createElement('col', { key: i }));
	  }
	
	  return _react2.default.createElement(
	    'colgroup',
	    null,
	    cols
	  );
	};
	
	var Innings = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(Innings, _React$Component);
	
	  function Innings() {
	    (0, _classCallCheck3.default)(this, Innings);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Innings.__proto__ || (0, _getPrototypeOf2.default)(Innings)).call(this));
	
	    _this._initReponsive = _this._initReponsive.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Innings, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initDeviceType();
	    }
	  }, {
	    key: 'initDeviceType',
	    value: function initDeviceType() {
	      this._handleResize = (0, _common2.throttle)(this._initReponsive, 150).bind(this);
	      try {
	        jQuery(window).resize(this._handleResize);
	        this._initReponsive();
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      jQuery(window).off('resize orientationchange', this._handleResize);
	    }
	  }, {
	    key: '_initReponsive',
	    value: function _initReponsive() {
	      var currentWidth = jQuery(window).outerWidth();
	      this.props.updateDeviceType && this.props.updateDeviceType(currentWidth);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$players = _props.players,
	          players = _props$players === undefined ? {
	        batsmen: {},
	        bowlers: {}
	      } : _props$players,
	          _props$reviews = _props.reviews,
	          reviews = _props$reviews === undefined ? [] : _props$reviews,
	          _props$crr = _props.crr,
	          crr = _props$crr === undefined ? '' : _props$crr,
	          _props$rrr = _props.rrr,
	          rrr = _props$rrr === undefined ? '' : _props$rrr,
	          _props$minRemainingOv = _props.minRemainingOvers,
	          minRemainingOvers = _props$minRemainingOv === undefined ? '' : _props$minRemainingOv,
	          _props$lastNForInning = _props.lastNForInnings,
	          lastNForInnings = _props$lastNForInning === undefined ? {} : _props$lastNForInning,
	          _props$partnership = _props.partnership,
	          partnership = _props$partnership === undefined ? '' : _props$partnership,
	          _props$lastBat = _props.lastBat,
	          lastBat = _props$lastBat === undefined ? '' : _props$lastBat,
	          _props$fow = _props.fow,
	          fow = _props$fow === undefined ? '' : _props$fow,
	          _props$recentOvers = _props.recentOvers,
	          recentOvers = _props$recentOvers === undefined ? [] : _props$recentOvers,
	          _props$activePlayers = _props.activePlayers,
	          activePlayers = _props$activePlayers === undefined ? [] : _props$activePlayers,
	          _props$isSmallDevice = _props.isSmallDevice,
	          isSmallDevice = _props$isSmallDevice === undefined ? false : _props$isSmallDevice,
	          _props$isWebView = _props.isWebView,
	          isWebView = _props$isWebView === undefined ? false : _props$isWebView,
	          _props$generalClassCa = _props.generalClassCard,
	          generalClassCard = _props$generalClassCa === undefined ? '' : _props$generalClassCa,
	          isLimitedOvers = _props.isLimitedOvers,
	          _props$bet = _props.bet365,
	          bet365 = _props$bet === undefined ? {} : _props$bet,
	          _props$gameState = _props.gameState,
	          gameState = _props$gameState === undefined ? '' : _props$gameState,
	          _props$showFullStats = _props.showFullStats,
	          showFullStats = _props$showFullStats === undefined ? false : _props$showFullStats,
	          _props$groundTime = _props.groundTime,
	          groundTime = _props$groundTime === undefined ? '' : _props$groundTime,
	          _props$editionDomain = _props.editionDomain,
	          editionDomain = _props$editionDomain === undefined ? '' : _props$editionDomain;
	
	
	      var affiliateCode = editionDomain === 'www.espncricinfo.com' ? _bet365AffiliateCodes.bet365AffiliateCodes.nextBatsmanOut : _bet365AffiliateCodes.bet365AffiliateCodes.editions;
	      // Flag to display component
	      var showComponent = false;
	      // Properties which need to be checked before deciding displayability
	      var props = [activePlayers.length];
	      // Iterate over props and check if data structures's lengths are not empty
	      for (var i = 0; i < props.length; i++) {
	        if (props[i]) {
	          showComponent = true;
	          break;
	        }
	      }
	
	      /**
	       * This is written to fix the vertical line splitter which appears on the
	       * left of live career table.
	       * Count the max num of stats columns (of either batsman & bowler).
	       *
	       */
	      var batsmanKeys = (0, _selectn2.default)('batsmen.keys', players) || [];
	      var bowlerKeys = (0, _selectn2.default)('bowlers.keys', players) || [];
	      // Max number of stats columns that can appear in current players section (additional +1 for player name)
	      var numColumns = Math.max(batsmanKeys.length, bowlerKeys.length) + 1;
	      // Number of live career columns
	      var secColGrpLen = 4;
	
	      var reviewsString = getReviewsMarkup(reviews, numColumns);
	      var lastnMarkup = getLastnMarkup(lastNForInnings);
	      /*
	      * @TODO - remove this logic. This is written to fix the vertical line
	      * splitter which appears on the left of live career table.
	      *
	      for (var j = colKeys.length - 1; j >= 0; j--) {
	        const key = colKeys[j]
	        let colspan = parseInt(key.colspan, 10)
	         if (isNaN(colspan)) {
	          firstColGrpLen++
	        } else {
	          console.info('going in else condition')
	          firstColGrpLen += colspan
	        }
	      }
	      */
	      var oddType = '';
	      if (gameState == 'pregame') {
	        oddType = 'odds';
	      } else if (gameState == 'live') {
	        oddType = 'situation';
	      }
	
	      var printGroundTime = '';
	      if (groundTime) {
	        printGroundTime = '<div>Ground time: ' + groundTime + '</div>';
	      }
	
	      // substract the second colgroup columns. Add 1 for player name column
	      var firstColGrpLen = numColumns;
	      if (!isSmallDevice) {
	        firstColGrpLen = numColumns - secColGrpLen;
	      }
	      var summaryTable = _react2.default.createElement(
	        'table',
	        { cellSpacing: '0', cellPadding: '0', 'data-text-contract': 'Contract table', 'data-text-expand': 'Expand table', 'data-fix-cols': '0' },
	        getColGroup(firstColGrpLen, isLimitedOvers),
	        showFullStats && getColGroup(secColGrpLen, isLimitedOvers) || null,
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { className: 'column-group desktop-tablet-only' },
	            _react2.default.createElement('th', { colSpan: firstColGrpLen, className: 'u-ta-l', dangerouslySetInnerHTML: { __html: printGroundTime } }),
	            showFullStats && _react2.default.createElement(
	              'th',
	              { colSpan: secColGrpLen, className: 'u-ta-c' },
	              generalClassCard
	            ) || null
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'results mobile-only' },
	            _react2.default.createElement(
	              'td',
	              { colSpan: numColumns },
	              crr ? [_react2.default.createElement(
	                'div',
	                { key: 'cl', className: 'label' },
	                'CRR:'
	              ), _react2.default.createElement(
	                'span',
	                { key: 'cs' },
	                crr
	              )] : null,
	              rrr ? [_react2.default.createElement(
	                'div',
	                { key: 'rl', className: 'label' },
	                'RRR:'
	              ), _react2.default.createElement(
	                'span',
	                { key: 'rs' },
	                rrr
	              )] : null,
	
	              // if isLimitedOvers flag is true do not show the minRemainingOvers value
	              minRemainingOvers && minRemainingOvers > 0 && !isLimitedOvers ? [_react2.default.createElement(
	                'div',
	                { key: 'rl', className: 'label' },
	                'Min. Ov. Rem:'
	              ), _react2.default.createElement(
	                'span',
	                { key: 'rs' },
	                minRemainingOvers
	              )] : null,
	              lastnMarkup ? [_react2.default.createElement('div', { className: 'label', dangerouslySetInnerHTML: { __html: lastnMarkup } }), _react2.default.createElement('span', null)] : null,
	              groundTime ? [_react2.default.createElement(
	                'div',
	                { key: 'rl', className: 'label' },
	                ' Ground Time:'
	              ), _react2.default.createElement(
	                'span',
	                { key: 'rs' },
	                groundTime
	              )] : null
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              { className: 'col-highlight u-ta-l' },
	              'BATSMEN'
	            ),
	            listStatKeys(players.batsmen)
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          listStats(players.batsmen, isWebView)
	        ),
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              { className: 'col-highlight u-ta-l' },
	              'BOWLERS'
	            ),
	            listStatKeys(players.bowlers)
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          listStats(players.bowlers, isWebView),
	          bet365.showInEdition && bet365.showInGeo && _react2.default.createElement(
	            'tr',
	            { key: 'so', className: 'results bet' },
	            _react2.default.createElement(
	              'td',
	              { colSpan: numColumns },
	              _react2.default.createElement(_common.Bet365, (0, _extends3.default)({}, bet365, { type: oddType, pageType: 'game', affiliateCodeOverwrite: affiliateCode }))
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { className: 'results' },
	            _react2.default.createElement(
	              'td',
	              { colSpan: numColumns },
	              partnership && _react2.default.createElement(
	                'div',
	                { className: 'resultsItem' },
	                _react2.default.createElement(
	                  'div',
	                  { key: 'pf', className: 'label full' },
	                  'Current Partnership :'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { key: 'ps', className: 'label short' },
	                  'P\'SHIP :'
	                ),
	                _react2.default.createElement('span', { key: 'psp', dangerouslySetInnerHTML: { __html: partnership } })
	              ) || null,
	              lastBat && _react2.default.createElement(
	                'div',
	                { className: 'resultsItem' },
	                _react2.default.createElement(
	                  'div',
	                  { key: 'lf', className: 'label full' },
	                  'Last Bat :'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { key: 'ls', className: 'label short' },
	                  'L\'BAT :'
	                ),
	                _react2.default.createElement('span', { key: 'lsp', dangerouslySetInnerHTML: { __html: lastBat } })
	              ) || null,
	              fow && _react2.default.createElement(
	                'div',
	                { className: 'resultsItem' },
	                _react2.default.createElement(
	                  'div',
	                  { key: 'ff', className: 'label full' },
	                  ' FoW :'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { key: 'fs', className: 'label short' },
	                  ' FoW :'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { key: 'fsp' },
	                  fow
	                )
	              ) || null
	            )
	          ),
	          reviews.length > 0 ? _react2.default.createElement('tr', { className: 'results', dangerouslySetInnerHTML: { __html: reviewsString } }) : null,
	          recentOvers.length > 0 ? _react2.default.createElement(RecentOvers, { overs: recentOvers, colspan: numColumns }) : null
	        )
	      );
	
	      // if device is small, wrap the table with scrollable container
	      if (isSmallDevice === true) {
	        summaryTable = _react2.default.createElement(
	          'div',
	          { className: 'table-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'scrollable' },
	            summaryTable
	          ),
	          _react2.default.createElement('div', { className: 'shadow right' }),
	          _react2.default.createElement('div', { className: 'shadow left', style: { 'zIndex': '10' } })
	        );
	      }
	
	      var summaryContent = _react2.default.createElement(
	        'article',
	        { className: 'sub-module current-inning' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          summaryTable
	        )
	      );
	
	      // Display component with data or just the parent elem based on showComponent flag
	      return showComponent ? summaryContent : _react2.default.createElement('article', { className: 'sub-module current-inning' });
	    }
	  }]);
	  return Innings;
	}(_react2.default.Component), _class.propTypes = {
	  updateDeviceType: _react.PropTypes.func
	}, _temp);
	exports.default = Innings;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchNotes = function MatchNotes(_ref) {
	  var _ref$noteGroups = _ref.noteGroups,
	      noteGroups = _ref$noteGroups === undefined ? [] : _ref$noteGroups;
	
	
	  var content = _react2.default.createElement(
	    'article',
	    { className: 'sub-module cricket research-notes' },
	    _react2.default.createElement(
	      'header',
	      { className: 'bordered' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Match Notes'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'css-accordion' },
	        noteGroups.map(function () {
	          var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var i = arguments[1];
	
	
	          var notes = n.notes || [];
	          // Get day for which this match note is being shown
	          var day = (0, _selectn2.default)('[0].day', notes) || 0;
	          // If day is 0, this match note needs to be shown under General heading
	          var accordionHeader = n.title || '';
	          var isExpanded = n.expanded;
	          var headerClass = isExpanded ? '' : 'collapsed';
	          //console.info('isExpanded', isExpanded)
	
	          return _react2.default.createElement(
	            'li',
	            { key: i, className: 'accordion-item' },
	            notes.length > 0 && _react2.default.createElement(
	              'div',
	              { className: 'accordion-header' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { role: 'button', 'data-toggle': 'collapse', href: '#accordion-0' + day, 'aria-expanded': 'false', 'aria-controls': 'accordion-01', className: headerClass },
	                  accordionHeader
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'accordion-0' + day, className: (0, _classnames2.default)('accordion-content collapse', { 'in': isExpanded }), 'aria-expanded': 'false' },
	              _react2.default.createElement(
	                'div',
	                { className: 'content' },
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'bulleted-list' },
	                  notes.length > 0 && notes.map(function () {
	                    var note = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	                    var j = arguments[1];
	                    return _react2.default.createElement('li', { key: j, dangerouslySetInnerHTML: { __html: note.text } });
	                  }),
	                  notes.length === 0 && _react2.default.createElement(
	                    'li',
	                    null,
	                    accordionHeader
	                  )
	                )
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	
	  return noteGroups.length ? content : _react2.default.createElement('article', { className: 'sub-module cricket research-notes' });
	};
	
	exports.default = MatchNotes;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Statistics = exports.BestPerformers = exports.CurrentPartnerships = exports.PitchMap = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PlayerDetails = __webpack_require__(805);
	
	var _PlayerDetails2 = _interopRequireDefault(_PlayerDetails);
	
	var _common = __webpack_require__(686);
	
	var _Graphics = __webpack_require__(705);
	
	var _Partnerships = __webpack_require__(835);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PitchMap = exports.PitchMap = function PitchMap(_ref) {
	  var _ref$map = _ref.map,
	      map = _ref$map === undefined ? {} : _ref$map;
	
	
	  var renderGrid = function renderGrid() {
	    var grid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var totalBalls = arguments[1];
	
	    // Using colors generated by a color blender
	    // TODO: get updated color classnames and use them
	    var colors = ['#F2C50C', '#F2B320', '#F2A127', '#F08F2C', '#EF7D30'];
	
	    return grid.map(function () {
	      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var i = arguments[1];
	
	      return _react2.default.createElement(
	        'tr',
	        { key: i },
	        rows.map(function (column, j) {
	          var wickets = column[1];
	          var balls = column[2];
	          var percent = balls / totalBalls * 100;
	          var bgColor = '#fff';
	
	          if (percent > 81) {
	            bgColor = colors[4];
	          } else if (percent >= 61 && percent < 81) {
	            bgColor = colors[3];
	          } else if (percent >= 41 && percent < 61) {
	            bgColor = colors[2];
	          } else if (percent >= 21 && percent < 41) {
	            bgColor = colors[1];
	          } else if (percent >= 1 && percent < 21) {
	            bgColor = colors[0];
	          }
	
	          return _react2.default.createElement(
	            'td',
	            { key: j, style: { backgroundColor: bgColor } },
	            wickets > 0 ? wickets + 'W' : ''
	          );
	        })
	      );
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'chart-table-container' },
	    map.rhb.map && _react2.default.createElement(
	      'table',
	      { className: 'chart-table' },
	      _react2.default.createElement(
	        'caption',
	        null,
	        'RHB',
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'OFF'
	          ),
	          _react2.default.createElement('span', { className: 'icon-wicket' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'LEG'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        renderGrid(map.rhb.map, map.rhb.totalBalls)
	      )
	    ),
	    (map.rhb.map || map.lhb.map) && _react2.default.createElement(
	      'ul',
	      { className: 'chart-table-headers' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'label short' },
	          'FT'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'label full' },
	          'FULL TOSS'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'label short' },
	          'Y'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'label full' },
	          'YORKER'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'label short' },
	          'F'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'label full' },
	          'FULL LENGTH'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'label short' },
	          'G'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'label full' },
	          'GOOD LENGTH'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'label short' },
	          'SG'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'label full' },
	          'SHORT OF GOOD LENGTH'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'label short' },
	          'S'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'label full' },
	          'SHORT LENGTH'
	        )
	      )
	    ),
	    map.lhb.map && _react2.default.createElement(
	      'table',
	      { className: 'chart-table', cellPadding: '0', cellSpacing: '0' },
	      _react2.default.createElement(
	        'caption',
	        null,
	        'LHB',
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'LEG'
	          ),
	          _react2.default.createElement('span', { className: 'icon-wicket' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'OFF'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        renderGrid(map.lhb.map, map.lhb.totalBalls)
	      )
	    )
	  );
	};
	
	var CurrentPartnerships = exports.CurrentPartnerships = function CurrentPartnerships() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _props$values = props.values,
	      values = _props$values === undefined ? [] : _props$values,
	      _props$title = props.title,
	      title = _props$title === undefined ? 'PARTNERSHIPS' : _props$title;
	
	
	  var partnerships = _react2.default.createElement(
	    'div',
	    { className: 'stat-container partnerships' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      title
	    ),
	    _react2.default.createElement(_Partnerships.PartnershipsList, { values: values, title: title })
	  );
	
	  return values.length ? partnerships : _react2.default.createElement('div', { className: 'stat-container partnerships' });
	};
	
	var Batsman = function Batsman(_ref2) {
	  var _ref2$href = _ref2.href,
	      href = _ref2$href === undefined ? '#' : _ref2$href,
	      _ref2$img = _ref2.img,
	      img = _ref2$img === undefined ? '' : _ref2$img,
	      _ref2$name = _ref2.name,
	      name = _ref2$name === undefined ? '' : _ref2$name,
	      _ref2$team = _ref2.team,
	      team = _ref2$team === undefined ? '' : _ref2$team,
	      _ref2$runs = _ref2.runs,
	      runs = _ref2$runs === undefined ? '' : _ref2$runs,
	      _ref2$control = _ref2.control,
	      control = _ref2$control === undefined ? '' : _ref2$control,
	      _ref2$productive = _ref2.productive,
	      productive = _ref2$productive === undefined ? {
	    shotType: '',
	    runs: '',
	    details: ''
	  } : _ref2$productive,
	      _ref2$pie = _ref2.pie,
	      pie = _ref2$pie === undefined ? [] : _ref2$pie,
	      top = _ref2.top;
	
	
	  var dataVisStyle = {};
	
	  if (!pie.length) {
	    dataVisStyle.minHeight = '50px';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'player' },
	    _react2.default.createElement(_PlayerDetails2.default, { name: name, team: team, img: img, href: href }),
	    _react2.default.createElement('div', { className: 'runs', dangerouslySetInnerHTML: { __html: runs } }),
	    _react2.default.createElement(
	      'div',
	      { className: 'data-vis', style: dataVisStyle },
	      _react2.default.createElement(
	        'div',
	        { className: 'data-vis-col left' },
	        control && _react2.default.createElement(_Graphics.CompareLineGraph, { value: control, text: 'Control %' }) || null,
	        _react2.default.createElement(
	          'div',
	          { className: 'data-text' },
	          productive.shotType && _react2.default.createElement(
	            'ul',
	            null,
	            productive.runs && _react2.default.createElement(
	              'li',
	              { className: 'header' },
	              'Productive Shot'
	            ),
	            productive.runs && _react2.default.createElement(
	              'li',
	              { style: { textTransform: 'capitalize' }, className: 'shot-type' },
	              productive.shotType
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'data-runs' },
	              productive.runs,
	              ' runs'
	            ),
	            _react2.default.createElement('li', { dangerouslySetInnerHTML: { __html: productive.details } })
	          )
	        )
	      ),
	      pie.length && _react2.default.createElement(_Graphics.PieChart, { className: 'right', topSlice: top, values: pie }) || null
	    )
	  );
	};
	
	var Bowler = function Bowler(_ref3) {
	  var _ref3$pitchMap = _ref3.pitchMap,
	      pitchMap = _ref3$pitchMap === undefined ? [] : _ref3$pitchMap,
	      _ref3$name = _ref3.name,
	      name = _ref3$name === undefined ? '' : _ref3$name,
	      _ref3$team = _ref3.team,
	      team = _ref3$team === undefined ? '' : _ref3$team,
	      _ref3$img = _ref3.img,
	      img = _ref3$img === undefined ? '' : _ref3$img,
	      _ref3$href = _ref3.href,
	      href = _ref3$href === undefined ? '' : _ref3$href,
	      _ref3$stats = _ref3.stats,
	      stats = _ref3$stats === undefined ? [] : _ref3$stats;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'player' },
	    _react2.default.createElement(_PlayerDetails2.default, { name: name, team: team, img: img, href: href }),
	    _react2.default.createElement(
	      'dl',
	      { className: 'stat-overview' },
	      stats.map(function (stat, i) {
	        return _react2.default.createElement(
	          'dd',
	          { key: i },
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            stat.text || stat.abbreviation
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'value' },
	            stat.value
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(PitchMap, { map: pitchMap })
	  );
	};
	
	var BestPerformers = exports.BestPerformers = function BestPerformers(_ref4) {
	  var _ref4$type = _ref4.type,
	      type = _ref4$type === undefined ? '' : _ref4$type,
	      _ref4$players = _ref4.players,
	      players = _ref4$players === undefined ? [] : _ref4$players,
	      _ref4$title = _ref4.title,
	      title = _ref4$title === undefined ? '' : _ref4$title;
	
	  var content = _react2.default.createElement(
	    'article',
	    { className: 'sub-module stats' },
	    _react2.default.createElement(
	      'header',
	      { className: 'bordered' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('stat-container', type) },
	        players.map(function (player, i) {
	          if (type == 'batsman') {
	            return _react2.default.createElement(Batsman, (0, _extends3.default)({ key: i }, player));
	          } else if (type == 'bowler') {
	            return _react2.default.createElement(Bowler, (0, _extends3.default)({ key: i }, player));
	          }
	        })
	      )
	    )
	  );
	
	  return players.length ? content : _react2.default.createElement('article', { className: 'sub-module stats', style: { display: 'none' } });
	};
	
	var Statistics = exports.Statistics = function Statistics(_ref5) {
	  var _ref5$partnerships = _ref5.partnerships,
	      partnerships = _ref5$partnerships === undefined ? [] : _ref5$partnerships,
	      _ref5$link = _ref5.link,
	      link = _ref5$link === undefined ? '#' : _ref5$link,
	      _ref5$batsmen = _ref5.batsmen,
	      batsmen = _ref5$batsmen === undefined ? [] : _ref5$batsmen,
	      _ref5$bowlers = _ref5.bowlers,
	      bowlers = _ref5$bowlers === undefined ? [] : _ref5$bowlers,
	      hideShowClass = _ref5.hideShowClass,
	      _ref5$showFooter = _ref5.showFooter,
	      showFooter = _ref5$showFooter === undefined ? false : _ref5$showFooter,
	      _ref5$gameState = _ref5.gameState,
	      gameState = _ref5$gameState === undefined ? '' : _ref5$gameState,
	      _ref5$titles = _ref5.titles,
	      titles = _ref5$titles === undefined ? { batsmen: 'Current Batsmen', bowlers: 'Current bowlers' } : _ref5$titles,
	      _ref5$trackingName = _ref5.trackingName,
	      trackingName = _ref5$trackingName === undefined ? '' : _ref5$trackingName;
	
	  var content = _react2.default.createElement(
	    'div',
	    { className: hideShowClass ? 'hide-show' : '' },
	    _react2.default.createElement(
	      'article',
	      { className: 'sub-module stats' },
	      _react2.default.createElement(
	        'header',
	        { className: 'bordered' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Statistics'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        batsmen.length && _react2.default.createElement(
	          'div',
	          { className: 'stat-container batsmen' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            titles.batsmen
	          ),
	          batsmen.map(function (batsman, i) {
	            return _react2.default.createElement(Batsman, (0, _extends3.default)({ key: i }, batsman));
	          })
	        ) || null,
	        bowlers.length && _react2.default.createElement(
	          'div',
	          { className: 'stat-container bowler' },
	          bowlers.length && _react2.default.createElement(
	            'h3',
	            null,
	            titles.bowlers
	          ),
	          bowlers.map(function (bowler, i) {
	            return _react2.default.createElement(Bowler, (0, _extends3.default)({ key: i }, bowler));
	          })
	        ) || null,
	        gameState == 'live' && _react2.default.createElement(CurrentPartnerships, { values: partnerships })
	      ),
	      showFooter && _react2.default.createElement(
	        'footer',
	        null,
	        _react2.default.createElement(_common.AnchorLink, { to: link, name: trackingName, text: 'More Statistics' })
	      )
	    )
	  );
	
	  if (batsmen.length || bowlers.length || gameState == 'live' && partnerships.length) {
	    return content;
	  } else {
	    return _react2.default.createElement('article', { className: 'sub-module stats', style: { display: 'none' } });
	  }
	};

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Partnerships = exports.PartnershipsList = undefined;
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PartnershipsList = exports.PartnershipsList = function PartnershipsList(_ref) {
	  var _ref$values = _ref.values,
	      values = _ref$values === undefined ? [] : _ref$values,
	      _ref$color = _ref.color1,
	      color1 = _ref$color === undefined ? '#5F9941' : _ref$color,
	      _ref$color2 = _ref.color2,
	      color2 = _ref$color2 === undefined ? '#5F9941' : _ref$color2;
	
	
	  var list = values.map(function (partnership, i) {
	    return _react2.default.createElement(
	      'div',
	      { key: i, className: 'data-vis-box-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'stat-graph compareLineGraph compareCenter' },
	        _react2.default.createElement(
	          'div',
	          { className: 'bar-total' },
	          partnership.total
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bar-col left' },
	          _react2.default.createElement(
	            'div',
	            { className: 'chartValue' },
	            _react2.default.createElement(
	              'span',
	              { className: 'name' },
	              partnership.playerA.name
	            ),
	            _react2.default.createElement('span', { className: 'value', dangerouslySetInnerHTML: { __html: '' + partnership.playerA.value } })
	          ),
	          _react2.default.createElement('span', { className: 'bar-percentage', style: { background: color1, width: (partnership.playerA.runs || 0) + '%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bar-col right' },
	          _react2.default.createElement('span', { className: 'bar-percentage less', style: { background: color2, width: (partnership.playerB.runs || 0) + '%' } }),
	          _react2.default.createElement(
	            'div',
	            { className: 'chartValue' },
	            _react2.default.createElement(
	              'span',
	              { className: 'name' },
	              partnership.playerB.name
	            ),
	            _react2.default.createElement('span', { className: 'value', dangerouslySetInnerHTML: { __html: '' + partnership.playerB.value } })
	          )
	        )
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    list
	  );
	};
	
	/**
	 * Used in partnerships module on statistics page.
	 * Display partnership graphs in Innings buttons for limited over matches.
	 * Display partnership graphs in Innings tabs for test matches.
	 */
	
	var Partnerships = exports.Partnerships = function (_React$Component) {
	  (0, _inherits3.default)(Partnerships, _React$Component);
	
	  function Partnerships(props) {
	    (0, _classCallCheck3.default)(this, Partnerships);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Partnerships.__proto__ || (0, _getPrototypeOf2.default)(Partnerships)).call(this, props));
	
	    _this.state = { active: 0 };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Partnerships, [{
	    key: 'switchTab',
	    value: function switchTab(tab) {
	      this.setState({
	        active: tab
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$teams = _props.teams,
	          teams = _props$teams === undefined ? {} : _props$teams,
	          _props$uiControls = _props.uiControls,
	          uiControls = _props$uiControls === undefined ? {} : _props$uiControls,
	          _props$pshipByInnings = _props.pshipByInnings,
	          pshipByInnings = _props$pshipByInnings === undefined ? [] : _props$pshipByInnings;
	      var _state$active = this.state.active,
	          active = _state$active === undefined ? 0 : _state$active;
	
	      var homeTeam = teams.home || {};
	      var awayTeam = teams.away || {};
	      var homeColor = homeTeam.color;
	      var awayColor = awayTeam.color;
	      // dynamic class name based on format
	      var statContainerClass = uiControls.showButtons ? '' : 'tab-pane';
	      // Buttons appear for limited overs matches
	
	      var teamByInnings = [];
	
	      if (homeTeam.order === 1) {
	        teamByInnings.push(homeTeam, awayTeam);
	      } else {
	        teamByInnings.push(awayTeam, homeTeam);
	      }
	
	      var innButtons = _react2.default.createElement(
	        'div',
	        { className: 'tabControls hidden-sm hidden-md hidden-lg' },
	        _react2.default.createElement(
	          'div',
	          { className: 'filter form-group button-group' },
	          teamByInnings.map(function (t, i) {
	            return _react2.default.createElement(
	              'button',
	              { key: i,
	                onClick: _this2.switchTab.bind(_this2, i),
	                className: (0, _classnames2.default)('button-filter-alt lg fixed', { active: i == active }) },
	              _react2.default.createElement(
	                'span',
	                { className: 'team-name' },
	                t.abbrev || t.name
	              )
	            );
	          })
	        )
	      );
	
	      var innTabs = _react2.default.createElement(
	        'div',
	        { className: 'tab-container' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'tabs alt', 'data-behavior': 'tabs_transform' },
	          pshipByInnings.map(function (inn, i) {
	            var title = inn.titles && inn.titles.brief;
	            return _react2.default.createElement(
	              'li',
	              { onClick: _this2.switchTab.bind(_this2, i), key: i, className: i == active ? 'active' : '' },
	              _react2.default.createElement(
	                'span',
	                null,
	                title
	              )
	            );
	          })
	        )
	      );
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'sub-module stats tabbedTable partnership-tabs', 'data-behavior': 'tabbedTable' },
	        _react2.default.createElement(
	          'header',
	          { className: 'bordered' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Partnerships'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          uiControls.showButtons ? innButtons : innTabs,
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            pshipByInnings.map(function (inning, i) {
	              //console.info('i, active', i, active)
	              var color = inning.ha === 'home' ? homeColor : awayColor;
	              return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('table-wrap stat-container partnerships', { active: i == active }, statContainerClass),
	                  key: i },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  inning.titles.full
	                ),
	                _react2.default.createElement(PartnershipsList, { color1: color, color2: color, values: inning.data, key: i })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return Partnerships;
	}(_react2.default.Component);
	
	exports.default = Partnerships;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScorecardSummary = undefined;
	
	var _keys = __webpack_require__(415);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(686);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScorecardSummary = exports.ScorecardSummary = function ScorecardSummary(_ref) {
	  var _ref$fullSummaryLink = _ref.fullSummaryLink,
	      fullSummaryLink = _ref$fullSummaryLink === undefined ? '' : _ref$fullSummaryLink,
	      _ref$innings = _ref.innings,
	      innings = _ref$innings === undefined ? {} : _ref$innings,
	      isLimitedOvers = _ref.isLimitedOvers;
	
	
	  var content = _react2.default.createElement(
	    'article',
	    { className: 'sub-module scorecard-summary' },
	    _react2.default.createElement(
	      'header',
	      { className: 'bordered' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Scorecard Summary'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      (0, _keys2.default)(innings).map(function (innCount, i) {
	        var _innings$innCount = innings[innCount],
	            team = _innings$innCount.team,
	            batsmen = _innings$innCount.batsmen,
	            bowlers = _innings$innCount.bowlers;
	
	        return _react2.default.createElement(
	          'div',
	          { key: i, className: 'inning' },
	          team && _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(
	              'x-span',
	              null,
	              team.teamDisplayName,
	              ' ',
	              team.inningsRunWicket
	            ),
	            team.overs && _react2.default.createElement(
	              'span',
	              null,
	              '(',
	              team.overs,
	              ' OVERS)'
	            ) || null,
	            isLimitedOvers ? '' : _react2.default.createElement(
	              'div',
	              { className: 'innings' },
	              team.innDisplayName
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'two-col-table' },
	            batsmen && batsmen.map(function (b, j) {
	              var stats = b.stats || {};
	              // Need to show * for not out player
	              var isNotOut = (0, _selectn2.default)('notouts.value', stats) == '1' ? true : false;
	              var runsScored = (0, _selectn2.default)('runs.value', stats);
	              var ballsFaced = (0, _selectn2.default)('ballsFaced.value', stats);
	              var batsmanName = b.name ? b.name : '';
	              var batsmanLink = batsmanName ? _react2.default.createElement(
	                'a',
	                { href: b.href },
	                batsmanName,
	                isNotOut ? '*' : null
	              ) : _react2.default.createElement(
	                'a',
	                null,
	                '-'
	              );
	              return _react2.default.createElement(
	                'li',
	                { key: j },
	                batsmanLink,
	                runsScored && ballsFaced && _react2.default.createElement(
	                  'span',
	                  null,
	                  runsScored,
	                  ' (',
	                  ballsFaced,
	                  ')'
	                ) || null
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'two-col-table' },
	            bowlers && bowlers.map(function (b, j) {
	              var stats = b.stats || {};
	              var wicketsTaken = (0, _selectn2.default)('wickets.value', stats);
	              var runsConceded = (0, _selectn2.default)('conceded.value', stats);
	              var oversBowled = (0, _selectn2.default)('overs.value', stats);
	              var bowlerName = b.name ? b.name : '';
	              var bowlerLink = bowlerName ? _react2.default.createElement(
	                'a',
	                { href: b.href },
	                b.name
	              ) : _react2.default.createElement(
	                'a',
	                null,
	                '-'
	              );
	              return _react2.default.createElement(
	                'li',
	                { key: j },
	                bowlerLink,
	                wicketsTaken && oversBowled && _react2.default.createElement(
	                  'span',
	                  null,
	                  wicketsTaken,
	                  '/',
	                  runsConceded,
	                  ' (',
	                  oversBowled,
	                  ')'
	                ) || null
	              );
	            })
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'footer',
	      null,
	      fullSummaryLink && _react2.default.createElement(_common.AnchorLink, { to: fullSummaryLink, text: 'Full Scorecard' })
	    )
	  );
	
	  return (0, _keys2.default)(innings).length ? content : _react2.default.createElement('article', { style: { display: 'none' }, className: 'sub-module scorecard-summary' });
	};
	
	exports.default = ScorecardSummary;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SquadModule = exports.SquadTabs = undefined;
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerRow = function PlayerRow(_ref) {
	  var player = _ref.player,
	      key = _ref.key;
	
	  return _react2.default.createElement(
	    'tr',
	    { key: key },
	    _react2.default.createElement(
	      'td',
	      { className: 'name' },
	      _react2.default.createElement('a', { href: player.href || '#', dangerouslySetInnerHTML: { __html: player.name } })
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'role' },
	      player.role
	    )
	  );
	};
	
	var SquadTabs = exports.SquadTabs = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(SquadTabs, _React$Component);
	
	  function SquadTabs(props) {
	    (0, _classCallCheck3.default)(this, SquadTabs);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SquadTabs.__proto__ || (0, _getPrototypeOf2.default)(SquadTabs)).call(this, props));
	
	    _this.state = { active: 'a' };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SquadTabs, [{
	    key: 'switchTab',
	    value: function switchTab(tab) {
	      this.setState({
	        active: tab
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$active = this.state.active,
	          active = _state$active === undefined ? 'a' : _state$active;
	      var _props = this.props,
	          _props$home = _props.home,
	          home = _props$home === undefined ? { players: [] } : _props$home,
	          _props$away = _props.away,
	          away = _props$away === undefined ? { players: [] } : _props$away,
	          _props$isPlayingXI = _props.isPlayingXI,
	          isPlayingXI = _props$isPlayingXI === undefined ? false : _props$isPlayingXI;
	
	      var homePlayersLen = home.players.length || 0;
	      var awayPlayersLen = away.players.length || 0;
	      var squadTabs = _react2.default.createElement(
	        'article',
	        { className: 'boxscore-tabs sub-module-mobile-combine-split combined squad', 'data-behavior': 'content_tab_mobile' },
	        _react2.default.createElement(
	          'header',
	          { className: 'bordered' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            isPlayingXI ? 'Playing XI' : 'Squad'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'filter form-group button-group' },
	          _react2.default.createElement(
	            'button',
	            { onClick: this.switchTab.bind(this, 'a'), className: (0, _classnames2.default)('button-filter-alt lg fixed', { active: active == 'a' }, { 'disabled': home.isDisabledTab }), disabled: home.isDisabledTab },
	            _react2.default.createElement(
	              'span',
	              { className: 'team-name' },
	              home.name || ''
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'team-name-short' },
	              home.shortName || home.name || ''
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.switchTab.bind(this, 'b'), className: (0, _classnames2.default)('button-filter-alt lg fixed', { active: active == 'b' }, { 'disabled': away.isDisabledTab }), disabled: away.isDisabledTab },
	            _react2.default.createElement(
	              'span',
	              { className: 'team-name' },
	              away.name || ''
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'team-name-short' },
	              away.shortName || away.name || ''
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-tab', style: { display: active == 'a' ? 'block' : 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'col column-one' },
	              _react2.default.createElement(
	                'div',
	                { className: 'sub-module cricket' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'content' },
	                  _react2.default.createElement(SquadTable, { oppTeamPlayersLen: awayPlayersLen, team: home })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'content-tab', style: { display: active == 'b' ? 'block' : 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'col column-two' },
	              _react2.default.createElement(
	                'div',
	                { className: 'sub-module cricket' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'content' },
	                  _react2.default.createElement(SquadTable, { oppTeamPlayersLen: homePlayersLen, team: away })
	                )
	              )
	            )
	          )
	        )
	      );
	
	      return homePlayersLen || awayPlayersLen ? squadTabs : _react2.default.createElement('article', null);
	    }
	  }]);
	  return SquadTabs;
	}(_react2.default.Component), _class.propTypes = {
	  children: _react.PropTypes.object
	}, _temp);
	
	
	var SquadTable = function SquadTable(_ref2) {
	  var _ref2$team = _ref2.team,
	      team = _ref2$team === undefined ? {} : _ref2$team,
	      caption = _ref2.caption,
	      oppTeamPlayersLen = _ref2.oppTeamPlayersLen;
	
	
	  var imgString = '<img data-src="' + team.logo + '" class="lazyload"/> ' + team.shortName;
	
	  var squadPlayers = _react2.default.createElement(
	    'tbody',
	    null,
	    (team.players || []).map(function (p, i) {
	      return _react2.default.createElement(PlayerRow, { key: i, player: p });
	    })
	  );
	  var squadNotAnnounced = [];
	  if (team.players.length === 0) {
	    squadNotAnnounced.push(_react2.default.createElement(
	      'tr',
	      { key: 'e' },
	      _react2.default.createElement(
	        'td',
	        { colSpan: '2', className: 'nya u-ta-c' },
	        'Squad not yet announced'
	      )
	    ));
	    // ittrate over other team squad list to get blank <tr> markup
	    for (var i = 0; i < oppTeamPlayersLen - 1; i++) {
	      squadNotAnnounced.push(_react2.default.createElement(
	        'tr',
	        { key: 'e' + i },
	        _react2.default.createElement(
	          'td',
	          { className: 'name' },
	          '-'
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'role' },
	          '-'
	        )
	      ));
	    }
	  }
	  return _react2.default.createElement(
	    'table',
	    null,
	    (team.logo || team.shortName) && caption && _react2.default.createElement('caption', { dangerouslySetInnerHTML: { __html: imgString } }) || _react2.default.createElement('caption', null),
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          null,
	          'PLAYER'
	        ),
	        _react2.default.createElement(
	          'th',
	          { className: 'name' },
	          'ROLE'
	        )
	      )
	    ),
	
	    // if team squad are unavailable show 'Squad not yet announced' message.
	    team.players.length ? squadPlayers : _react2.default.createElement(
	      'tbody',
	      null,
	      squadNotAnnounced
	    )
	  );
	};
	
	var SquadModule = exports.SquadModule = function SquadModule(_ref3) {
	  var _ref3$home = _ref3.home,
	      home = _ref3$home === undefined ? {} : _ref3$home,
	      _ref3$away = _ref3.away,
	      away = _ref3$away === undefined ? {} : _ref3$away,
	      _ref3$hideShowClass = _ref3.hideShowClass,
	      hideShowClass = _ref3$hideShowClass === undefined ? true : _ref3$hideShowClass;
	
	  var homePlayers = home.players || [];
	  var awayPlayers = away.players || [];
	  var homePlayersLen = homePlayers.length || 0;
	  var awayPlayersLen = awayPlayers.length || 0;
	
	  var content = _react2.default.createElement(
	    'div',
	    { className: hideShowClass ? 'hide-show' : '' },
	    _react2.default.createElement(
	      'article',
	      { className: 'sub-module squad-table' },
	      _react2.default.createElement(
	        'header',
	        { className: 'bordered' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Squad'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'table-wrap' },
	        _react2.default.createElement(SquadTable, { oppTeamPlayersLen: awayPlayersLen, team: home, caption: true })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'table-wrap' },
	        _react2.default.createElement(SquadTable, { oppTeamPlayersLen: homePlayersLen, team: away, caption: true })
	      )
	    )
	  );
	
	  return homePlayersLen || awayPlayersLen ? content : _react2.default.createElement('article', { className: 'sub-module squad-table', style: { display: 'none' } });
	};
	
	exports.default = {
	  SquadModule: SquadModule,
	  SquadTabs: SquadTabs
	};

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(412);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(647);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(362);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(686);
	
	var _common2 = __webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommentaryFeedback = function (_React$Component) {
	  (0, _inherits3.default)(CommentaryFeedback, _React$Component);
	
	  function CommentaryFeedback() {
	    (0, _classCallCheck3.default)(this, CommentaryFeedback);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CommentaryFeedback.__proto__ || (0, _getPrototypeOf2.default)(CommentaryFeedback)).call(this));
	
	    _this._onChange = _this._onChange.bind(_this);
	    _this._validate = _this._validate.bind(_this);
	    _this._onChangeRecaptcha = _this._onChangeRecaptcha.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.reset = _this.reset.bind(_this);
	    _this.state = {
	      values: {},
	      errors: {},
	      invalidFields: true
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(CommentaryFeedback, [{
	    key: 'getUserDetails',
	    value: function getUserDetails() {
	      var _this2 = this;
	
	      (0, _common2.isLibraryLoaded)({
	        namespace: 'DisneyID',
	        callback: function callback() {
	          window.DisneyID.get().getGuest().done(function () {
	            var guest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var profile = guest.profile || {};
	            var _profile$firstName = profile.firstName,
	                firstName = _profile$firstName === undefined ? '' : _profile$firstName,
	                _profile$lastName = profile.lastName,
	                lastName = _profile$lastName === undefined ? '' : _profile$lastName,
	                _profile$email = profile.email,
	                email = _profile$email === undefined ? '' : _profile$email;
	
	            var name = firstName + ' ' + lastName;
	
	            _this2.setState({
	              values: {
	                name: name,
	                email: email
	              }
	            });
	          });
	        }
	      });
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      var _props$status = this.props.status;
	      _props$status = _props$status === undefined ? {} : _props$status;
	      var SUCCESS = _props$status.SUCCESS;
	
	
	      if (SUCCESS === true) {
	        this.setState({
	          values: {},
	          errors: {},
	          invalidFields: true
	        });
	        this.refs.recaptcha.reset();
	        this.getUserDetails();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      try {
	        this.getUserDetails();
	
	        jQuery('#form--commentary #submit_btn .button__ripple').on('webkitAnimationEnd oanimationend oAnimationEnd msAnimationEnd animationend', function () {
	          _this3.reset();
	        });
	      } catch (err) {
	        console.error(err);
	      }
	    }
	  }, {
	    key: '_updateValue',
	    value: function _updateValue(name, value) {
	      var values = this.state.values;
	      var invalidFields = jQuery('#form--commentary').find(':invalid').length > 0;
	
	      value = value.replace(/^\s+/, '');
	
	      values = (0, _assign2.default)({}, values, (0, _defineProperty3.default)({}, name, value));
	
	      this.setState({ values: values, invalidFields: invalidFields });
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(ev) {
	      var input = ev.target;
	
	      this._updateValue(input.name, input.value);
	    }
	  }, {
	    key: '_onChangeRecaptcha',
	    value: function _onChangeRecaptcha(value) {
	      this._updateValue('g-recaptcha-response', value);
	    }
	  }, {
	    key: '_validate',
	    value: function _validate(ev) {
	      var input = ev.target;
	      var inputErr = null;
	      var errors = this.state.errors;
	
	      if (input.checkValidity() === false) {
	        inputErr = input.validationMessage;
	      }
	
	      errors = (0, _assign2.default)({}, errors, (0, _defineProperty3.default)({}, input.name, inputErr));
	
	      this.setState({ errors: errors });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	      var values = this.state.values;
	      var gameId = this.props.gameId;
	
	      var regex = /(<([^>]+)>)/ig;
	      var _values$name = values.name,
	          name = _values$name === undefined ? '' : _values$name,
	          _values$text = values.text,
	          text = _values$text === undefined ? '' : _values$text,
	          _values$email = values.email,
	          email = _values$email === undefined ? '' : _values$email,
	          rest = (0, _objectWithoutProperties3.default)(values, ['name', 'text', 'email']);
	
	
	      if (typeof name === 'string') {
	        name = name.replace(regex, '');
	      }
	      if (typeof email === 'string') {
	        email = email.toLowerCase();
	      }
	      if (typeof text === 'string') {
	        text = text.replace(regex, '');
	      }
	
	      this.props.postCommentryFeedback((0, _extends3.default)({ name: name, text: text, email: email }, rest, { object_id: gameId }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          invalidFields = _state.invalidFields,
	          values = _state.values,
	          errors = _state.errors;
	      var _props = this.props,
	          _props$status2 = _props.status;
	      _props$status2 = _props$status2 === undefined ? {} : _props$status2;
	      var SUBMITTING = _props$status2.SUBMITTING,
	          SUCCESS = _props$status2.SUCCESS,
	          ERROR = _props$status2.ERROR,
	          isUpdatesOnly = _props.isUpdatesOnly;
	      // UpdatesOnly matches doesnt need CommentaryFeedback.
	
	      if (isUpdatesOnly) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'sub-module commentary__feedback' },
	        _react2.default.createElement(
	          'header',
	          { className: 'bordered' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Commentary Feedback'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'form',
	            { className: 'form form--commentary', id: 'form--commentary', onSubmit: this.handleSubmit },
	            _react2.default.createElement(
	              'div',
	              { className: 'form__container' },
	              _react2.default.createElement(_common.Input, {
	                key: 'nm',
	                groupClass: 'form__group--commentary',
	                values: values,
	                errors: errors,
	                input: { type: 'text', id: 'name', name: 'name', label: 'Name', required: true, tabIndex: 1, onChange: this._onChange, onBlur: this._validate } }),
	              _react2.default.createElement(_common.Input, {
	                key: 'em',
	                groupClass: 'form__group--commentary',
	                values: values,
	                errors: errors,
	                input: { type: 'email', id: 'email', name: 'email', label: 'Email', required: true, tabIndex: 2, pattern: '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$', onChange: this._onChange, onBlur: this._validate } })
	            ),
	            _react2.default.createElement(_common.Textarea, {
	              key: 'msg',
	              groupClass: 'form__group--commentary',
	              showLabel: true,
	              values: values,
	              errors: errors,
	              input: { id: 'form__message', name: 'text', label: 'All feedback is read by us but only a small number are published.', required: true, tabIndex: 3, row: 3, placeholder: 'Your Message (500 words)', onChange: this._onChange, onBlur: this._validate, maxLength: 500 } }),
	            _react2.default.createElement(_common.Recaptcha, {
	              key: 'rc',
	              groupClass: 'form__group--commentary commentary__captcha',
	              ref: 'recaptcha',
	              sitekey: '6Lc66xIUAAAAAE6RRx2s2GO01aCRx_QGBTXrDiXZ',
	              tabindex: 4,
	              onChange: this._onChangeRecaptcha }),
	            _react2.default.createElement(_common.Button, {
	              id: 'submit_btn',
	              groupClass: 'commentary__button',
	              tabindex: 5,
	              disabled: invalidFields || ERROR,
	              submitting: SUBMITTING,
	              success: SUCCESS })
	          )
	        )
	      );
	    }
	  }]);
	  return CommentaryFeedback;
	}(_react2.default.Component); /* global jQuery */
	
	
	exports.default = CommentaryFeedback;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global jQuery espn */
	var Article = function (_Component) {
	  (0, _inherits3.default)(Article, _Component);
	
	  function Article() {
	    (0, _classCallCheck3.default)(this, Article);
	    return (0, _possibleConstructorReturn3.default)(this, (Article.__proto__ || (0, _getPrototypeOf2.default)(Article)).call(this));
	  }
	
	  (0, _createClass3.default)(Article, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() /*nextProps*/{
	      /*
	       * Alternate solution to hinder articale update id the same article is getting updated
	       *
	      const articleId = selectn('article.id', this.props)
	      const articleIdNext = selectn('article.id', nextProps)
	      const html = selectn('article.html', this.props) || ''
	      const htmlNext = selectn('article.html', nextProps) || ''
	       return articleId !== articleIdNext ? true : html.length !== htmlNext.length
	      */
	      try {
	        var embeddedPlayerId = (0, _selectn2.default)('video.player.embeddedPlayerId', espn) || '';
	        // prevent the article update if the video element is present in the DOM
	        if (embeddedPlayerId !== '') {
	          return jQuery('#article-feed ' + '#' + embeddedPlayerId).size() > 0 ? false : true;
	        } else {
	          return true;
	        }
	      } catch (err) {
	        console.error(err);
	        // in case of any error component should get updated
	        return true;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$article = this.props.article,
	          article = _props$article === undefined ? {} : _props$article;
	
	      var articleMarkup = article.html || '';
	      articleMarkup = articleMarkup.replace('<\\/script>', '<\/script>');
	      return _react2.default.createElement('section', { id: 'article-feed',
	        className: 'col-b',
	        'data-behavior': 'author_overlay article_header_news_feed_item_meta social_tools comment',
	        dangerouslySetInnerHTML: { __html: articleMarkup } });
	    }
	  }]);
	  return Article;
	}(_react.Component);
	
	exports.default = Article;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HawkEye;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HawkEye(_ref) {
	  var _ref$hawkEyeSrc = _ref.hawkEyeSrc,
	      hawkEyeSrc = _ref$hawkEyeSrc === undefined ? '' : _ref$hawkEyeSrc;
	
	  var style = {
	    margin: '0 auto',
	    backgroundColor: '#FFF',
	    textAlign: 'center',
	    padding: '20'
	  };
	  var iframeStyle = {
	    backgroundColor: '#FFF'
	  };
	  return _react2.default.createElement(
	    'section',
	    { style: style },
	    _react2.default.createElement('iframe', { id: 'hawkeye', name: 'hawkeye', src: hawkEyeSrc, style: iframeStyle,
	      frameBorder: '0', width: '630', height: '750', marginWidth: '0', marginHeight: '0' })
	  );
	}

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CloseOfPlay = function CloseOfPlay(_ref) {
	  var _ref$cop = _ref.cop,
	      cop = _ref$cop === undefined ? [] : _ref$cop;
	
	  //temporary, till FE team add class/styles to toolkit
	  var liStyle = {
	    fontSize: '12px',
	    color: '#6c6d6f',
	    paddingBottom: '5px'
	  };
	  var dateStyle = {
	    color: '#000',
	    fontWeight: 'bold'
	  };
	  var content = _react2.default.createElement(
	    'article',
	    { className: 'sub-module cricket' },
	    _react2.default.createElement(
	      'header',
	      { className: 'bordered' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Close of Play'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        cop && cop.map(function () {
	          var c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var i = arguments[1];
	
	          return _react2.default.createElement(
	            'li',
	            { key: i, style: liStyle },
	            _react2.default.createElement(
	              'span',
	              { style: dateStyle },
	              ' ',
	              c.date
	            ),
	            ' ',
	            c.date ? '-' : '',
	            ' ',
	            c.text
	          );
	        })
	      )
	    )
	  );
	
	  return cop.length ? content : _react2.default.createElement('article', { className: 'sub-module cricket' });
	};
	
	exports.default = CloseOfPlay;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Scorers = function Scorers(_ref) {
	  var _ref$scorer = _ref.scorer,
	      scorer = _ref$scorer === undefined ? '' : _ref$scorer,
	      _ref$commentator = _ref.commentator,
	      commentator = _ref$commentator === undefined ? '' : _ref$commentator;
	
	  var htmlString = [];
	
	  if (scorer) {
	    htmlString.push('Scorer: <span>' + scorer + '</span>');
	  }
	
	  if (commentator) {
	    htmlString.push('Commentator: <span>' + commentator + '</span>');
	  }
	  return _react2.default.createElement('p', { className: 'commentator-scorer', dangerouslySetInnerHTML: { __html: htmlString.length && htmlString.join(' | ') || null } });
	};
	
	exports.default = Scorers;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Charts = undefined;
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d = __webpack_require__(844);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(423);
	
	var utils = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lookup commonly used team colors
	/* global jQuery */
	var teamColors = {
	  home: '#40b5e5',
	  away: '#ef3a49',
	  default: '#aaa'
	
	  /**
	   * Update overs comparison data from feed.
	   * If an innings does not have values property (array of overs), set to empty
	   * array.
	   *
	   * @param  {Array} data Innings data
	   * @return {undefined}      undefined
	   */
	};function setDataForEmptyOvers(data) {
	  for (var i = 0; i < data.length; i++) {
	    var d = data[i];
	    if (d.hasOwnProperty('values') === false) {
	      d.values = [];
	    }
	  }
	}
	/**
	 * tooltip position is calculated based on mouse hover co-ordinates.
	 * X co-ordinate based on hover X co-ordinate and chart container's median co-ordinates
	 * Y co-ordinate based on document height, hover Y co-ordinates, tooltip height
	 * @param {Object} div tooltip instance
	 * @param {String} mainContainerSelector mainContainer reference
	 * @param {String} divSelector Chartcontainer reference
	 * @param {Number} width width of chart container
	 * @return {undefined} undefined
	*/
	function getTooltipPosition(div, mainContainerSelector, divSelector, width) {
	  var docHeight = parseInt(jQuery(document).height(), 10);
	  var tooltipHeight = parseInt(div.style('height'), 10);
	  var tooltipWidth = parseInt(div.style('width'), 10);
	  var leftPos = 0;
	  var topPos = 0;
	  var mainContainerOffset = jQuery(mainContainerSelector).offset();
	  var chartContainerOffset = jQuery(divSelector).offset();
	  // If hovered position is in left half of chart container tooltip will be leaned towards right and viceversa
	  if (_d2.default.event.pageX > parseInt(chartContainerOffset.left + width / 2)) {
	    leftPos = _d2.default.event.pageX - tooltipWidth - 10;
	  } else {
	    leftPos = _d2.default.event.pageX + 10;
	  }
	  // If sufficient gap (tooltip height) is available between hovered position and end of document, then tooltip will be downwards else upwards
	  if (docHeight - _d2.default.event.pageY - 20 > tooltipHeight) {
	    topPos = _d2.default.event.pageY - parseInt(mainContainerOffset.top, 10) + 10;
	  } else {
	    topPos = _d2.default.event.pageY - tooltipHeight - parseInt(mainContainerOffset.top, 10) - 10;
	  }
	  return { leftPos: leftPos, topPos: topPos };
	}
	/**
	 * Draw legends for the charts
	 * @param  {Array} svg       SVG element
	 * @param  {NUmber} width     width of the chart area
	 * @param  {String} team1 display name/abbreviation of team 1
	 * @param  {String} team2 display name/abbreviation of team 2
	 * @param  {Number} inn1Overs Number of overs in 1st innings
	 * @param  {Number} inn2Overs Number of overs in 2nd innings
	 * @return {undefined} undefined
	 */
	function drawLegend(svg, width) {
	  var team1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var team2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var inn1Overs = arguments[4];
	  var inn2Overs = arguments[5];
	
	  // Chart legends
	  //console.info('inn1Overs, inn2Overs', inn1Overs, inn2Overs)
	  var team1Name = team1.teamName || 'TEAM A';
	  var team2Name = team2.teamName || 'TEAM B';
	  var team1Color = team1.name === 'home' ? teamColors.home : teamColors.away;
	  var team2Color = team2.name === 'home' ? teamColors.home : teamColors.away;
	  // Draw team 1 legend only if team 1 number of overs is positive number
	  if (inn1Overs > 0) {
	    svg.append('rect').attr('x', width - 180).attr('y', -20).attr('height', 10).attr('width', 10).attr('fill', team1Color);
	    svg.append('text').attr('x', width - 180 + 15).attr('y', -20 + 10).text(team1Name).attr('fill', teamColors.default);
	  }
	
	  // Draw team 2 legend only if team 2 number of overs is positive number
	  if (inn2Overs > 0) {
	    svg.append('rect').attr('x', width - 180).attr('y', 5).attr('height', 10).attr('width', 10).attr('fill', team2Color);
	    svg.append('text').attr('x', width - 180 + 15).attr('y', 5 + 10).text(team2Name).attr('fill', teamColors.default);
	  }
	}
	
	function barChart() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$divSelector = _ref.divSelector,
	      divSelector = _ref$divSelector === undefined ? '#chart-manhattan' : _ref$divSelector,
	      div = _ref.div,
	      data = _ref.data;
	
	  var inn1Overs = (0, _selectn2.default)('[0].values.length', data) || 0;
	  var inn2Overs = (0, _selectn2.default)('[1].values.length', data) || 0;
	  var overs = inn1Overs > inn2Overs ? inn1Overs : inn2Overs;
	
	  var outerHeight = 375;
	  var margin = { top: 30, right: 5, bottom: 30, left: 35 };
	  var mainContainerSelector = '#main-container';
	  var width = jQuery(divSelector).width() - margin.left - margin.right;
	  var height = outerHeight - margin.top - margin.bottom;
	  var maxTicks = 25;
	  var yAxisTicks = 4;
	  var diameter = 13;
	  var breakPoint = 1024;
	  // Extract team names
	  var team1 = (0, _selectn2.default)('[0]', data) || {};
	  var team2 = (0, _selectn2.default)('[1]', data) || {};
	
	  var maxRuns = _d2.default.max(data, function (t) {
	    return _d2.default.max(t.values, function (v) {
	      return v.runs;
	    });
	  });
	  var yMax = Math.ceil(maxRuns / 5) * 5;
	  var y = _d2.default.scale.linear().domain([0, yMax]).range([height, margin.top]);
	
	  var x0 = _d2.default.scale.ordinal().domain(_d2.default.range(1, overs + 1)).rangeBands([0, width - margin.right], .2);
	
	  var x1 = _d2.default.scale.ordinal().domain([0, 1]).rangeBands([0, x0.rangeBand()]);
	
	  var xAxis = _d2.default.svg.axis().scale(x0).tickValues(x0.domain().filter(function (d, i) {
	    return overs > maxTicks ? !(i % 5) : true;
	  })).orient('bottom');
	
	  var yAxis = _d2.default.svg.axis().scale(y).tickSize(-width + margin.right).ticks(overs < yAxisTicks ? overs : yAxisTicks).orient('left');
	
	  // set circle diameter
	  if (x1.rangeBand() < diameter) {
	    diameter = x1.rangeBand();
	
	    if (diameter < 6) {
	      diameter = 6;
	    }
	  }
	
	  var svg = _d2.default.select(divSelector).append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	  svg.append('g').attr('class', 'y axis').call(yAxis);
	
	  svg.append('g').attr('class', 'x axis').attr('transform', 'translate(0,' + height + ')').call(xAxis);
	
	  svg.append('g').selectAll('g').data(data).enter().append('g').style('fill', function (d) {
	    return d.name === 'home' ? teamColors.home : teamColors.away;
	  }).attr('transform', function (d, i) {
	    return 'translate(' + x1(i) + ',0)';
	  }).selectAll('g').data(function (d) {
	    return d.values;
	  }).enter().append('rect').attr('height', function (d) {
	    return height - y(d.runs);
	  }).attr('width', x1.rangeBand()).attr('x', function (d) {
	    return x0(d.over);
	  }).attr('y', function (d) {
	    return y(d.runs);
	  });
	
	  svg.selectAll('dot').data(data).enter().append('g').selectAll('g').data(function (d) {
	    return d.values;
	  }).enter().append('g').selectAll('g').data(function (d) {
	    return d.wickets;
	  }).enter().append('circle').attr('r', diameter / 2).attr('stroke', function () {
	    return _d2.default.select(this.parentNode.parentNode).datum().name === 'home' ? teamColors.home : teamColors.away;
	  }).attr('stroke-width', '2px').attr('fill', 'white').attr('cx', function () {
	    var datum = _d2.default.select(this.parentNode.parentNode).datum();
	    return x0(_d2.default.select(this.parentNode).datum().over) + x1.rangeBand() / 2 + (datum.name == 'home' ? 0 : x1.rangeBand());
	  }).attr('cy', function (d, i) {
	    return y(_d2.default.select(this.parentNode).datum().runs) - diameter / 2 - i * diameter;
	  }).on('mouseover', function (d) {
	    if (jQuery(window).width() < breakPoint) {
	      return;
	    }
	    var toolipPosition = {};
	    div.html(d.text);
	    toolipPosition = getTooltipPosition(div, mainContainerSelector, divSelector, width);
	    div.transition().duration(200).style('opacity', .9);
	    div.style('left', toolipPosition.leftPos + 'px').style('top', toolipPosition.topPos + 'px');
	  }).on('mouseout', function () {
	    if (jQuery(window).width() < breakPoint) {
	      return;
	    }
	    div.transition().duration(350).style('opacity', 0);
	  });
	
	  svg.append('text').attr('x', width / 2 - 25) // 25 is roughly text elem width/2, to be calc
	  .attr('y', height + margin.bottom).text('OVERS').attr('fill', teamColors.default);
	
	  svg.append('text').attr('y', 0 - margin.left + 10) // 10 is approx half of label height
	  .attr('x', 0 - (height / 2 + 50)) // 50 is approx half of label width
	  .attr('transform', 'rotate(-90)').text('RUNS PER OVER').attr('fill', teamColors.default);
	
	  drawLegend(svg, width, team1, team2, inn1Overs, inn2Overs);
	}
	
	function lineChart(_ref2) {
	  var data = _ref2.data,
	      _ref2$divSelector = _ref2.divSelector,
	      divSelector = _ref2$divSelector === undefined ? '#chart-runrate' : _ref2$divSelector,
	      keys = _ref2.keys,
	      div = _ref2.div,
	      _ref2$yLabel = _ref2.yLabel,
	      yLabel = _ref2$yLabel === undefined ? 'RUNS' : _ref2$yLabel;
	
	
	  try {
	
	    var inn1Overs = (0, _selectn2.default)('[0].values.length', data) || 0;
	    var inn2Overs = (0, _selectn2.default)('[1].values.length', data) || 0;
	    var overs = inn1Overs > inn2Overs ? inn1Overs : inn2Overs;
	
	    var maxTicks = 10;
	    var minTicksSpacing = 30;
	    var yAxisTicks = 4;
	    var outerHeight = 375;
	    var mainContainerSelector = '#main-container';
	    var diameter = 13;
	    var breakPoint = 1024;
	    // Extract team names
	    var team1 = (0, _selectn2.default)('[0]', data) || {};
	    var team2 = (0, _selectn2.default)('[1]', data) || {};
	
	    keys = keys || {
	      x: 'over',
	      y: 'runs'
	    };
	    var margin = { top: 30, right: 20, bottom: 30, left: 20 };
	    var width = jQuery(divSelector).width() - margin.left - margin.right;
	    var height = outerHeight - margin.top - margin.bottom;
	
	    var x = _d2.default.scale.linear().range([margin.left, width - margin.right]);
	
	    var x0 = _d2.default.scale.ordinal().domain(_d2.default.range(1, overs + 1)).rangeBands([0, width - margin.right], .2);
	
	    var x1 = _d2.default.scale.ordinal().domain([0, 1]).rangeBands([0, x0.rangeBand()]);
	
	    var y = _d2.default.scale.linear().range([height, margin.top]);
	
	    var xAxis = _d2.default.svg.axis().scale(x).ticks(overs > maxTicks ? Math.floor(width / minTicksSpacing) : overs - 1).orient('bottom');
	
	    var yAxis = _d2.default.svg.axis().scale(y).ticks(yAxisTicks).tickSize(-width + margin.right).tickPadding(10).orient('left');
	
	    // set circle diameter
	    if (x1.rangeBand() < diameter) {
	      diameter = x1.rangeBand();
	
	      if (diameter < 6) {
	        diameter = 6;
	      }
	    }
	
	    var line = _d2.default.svg.line().interpolate('linear').x(function (d) {
	      return x(d[keys.x]);
	    }).y(function (d) {
	      return y(d[keys.y]);
	    });
	
	    var svg = _d2.default.select(divSelector).append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	    x.domain([1, overs]);
	
	    var yMax = _d2.default.max(data, function (t) {
	      return _d2.default.max(t.values, function (v) {
	        return v[keys.y];
	      });
	    });
	
	    y.domain([_d2.default.min(data, function (t) {
	      return _d2.default.min(t.values, function (v) {
	        return v[keys.y];
	      });
	    }), yMax]);
	
	    yAxis.ticks(yMax < yAxisTicks ? yMax : yAxisTicks);
	
	    svg.append('g').attr('class', 'x axis').attr('transform', 'translate(0,' + height + ')').call(xAxis);
	
	    svg.append('g').attr('class', 'y axis').attr('transform', 'translate(' + margin.left + ',0)').call(yAxis);
	
	    var team = svg.selectAll('.team').data(data).enter().append('g').attr('class', 'team');
	
	    team.append('path').attr('class', 'line').attr('fill', 'transparent').attr('d', function (d) {
	      return line(d.values);
	    }).style('stroke', function (d) {
	      return d.name === 'home' ? teamColors.home : teamColors.away;
	    });
	
	    svg.selectAll('dot').data(data).enter().append('g').selectAll('g').data(function (d) {
	      return d.values;
	    }).enter().append('g').selectAll('g').data(function (d) {
	      return d.wickets;
	    }).enter().append('circle').attr('r', diameter / 2).attr('stroke', function () {
	      return _d2.default.select(this.parentNode.parentNode).datum().name === 'home' ? teamColors.home : teamColors.away;
	    }).attr('stroke-width', '2px').attr('fill', 'white').attr('cx', function () {
	      return x(_d2.default.select(this.parentNode).datum()[keys.x]);
	    }).attr('cy', function (d, i) {
	      return y(_d2.default.select(this.parentNode).datum()[keys.y]) + i * diameter;
	    }).on('mouseover', function (d) {
	      if (jQuery(window).width() < breakPoint) {
	        return;
	      }
	      var toolipPosition = {};
	      div.html(d.text);
	      toolipPosition = getTooltipPosition(div, mainContainerSelector, divSelector, width);
	      div.transition().duration(200).style('opacity', .9);
	      div.style('left', toolipPosition.leftPos + 'px').style('top', toolipPosition.topPos + 'px');
	    }).on('mouseout', function () {
	      if (jQuery(window).width() < breakPoint) {
	        return;
	      }
	      div.transition().duration(350).style('opacity', 0);
	    });
	    svg.append('text').attr('x', width / 2 - 25) // 25 is roughly text elem width/2, to be calc
	    .attr('y', height + margin.bottom).text('OVERS').attr('fill', teamColors.default);
	
	    svg.append('text').attr('y', 0 - margin.left / 2).attr('x', 0 - (height / 2 + 25)) // 25 is approx half of label width
	    .attr('transform', 'rotate(-90)').text(yLabel).attr('fill', teamColors.default);
	
	    // Chart legends
	    drawLegend(svg, width, team1, team2, inn1Overs, inn2Overs);
	
	    return svg;
	  } catch (e) {
	    console.log(e);
	  }
	}
	
	var Charts = exports.Charts = function (_React$Component) {
	  (0, _inherits3.default)(Charts, _React$Component);
	
	  function Charts() {
	    (0, _classCallCheck3.default)(this, Charts);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Charts.__proto__ || (0, _getPrototypeOf2.default)(Charts)).call(this));
	
	    _this._buildCharts = _this._buildCharts.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Charts, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.div = null;
	      jQuery(window).off('resize orientationchange', this._handleResize);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._buildCharts();
	      this._handleResize = utils.throttle(this._buildCharts, 150).bind(this);
	      jQuery(window).on('resize orientationchange', this._handleResize);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._buildCharts();
	    }
	  }, {
	    key: '_buildCharts',
	    value: function _buildCharts() {
	      try {
	        if (!this.div) {
	          this.div = _d2.default.select('#main-container').append('div').attr('class', 'chart-tooltip').style('opacity', 0);
	        }
	
	        // TODO: pick and show appropriate inning comparisons
	        var data = (0, _selectn2.default)('comparison[0]', this.props) || [];
	
	        setDataForEmptyOvers(data);
	
	        if (data.length) {
	          // Empty containers
	          jQuery('#chart-runrate, #chart-manhattan, #chart-worm').html('');
	          // TODO: try and update the chart instead of over-writing
	          lineChart({ divSelector: '#chart-runrate', data: data, keys: {
	              x: 'over',
	              y: 'rate'
	            }, div: this.div, yLabel: 'RUN RATE' });
	
	          lineChart({ divSelector: '#chart-worm', data: data, keys: {
	              x: 'over',
	              y: 'totalRuns'
	            }, div: this.div, yLabel: 'RUNS' });
	
	          barChart({ div: this.div, data: data });
	        } else {
	          // hide
	          // TODO: use component state to show/hide
	          jQuery('#runrate, #manhattan, #worm').hide();
	        }
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$teams = _props.teams,
	          teams = _props$teams === undefined ? {} : _props$teams,
	          _props$uiControls = _props.uiControls,
	          uiControls = _props$uiControls === undefined ? {} : _props$uiControls,
	          _props$comparison = _props.comparison,
	          comparison = _props$comparison === undefined ? [] : _props$comparison;
	
	      var data = comparison[0] || [];
	
	      teamColors.home = (0, _selectn2.default)('home.color', teams) || '#40b5e5';
	      teamColors.away = (0, _selectn2.default)('away.color', teams) || '#ef3a49';
	
	      var style = '<style>\n      svg {\n        font-size: 70%;\n      }\n      .axis path,\n      .axis line {\n        fill: none;\n        stroke: #aaa;\n        shape-rendering: crispEdges;\n      }\n      .x.axis path {\n        display: none;\n      }\n      .line {\n        fill: none;\n        stroke-width: 3px;\n      }\n      .tick line {\n        stroke: #aaa;\n        stroke-dasharray: 3,3;\n      }\n      .tick text {\n        stroke #666\n      }\n      div.chart-tooltip {\n        position: absolute;\n        text-align: left;\n        padding: 10px;\n        border: 0px;\n        background: #eee;\n        font-size: 80%;\n        pointer-events: none;\n        max-width: 350px;\n    }\n    @media screen and (max-width: 1024px) {\n      .chart-tooltip {\n        display:none\n      }\n    }\n    </style>\n    ';
	
	      var chartContent = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'article',
	          { className: 'sub-module stats', id: 'manhattan' },
	          _react2.default.createElement(
	            'header',
	            { className: 'bordered' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Manhattan'
	            )
	          ),
	          _react2.default.createElement('div', { style: { minHeight: '375px' }, className: 'content', dangerouslySetInnerHTML: { __html: '<div id="chart-manhattan" />' } })
	        ),
	        _react2.default.createElement(
	          'article',
	          { className: 'sub-module stats', id: 'runrate' },
	          _react2.default.createElement(
	            'header',
	            { className: 'bordered' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Run rate graph'
	            )
	          ),
	          _react2.default.createElement('div', { style: { minHeight: '375px' }, className: 'content', dangerouslySetInnerHTML: { __html: '<div id="chart-runrate" />' } })
	        ),
	        _react2.default.createElement(
	          'article',
	          { className: 'sub-module stats', id: 'worm' },
	          _react2.default.createElement(
	            'header',
	            { className: 'bordered' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Worm'
	            )
	          ),
	          _react2.default.createElement('div', { style: { minHeight: '375px' }, className: 'content', dangerouslySetInnerHTML: { __html: '<div id="chart-worm" />' } })
	        ),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: style } })
	      );
	
	      return uiControls.showCharts && data.length ? chartContent : _react2.default.createElement('div', null);
	    }
	  }]);
	  return Charts;
	}(_react2.default.Component);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GameBreak = undefined;
	
	var _getPrototypeOf = __webpack_require__(276);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(302);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(303);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(307);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(353);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GameBreak = exports.GameBreak = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(GameBreak, _React$Component);
	
	  function GameBreak(props) {
	    (0, _classCallCheck3.default)(this, GameBreak);
	
	    //init game status and breaks checks (all false if game in progress)
	    var _this = (0, _possibleConstructorReturn3.default)(this, (GameBreak.__proto__ || (0, _getPrototypeOf2.default)(GameBreak)).call(this, props));
	
	    _this._isCurrEqPrevBreak = false;
	    _this._isValidGameBreak = false;
	    _this._isPrevBreakExists = false;
	    _this._currentGamebreakstatus = '';
	    _this._prevGamebreakstatus = '';
	
	    _this._gamestatus = (0, _selectn2.default)('gamestatus', props);
	    _this._gamebreakstatus = (0, _selectn2.default)('gamebreakstatus', props);
	
	    _this._config = {};
	    _this._config.initialized = false;
	    _this._config.showad = false;
	
	    _this._config.gameId = 0;
	    _this._config.type = null;
	    _this._config.sport = null;
	    _this._config.gamestatus = null;
	    _this._config.gamebreakstatus = null;
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(GameBreak, [{
	    key: 'videoHtml',
	    value: function videoHtml() {
	      var html = '\n      <div id="gamepackage-gamebreak" class="sub-module videoAdBreak" style="display: none;">\n        <div class="content">\n          <div class="video-ad-break-wrap">\n            <div class="video-ad-status">\n              <div class="time-til-skip">\n                <span>\n                  <span class="countdown"></span>\n                  <a id="skipad-link" style="display: none; float: right; padding: 0px 5px; height: 20px; color: #fff;">Skip this Ad</a>\n                </span>\n              </div>\n            </div>\n            <div class="video-ad-break">\n              <div class="wrapper">\n                <div id="gbVideoPlayer"></div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    ';
	      return html;
	    }
	  }, {
	    key: 'createGameConfig',
	    value: function createGameConfig() {
	      var data = this.props || {};
	      var params = (0, _selectn2.default)('params', this.props) || {},
	          gameconfig = {};
	      if (params.gameId !== '') {
	        gameconfig = {
	          gameId: params.gameId ? params.gameId : undefined,
	          type: params.pageType ? params.pageType : undefined,
	          sport: params.sport ? params.sport : undefined,
	          gamestatus: data.gamestatus ? data.gamestatus : undefined,
	          gamebreakstatus: data.gamebreakstatus ? data.gamebreakstatus : undefined
	          //changing live state to in since all the sports uses pre, post and in for gameStates
	        };if (gameconfig.gamestatus === 'live') {
	          gameconfig.gamestatus = 'in';
	        }
	      }
	      this._config.gameId = gameconfig.gameId;
	      this._config.type = gameconfig.type;
	      this._config.sport = gameconfig.sport;
	      this._config.gamestatus = gameconfig.gamestatus;
	      this._config.gamebreakstatus = this._currentGamebreakstatus;
	    }
	
	    /**
	     * [callGamebreakAd call the gamebreak ad after inserting HTML for the ooyala player]
	     * @return {[type]} [runs the ad]
	     */
	
	  }, {
	    key: 'callGamebreakAd',
	    value: function callGamebreakAd() {
	      this.createGameConfig();
	      if (this._config.showad === true) {
	        this.props.gamebreak({ addplayerhtml: this.videoHtml() });
	        this.props.gamebreak(this._config);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      //when the page loads and component is loaded run the ad and inits the counter
	      var pageType = this._config.pageType || '';
	      this._currentGamebreakstatus = (0, _selectn2.default)('gamebreakstatus', this.props) || '';
	      if (pageType === 'game' && this._config.showad === true) {
	        this.callGamebreakAd();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      //the ad component shouldn't refresh during polling
	      var pageType = (0, _selectn2.default)('params.pageType', nextProps) || '';
	      this._currentGamebreakstatus = (0, _selectn2.default)('gamebreakstatus', nextProps) || '';
	      this._prevGamebreakstatus = (0, _selectn2.default)('gamebreakstatus', this.props) || '';
	      var gamestatusArr = ['lunch', 'dinner', 'drinks', 'tea', 'innings'];
	
	      //Flag is true when the gamebreak is one of the allowed values in gamestatusArr
	      this._isValidGameBreak = gamestatusArr.indexOf(this._currentGamebreakstatus) > -1;
	
	      //Flag is true if the current game break info is equal to previous state (happens when the break is ongoing)
	      this._isCurrEqPrevBreak = this._currentGamebreakstatus === this._prevGamebreakstatus && this._currentGamebreakstatus !== '';
	
	      //Flag is set true when the game has a previous state break info and no current break info status
	      this._isPrevBreakExists = this._currentGamebreakstatus !== this._prevGamebreakstatus && gamestatusArr.indexOf(this._prevGamebreakstatus) > -1;
	
	      if (pageType === 'game') {
	
	        // do not re render for any states, will reinsert the content in dom if needed
	        if (this._isCurrEqPrevBreak && this._isValidGameBreak) {
	          //works on first load
	          this._config.showad = true;
	        }
	        // when previous gamebreakstatus is available don't show the ad
	        if (this._isPrevBreakExists) {
	          this._config.showad = false;
	        }
	        // all game gamebreakstatus are empty don't show ad
	        if (!this._isPrevBreakExists && !this._isValidGameBreak && !this._isCurrEqPrevBreak) {
	          this._config.showad = false;
	        }
	        // first time gamebreakstatus available show the ad
	        if (this._currentGamebreakstatus !== '' && this._prevGamebreakstatus === '') {
	          this._config.showad = true;
	        }
	
	        if (this._config.showad === false) {
	          return false;
	        }
	
	        this.callGamebreakAd();
	
	        return false;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      this._gamestatus = (0, _selectn2.default)('gamestatus', this.props);
	      this._gamebreakstatus = (0, _selectn2.default)('gamebreakstatus', this.props);
	
	      //load the component if game is live
	      if (this._gamestatus && this._gamestatus === 'live') {
	        this._config.initialized = true;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('article', { key: 'gmart', id: 'videogamebreak', style: { backgroundColor: '#333' }, dangerouslySetInnerHTML: { __html: this.videoHtml() } })
	        );
	      }
	    }
	  }]);
	  return GameBreak;
	}(_react2.default.Component), _class.propTypes = {
	  children: _react.PropTypes.object
	}, _temp);

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCricketViewLite = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _index = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generate the Game package view for Cricket
	 * @param  {String} options.pageType PageType
	 * @param  {Object} options.state    Application state
	 * @return {Object}                  Arrays having React components for each column
	 */
	var getCricketViewLite = exports.getCricketViewLite = function getCricketViewLite(_ref) {
	  var _ref$pageType = _ref.pageType,
	      pageType = _ref$pageType === undefined ? 'game' : _ref$pageType,
	      _ref$state = _ref.state,
	      state = _ref$state === undefined ? {} : _ref$state,
	      params = _ref.params;
	
	  var appView = '';
	  var currentPageLink = '#';
	  var links = state.links || [];
	
	  links.map(function (link) {
	    if (link.pageType === pageType) {
	      currentPageLink = link.href;
	    }
	  });
	
	  switch (pageType) {
	    case 'game':
	    case 'match':
	      appView = getSummary({ state: state, params: params, currentPageLink: currentPageLink });
	      break;
	
	    case 'scorecard':
	      appView = getScorecard({ state: state });
	      break;
	  }
	
	  return appView;
	};
	
	var getSummary = function getSummary(_ref2) {
	  var state = _ref2.state,
	      params = _ref2.params,
	      currentPageLink = _ref2.currentPageLink;
	
	  var isLimitedOvers = (0, _selectn2.default)('matchFlags.limitedOvers', state);
	  var partCommentary = state.partCommentary || {};
	  var gameStateClassFeature = state.gameStateClassFeature,
	      summary = state.summary,
	      gameStrip = state.gameStrip,
	      showGameDetailFooter = state.showGameDetailFooter;
	  var sport = params.sport;
	
	
	  var content = [_react2.default.createElement(_index.ScoreCell, (0, _extends3.default)({ key: 'sc' }, gameStrip, { sport: sport, className: gameStateClassFeature, summaryText: summary, showGameDetailFooter: showGameDetailFooter })), _react2.default.createElement(_index.TopStories, (0, _extends3.default)({ key: 't' }, state.article)), _react2.default.createElement(_index.Commentary, (0, _extends3.default)({ key: 'c' }, partCommentary, { isWebView: state.isWebView, showCommentPreText: true })), _react2.default.createElement(_index.Squad, (0, _extends3.default)({ key: 's' }, state.rosters))];
	
	  switch (state.gameState) {
	    case 'live':
	      content = [_react2.default.createElement(_index.ScoreCell, (0, _extends3.default)({ key: 'sc' }, gameStrip, { sport: sport, className: gameStateClassFeature, summaryText: summary, showGameDetailFooter: showGameDetailFooter, currentPageLink: currentPageLink })), _react2.default.createElement(_index.InningsSummary, (0, _extends3.default)({ key: 'i' }, state.innings, { isSmallDevice: state.isSmallDevice, isWebView: state.isWebView, isLimitedOvers: isLimitedOvers })), _react2.default.createElement(_index.Commentary, (0, _extends3.default)({ key: 'c' }, state.partCommentary, { isWebView: state.isWebView }))];
	      break;
	
	    case 'final':
	      content = [_react2.default.createElement(_index.ScoreCell, (0, _extends3.default)({ key: 'sc' }, gameStrip, { sport: sport, className: gameStateClassFeature, summaryText: summary, showGameDetailFooter: showGameDetailFooter })), _react2.default.createElement(_index.TopStories, (0, _extends3.default)({ key: 't' }, state.article)), _react2.default.createElement(_index.ScorecardSummary, (0, _extends3.default)({ key: 'ss' }, state.scorecardSummary, { isLimitedOvers: isLimitedOvers })), _react2.default.createElement(_index.MatchDetails, (0, _extends3.default)({ key: 'md' }, state.matchDetails, { hideShowClass: true })), _react2.default.createElement(_index.Commentary, (0, _extends3.default)({ key: 'c' }, state.partCommentary, { isWebView: state.isWebView }))];
	      break;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { key: 'sm', className: 'cricinfo__content' },
	    content
	  );
	};
	
	var getScorecard = function getScorecard(_ref3) {
	  var state = _ref3.state;
	
	  var officials = (0, _selectn2.default)('matchDetails.officials', state);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cricinfo__content' },
	    _react2.default.createElement(_index.Innings, (0, _extends3.default)({ key: 'in' }, state.scorecard, { isWebView: state.isWebView })),
	    _react2.default.createElement(_index.MatchOfficials, { key: 'mo', officials: officials })
	  );
	};
	
	exports.default = getCricketViewLite;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MatchDetails = exports.MatchOfficials = exports.Team = exports.Innings = exports.ScorecardSummary = exports.Squad = exports.Commentary = exports.TopStories = exports.InningsSummary = exports.ScoreCell = exports.GlobalNavTertiary = undefined;
	
	var _GlobalNavTertiary = __webpack_require__(848);
	
	var _GlobalNavTertiary2 = _interopRequireDefault(_GlobalNavTertiary);
	
	var _ScoreCell = __webpack_require__(849);
	
	var _ScoreCell2 = _interopRequireDefault(_ScoreCell);
	
	var _InningsSummary = __webpack_require__(850);
	
	var _InningsSummary2 = _interopRequireDefault(_InningsSummary);
	
	var _TopStories = __webpack_require__(851);
	
	var _TopStories2 = _interopRequireDefault(_TopStories);
	
	var _Commentary = __webpack_require__(852);
	
	var _Commentary2 = _interopRequireDefault(_Commentary);
	
	var _Squad = __webpack_require__(853);
	
	var _Squad2 = _interopRequireDefault(_Squad);
	
	var _ScorecardSummary = __webpack_require__(854);
	
	var _ScorecardSummary2 = _interopRequireDefault(_ScorecardSummary);
	
	var _Innings = __webpack_require__(855);
	
	var _Innings2 = _interopRequireDefault(_Innings);
	
	var _Team = __webpack_require__(856);
	
	var _Team2 = _interopRequireDefault(_Team);
	
	var _MatchOfficials = __webpack_require__(857);
	
	var _MatchOfficials2 = _interopRequireDefault(_MatchOfficials);
	
	var _MatchDetails = __webpack_require__(858);
	
	var _MatchDetails2 = _interopRequireDefault(_MatchDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.GlobalNavTertiary = _GlobalNavTertiary2.default;
	exports.ScoreCell = _ScoreCell2.default;
	exports.InningsSummary = _InningsSummary2.default;
	exports.TopStories = _TopStories2.default;
	exports.Commentary = _Commentary2.default;
	exports.Squad = _Squad2.default;
	exports.ScorecardSummary = _ScorecardSummary2.default;
	exports.Innings = _Innings2.default;
	exports.Team = _Team2.default;
	exports.MatchOfficials = _MatchOfficials2.default;
	exports.MatchDetails = _MatchDetails2.default;
	exports.default = {
	  GlobalNavTertiary: _GlobalNavTertiary2.default,
	  ScoreCell: _ScoreCell2.default,
	  InningsSummary: _InningsSummary2.default,
	  TopStories: _TopStories2.default,
	  Commentary: _Commentary2.default,
	  Squad: _Squad2.default,
	  ScorecardSummary: _ScorecardSummary2.default,
	  Innings: _Innings2.default,
	  Team: _Team2.default,
	  MatchOfficials: _MatchOfficials2.default,
	  MatchDetails: _MatchDetails2.default
	};

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(686);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GlobalNavTertiary = function GlobalNavTertiary(_ref) {
	  var _ref$links = _ref.links,
	      links = _ref$links === undefined ? [] : _ref$links,
	      _ref$activeKey = _ref.activeKey,
	      activeKey = _ref$activeKey === undefined ? '' : _ref$activeKey,
	      _ref$keyProp = _ref.keyProp,
	      keyProp = _ref$keyProp === undefined ? 'pageType' : _ref$keyProp;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cricinfo__header__tabs' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'cricinfo__header__tabs__list' },
	      links.map(function (link, i) {
	        var liClass = (0, _classnames2.default)('cricinfo__header__tabs__list__item', { 'cricinfo__header__tabs__list__item--active': activeKey == link[keyProp] });
	        var isRouterLink = typeof link.isRouterLink === 'boolean' ? link.isRouterLink : true;
	        // external links need to open in new window
	        var linkTarget = {};
	        if (link.external) {
	          isRouterLink = false;
	          linkTarget.target = '_blank';
	        }
	
	        return _react2.default.createElement(
	          'li',
	          { key: i, className: liClass },
	          _react2.default.createElement(_common.AnchorLink, (0, _extends3.default)({
	            trackingName: link.trackingName
	          }, linkTarget, {
	            'data-linktype': link.pageType || '',
	            classes: 'cricinfo__type__link',
	            text: link.text,
	            to: link.href,
	            isRouterLink: isRouterLink }))
	        );
	      })
	    )
	  );
	};
	
	exports.default = GlobalNavTertiary;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScoreCell = exports.Competitor = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Competitor = exports.Competitor = function Competitor(_ref) {
	  var _ref$abbrev = _ref.abbrev,
	      abbrev = _ref$abbrev === undefined ? '' : _ref$abbrev,
	      _ref$scoreMarkupMobil = _ref.scoreMarkupMobile,
	      scoreMarkupMobile = _ref$scoreMarkupMobil === undefined ? '' : _ref$scoreMarkupMobil,
	      _ref$team = _ref.team,
	      team = _ref$team === undefined ? 'home' : _ref$team;
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'cscore__item cscore__item--' + team },
	    _react2.default.createElement(
	      'div',
	      { className: 'cscore__name' },
	      abbrev
	    ),
	    _react2.default.createElement('div', { className: 'cscore__score', dangerouslySetInnerHTML: { __html: scoreMarkupMobile } })
	  );
	};
	
	var ScoreCell = exports.ScoreCell = function ScoreCell(_ref2) {
	  var gameState = _ref2.gameState,
	      _ref2$header = _ref2.header,
	      header = _ref2$header === undefined ? '' : _ref2$header,
	      _ref2$time = _ref2.time,
	      time = _ref2$time === undefined ? '' : _ref2$time,
	      _ref2$date = _ref2.date,
	      date = _ref2$date === undefined ? '' : _ref2$date,
	      _ref2$teams = _ref2.teams,
	      teams = _ref2$teams === undefined ? {} : _ref2$teams,
	      _ref2$sport = _ref2.sport,
	      sport = _ref2$sport === undefined ? '' : _ref2$sport,
	      _ref2$className = _ref2.className,
	      className = _ref2$className === undefined ? '' : _ref2$className,
	      _ref2$summaryText = _ref2.summaryText,
	      summaryText = _ref2$summaryText === undefined ? '' : _ref2$summaryText,
	      _ref2$winnerClassFeat = _ref2.winnerClassFeature,
	      winnerClassFeature = _ref2$winnerClassFeat === undefined ? '' : _ref2$winnerClassFeat,
	      _ref2$homeTeamBattedF = _ref2.homeTeamBattedFirst,
	      homeTeamBattedFirst = _ref2$homeTeamBattedF === undefined ? true : _ref2$homeTeamBattedF,
	      showGameDetailFooter = _ref2.showGameDetailFooter,
	      _ref2$currentPageLink = _ref2.currentPageLink,
	      currentPageLink = _ref2$currentPageLink === undefined ? '#' : _ref2$currentPageLink;
	
	  var team1 = homeTeamBattedFirst ? teams.home : teams.away;
	  var team2 = homeTeamBattedFirst ? teams.away : teams.home;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cricinfo__content__item' },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('cscore', className, winnerClassFeature) },
	      _react2.default.createElement(
	        'div',
	        { className: 'cricinfo__type__link' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cscore__overview' },
	          (date || time) && _react2.default.createElement(
	            'div',
	            { className: 'cscore__overview__title' },
	            gameState === 'pregame' ? date : time
	          ),
	          header && _react2.default.createElement(
	            'div',
	            { className: 'cscore__overview__detail' },
	            header
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'cscore__competitors' },
	          _react2.default.createElement(Competitor, (0, _extends3.default)({ team: 'home' }, team1, { sport: sport })),
	          _react2.default.createElement(Competitor, (0, _extends3.default)({ team: 'away' }, team2, { sport: sport }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cscore__info' },
	          summaryText && showGameDetailFooter ? summaryText : '',
	          gameState === 'live' && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: currentPageLink, style: { margin: '5px 0', 'display': 'inline-block', 'textDecoration': 'none' } },
	              _react2.default.createElement('img', { src: 'http://a.espncdn.com/i/cricinfo/refresh.gif', width: '20', height: '20', style: { 'verticalAlign': 'middle', marginRight: '10px' } }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Refresh'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ScoreCell;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Construct recent overs string
	 * @param  {Array}  options.overs overs array (last 12 balls)
	 * @return {String}               displayable string of last 12 balls. Each over
	 *                                is separated by a pipe (|)
	 */
	var RecentOvers = function RecentOvers(_ref) {
	  var _ref$overs = _ref.overs,
	      overs = _ref$overs === undefined ? [] : _ref$overs;
	
	
	  var recent = [];
	
	  overs.map(function () {
	    var over = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var i = arguments[1];
	
	    over.map(function (r) {
	      var isDot = r == '0';
	      recent.push('' + (isDot ? '.' : r));
	    });
	    // Add separator, If not last
	    // TODO: use Array.reduce and refactor
	    if (i !== overs.length - 1) {
	      recent.push(' | ');
	    }
	  });
	
	  return _react2.default.createElement(
	    'tr',
	    { className: 'cricinfo__table__tr' },
	    _react2.default.createElement(
	      'td',
	      { colSpan: '2', className: 'cricinfo__table__td' },
	      _react2.default.createElement(
	        'span',
	        { className: 'cricinfo__type__weight--bold' },
	        'Recent:'
	      ),
	      ' ',
	      recent.join(' ')
	    )
	  );
	};
	
	/**
	 * Innings summary component for live games.
	 * Displays current batsmen, bowlers, partership details, last wicket etc.
	 * @return {React.Element} Summary of live innings
	 */
	var InningsSummary = function InningsSummary(_ref2) {
	  var _ref2$liteBatsmen = _ref2.liteBatsmen,
	      liteBatsmen = _ref2$liteBatsmen === undefined ? [] : _ref2$liteBatsmen,
	      _ref2$liteBowlers = _ref2.liteBowlers,
	      liteBowlers = _ref2$liteBowlers === undefined ? [] : _ref2$liteBowlers,
	      _ref2$heading = _ref2.heading,
	      heading = _ref2$heading === undefined ? '' : _ref2$heading,
	      _ref2$partnership = _ref2.partnership,
	      partnership = _ref2$partnership === undefined ? '' : _ref2$partnership,
	      _ref2$lastWicket = _ref2.lastWicket,
	      lastWicket = _ref2$lastWicket === undefined ? '' : _ref2$lastWicket,
	      _ref2$fow = _ref2.fow,
	      fow = _ref2$fow === undefined ? '' : _ref2$fow,
	      recentOvers = _ref2.recentOvers,
	      _ref2$sessionInfo = _ref2.sessionInfo,
	      sessionInfo = _ref2$sessionInfo === undefined ? '' : _ref2$sessionInfo;
	
	
	  if (liteBatsmen.length === 0 || liteBowlers.length === 0) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'cricinfo__content__item' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'cricinfo__sub-title' },
	        sessionInfo
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cricinfo__content__item' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'cricinfo__sub-title' },
	      heading
	    ),
	    _react2.default.createElement(
	      'table',
	      { className: 'cricinfo__table cricinfo__table--light' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          { className: 'cricinfo__table__tr' },
	          _react2.default.createElement(
	            'th',
	            { colSpan: '2', className: 'cricinfo__table__th cricinfo__type__align--left' },
	            'BATSMAN'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        liteBatsmen.map(function () {
	          var batsman = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { stats: [] };
	          var i = arguments[1];
	
	          return _react2.default.createElement(_common.BatsmanLite, { batsman: batsman, bId: i, showOutComms: false });
	        }),
	        _react2.default.createElement(RecentOvers, { overs: recentOvers }),
	        partnership ? _react2.default.createElement(
	          'tr',
	          { className: 'cricinfo__table__tr' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: '2', className: 'cricinfo__table__td' },
	            _react2.default.createElement(
	              'span',
	              { className: 'cricinfo__type__weight--bold' },
	              'Partnership:'
	            ),
	            ' ',
	            partnership
	          )
	        ) : null,
	        lastWicket ? _react2.default.createElement(
	          'tr',
	          { className: 'cricinfo__table__tr' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: '2', className: 'cricinfo__table__td' },
	            _react2.default.createElement(
	              'span',
	              { className: 'cricinfo__type__weight--bold' },
	              'Last W\'ket:'
	            ),
	            ' ',
	            lastWicket
	          )
	        ) : null
	      ),
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          { className: 'cricinfo__table__tr' },
	          _react2.default.createElement(
	            'th',
	            { colSpan: '2', className: 'cricinfo__table__th cricinfo__type__align--left' },
	            'BOWLERS'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        liteBowlers.map(function () {
	          var bowler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { stats: [] };
	          var i = arguments[1];
	
	          return _react2.default.createElement(_common.BowlerLite, { bowler: bowler, bId: i });
	        }),
	        fow ? _react2.default.createElement(
	          'tr',
	          { className: 'cricinfo__table__tr' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: '2', className: 'cricinfo__table__td' },
	            _react2.default.createElement(
	              'span',
	              { className: 'cricinfo__type__weight--bold' },
	              'Fall of Wicket:'
	            ),
	            ' ',
	            fow
	          )
	        ) : null
	      )
	    )
	  );
	};
	
	exports.default = InningsSummary;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TopStories = function TopStories(_ref) {
	  var _ref$id = _ref.id,
	      id = _ref$id === undefined ? '' : _ref$id,
	      _ref$href = _ref.href,
	      href = _ref$href === undefined ? '' : _ref$href,
	      _ref$headline = _ref.headline,
	      headline = _ref$headline === undefined ? '' : _ref$headline,
	      _ref$type = _ref.type,
	      type = _ref$type === undefined ? '' : _ref$type,
	      _ref$images = _ref.images,
	      images = _ref$images === undefined ? [] : _ref$images;
	
	  var image = images[0] || {};
	
	  var module = _react2.default.createElement(
	    'div',
	    { className: 'cricinfo__content__item' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'cricinfo__sub-title' },
	      type
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'cricinfo__article__list' },
	      _react2.default.createElement(
	        'li',
	        { className: 'cricinfo__article__list__item' },
	        image && image.url && _react2.default.createElement(
	          'div',
	          { className: 'cricinfo__article__img' },
	          _react2.default.createElement('img', { src: image.url, alt: 'placeholder', height: '38', width: '38' })
	        ),
	        headline && _react2.default.createElement(
	          'a',
	          { name: '&lpos=:editorial', className: 'cricinfo__type__link', href: href },
	          _react2.default.createElement(
	            'div',
	            { className: 'cricinfo__article__title' },
	            headline
	          )
	        )
	      )
	    )
	  );
	
	  return id ? module : _react2.default.createElement('div', { style: { display: 'none' } });
	};
	
	exports.default = TopStories;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Entities = __webpack_require__(652).XmlEntities;
	var entities = new Entities();
	
	function limitWords(text, limit) {
	  text = text.split(' ', limit).join(' ').split('.').slice(0, -1).join('.');
	
	  return text + '.';
	}
	
	var Commentary = function Commentary(_ref) {
	  var _ref$overs = _ref.overs,
	      overs = _ref$overs === undefined ? [] : _ref$overs,
	      _ref$commentPreText = _ref.commentPreText,
	      commentPreText = _ref$commentPreText === undefined ? '' : _ref$commentPreText,
	      _ref$showCommentPreTe = _ref.showCommentPreText,
	      showCommentPreText = _ref$showCommentPreTe === undefined ? false : _ref$showCommentPreTe;
	
	  commentPreText = commentPreText && entities.decode(limitWords(commentPreText, 100)).replace(new RegExp('<br>', 'g'), '').replace(/\n\n/gm, '</p><p>');
	
	  var commentary = _react2.default.createElement(
	    'div',
	    { className: 'cricinfo__content__item' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'cricinfo__sub-title' },
	      'Commentary'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cricinfo__content__detail' },
	      showCommentPreText && commentPreText && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: '<p> ' + commentPreText + ' </p>' } }),
	      overs.map(function (o, i) {
	        var comms = (o.comments || []).map(function (c, i) {
	          var liClass = (0, _classnames2.default)('cricinfo__content__detail__list__item', {
	            'cricinfo__content__detail__list__item--has-space': !commentPreText && i > 0
	          });
	          var textMarkup = entities.decode(c.text);
	          var postText = c.post;
	          return _react2.default.createElement(
	            'li',
	            { key: i, className: liClass },
	            postText && entities.decode(postText).split('\n\n').map(function (text, i) {
	              var bKey = 'b' + i;
	              return _react2.default.createElement('div', { className: 'comment', key: bKey, dangerouslySetInnerHTML: { __html: text } });
	            }) || null,
	            _react2.default.createElement(
	              'span',
	              { className: 'cricinfo__type__weight--bold' },
	              c.timeStamp
	            ),
	            _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: textMarkup } })
	          );
	        });
	
	        var overSummary = [o.endOfOver && _react2.default.createElement(
	          'div',
	          { className: 'cricinfo__endOfOver' },
	          'End of over: ',
	          o.endOfOver
	        ) || '', _react2.default.createElement(
	          'ul',
	          { className: 'cricinfo__content__detail__list' },
	          comms
	        )];
	
	        return overSummary;
	      })
	    )
	  );
	
	  return overs.length || overs.length === 0 && commentPreText ? commentary : _react2.default.createElement('div', { className: 'cricinfo__content__item' });
	};
	
	exports.default = Commentary;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SquadList = function SquadList(_ref) {
	  var _ref$team = _ref.team,
	      team = _ref$team === undefined ? {} : _ref$team,
	      _ref$hasSpace = _ref.hasSpace,
	      hasSpace = _ref$hasSpace === undefined ? false : _ref$hasSpace;
	
	  var liClass = (0, _classnames2.default)('cricinfo__content__detail__list__item', { 'cricinfo__content__detail__list__item--has-space': hasSpace });
	  var playersList = (team.players || []).map(function (player) {
	    return player.name;
	  });
	
	  playersList = playersList.join(', ');
	
	  return _react2.default.createElement(
	    'li',
	    { className: liClass },
	    _react2.default.createElement(
	      'span',
	      { className: 'cricinfo__type__weight--bold' },
	      team.name,
	      ':'
	    ),
	    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: playersList } })
	  );
	};
	
	var Squad = function Squad(_ref2) {
	  var _ref2$home = _ref2.home,
	      home = _ref2$home === undefined ? {} : _ref2$home,
	      _ref2$away = _ref2.away,
	      away = _ref2$away === undefined ? {} : _ref2$away;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cricinfo__content__item' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'cricinfo__sub-title' },
	      'Squad'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cricinfo__content__detail' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'cricinfo__content__detail__list' },
	        _react2.default.createElement(SquadList, { team: home }),
	        _react2.default.createElement(SquadList, { team: away, hasSpace: true })
	      )
	    )
	  );
	};
	
	exports.default = Squad;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(415);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScorecardSummary = function ScorecardSummary(_ref) {
	  var _ref$fullSummaryLink = _ref.fullSummaryLink,
	      fullSummaryLink = _ref$fullSummaryLink === undefined ? '' : _ref$fullSummaryLink,
	      _ref$innings = _ref.innings,
	      innings = _ref$innings === undefined ? {} : _ref$innings,
	      isLimitedOvers = _ref.isLimitedOvers;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cricinfo__content__item' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'cricinfo__sub-title' },
	      'Scorecard Summary'
	    ),
	    _react2.default.createElement(
	      'table',
	      { className: 'cricinfo__table' },
	      (0, _keys2.default)(innings).map(function (innCount) {
	        var _innings$innCount = innings[innCount],
	            team = _innings$innCount.team,
	            batsmen = _innings$innCount.batsmen,
	            bowlers = _innings$innCount.bowlers;
	
	        var teamHead = _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { className: 'cricinfo__table__tr' },
	            _react2.default.createElement(
	              'th',
	              { className: 'cricinfo__table__th cricinfo__type__align--left' },
	              team.teamDisplayName,
	              ' ',
	              isLimitedOvers ? '' : team.innDisplayName
	            ),
	            _react2.default.createElement(
	              'th',
	              { className: 'cricinfo__table__th cricinfo__type__align--right' },
	              team.inningsRunWicket
	            )
	          )
	        );
	        var teamBody = _react2.default.createElement(
	          'tbody',
	          null,
	          batsmen && batsmen.map(function (b, j) {
	            var stats = b.stats || {};
	            // Need to show * for not out player
	            var isNotOut = (0, _selectn2.default)('notouts.value', stats) == '1' ? true : false;
	            var runsScored = (0, _selectn2.default)('runs.value', stats);
	            var ballsFaced = (0, _selectn2.default)('ballsFaced.value', stats);
	            var name = '' + (b.name || '-') + (isNotOut ? '*' : '');
	            var runsAndBalls = runsScored && ballsFaced ? runsScored + ' (' + ballsFaced + ')' : '-';
	
	            return _react2.default.createElement(
	              'tr',
	              { key: j, className: 'cricinfo__table__tr' },
	              _react2.default.createElement(
	                'td',
	                { className: 'cricinfo__table__td cricinfo__type__align--left' },
	                name
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'cricinfo__table__td cricinfo__type__align--right' },
	                runsAndBalls
	              )
	            );
	          }),
	          bowlers && bowlers.map(function (b, j) {
	            var stats = b.stats || {};
	            var wicketsTaken = (0, _selectn2.default)('wickets.value', stats);
	            var runsConceded = (0, _selectn2.default)('conceded.value', stats);
	            var wicketAndRuns = wicketsTaken && runsConceded ? wicketsTaken + '/' + runsConceded : '-';
	
	            return _react2.default.createElement(
	              'tr',
	              { key: j, className: 'cricinfo__table__tr' },
	              _react2.default.createElement(
	                'td',
	                { className: 'cricinfo__table__td cricinfo__type__align--left' },
	                b.name || '-'
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'cricinfo__table__td cricinfo__type__align--right' },
	                wicketAndRuns
	              )
	            );
	          })
	        );
	        return [teamHead, teamBody];
	      }),
	      _react2.default.createElement(
	        'tfoot',
	        null,
	        _react2.default.createElement(
	          'tr',
	          { className: 'cricinfo__table__tr' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: '2', className: 'cricinfo__table__td cricinfo__table__td--footer cricinfo__type__align--center' },
	            fullSummaryLink && _react2.default.createElement(_common.AnchorLink, {
	              classes: 'cricinfo__type__link',
	              to: fullSummaryLink, text: 'Full Scorecard' })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ScorecardSummary;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Inning = undefined;
	
	var _extends2 = __webpack_require__(361);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(415);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _common = __webpack_require__(423);
	
	var _index = __webpack_require__(847);
	
	var _common2 = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	const ListOfInnings = ({
	  innings = {}
	}) => {
	
	  let allInnings = Object.keys(innings) || []
	  let maxInn = allInnings.length
	
	  return (
	    <div>
	    {
	    allInnings.map(function (innNum) {
	      let inn = innings[innNum] || {}
	      let title = inn.title || 'Innings'
	      console.info('title', title)
	      let buttonClasses = [ 'cricinfo__league__header--header' ]
	      let spanClasses = [ 'cricinfo__caret' ]
	      if (maxInn == innNum) {
	        buttonClasses.push('cricinfo__accordion--active')
	        spanClasses.push('cricinfo__caret--down')
	      }
	      else{
	        spanClasses.push('cricinfo__caret--right')
	      }
	      return (
	        <a className="cricinfo__league__header" ><h3
	          id="h3_title" style={{ fontWeight:'normal' }} 
	          className={classnames(buttonClasses)}>
	            {title}
	        </h3></a>
	      )
	    })
	    }
	    </div>
	  )
	}
	*/
	
	/**
	 * get fall of wicket markup.
	 * Function is required since text appears in text nodes and not inside any
	 * wrapper nodes.
	 *
	 * @param  {Array}  fows strings of wickets fallen
	 * @return {Object}      html markup object
	 */
	function getFowMarkup() {
	  var fows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var fowMarkup = '';
	  if (fows.length > 0) {
	    fowMarkup = '<span class="cricinfo__type__weight--bold">Fall of Wickets: </span>' + fows.join(', ');
	  }
	  return { __html: fowMarkup };
	}
	
	/**
	 * Print a inline list of players.
	 * @return {React.Element} list of players
	 */
	
	//import selectn from 'selectn'
	var MultiplePlayers = function MultiplePlayers(_ref) {
	  var _ref$players = _ref.players,
	      players = _ref$players === undefined ? [] : _ref$players,
	      _ref$remainingBatsmen = _ref.remainingBatsmen,
	      remainingBatsmen = _ref$remainingBatsmen === undefined ? '' : _ref$remainingBatsmen;
	
	
	  var playerNames = '';
	  players.map(function (p, i) {
	    var playerRole = (0, _common.getPlayerRoles)(p.name, p.roles, i == players.length - 1 ? '' : ', ') || {};
	    var s = playerRole.__html || '';
	    playerNames += s;
	  });
	
	  var remainingPlayers = { __html: '<span class=\'cricinfo__type__weight--bold\'>' + remainingBatsmen + ':</span> ' + playerNames };
	
	  return _react2.default.createElement(
	    'tr',
	    { className: 'cricinfo__table__tr' },
	    _react2.default.createElement('td', { colSpan: '2', className: 'cricinfo__table__td', dangerouslySetInnerHTML: remainingPlayers })
	  );
	};
	
	var Batting = function Batting(_ref2) {
	  var _ref2$batsmen = _ref2.batsmen,
	      batsmen = _ref2$batsmen === undefined ? [] : _ref2$batsmen,
	      _ref2$didNotBat = _ref2.didNotBat,
	      didNotBat = _ref2$didNotBat === undefined ? [] : _ref2$didNotBat,
	      _ref2$total = _ref2.total,
	      total = _ref2$total === undefined ? '' : _ref2$total,
	      _ref2$extras = _ref2.extras,
	      extras = _ref2$extras === undefined ? '' : _ref2$extras,
	      _ref2$remainingBatsme = _ref2.remainingBatsmen,
	      remainingBatsmen = _ref2$remainingBatsme === undefined ? '' : _ref2$remainingBatsme,
	      _ref2$fows = _ref2.fows,
	      fows = _ref2$fows === undefined ? [] : _ref2$fows;
	
	
	  return _react2.default.createElement(
	    'table',
	    { className: 'cricinfo__table cricinfo__table--light' },
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        { className: 'cricinfo__table__tr' },
	        _react2.default.createElement(
	          'th',
	          { colSpan: '2', className: 'cricinfo__table__th cricinfo__type__align--left' },
	          'BATSMAN'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      batsmen.map(function () {
	        var batsman = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { stats: [] };
	        var i = arguments[1];
	
	        return _react2.default.createElement(_common2.BatsmanLite, { batsman: batsman, bId: i, key: i, showOutComms: true });
	      }),
	      extras && _react2.default.createElement(
	        'tr',
	        { className: 'cricinfo__table__tr' },
	        _react2.default.createElement(
	          'td',
	          { className: 'cricinfo__table__td cricinfo__type__weight--bold' },
	          'Extras'
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'cricinfo__table__td cricinfo__type__weight--bold cricinfo__type__align--right' },
	          extras
	        )
	      ) || null,
	      total && _react2.default.createElement(
	        'tr',
	        { className: 'cricinfo__table__tr' },
	        _react2.default.createElement(
	          'td',
	          { className: 'cricinfo__table__td cricinfo__type__weight--bold' },
	          'Total'
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'cricinfo__table__td cricinfo__type__weight--bold cricinfo__type__align--right' },
	          total
	        )
	      ) || null,
	      didNotBat && didNotBat.length && _react2.default.createElement(MultiplePlayers, { players: didNotBat, remainingBatsmen: remainingBatsmen }) || null,
	      fows && fows.length > 0 && _react2.default.createElement(
	        'tr',
	        { className: 'cricinfo__table__tr' },
	        _react2.default.createElement('td', { colSpan: '2', className: 'cricinfo__table__td', dangerouslySetInnerHTML: getFowMarkup(fows) })
	      ) || ''
	    )
	  );
	};
	
	var Bowling = function Bowling(_ref3) {
	  var _ref3$bowlers = _ref3.bowlers,
	      bowlers = _ref3$bowlers === undefined ? [] : _ref3$bowlers;
	
	  return _react2.default.createElement(
	    'table',
	    { className: 'cricinfo__table cricinfo__table--light' },
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        { className: 'cricinfo__table__tr' },
	        _react2.default.createElement(
	          'th',
	          { colSpan: '2', className: 'cricinfo__table__th cricinfo__type__align--left' },
	          'BOWLING'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      bowlers.map(function () {
	        var bowler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { stats: [] };
	        var i = arguments[1];
	
	        return _react2.default.createElement(_common2.BowlerLite, { bowler: bowler, bId: i, key: i });
	      })
	    )
	  );
	};
	
	var Inning = exports.Inning = function Inning(_ref4) {
	  var _ref4$title = _ref4.title,
	      title = _ref4$title === undefined ? 'Innings' : _ref4$title,
	      _ref4$batsmen = _ref4.batsmen,
	      batsmen = _ref4$batsmen === undefined ? [] : _ref4$batsmen,
	      _ref4$bowlers = _ref4.bowlers,
	      bowlers = _ref4$bowlers === undefined ? [] : _ref4$bowlers,
	      _ref4$didNotBat = _ref4.didNotBat,
	      didNotBat = _ref4$didNotBat === undefined ? [] : _ref4$didNotBat,
	      _ref4$total = _ref4.total,
	      total = _ref4$total === undefined ? '' : _ref4$total,
	      _ref4$extras = _ref4.extras,
	      extras = _ref4$extras === undefined ? '' : _ref4$extras,
	      _ref4$remainingBatsme = _ref4.remainingBatsmen,
	      remainingBatsmen = _ref4$remainingBatsme === undefined ? '' : _ref4$remainingBatsme,
	      _ref4$fows = _ref4.fows,
	      fows = _ref4$fows === undefined ? [] : _ref4$fows,
	      id = _ref4.id,
	      _ref4$otherTeamDetail = _ref4.otherTeamDetails,
	      otherTeamDetails = _ref4$otherTeamDetail === undefined ? {} : _ref4$otherTeamDetail,
	      _ref4$isWebView = _ref4.isWebView,
	      isWebView = _ref4$isWebView === undefined ? false : _ref4$isWebView,
	      inningStatus = _ref4.inningStatus,
	      headerInfo = _ref4.headerInfo;
	
	
	  var innStyles = {
	    //border : '2px solid #f00' ,
	    //'marginTop': '5px'
	  };
	  headerInfo = inningStatus === 'forfeit' ? headerInfo : '';
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'a',
	      { className: 'cricinfo__league__header' },
	      _react2.default.createElement(
	        'h3',
	        {
	          id: 'h3_title', style: { fontWeight: 'normal' },
	          className: (0, _classnames2.default)('cricinfo__league__header--header') },
	        title,
	        ' ',
	        headerInfo
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'content_1', className: 'cricinfo__accordion__content', style: innStyles },
	      _react2.default.createElement(Batting, { batsmen: batsmen, didNotBat: didNotBat, total: total, extras: extras, remainingBatsmen: remainingBatsmen, fows: fows, isWebView: isWebView }),
	      bowlers && bowlers.length > 0 && _react2.default.createElement(Bowling, { id: id, bowlers: bowlers, isWebView: isWebView }) || '',
	      otherTeamDetails && otherTeamDetails.players.length && _react2.default.createElement(_index.Team, { details: otherTeamDetails }) || ''
	    )
	  );
	};
	
	var Innings = function Innings(_ref5) {
	  var _ref5$innings = _ref5.innings,
	      innings = _ref5$innings === undefined ? {} : _ref5$innings,
	      _ref5$otherTeamDetail = _ref5.otherTeamDetails,
	      otherTeamDetails = _ref5$otherTeamDetail === undefined ? {} : _ref5$otherTeamDetail,
	      _ref5$isWebView = _ref5.isWebView,
	      isWebView = _ref5$isWebView === undefined ? false : _ref5$isWebView;
	
	  //console.info('innings', innings)
	  //console.info('otherTeamDetails', otherTeamDetails)
	  //console.info('isWebView', isWebView)
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cricinfo__content__item' },
	    _react2.default.createElement(
	      'div',
	      { className: 'cricinfo__accordion' },
	      (0, _keys2.default)(innings).map(function (inning, i) {
	        return _react2.default.createElement(Inning, (0, _extends3.default)({ key: i, id: i }, innings[inning], { otherTeamDetails: otherTeamDetails, isWebView: isWebView }));
	      })
	    )
	  );
	};
	
	exports.default = Innings;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Team = function Team(_ref) {
	  var _ref$details = _ref.details,
	      details = _ref$details === undefined ? {} : _ref$details;
	
	
	  var players = details.players || [];
	  var playerNames = '';
	  players.map(function (p, i) {
	    var playerRole = (0, _common.getPlayerRoles)(p.name, p.roles, i == players.length - 1 ? '' : ', ') || {};
	    var s = playerRole.__html || '';
	    playerNames += s;
	  });
	
	  var teamMarkup = { __html: '' + playerNames };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cricinfo__content__item' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'cricinfo__sub-title' },
	      details.name,
	      ' Team'
	    ),
	    _react2.default.createElement('div', { className: 'cricinfo__content__detail', dangerouslySetInnerHTML: teamMarkup })
	  );
	};
	
	exports.default = Team;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchDetailItem = function MatchDetailItem(_ref) {
	  var _ref$type = _ref.type,
	      type = _ref$type === undefined ? '' : _ref$type,
	      _ref$persons = _ref.persons,
	      persons = _ref$persons === undefined ? [] : _ref$persons;
	
	  var officials = persons.map(function (p) {
	    return p.name;
	  });
	
	  officials = officials.join(', ');
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'cricinfo__content__detail__list__item' },
	    _react2.default.createElement(
	      'span',
	      { className: 'cricinfo__type__weight--bold' },
	      type,
	      ' :'
	    ),
	    officials
	  );
	};
	
	var MatchOfficials = function MatchOfficials(_ref2) {
	  var _ref2$officials = _ref2.officials,
	      officials = _ref2$officials === undefined ? {} : _ref2$officials;
	
	  var umpire = officials.umpire && officials.umpire || [];
	  var tvUmpire = officials['tv umpire'] && officials['tv umpire'] || [];
	  var reserveUmpire = officials['reserve umpire'] && officials['reserve umpire'] || [];
	  var referee = officials.referee && officials.referee || [];
	  var props = [umpire.length, tvUmpire.length, reserveUmpire.length, referee.length];
	  var show = false;
	
	  // loops through all props and sets show=true
	  // if any one of them is available
	  for (var i = 0; i < props.length; i++) {
	    if (props[i]) {
	      show = true;
	    }
	  }
	
	  var content = _react2.default.createElement(
	    'div',
	    { className: 'cricinfo__content__item' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'cricinfo__sub-title' },
	      'Match Officials'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cricinfo__content__detail' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'cricinfo__content__detail__list' },
	        umpire.length && _react2.default.createElement(MatchDetailItem, { type: 'Umpires', persons: officials.umpire }) || null,
	        tvUmpire.length && _react2.default.createElement(MatchDetailItem, { type: 'TV Umpires', persons: officials['tv umpire'] }) || null,
	        reserveUmpire.length && _react2.default.createElement(MatchDetailItem, { type: 'Reserve Umpire', persons: officials['reserve umpire'] }) || null,
	        referee.length && _react2.default.createElement(MatchDetailItem, { type: 'Match Referee', persons: officials.referee }) || null
	      )
	    )
	  );
	
	  return show ? content : _react2.default.createElement('div', { className: 'cricinfo__content__item' });
	};
	
	exports.default = MatchOfficials;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchDetailItem = function MatchDetailItem(_ref) {
	  var _ref$type = _ref.type,
	      type = _ref$type === undefined ? '' : _ref$type,
	      _ref$persons = _ref.persons,
	      persons = _ref$persons === undefined ? [] : _ref$persons,
	      _ref$value = _ref.value,
	      value = _ref$value === undefined ? '' : _ref$value,
	      _ref$enableLink = _ref.enableLink,
	      enableLink = _ref$enableLink === undefined ? false : _ref$enableLink;
	
	  var len = persons.length;
	  if (len > 0) {
	    persons = persons.map(function (p, i) {
	      if (enableLink === true && p.href !== '#') {
	        return '<a href=' + p.href + '>' + p.name + '</a>';
	      } else {
	        var separator = '';
	
	        // add separator if more than one item
	        if (i > 0) {
	          // `and` if last item
	          if (i == len - 1) {
	            separator = ' and ';
	          } else {
	            // `,` if middle item
	            separator = ', ';
	          }
	        }
	
	        return separator + p.name;
	      }
	    });
	  }
	
	  persons = persons.join('');
	
	  return _react2.default.createElement(
	    'tr',
	    { className: 'cricinfo__table__tr' },
	    _react2.default.createElement(
	      'td',
	      { className: 'cricinfo__table__td' },
	      _react2.default.createElement(
	        'span',
	        { className: 'cricinfo__type__weight--bold' },
	        type || '',
	        ': '
	      ),
	      persons.length > 0 && _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: persons } }),
	      value.length > 0 && value
	    )
	  );
	};
	
	var MatchDetails = function MatchDetails(_ref2) {
	  var _ref2$officials = _ref2.officials,
	      officials = _ref2$officials === undefined ? {} : _ref2$officials,
	      _ref2$debuts = _ref2.debuts,
	      debuts = _ref2$debuts === undefined ? [] : _ref2$debuts,
	      _ref2$toss = _ref2.toss,
	      toss = _ref2$toss === undefined ? '' : _ref2$toss,
	      _ref2$matchFormat = _ref2.matchFormat,
	      matchFormat = _ref2$matchFormat === undefined ? '' : _ref2$matchFormat,
	      _ref2$series = _ref2.series,
	      series = _ref2$series === undefined ? [] : _ref2$series,
	      _ref2$featuredAthlete = _ref2.featuredAthletesDetails,
	      featuredAthletesDetails = _ref2$featuredAthlete === undefined ? [] : _ref2$featuredAthlete;
	
	
	  var umpire = officials.umpire && officials.umpire || [];
	  var tvUmpire = officials['tv umpire'] && officials['tv umpire'] || [];
	  var reserveUmpire = officials['reserve umpire'] && officials['reserve umpire'] || [];
	  var referee = officials.referee && officials.referee || [];
	  var props = [debuts.length, umpire.length, tvUmpire.length, reserveUmpire.length, referee.length, matchFormat, featuredAthletesDetails.length];
	  var show = false;
	
	  // loops through all props and sets show=true
	  // if any one of them is available
	  for (var i = 0; i < props.length; i++) {
	    if (props[i]) {
	      show = true;
	    }
	  }
	  var content = _react2.default.createElement(
	    'div',
	    { className: 'cricinfo__content__item' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'cricinfo__sub-title' },
	      'Match Details'
	    ),
	    _react2.default.createElement(
	      'table',
	      { className: 'cricinfo__table' },
	      _react2.default.createElement(
	        'tbody',
	        null,
	        series.length && _react2.default.createElement(MatchDetailItem, { type: 'Series', persons: series, enableLink: true }) || null,
	        toss && _react2.default.createElement(MatchDetailItem, { type: 'Toss', persons: [], value: toss }) || null,
	        featuredAthletesDetails && featuredAthletesDetails.map(function (item, i) {
	          if (item[1].length === 0) {
	            return null;
	          }
	          var featuredAthleteType = (0, _selectn2.default)('[0].featuredAthletesType', item[1]) || '';
	          return _react2.default.createElement(MatchDetailItem, { key: i, type: featuredAthleteType, persons: item[1] });
	        }),
	        debuts.length && _react2.default.createElement(MatchDetailItem, { type: matchFormat + ' debut', value: '', persons: debuts }) || null,
	        umpire.length && _react2.default.createElement(MatchDetailItem, { type: 'Umpires', value: '', persons: officials.umpire }) || null,
	        tvUmpire.length && _react2.default.createElement(MatchDetailItem, { type: 'TV Umpires', value: '', persons: officials['tv umpire'] }) || null,
	        reserveUmpire.length && _react2.default.createElement(MatchDetailItem, { type: 'Reserve Umpire', value: '', persons: officials['reserve umpire'] }) || null,
	        referee.length && _react2.default.createElement(MatchDetailItem, { type: 'Match Referee', value: '', persons: officials.referee }) || null
	      )
	    )
	  );
	
	  return show ? content : _react2.default.createElement('div', { style: { display: 'none' } });
	};
	
	exports.default = MatchDetails;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterLite = undefined;
	
	var _FooterLite = __webpack_require__(860);
	
	var _FooterLite2 = _interopRequireDefault(_FooterLite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.FooterLite = _FooterLite2.default;
	exports.default = {
	  FooterLite: _FooterLite2.default
	};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterLite = function FooterLite(_ref) {
	  var editionUserGeo = _ref.editionUserGeo;
	
	
	  var internetBasedAds = editionUserGeo === 'us' ? 'http://preferences-mgr.truste.com/?type=espn&affiliateId=148' : 'http://preferences-mgr.truste.com/?pid=disney01&aid=espnemea01&type=espnemea';
	  var currentYear = new Date().getFullYear();
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'cricinfo__footer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'cricinfo__footer__detail' },
	        '\xA9 ',
	        currentYear,
	        ' ESPN Sports Media Ltd.',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://disneytermsofuse.com/', target: '_blank' },
	          'Terms of Use'
	        ),
	        ',\xA0',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://disneyprivacycenter.com/', target: '_blank' },
	          'Privacy Policy'
	        ),
	        ',\xA0',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://disneyprivacycenter.com/cookies-policy-translations/cookies-policy/', target: '_blank' },
	          'Cookie Policy'
	        ),
	        ',\xA0',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://www.nielsen.com/digitalprivacy', target: '_blank' },
	          'About Nielsen Measurement'
	        ),
	        ' and\xA0',
	        _react2.default.createElement(
	          'a',
	          { href: internetBasedAds || '#', target: '_blank' },
	          'Interest-Based Ads'
	        ),
	        ' are applicable to you. All rights reserved.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'cricinfo__footer__actions' },
	        _react2.default.createElement(
	          'a',
	          { href: '#', target: '_blank', className: 'cricinfo__type__link' },
	          'More from ESPN'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'cricinfo__footer__link__list' },
	          _react2.default.createElement(
	            'li',
	            { className: 'cricinfo__footer__link__list__item' },
	            _react2.default.createElement(
	              'a',
	              { href: '#', target: '_blank', className: 'cricinfo__type__link' },
	              'ESPN'
	            ),
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'cricinfo__footer__link__list__item' },
	            _react2.default.createElement(
	              'a',
	              { href: '#', target: '_blank', className: 'cricinfo__type__link' },
	              'The Cricket Monthly'
	            ),
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'cricinfo__footer__link__list__item' },
	            _react2.default.createElement(
	              'a',
	              { href: '#', target: '_blank', className: 'cricinfo__type__link' },
	              'FireThirtyEight'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = FooterLite;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isFastCastAvailable = isFastCastAvailable;
	exports.disconnectScores = disconnectScores;
	exports.disconnectGPG = disconnectGPG;
	exports.scoresFastCast = scoresFastCast;
	exports.gamepackageFastCast = gamepackageFastCast;
	
	var _actionTypes = __webpack_require__(413);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _transform = __webpack_require__(616);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _cricket = __webpack_require__(668);
	
	var _cloneDeep = __webpack_require__(862);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _selectn = __webpack_require__(427);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import qs from 'query-string'
	//import moment from 'moment-timezone'
	
	var scoreRef = void 0; /* global espn */
	
	/**
	 * @fileOverview Utilty to setup Cricket specific fastcast connections.
	 */
	
	var gamepackageRef = void 0;
	
	/**
	 * Is this team specific scoreboard page?
	 * @param  {Object}  params request params
	 * @return {Boolean}        true if it's team specific scoreboard else false
	 */
	function isTeamBasedScoresPage(params) {
	  if (params.pageType === 'scores') {
	    if (params.hasOwnProperty('team') && typeof params.team === 'string') {
	      //console.info('isTeamBasedScoresPage', true)
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Is this series specific scoreboard page?
	 * @param  {Object}  params request params
	 * @return {Boolean}        true if it's series specific scoreboard else false
	 */
	function isSeriesBasedScoresPage(params) {
	  if (params.pageType === 'scores') {
	    if (params.hasOwnProperty('league') && typeof params.league === 'string') {
	      //console.info('isSeriesBasedScoresPage', true)
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Is fastcast available for this page?
	 * @param  {Object} params request params
	 * @return {Boolean}        true if fastcast should enable else false
	 */
	function isFastCastAvailable(params) {
	  //console.info('params', params)
	  // Fastcast should be disabled if sport is not cricket
	  if (params.hasOwnProperty('sport') && params.sport !== 'cricket') {
	    return false;
	  }
	  // Fastcast should be disabled if it's team/series specific scores page
	  if (isTeamBasedScoresPage(params) || isSeriesBasedScoresPage(params)) {
	    //console.info('On series/team sepcific scores page, fastcast will not update')
	    return false;
	  }
	  return true;
	}
	
	/**
	 * Should fastcast update be applied?
	 * @param  {Object} query query object
	 * @return {Boolean}       true if fastcast update should be applied else false
	 */
	/*
	function shouldUpdateFastCast(query) {
	  // Get current date in required format
	  const curDate = moment.utc().format('YYYYMMDD')
	  //console.info('curDate, query', curDate, query)
	  if (query && query.hasOwnProperty('date')) {
	    // Return false if current date is not same as date passed via query object
	    if (query.date !== curDate) {
	      //console.info('On different date than current one, fastcast will not update')
	      return false
	    }
	  }
	  return true
	}
	*/
	
	function disconnectScores() {
	  var _props$fastCastMeta = this.props.fastCastMeta,
	      fastCastMeta = _props$fastCastMeta === undefined ? {} : _props$fastCastMeta;
	  // Return if fastcast is not available
	
	  if (fastCastMeta.enabled === false) {
	    return;
	  }
	
	  // Prepare for disconnect
	  var scoresTopic = fastCastMeta.scoresTopic,
	      topEventTopic = fastCastMeta.topEventTopic;
	
	  try {
	    espn.flow.disconnect(scoresTopic, scoreRef);
	    espn.flow.disconnect(topEventTopic, scoreRef);
	    //console.info('After disconnecting cricket scores fastcast')
	  } catch (e) {
	    console.log('e', e);
	  }
	}
	
	function disconnectGPG() {
	  var _props$fastCastMeta2 = this.props.fastCastMeta,
	      fastCastMeta = _props$fastCastMeta2 === undefined ? {} : _props$fastCastMeta2;
	  // Return if fastcast is not available
	
	  if (fastCastMeta.enabled === false) {
	    return;
	  }
	
	  // Prepare for disconnect
	  var topic = fastCastMeta.topic;
	  try {
	    espn.flow.disconnect(topic, gamepackageRef);
	    //console.info(`After disconnecting cricket ${topic} fastcast`)
	  } catch (e) {
	    console.log('e', e);
	  }
	}
	
	/**
	 * Handle messages received from scores fastcast connection
	 * @param  {Object} res data received
	 * @return {undefined}   undefined
	 */
	function handleScores() {
	  var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _props = this.props,
	      _props$edition = _props.edition,
	      edition = _props$edition === undefined ? {} : _props$edition,
	      _props$params = _props.params,
	      params = _props$params === undefined ? {} : _props$params,
	      _props$location = _props.location,
	      location = _props$location === undefined ? {} : _props$location,
	      dispatch = _props.dispatch,
	      _props$fastCastMeta3 = _props.fastCastMeta,
	      fastCastMeta = _props$fastCastMeta3 === undefined ? {} : _props$fastCastMeta3,
	      _props$appProps = _props.appProps,
	      appProps = _props$appProps === undefined ? {} : _props$appProps,
	      isFastcastAllowed = _props.isFastcastAllowed,
	      _props$topEvents = _props.topEvents,
	      topEvents = _props$topEvents === undefined ? [] : _props$topEvents;
	  //const query = location.query || qs.parse(location.search)
	
	  if (fastCastMeta.enabled === true) {
	    //console.info('handleScores: scores fastcast data received', res)
	    //disabling ajax polling
	    if (this.timer) {
	      window.clearInterval(this.timer);
	      this.timer = null;
	    }
	    // set the flag that fastcast is allowed thru network
	    if (isFastcastAllowed !== true) {
	      dispatch({
	        type: _actionTypes2.default.ALLOW_DENY_FASTCAST,
	        payload: true
	      });
	    }
	
	    if (res.topic == fastCastMeta.scoresTopic) {
	      dispatch({
	        params: params,
	        edition: edition,
	        location: location,
	        isFastcast: true,
	        //url: gamepackage.url,
	        type: _actionTypes2.default.GET_SCOREBOARD,
	        data: transform.onGetScoreboard({ res: res, edition: edition, params: params, location: location, appProps: appProps, topEvents: topEvents })
	      });
	      console.log('FC : Update scoreboard');
	    } else if (res.topic == fastCastMeta.topEventTopic) {
	      dispatch({
	        isFastcast: true,
	        type: _actionTypes2.default.GET_TOPEVENTS,
	        data: transform.onGetTopEventScores({ res: res, edition: edition })
	      });
	      console.log('FC : Update topevents');
	    }
	  }
	}
	
	function scoresFastCast() {
	  var _props2 = this.props,
	      _props2$fastCastMeta = _props2.fastCastMeta,
	      fastCastMeta = _props2$fastCastMeta === undefined ? {} : _props2$fastCastMeta,
	      _props2$appProps = _props2.appProps,
	      appProps = _props2$appProps === undefined ? {} : _props2$appProps,
	      _props2$edition = _props2.edition,
	      edition = _props2$edition === undefined ? {} : _props2$edition;
	  /**
	   * Do not setup fastcast connection if polling is not enabled.
	   * See scoreboard.index.shouldPoll for the polling logic
	   */
	
	  if (fastCastMeta.enabled === false) {
	    //console.info('Fastcast is not enabled')
	    return;
	  }
	  var scoresTopic = fastCastMeta.scoresTopic,
	      topEventTopic = fastCastMeta.topEventTopic;
	
	  if (appProps.qaApi) {
	    // reconnect the socket to perf.fastcast.go.com
	    espn.flow.reconnect(null, { enablePerf: true });
	  }
	  // check topic is already subscribed to
	  if (typeof scoreRef == 'undefined') {
	    scoreRef = handleScores.bind(this);
	  }
	  if (typeof espn.flow.activeTopics[scoresTopic] == 'undefined') {
	    espn.flow.connect(scoresTopic, scoreRef);
	  } else if (typeof espn.flow.activeTopics[topEventTopic] == 'undefined' || !edition.isEspnCricinfo && ((0, _selectn2.default)('flow.activeTopics[' + topEventTopic + '].callbacks.length', espn) || 0) <= 1) {
	    espn.flow.connect(topEventTopic, scoreRef);
	  }
	}
	
	/**
	 * Handle messages received from gamepackage fastcast connection
	 * @param  {Object} res data received
	 * @return {undefined}   undefined
	 */
	function handleGamepackage(res) {
	  var resClone = (0, _cloneDeep2.default)(res);
	  var _props3 = this.props,
	      _props3$edition = _props3.edition,
	      edition = _props3$edition === undefined ? {} : _props3$edition,
	      _props3$params = _props3.params,
	      params = _props3$params === undefined ? {} : _props3$params,
	      dispatch = _props3.dispatch,
	      _props3$fastCastMeta = _props3.fastCastMeta,
	      fastCastMeta = _props3$fastCastMeta === undefined ? {} : _props3$fastCastMeta,
	      _props3$appProps = _props3.appProps,
	      appProps = _props3$appProps === undefined ? {} : _props3$appProps,
	      isFastcastAllowed = _props3.isFastcastAllowed,
	      loading = _props3.loading;
	  var _params$pageType = params.pageType,
	      pageType = _params$pageType === undefined ? '' : _params$pageType;
	  // Apply update if fastcast is enabled
	
	  if (fastCastMeta.enabled === true) {
	    //console.info('handleGamepackage: gamepkg fastcast data received', res)
	
	    // disable ajax polling as fastcast is allowed
	    if (this.timer) {
	      window.clearInterval(this.timer);
	      this.timer = null;
	    }
	
	    // set the flag that fastcast is allowed thru network
	    if (isFastcastAllowed !== true) {
	      dispatch({
	        type: _actionTypes2.default.ALLOW_DENY_FASTCAST,
	        payload: true
	      });
	    }
	
	    dispatch({
	      params: params,
	      edition: edition,
	      location: location,
	      appProps: appProps,
	      isFastcast: true,
	      //url: gamepackage.url,
	      type: _actionTypes2.default.GET_GAMEPACKAGE,
	      data: transform.onGetGamePackage({ res: resClone, edition: edition, params: params, location: location, appProps: appProps })
	    });
	  }
	
	  if (pageType == 'commentary' && !loading) {
	    console.log('Commentary polling kicks in');
	    dispatch((0, _cricket.getPlayByPlayMore)({ edition: edition, params: params, location: location, page: null, isPolling: true, appProps: appProps }));
	  }
	
	  console.log('Update FC');
	}
	
	function gamepackageFastCast() {
	  var _props4 = this.props,
	      _props4$fastCastMeta = _props4.fastCastMeta,
	      fastCastMeta = _props4$fastCastMeta === undefined ? {} : _props4$fastCastMeta,
	      _props4$appProps = _props4.appProps,
	      appProps = _props4$appProps === undefined ? {} : _props4$appProps;
	  /**
	   * Do not setup fastcast connection if polling is not enabled.
	   * See helpers.shouldPoll for the polling logic
	   */
	
	  if (fastCastMeta.enabled === false) {
	    //console.info('Fastcast is not enabled, will NOT setup gamepackage fastcast')
	    return;
	  }
	  var topic = fastCastMeta.topic;
	  //console.info(`Setting up connection to ${topic}`, new Date())
	
	  // Return since this topic is already subscribed to
	  if (typeof espn.flow.activeTopics[topic] !== 'undefined') {
	    //console.info('gamepackage fastcast is already setup', espn.flow.activeTopics[topic])
	    return;
	  }
	
	  gamepackageRef = handleGamepackage.bind(this);
	
	  if (appProps.qaApi) {
	    // reconnect the socket to perf.fastcast.go.com
	    espn.flow.reconnect(null, { enablePerf: true });
	  }
	  espn.flow.connect(topic, gamepackageRef);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(863);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(864),
	    arrayEach = __webpack_require__(902),
	    assignValue = __webpack_require__(903),
	    baseAssign = __webpack_require__(906),
	    baseAssignIn = __webpack_require__(926),
	    cloneBuffer = __webpack_require__(930),
	    copyArray = __webpack_require__(931),
	    copySymbols = __webpack_require__(932),
	    copySymbolsIn = __webpack_require__(936),
	    getAllKeys = __webpack_require__(939),
	    getAllKeysIn = __webpack_require__(941),
	    getTag = __webpack_require__(942),
	    initCloneArray = __webpack_require__(947),
	    initCloneByTag = __webpack_require__(948),
	    initCloneObject = __webpack_require__(955),
	    isArray = __webpack_require__(913),
	    isBuffer = __webpack_require__(914),
	    isMap = __webpack_require__(957),
	    isObject = __webpack_require__(882),
	    isSet = __webpack_require__(959),
	    keys = __webpack_require__(908);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	
	    return result;
	  }
	
	  if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	
	    return result;
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(865),
	    stackClear = __webpack_require__(873),
	    stackDelete = __webpack_require__(874),
	    stackGet = __webpack_require__(875),
	    stackHas = __webpack_require__(876),
	    stackSet = __webpack_require__(877);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(866),
	    listCacheDelete = __webpack_require__(867),
	    listCacheGet = __webpack_require__(870),
	    listCacheHas = __webpack_require__(871),
	    listCacheSet = __webpack_require__(872);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 866 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(868);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(869);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 869 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(868);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(868);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(868);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(865);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 874 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 875 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 876 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(865),
	    Map = __webpack_require__(878),
	    MapCache = __webpack_require__(887);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(879),
	    root = __webpack_require__(258);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(880),
	    getValue = __webpack_require__(886);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(881),
	    isMasked = __webpack_require__(883),
	    isObject = __webpack_require__(882),
	    toSource = __webpack_require__(885);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(256),
	    isObject = __webpack_require__(882);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 882 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(884);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(258);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 885 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 886 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(888),
	    mapCacheDelete = __webpack_require__(896),
	    mapCacheGet = __webpack_require__(899),
	    mapCacheHas = __webpack_require__(900),
	    mapCacheSet = __webpack_require__(901);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(889),
	    ListCache = __webpack_require__(865),
	    Map = __webpack_require__(878);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(890),
	    hashDelete = __webpack_require__(892),
	    hashGet = __webpack_require__(893),
	    hashHas = __webpack_require__(894),
	    hashSet = __webpack_require__(895);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(891);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(879);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 892 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(891);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(891);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(891);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(897);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(898);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 898 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(897);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(897);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(897);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 902 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(904),
	    eq = __webpack_require__(869);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(905);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(879);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(907),
	    keys = __webpack_require__(908);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(903),
	    baseAssignValue = __webpack_require__(904);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(909),
	    baseKeys = __webpack_require__(922),
	    isArrayLike = __webpack_require__(925);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(910),
	    isArguments = __webpack_require__(911),
	    isArray = __webpack_require__(913),
	    isBuffer = __webpack_require__(914),
	    isIndex = __webpack_require__(916),
	    isTypedArray = __webpack_require__(917);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 910 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(912),
	    isObjectLike = __webpack_require__(264);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(256),
	    isObjectLike = __webpack_require__(264);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 913 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(258),
	    stubFalse = __webpack_require__(915);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(266)(module)))

/***/ }),
/* 915 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 916 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(918),
	    baseUnary = __webpack_require__(920),
	    nodeUtil = __webpack_require__(921);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(256),
	    isLength = __webpack_require__(919),
	    isObjectLike = __webpack_require__(264);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 919 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 920 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(259);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(266)(module)))

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(923),
	    nativeKeys = __webpack_require__(924);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 923 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(263);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(881),
	    isLength = __webpack_require__(919);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(907),
	    keysIn = __webpack_require__(927);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(909),
	    baseKeysIn = __webpack_require__(928),
	    isArrayLike = __webpack_require__(925);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(882),
	    isPrototype = __webpack_require__(923),
	    nativeKeysIn = __webpack_require__(929);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 929 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(258);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(266)(module)))

/***/ }),
/* 931 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(907),
	    getSymbols = __webpack_require__(933);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(934),
	    stubArray = __webpack_require__(935);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 934 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 935 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(907),
	    getSymbolsIn = __webpack_require__(937);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(938),
	    getPrototype = __webpack_require__(262),
	    getSymbols = __webpack_require__(933),
	    stubArray = __webpack_require__(935);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 938 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(940),
	    getSymbols = __webpack_require__(933),
	    keys = __webpack_require__(908);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(938),
	    isArray = __webpack_require__(913);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(940),
	    getSymbolsIn = __webpack_require__(937),
	    keysIn = __webpack_require__(927);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(943),
	    Map = __webpack_require__(878),
	    Promise = __webpack_require__(944),
	    Set = __webpack_require__(945),
	    WeakMap = __webpack_require__(946),
	    baseGetTag = __webpack_require__(256),
	    toSource = __webpack_require__(885);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(879),
	    root = __webpack_require__(258);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(879),
	    root = __webpack_require__(258);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(879),
	    root = __webpack_require__(258);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(879),
	    root = __webpack_require__(258);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 947 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(949),
	    cloneDataView = __webpack_require__(951),
	    cloneRegExp = __webpack_require__(952),
	    cloneSymbol = __webpack_require__(953),
	    cloneTypedArray = __webpack_require__(954);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(950);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(258);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(949);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 952 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(257);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(949);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(956),
	    getPrototype = __webpack_require__(262),
	    isPrototype = __webpack_require__(923);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(882);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(958),
	    baseUnary = __webpack_require__(920),
	    nodeUtil = __webpack_require__(921);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(942),
	    isObjectLike = __webpack_require__(264);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(960),
	    baseUnary = __webpack_require__(920),
	    nodeUtil = __webpack_require__(921);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(942),
	    isObjectLike = __webpack_require__(264);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ })
]));


// WEBPACK FOOTER //
// 1.bundle.63b2c4bf1d96c0ff.js